/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
  /** The javascript `Date` as integer. Type represents date and time as number of milliseconds from start of UNIX epoch. */
  Timestamp: { input: any; output: any; }
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AamMethodWeightInput = {
  method: Scalars['String']['input'];
  weight: Scalars['Float']['input'];
};

export type AamOptimizationInput = {
  benchmarks?: InputMaybe<Array<BenchmarkWeightInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  decayFactor?: InputMaybe<Scalars['Float']['input']>;
  enhancedRobustness?: InputMaybe<Scalars['Boolean']['input']>;
  excludeCash?: InputMaybe<Scalars['Boolean']['input']>;
  excludeManagerTags?: InputMaybe<Array<Scalars['String']['input']>>;
  hideNames?: InputMaybe<Scalars['Boolean']['input']>;
  maxManagerWeight?: InputMaybe<Scalars['Float']['input']>;
  maxStaleMonths?: InputMaybe<Scalars['Int']['input']>;
  maxStrategyWeight?: InputMaybe<Scalars['Float']['input']>;
  methodWeights?: InputMaybe<Array<AamMethodWeightInput>>;
  minManagerWeight?: InputMaybe<Scalars['Float']['input']>;
  minPairMonths?: InputMaybe<Scalars['Int']['input']>;
  minStrategyWeight?: InputMaybe<Scalars['Float']['input']>;
  minVolatility?: InputMaybe<Scalars['Float']['input']>;
  shrinkage?: InputMaybe<Scalars['Float']['input']>;
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  strategyShrinkage?: InputMaybe<Scalars['Float']['input']>;
  strategyType?: InputMaybe<Scalars['String']['input']>;
  useProxies?: InputMaybe<Scalars['Boolean']['input']>;
  windowMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type AamOptimizationOption = {
  __typename?: 'AamOptimizationOption';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type AamOptimizationOptions = {
  __typename?: 'AamOptimizationOptions';
  methods: Array<AamOptimizationOption>;
  strategyTypes: Array<AamOptimizationOption>;
};

export type AamOptimizationRun = {
  __typename?: 'AamOptimizationRun';
  /** The JSON as a chat file, when the run was started from a conversation. */
  jsonArtifactId?: Maybe<Scalars['Int']['output']>;
  /** Download link for the JSON document. */
  jsonUrl?: Maybe<Scalars['String']['output']>;
  /** The PDF as a chat file, when the run was started from a conversation. */
  pdfArtifactId?: Maybe<Scalars['Int']['output']>;
  /** Download link for the PDF report. */
  pdfUrl?: Maybe<Scalars['String']['output']>;
  /** The report as data: method, settings, original and target dollars and weights by strategy and manager, returns, and the risk comparison. */
  report?: Maybe<Scalars['JSON']['output']>;
  /** Set when the run was asked to save to a conversation and saving failed. The run itself succeeded: the links are temporary downloads instead of chat files, and there are no artifact ids. */
  saveError?: Maybe<Scalars['String']['output']>;
};

export type AccessLevel = {
  __typename?: 'AccessLevel';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountTypeEnum = {
  __typename?: 'AccountTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountTypeEnumList = {
  __typename?: 'AccountTypeEnumList';
  items: Array<AccountTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AccountTypeEnumSort = {
  field: AccountTypeEnumSortEnum;
  order: SortInput;
};

export enum AccountTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AccountingManager = {
  __typename?: 'AccountingManager';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AccountingManagerFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AccountingManagerList = {
  __typename?: 'AccountingManagerList';
  items: Array<AccountingManager>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AccountingManagerSort = {
  field: AccountingManagerSortEnum;
  order: SortInput;
};

export enum AccountingManagerSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AdEntriesXApplicationFlags = {
  __typename?: 'AdEntriesXApplicationFlags';
  adEntry: User;
  applicationFlag: ApplicationFlags;
  applicationFlagId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type AdEntriesXApplicationFlagsFilter = {
  applicationFlagId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationFlagsInput = {
  applicationFlagId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationFlagsList = {
  __typename?: 'AdEntriesXApplicationFlagsList';
  items: Array<AdEntriesXApplicationFlags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdEntriesXApplicationFlagsSort = {
  field: AdEntriesXApplicationFlagsSortEnum;
  order: SortInput;
};

export enum AdEntriesXApplicationFlagsSortEnum {
  Id = 'id'
}

export type AdEntriesXApplicationsXSets = {
  __typename?: 'AdEntriesXApplicationsXSets';
  application: Application;
  applicationId: Scalars['Int']['output'];
  entry: User;
  entryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  set: Set;
  setId: Scalars['Int']['output'];
};

export type AdEntriesXApplicationsXSetsFilter = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  entryId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  setId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationsXSetsInput = {
  applicationId?: InputMaybe<Scalars['Int']['input']>;
  entryId?: InputMaybe<Scalars['Int']['input']>;
  setId?: InputMaybe<Scalars['Int']['input']>;
};

export type AdEntriesXApplicationsXSetsList = {
  __typename?: 'AdEntriesXApplicationsXSetsList';
  items: Array<AdEntriesXApplicationsXSets>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdEntriesXApplicationsXSetsSort = {
  field: AdEntriesXApplicationsXSetsSortEnum;
  order: SortInput;
};

export enum AdEntriesXApplicationsXSetsSortEnum {
  Id = 'id'
}

export type AdEntryType = {
  __typename?: 'AdEntryType';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<CountryEnum>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  otherState?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<StateEnum>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
  webPassword?: Maybe<Scalars['String']['output']>;
  webUserId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryEnumId?: InputMaybe<Scalars['Int']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax2?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  otherState?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
  stateEnumId?: InputMaybe<Scalars['Int']['input']>;
  webPassword?: InputMaybe<Scalars['String']['input']>;
  webUserId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type AddressSearchItem = {
  __typename?: 'AddressSearchItem';
  city?: Maybe<Scalars['String']['output']>;
  count?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
};

export type AdvComparison = {
  __typename?: 'AdvComparison';
  items: Array<AdvItemComparison>;
  previous: AdvFilingSummary;
  recent: AdvFilingSummary;
};

export type AdvFilingSummary = {
  __typename?: 'AdvFilingSummary';
  crd: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  filingDate: Scalars['Date']['output'];
};

export type AdvItemComparison = {
  __typename?: 'AdvItemComparison';
  changes: Array<Scalars['String']['output']>;
  item: Scalars['String']['output'];
  summary: Scalars['String']['output'];
};

/** The review of a firm's latest Form ADV Part 1. While the review is being generated, `task` is set and `answers` is empty. */
export type AdvReview = {
  __typename?: 'AdvReview';
  answers: Array<AdvReviewAnswer>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Form ADV Part 1 reviewed */
  documentId?: Maybe<Scalars['Int']['output']>;
  filingDate?: Maybe<Scalars['Date']['output']>;
  task?: Maybe<AsyncTaskStatus>;
};

export type AdvReviewAnswer = {
  __typename?: 'AdvReviewAnswer';
  answer: Scalars['String']['output'];
  /** The ADV item the answer was read from; null for page-1 metadata */
  item?: Maybe<Scalars['String']['output']>;
  notFound: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
};

export type AdvSummaryEmailNotification = {
  __typename?: 'AdvSummaryEmailNotification';
  documentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  legacySkipped?: Maybe<Scalars['Boolean']['output']>;
  notifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AdvSummaryEmailNotificationBulkInput = {
  documentIds: Array<Scalars['Int']['input']>;
  legacySkipped?: InputMaybe<Scalars['Boolean']['input']>;
  notifiedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdvisorTypeEnum = {
  __typename?: 'AdvisorTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AdvisorTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type AdvisorTypeEnumList = {
  __typename?: 'AdvisorTypeEnumList';
  items: Array<AdvisorTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AdvisorTypeEnumSort = {
  field: AdvisorTypeEnumSortEnum;
  order: SortInput;
};

export enum AdvisorTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AfsExtraction = {
  __typename?: 'AfsExtraction';
  administrator?: Maybe<Scalars['String']['output']>;
  affiliatedFunds?: Maybe<Scalars['String']['output']>;
  auditOpinionType?: Maybe<Scalars['String']['output']>;
  auditingStandards?: Maybe<Scalars['String']['output']>;
  auditorLocation?: Maybe<Scalars['String']['output']>;
  auditorName?: Maybe<Scalars['String']['output']>;
  basisOfAccountingFramework?: Maybe<Scalars['String']['output']>;
  capitalContributions?: Maybe<Scalars['Float']['output']>;
  capitalDistributions?: Maybe<Scalars['Float']['output']>;
  cash?: Maybe<Scalars['Float']['output']>;
  changeInAccruedIncentiveAllocation?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  custodians?: Maybe<Scalars['String']['output']>;
  dateOfAuditOpinion?: Maybe<Scalars['DateTime']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  domicile?: Maybe<Scalars['String']['output']>;
  emphasisOfMatter?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  extensionPeriod?: Maybe<Scalars['String']['output']>;
  fieldSources?: Maybe<Scalars['JSON']['output']>;
  fundInceptionDate?: Maybe<Scalars['DateTime']['output']>;
  fundLegalName?: Maybe<Scalars['String']['output']>;
  fundTerminationDate?: Maybe<Scalars['String']['output']>;
  holdings: Array<AfsHolding>;
  id: Scalars['Int']['output'];
  incentiveMechanics?: Maybe<Scalars['String']['output']>;
  interestExpense?: Maybe<Scalars['Float']['output']>;
  investmentAdvisor?: Maybe<Scalars['String']['output']>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  investmentInMasterFund?: Maybe<Scalars['Float']['output']>;
  investmentRelatedExpensesExcludingInterest?: Maybe<Scalars['Float']['output']>;
  investmentUnfunded?: Maybe<Scalars['Float']['output']>;
  investmentsCostTotal?: Maybe<Scalars['Float']['output']>;
  investorCommitments?: Maybe<Scalars['String']['output']>;
  investorUnfunded?: Maybe<Scalars['Float']['output']>;
  irr?: Maybe<Scalars['String']['output']>;
  largestPosition?: Maybe<Scalars['String']['output']>;
  largestPositionFairValue?: Maybe<Scalars['Float']['output']>;
  largestPositionType?: Maybe<Scalars['String']['output']>;
  legalForm?: Maybe<Scalars['String']['output']>;
  level1AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level1LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level1NavAmount?: Maybe<Scalars['Float']['output']>;
  level2AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level2LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level2NavAmount?: Maybe<Scalars['Float']['output']>;
  level3AssetsAmount?: Maybe<Scalars['Float']['output']>;
  level3LiabilitiesAmount?: Maybe<Scalars['Float']['output']>;
  level3NavAmount?: Maybe<Scalars['Float']['output']>;
  liquidationBasisOfAccounting?: Maybe<Scalars['Boolean']['output']>;
  liquidityTerms?: Maybe<Scalars['String']['output']>;
  managementFeeBase?: Maybe<Scalars['String']['output']>;
  managementFeeRate?: Maybe<Scalars['String']['output']>;
  managementFeesExpense?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  netAssets?: Maybe<Scalars['Float']['output']>;
  netIncreaseInPartnersCapitalFromOperations?: Maybe<Scalars['Float']['output']>;
  oddReview?: Maybe<AfsOddReview>;
  openingNetAssetValue?: Maybe<Scalars['Float']['output']>;
  performanceFee?: Maybe<Scalars['Float']['output']>;
  performanceFeeRate?: Maybe<Scalars['String']['output']>;
  periodEndDate?: Maybe<Scalars['DateTime']['output']>;
  presentationCurrency?: Maybe<Scalars['String']['output']>;
  presentationScalingFactor?: Maybe<Scalars['Int']['output']>;
  primeBrokers?: Maybe<Scalars['String']['output']>;
  shareClasses?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  strategy?: Maybe<Scalars['String']['output']>;
  subsequentEvents?: Maybe<Scalars['String']['output']>;
  totalAssets?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatio?: Maybe<Scalars['String']['output']>;
  totalExpenses?: Maybe<Scalars['Float']['output']>;
  totalInvestmentIncome?: Maybe<Scalars['Float']['output']>;
  totalInvestmentsAtFairValue?: Maybe<Scalars['Float']['output']>;
  totalLiabilities?: Maybe<Scalars['Float']['output']>;
  totalReturnRatioNet?: Maybe<Scalars['String']['output']>;
};

export type AfsHolding = {
  __typename?: 'AfsHolding';
  afsExtractionId: Scalars['Int']['output'];
  afsSecurityMappingId?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  fairValue?: Maybe<Scalars['Float']['output']>;
  holdingName: Scalars['String']['output'];
  holdingType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  netAssetsOrPartnersCapital?: Maybe<Scalars['Float']['output']>;
  percentageOfNav?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['DateTime']['output']>;
  securityMapping?: Maybe<AfsSecurityMapping>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
};

export type AfsHoldingList = {
  __typename?: 'AfsHoldingList';
  items: Array<AfsHolding>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum AfsHoldingSortEnum {
  FairValue = 'fairValue',
  HoldingName = 'holdingName',
  HoldingType = 'holdingType',
  PercentageOfNav = 'percentageOfNav'
}

export type AfsHoldingSortInput = {
  field: AfsHoldingSortEnum;
  order: SortInput;
};

export type AfsOddReview = {
  __typename?: 'AfsOddReview';
  afsExtractionId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  level1Amount?: Maybe<Scalars['Float']['output']>;
  level2Amount?: Maybe<Scalars['Float']['output']>;
  level3Amount?: Maybe<Scalars['Float']['output']>;
  level3SharePct?: Maybe<Scalars['Float']['output']>;
  leverageRatio?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nonInvestmentExpenseRatioCommitments?: Maybe<Scalars['Float']['output']>;
  nonInvestmentExpenseRatioNav?: Maybe<Scalars['Float']['output']>;
  nonInvestmentExpenses?: Maybe<Scalars['Float']['output']>;
  oddNetAssets?: Maybe<Scalars['Float']['output']>;
  oddTotalAssets?: Maybe<Scalars['Float']['output']>;
  oddTotalExpenses?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatioCommitments?: Maybe<Scalars['Float']['output']>;
  totalExpenseRatioNav?: Maybe<Scalars['Float']['output']>;
  totalInvestment?: Maybe<Scalars['Float']['output']>;
};

export type AfsSecurityMapping = {
  __typename?: 'AfsSecurityMapping';
  confidence: Scalars['Float']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  identifierType?: Maybe<Scalars['String']['output']>;
  identifierValue?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  llmReasoning?: Maybe<Scalars['String']['output']>;
  manuallyVerified: Scalars['Boolean']['output'];
  matchCriteriaHash?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  rawName: Scalars['String']['output'];
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  securityMasterName?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  suggestedSecurityMasterId?: Maybe<Scalars['Int']['output']>;
  suggestedSecurityMasterName?: Maybe<Scalars['String']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Agency = {
  __typename?: 'Agency';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type AgencyFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AgencyList = {
  __typename?: 'AgencyList';
  items: Array<Agency>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AgencySort = {
  field: AgencySortEnum;
  order: SortInput;
};

export enum AgencySortEnum {
  Id = 'id',
  Name = 'name',
  ShortName = 'shortName'
}

export type AggregatedHoldingResult = {
  __typename?: 'AggregatedHoldingResult';
  allMapped: Scalars['Boolean']['output'];
  fundCount: Scalars['Int']['output'];
  funds: Array<FundHoldingDetail>;
  /** Stable row key: 'sm:{id}' for mapped, 'unmapped:{holdingId}' for unmapped */
  groupKey: Scalars['String']['output'];
  hasSignificantExposure: Scalars['Boolean']['output'];
  holdingName: Scalars['String']['output'];
  holdingType?: Maybe<Scalars['String']['output']>;
  latestPeriodEndDate?: Maybe<Scalars['String']['output']>;
  /** Predominant match type: 'aiMatched', 'proxy', 'manual', 'mixed', or null */
  matchType?: Maybe<Scalars['String']['output']>;
  /** totalLookthroughValue / totalPortfolioValue * 100 */
  portfolioWeightPct?: Maybe<Scalars['Float']['output']>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  totalFairValue: Scalars['Float']['output'];
  /** Sum of look-through values across funds */
  totalLookthroughValue: Scalars['Float']['output'];
};

export enum AlignValue {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type AllocationInput = {
  analysisDate: Scalars['DateTime']['input'];
  benchmarkName?: InputMaybe<Scalars['String']['input']>;
  benchmarks: Array<BenchmarkWeightInput>;
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  excludeCash: Scalars['Boolean']['input'];
  quarterly: Scalars['Boolean']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tagType: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};

export type Application = {
  __typename?: 'Application';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ApplicationFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationFlagFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationFlagList = {
  __typename?: 'ApplicationFlagList';
  items: Array<ApplicationFlags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ApplicationFlagSort = {
  field: ApplicationFlagSortEnum;
  order: SortInput;
};

export enum ApplicationFlagSortEnum {
  Id = 'id'
}

export type ApplicationFlags = {
  __typename?: 'ApplicationFlags';
  applicationId: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ApplicationList = {
  __typename?: 'ApplicationList';
  items: Array<Application>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ApplicationSort = {
  field: ApplicationSortEnum;
  order: SortInput;
};

export enum ApplicationSortEnum {
  Id = 'id'
}

export type AssetClass2Enum = {
  __typename?: 'AssetClass2Enum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  market: AssetClassEnum;
  marketId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssetClass2EnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AssetClass2EnumList = {
  __typename?: 'AssetClass2EnumList';
  items: Array<AssetClass2Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AssetClass2EnumSort = {
  field: AssetClass2EnumSortEnum;
  order: SortInput;
};

export enum AssetClass2EnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type AssetClassEnum = {
  __typename?: 'AssetClassEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AssetClassEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AssetClassEnumList = {
  __typename?: 'AssetClassEnumList';
  items: Array<AssetClassEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AssetClassEnumSort = {
  field: AssetClassEnumSortEnum;
  order: SortInput;
};

export enum AssetClassEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type AssetClassStrategy = {
  assetClass?: InputMaybe<Array<EntityKey>>;
  strategy?: InputMaybe<Array<EntityKey>>;
  subStrategy?: InputMaybe<Array<EntityKey>>;
};

export type AssetClassStrategyFilter = {
  values: Array<AssetClassStrategy>;
};

export type AssumeUserInput = {
  assumedUserId?: InputMaybe<Scalars['Int']['input']>;
};

export type AsyncTaskStatus = {
  __typename?: 'AsyncTaskStatus';
  createUser: Scalars['String']['output'];
  endDate?: Maybe<Scalars['DateTime']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  jsonResult?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  timestamp: Scalars['Timestamp']['output'];
};

export type AsyncTaskStatusInput = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AuditContactTypeEnum = {
  __typename?: 'AuditContactTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type AuditContactTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AuditContactTypeEnumList = {
  __typename?: 'AuditContactTypeEnumList';
  items: Array<AuditContactTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AuditContactTypeEnumSort = {
  field: AuditContactTypeEnumSortEnum;
  order: SortInput;
};

export enum AuditContactTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AumEntry = {
  asOfDate: Scalars['DateTime']['input'];
  firmAUM?: InputMaybe<Scalars['Float']['input']>;
  investmentAUM?: InputMaybe<Scalars['Float']['input']>;
  strategyAUM?: InputMaybe<Scalars['Float']['input']>;
};

export type AumFlow = {
  __typename?: 'AumFlow';
  investment?: Maybe<Scalars['Float']['output']>;
  strategy?: Maybe<Scalars['Float']['output']>;
};

export type AumRecord = {
  __typename?: 'AumRecord';
  asOfDate: Scalars['DateTime']['output'];
  aum?: Maybe<Scalars['Float']['output']>;
};

export type AxysCode = {
  __typename?: 'AxysCode';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type AxysCodeFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type AxysCodeList = {
  __typename?: 'AxysCodeList';
  items: Array<AxysCode>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type AxysCodeSort = {
  field: AxysCodeSortEnum;
  order: SortInput;
};

export enum AxysCodeSortEnum {
  Code = 'code',
  Id = 'id'
}

export type Balances = {
  __typename?: 'Balances';
  acctManager?: Maybe<AccountingManager>;
  additions: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  endBalance: Scalars['Float']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  performance: Scalars['Float']['output'];
  portfolio?: Maybe<Portfolio>;
  portfolioId: Scalars['Int']['output'];
  redemptions: Scalars['Float']['output'];
  redemptionsSource?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<ManagerTags>;
};

export type BalancesFilter = {
  includeAccountingEntities?: InputMaybe<Scalars['Boolean']['input']>;
  managerAttributeName?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['Int']['input']>;
  modelStartDate?: InputMaybe<Scalars['Date']['input']>;
  modelStopDate?: InputMaybe<Scalars['Date']['input']>;
  performanceStart?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type BalancesList = {
  __typename?: 'BalancesList';
  items: Array<Balances>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type BalancesSort = {
  field: BalancesSortEnum;
  order: SortInput;
};

export enum BalancesSortEnum {
  Date = 'date',
  ManagerId = 'managerId',
  PortfolioId = 'portfolioId'
}

export type BatchReportSectionInput = {
  extractorPrompt?: InputMaybe<Scalars['String']['input']>;
  knowledgeBaseFilter?: InputMaybe<KnowledgeBaseFilter>;
  name: Scalars['String']['input'];
  reportPrompt?: InputMaybe<Scalars['String']['input']>;
  savedKnowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
};

export type BatchReportsInput = {
  additionalRecipients?: InputMaybe<Array<Scalars['String']['input']>>;
  consolidationPrompt?: InputMaybe<Scalars['String']['input']>;
  sections: Array<BatchReportSectionInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type BbgContainsDistribution = {
  __typename?: 'BbgContainsDistribution';
  _id: Scalars['String']['output'];
  _type: Scalars['String']['output'];
  accessible: Scalars['Boolean']['output'];
  contentType: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
};

export type BbgDistributionsResponse = {
  __typename?: 'BbgDistributionsResponse';
  _type: Scalars['JSON']['output'];
  contains?: Maybe<Array<BbgContainsDistribution>>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  error_description?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['JSONObject']['output']>>;
  identifier?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type BenchmarkData = {
  __typename?: 'BenchmarkData';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  records: Array<TimeSeriesRecord>;
};

export type BenchmarkTimeSeries = {
  __typename?: 'BenchmarkTimeSeries';
  benchmarks: Array<BenchmarkData>;
  root: Array<TimeSeriesRecord>;
};

export type BenchmarkWeightInput = {
  benchmarkId: Scalars['Int']['input'];
  weight: Scalars['Float']['input'];
};

export type BloombergPullLoadInput = {
  currency: Scalars['String']['input'];
  dailyId: Scalars['String']['input'];
  monthlyId: Scalars['String']['input'];
};

export type BloombergPullResponse = {
  __typename?: 'BloombergPullResponse';
  currency: Scalars['String']['output'];
  dailyId: Scalars['String']['output'];
  monthlyId: Scalars['String']['output'];
  tickers: Array<Scalars['String']['output']>;
};

export type BucketFileInput = {
  bucket: Scalars['String']['input'];
  copyAccount: Scalars['String']['input'];
  digest?: InputMaybe<Scalars['String']['input']>;
  filename: Scalars['String']['input'];
  sourceKey: Scalars['String']['input'];
};

export type BulkPersonProfileBuilderResponse = {
  __typename?: 'BulkPersonProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  personProfiles?: Maybe<Array<GeneratedPersonProfile>>;
};

export enum BusinessObject {
  Company = 'company',
  Firm = 'firm',
  Investment = 'investment'
}

export type BusinessObjectEnum = {
  __typename?: 'BusinessObjectEnum';
  description: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type BusinessObjectEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type BusinessObjectEnumList = {
  __typename?: 'BusinessObjectEnumList';
  items: Array<BusinessObjectEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type BusinessObjectEnumSort = {
  field: BusinessObjectEnumSortEnum;
  order: SortInput;
};

export enum BusinessObjectEnumSortEnum {
  Id = 'id'
}

export type CalendarUnitEnum = {
  __typename?: 'CalendarUnitEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CalendarUnitEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CalendarUnitEnumList = {
  __typename?: 'CalendarUnitEnumList';
  items: Array<CalendarUnitEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CalendarUnitEnumSort = {
  field: CalendarUnitEnumSortEnum;
  order: SortInput;
};

export enum CalendarUnitEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export enum CaseStudyAssetType {
  Private = 'private',
  Public = 'public'
}

export type Chart = {
  __typename?: 'Chart';
  url: Scalars['String']['output'];
};

/** High chart types */
export enum ChartType {
  Chart = 'Chart',
  StockChart = 'StockChart'
}

export type ChatAgent = {
  __typename?: 'ChatAgent';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  defaultMode: ChatAgentRunMode;
  description: Scalars['String']['output'];
  directive: Scalars['String']['output'];
  effort?: Maybe<ChatEffort>;
  id: Scalars['Int']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  requiredFlag?: Maybe<Scalars['String']['output']>;
  scope: ChatSkillScope;
  skills: Array<ChatSkill>;
  tools?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['Int']['output'];
};

export type ChatAgentCapabilities = {
  __typename?: 'ChatAgentCapabilities';
  allowedColors: Array<Scalars['String']['output']>;
  allowedEfforts: Array<ChatEffort>;
  allowedModels: Array<Scalars['String']['output']>;
  blockedTools: Array<ChatToolType>;
  mcpToolBundles: Array<McpToolBundleType>;
  mcpToolCategories: Array<McpToolBundleType>;
  notOfferedToAgents: Array<McpToolBundleType>;
};

export type ChatAgentFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatAgentHistory = {
  __typename?: 'ChatAgentHistory';
  archivedAt: Scalars['DateTime']['output'];
  archivedBy: Scalars['String']['output'];
  chatAgentId: Scalars['Int']['output'];
  defaultMode: ChatAgentRunMode;
  description: Scalars['String']['output'];
  directive: Scalars['String']['output'];
  effort?: Maybe<ChatEffort>;
  id: Scalars['Int']['output'];
  isAutoInvocable?: Maybe<Scalars['Boolean']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  scope: ChatSkillScope;
  skills?: Maybe<Scalars['JSON']['output']>;
  tools?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['Int']['output'];
};

export type ChatAgentInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultMode?: ChatAgentRunMode;
  description: Scalars['String']['input'];
  directive: Scalars['String']['input'];
  effort?: InputMaybe<ChatEffort>;
  isAutoInvocable?: Scalars['Boolean']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: ChatSkillScope;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatAgentList = {
  __typename?: 'ChatAgentList';
  items: Array<ChatAgent>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

/** Whether a spawned agent's conversation is discarded or kept for resumption */
export enum ChatAgentRunMode {
  Ephemeral = 'EPHEMERAL',
  Persistent = 'PERSISTENT'
}

export type ChatAgentSort = {
  field: ChatAgentSortEnum;
  order: SortInput;
};

export enum ChatAgentSortEnum {
  Createdate = 'createdate',
  Modifydate = 'modifydate',
  Name = 'name',
  Scope = 'scope'
}

export type ChatAgentUpdateInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  defaultMode?: InputMaybe<ChatAgentRunMode>;
  description?: InputMaybe<Scalars['String']['input']>;
  directive?: InputMaybe<Scalars['String']['input']>;
  effort?: InputMaybe<ChatEffort>;
  isAutoInvocable?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tools?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ChatContext = {
  documentId?: InputMaybe<Scalars['Int']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<ChatEntityType>;
  files?: InputMaybe<Array<ChatContextFile>>;
  knowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
  pageContext?: InputMaybe<PageContext>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatContextFile = {
  bucket: Scalars['String']['input'];
  documentId?: InputMaybe<Scalars['Int']['input']>;
  documentQueueId?: InputMaybe<Scalars['ID']['input']>;
  fileUrl: Scalars['String']['input'];
  key: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum ChatEffort {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  XHigh = 'XHigh'
}

export enum ChatEntityType {
  Company = 'company',
  Engagement = 'engagement',
  Firm = 'firm',
  Investment = 'investment'
}

export type ChatPreferences = {
  __typename?: 'ChatPreferences';
  enabled: Scalars['Boolean']['output'];
  lastUpdated?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['String']['output']>;
};

export type ChatPreferencesInput = {
  enabled: Scalars['Boolean']['input'];
  lastUpdated?: InputMaybe<Scalars['String']['input']>;
  preferences?: InputMaybe<Scalars['String']['input']>;
};

export type ChatSkill = {
  __typename?: 'ChatSkill';
  canDelete: Scalars['Boolean']['output'];
  canEdit: Scalars['Boolean']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  requiredFlag?: Maybe<Scalars['String']['output']>;
  scope: ChatSkillScope;
  version: Scalars['Int']['output'];
};

export type ChatSkillFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatSkillGrantableGroup = {
  __typename?: 'ChatSkillGrantableGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ChatSkillGroup = {
  __typename?: 'ChatSkillGroup';
  access: ChatSkillGroupAccess;
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  groupId: Scalars['Int']['output'];
  groupName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

/** Access level a group grant confers on a chat skill */
export enum ChatSkillGroupAccess {
  Write = 'WRITE'
}

export type ChatSkillHistory = {
  __typename?: 'ChatSkillHistory';
  archivedAt: Scalars['DateTime']['output'];
  archivedBy: Scalars['String']['output'];
  archivedByFullName?: Maybe<Scalars['String']['output']>;
  chatSkillId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  instructions: Scalars['String']['output'];
  isAutoInvocable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  scope: ChatSkillScope;
  version: Scalars['Int']['output'];
};

export type ChatSkillInput = {
  description: Scalars['String']['input'];
  instructions: Scalars['String']['input'];
  isAutoInvocable?: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: ChatSkillScope;
};

export type ChatSkillList = {
  __typename?: 'ChatSkillList';
  items: Array<ChatSkill>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ChatSkillSchedule = {
  __typename?: 'ChatSkillSchedule';
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  extraInstructions?: Maybe<Scalars['String']['output']>;
  frequency: ChatSkillScheduleFrequency;
  id: Scalars['Int']['output'];
  lastConversationId?: Maybe<Scalars['Int']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunStatus?: Maybe<ChatSkillScheduleRunStatus>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nextRunAt: Scalars['DateTime']['output'];
  runAtHour: Scalars['Int']['output'];
  runAtMinute: Scalars['Int']['output'];
  runOnDayOfMonth?: Maybe<Scalars['Int']['output']>;
  runOnWeekday?: Maybe<Scalars['Int']['output']>;
  timezone: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type ChatSkillScheduleFilter = {
  chatSkillId?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum ChatSkillScheduleFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekdays = 'WEEKDAYS',
  Weekly = 'WEEKLY'
}

export type ChatSkillScheduleInput = {
  chatSkillId: Scalars['Int']['input'];
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  extraInstructions?: InputMaybe<Scalars['String']['input']>;
  frequency: ChatSkillScheduleFrequency;
  runAtHour: Scalars['Int']['input'];
  runAtMinute?: InputMaybe<Scalars['Int']['input']>;
  runOnDayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  runOnWeekday?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ChatSkillScheduleList = {
  __typename?: 'ChatSkillScheduleList';
  items: Array<ChatSkillSchedule>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum ChatSkillScheduleRunStatus {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

export type ChatSkillScheduleSort = {
  field: ChatSkillScheduleSortEnum;
  order: SortInput;
};

export enum ChatSkillScheduleSortEnum {
  Createdate = 'createdate',
  Id = 'id',
  NextRunAt = 'nextRunAt'
}

/** Scope determines who can access the skill */
export enum ChatSkillScope {
  Organization = 'ORGANIZATION',
  Personal = 'PERSONAL',
  System = 'SYSTEM'
}

export type ChatSkillSort = {
  field: ChatSkillSortEnum;
  order: SortInput;
};

export enum ChatSkillSortEnum {
  Createdate = 'createdate',
  Modifydate = 'modifydate',
  Name = 'name',
  Scope = 'scope'
}

export type ChatSkillUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  isAutoInvocable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredFlag?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<ChatSkillScope>;
};

export type ChatSubscriptionPayload = {
  __typename?: 'ChatSubscriptionPayload';
  error?: Maybe<Scalars['Boolean']['output']>;
  messageStream: MessageStream;
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
};

export type ChatTaskFinishedPayload = {
  __typename?: 'ChatTaskFinishedPayload';
  /** The file saved to the conversation, when the task produced one and saving it worked. */
  conversationArtifactId?: Maybe<Scalars['Int']['output']>;
  conversationId: Scalars['Int']['output'];
  taskId: Scalars['String']['output'];
};

export enum ChatToolType {
  ActivateSkillTool = 'ActivateSkillTool',
  AlphaVantageMcp = 'AlphaVantageMcp',
  AtlasTool = 'AtlasTool',
  CalculatorTool = 'CalculatorTool',
  ChartTool = 'ChartTool',
  CitationTool = 'CitationTool',
  CsvExportTool = 'CsvExportTool',
  CurrentPageTool = 'CurrentPageTool',
  DocumentTextReaderTool = 'DocumentTextReaderTool',
  DocumentsRagTool = 'DocumentsRagTool',
  FeedbackTool = 'FeedbackTool',
  ModifyMutationPlanTool = 'ModifyMutationPlanTool',
  NotesRagTool = 'NotesRagTool',
  ScratchpadTool = 'ScratchpadTool',
  SiriusMcp = 'SiriusMcp',
  SpawnSubAgentTool = 'SpawnSubAgentTool',
  SpreadsheetReaderTool = 'SpreadsheetReaderTool',
  StageMutationsTool = 'StageMutationsTool',
  UpdatePreferencesTool = 'UpdatePreferencesTool'
}

export type Citation = {
  __typename?: 'Citation';
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type CitationInput = {
  id: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

export type ClearSettingInput = {
  clearSettingKey: ClearSettingKey;
  userId: Scalars['Int']['input'];
};

export enum ClearSettingKey {
  ChatPreferences = 'chatPreferences',
  DefaultInvestmentView = 'defaultInvestmentView'
}

export type Client = {
  __typename?: 'Client';
  clientName?: Maybe<Scalars['String']['output']>;
  clientType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
};

/** One month of a share class's allocation (AllocationsNew), with what was ENTERED for the month beside what was computed. Returns and fee rates are in PERCENT (1.25 = 1.25%). */
export type ClientAllocationRow = {
  __typename?: 'ClientAllocationRow';
  actGrossEndBal?: Maybe<Scalars['Float']['output']>;
  actGrossReturn?: Maybe<Scalars['Float']['output']>;
  actNetEndBal?: Maybe<Scalars['Float']['output']>;
  actNetReturn?: Maybe<Scalars['Float']['output']>;
  addition?: Maybe<Scalars['Float']['output']>;
  adjBegBal?: Maybe<Scalars['Float']['output']>;
  adminFee?: Maybe<Scalars['Float']['output']>;
  adminFeeRate?: Maybe<Scalars['Float']['output']>;
  begBal: Scalars['Float']['output'];
  clientId: Scalars['Int']['output'];
  clientName: Scalars['String']['output'];
  date: Scalars['Date']['output'];
  /** Derived inputs: not editable. */
  derived?: Maybe<Scalars['Boolean']['output']>;
  effGrossReturn?: Maybe<Scalars['Float']['output']>;
  effNetReturn?: Maybe<Scalars['Float']['output']>;
  enteredAdminFee?: Maybe<Scalars['Float']['output']>;
  enteredIncentiveFee?: Maybe<Scalars['Float']['output']>;
  /** Fees as entered for the month (null: calculated). */
  enteredMgmtFee?: Maybe<Scalars['Float']['output']>;
  estGrossEndBal?: Maybe<Scalars['Float']['output']>;
  estGrossReturn?: Maybe<Scalars['Float']['output']>;
  estNetEndBal?: Maybe<Scalars['Float']['output']>;
  estNetReturn?: Maybe<Scalars['Float']['output']>;
  finalGrossReturn?: Maybe<Scalars['Float']['output']>;
  finalNetReturn?: Maybe<Scalars['Float']['output']>;
  grossEndBal?: Maybe<Scalars['Float']['output']>;
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  /** Entered, else calculated from the fee schedule. */
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeRate?: Maybe<Scalars['Float']['output']>;
  netEndBal?: Maybe<Scalars['Float']['output']>;
  pl?: Maybe<Scalars['Float']['output']>;
  rcgFundId: Scalars['Int']['output'];
  rcgFundName: Scalars['String']['output'];
  redemption?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
  shareClassName: Scalars['String']['output'];
  switchIn?: Maybe<Scalars['Float']['output']>;
  switchOut?: Maybe<Scalars['Float']['output']>;
};

/** A share class's capital changes for a month (vCashFlowsAndSwitches): redemptions and switch-outs are negative. */
export type ClientCapitalFlowRow = {
  __typename?: 'ClientCapitalFlowRow';
  addition?: Maybe<Scalars['Float']['output']>;
  date: Scalars['Date']['output'];
  redemption?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
  switchIn?: Maybe<Scalars['Float']['output']>;
  switchOut?: Maybe<Scalars['Float']['output']>;
};

export type ClientDocumentNotificationStatus = {
  __typename?: 'ClientDocumentNotificationStatus';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** A fee option (FeeAUMOptionEnum, FeeRateOptionEnum or FeeUnitOptionEnum). */
export type ClientFeeOption = {
  __typename?: 'ClientFeeOption';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export type ClientFeeOptions = {
  __typename?: 'ClientFeeOptions';
  /** The balance a fee is charged on. */
  aum?: Maybe<Array<ClientFeeOption>>;
  /** How an annual rate becomes monthly. */
  rate?: Maybe<Array<ClientFeeOption>>;
  /** Percentage of the balance, or dollars. */
  unit?: Maybe<Array<ClientFeeOption>>;
};

export type ClientFeeTierInput = {
  isFlat: Scalars['Boolean']['input'];
  rate: Scalars['Float']['input'];
  threshold: Scalars['Float']['input'];
};

/** One band of a fee schedule. rate is annual, as entered: percent for a percentage unit, else dollars. */
export type ClientFeeTierRow = {
  __typename?: 'ClientFeeTierRow';
  isFlat: Scalars['Boolean']['output'];
  rate: Scalars['Float']['output'];
  threshold: Scalars['Float']['output'];
};

export type ClientFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ClientInvestmentClient = {
  __typename?: 'ClientInvestmentClient';
  clientId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** An RCG fund clients can hold share classes in (the legacy vRcgFunds2). */
export type ClientInvestmentFund = {
  __typename?: 'ClientInvestmentFund';
  /** Groups funds for multi-fund pages: investment structure, else NAV classification. */
  groupId?: Maybe<Scalars['Int']['output']>;
  groupName: Scalars['String']['output'];
  /** A combined fund: its one share class is the sum of its child funds'. */
  isCombined?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rcgFundId: Scalars['Int']['output'];
};

export type ClientList = {
  __typename?: 'ClientList';
  items: Array<Client>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

/** One share class's month-end entries: null clears a value, an omitted field is left as it is. */
export type ClientMonthEntryInput = {
  actualEndBal?: InputMaybe<Scalars['Float']['input']>;
  adminFee?: InputMaybe<Scalars['Float']['input']>;
  /** Percent (1.25 = 1.25%). */
  finalGrossReturn?: InputMaybe<Scalars['Float']['input']>;
  /** Percent (1.25 = 1.25%). */
  finalNetReturn?: InputMaybe<Scalars['Float']['input']>;
  /** Performance (incentive) fee. */
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  mgmtFee?: InputMaybe<Scalars['Float']['input']>;
  shareClassId: Scalars['Int']['input'];
};

export type ClientShareClassInput = {
  adminTiers: Array<ClientFeeTierInput>;
  clientId: Scalars['Int']['input'];
  feeAumOptionId: Scalars['Int']['input'];
  feeRateOptionId: Scalars['Int']['input'];
  feeUnitOptionId: Scalars['Int']['input'];
  mgmtTiers: Array<ClientFeeTierInput>;
  name: Scalars['String']['input'];
  rcgFundId: Scalars['Int']['input'];
  /** Set to edit (and possibly rename) an existing share class. */
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
  unfunded: Scalars['Boolean']['input'];
};

/** A client's share class in an RCG fund, with its fee terms. */
export type ClientShareClassRow = {
  __typename?: 'ClientShareClassRow';
  adminTiers: Array<ClientFeeTierRow>;
  clientId: Scalars['Int']['output'];
  /** No flows, switches, balances or allocations refer to it. */
  deletable?: Maybe<Scalars['Boolean']['output']>;
  /** Its flows, balances and fees are derived from other share classes (a combined fund's, or 1875), not entered. */
  derived?: Maybe<Scalars['Boolean']['output']>;
  feeAumOptionId: Scalars['Int']['output'];
  feeRateOptionId: Scalars['Int']['output'];
  feeUnitOptionId: Scalars['Int']['output'];
  mgmtTiers: Array<ClientFeeTierRow>;
  name: Scalars['String']['output'];
  rcgFundId: Scalars['Int']['output'];
  shareClassId: Scalars['Int']['output'];
  /** Committed capital: returns are not applied. */
  unfunded?: Maybe<Scalars['Boolean']['output']>;
};

export type ClientSort = {
  field: ClientSortEnum;
  order: SortInput;
};

export enum ClientSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

/** A transfer between two share classes in a month, as entered (positive). */
export type ClientSwitchRow = {
  __typename?: 'ClientSwitchRow';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  fromShareClassId: Scalars['Int']['output'];
  toShareClassId: Scalars['Int']['output'];
};

export enum ClientVisibleTabs {
  Analytics = 'analytics',
  Documents = 'documents',
  Investment = 'investment',
  Overview = 'overview',
  OverviewGeneral = 'overviewGeneral',
  OverviewPerformance = 'overviewPerformance',
  OverviewPorfolio = 'overviewPorfolio',
  OverviewServiceProviders = 'overviewServiceProviders'
}

export type CloseDateFundSize = {
  __typename?: 'CloseDateFundSize';
  closeDate: Scalars['Date']['output'];
  fundSize: Scalars['Float']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  peCloseDateFundSizeId: Scalars['Int']['output'];
};

export type CloseDateShort = {
  closeDate?: InputMaybe<Scalars['Date']['input']>;
  fundSize?: InputMaybe<Scalars['Float']['input']>;
};

export type CogencyLink = {
  __typename?: 'CogencyLink';
  adminBookType: Scalars['Int']['output'];
  cogFinal?: Maybe<Scalars['Boolean']['output']>;
  cogFirstMonthAdjust?: Maybe<Scalars['Boolean']['output']>;
  cogStartDate?: Maybe<Scalars['Date']['output']>;
  cogencyId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investment: Investment;
  isInactive: Scalars['Boolean']['output'];
  isLiquidating: Scalars['Boolean']['output'];
  solovisDataEnabled: Scalars['Boolean']['output'];
  solovisTranStartDate?: Maybe<Scalars['Date']['output']>;
};

export type CogencyLinkInput = {
  cogFinal?: InputMaybe<Scalars['Boolean']['input']>;
  cogFirstMonthAdjust?: InputMaybe<Scalars['Boolean']['input']>;
  cogStartDate?: InputMaybe<Scalars['Date']['input']>;
  cogencyId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  solovisDataEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  solovisTranStartDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Company = {
  __typename?: 'Company';
  applicationCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  companyType?: Maybe<CompanyTypeEnum>;
  companyTypeEnumId?: Maybe<Scalars['ID']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deals: Array<Deal>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  documents: Array<Maybe<Document>>;
  faceOfCompany?: Maybe<FirmEmployment>;
  fieldData: FieldData;
  fieldHistory: Array<Field>;
  fields?: Maybe<CompanyFields>;
  firmAttributes: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isBusinessApplication: Scalars['Boolean']['output'];
  lastFundingType?: Maybe<FundingTypeEnum>;
  lastFundingTypeEnumId?: Maybe<Scalars['ID']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Has RockCreek signed an NDA precluding them from sharing fund data with 3rd Parties? */
  ndaSigned?: Maybe<Scalars['Boolean']['output']>;
  operatingStatus?: Maybe<OperatingStatusEnum>;
  operatingStatusEnumId?: Maybe<Scalars['ID']['output']>;
  primaryAssignment?: Maybe<Scalars['String']['output']>;
  primaryCompanyAdvisor?: Maybe<User>;
  primaryCompanyManager?: Maybe<FirmEmployment>;
  summary?: Maybe<Scalars['String']['output']>;
  templateOptions: Array<Scalars['String']['output']>;
  valuations: Array<CompanyValuation>;
};


export type CompanyDealsArgs = {
  filter?: InputMaybe<DealFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealSort>>;
};


export type CompanyFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type CompanyFieldsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type CompanyTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};


export type CompanyValuationsArgs = {
  filter?: InputMaybe<CompanyValuationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyValuationSort>>;
};

export type CompanyEnum = {
  __typename?: 'CompanyEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CompanyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyEnumList = {
  __typename?: 'CompanyEnumList';
  items: Array<CompanyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyEnumSort = {
  field: CompanyEnumSortEnum;
  order: SortInput;
};

export enum CompanyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type CompanyFields = {
  __typename?: 'CompanyFields';
  companyId: Scalars['ID']['output'];
  companyName?: Maybe<CompanyName>;
  state?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<FieldValue>>;
};

export type CompanyFilter = {
  applicationCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  companyTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  fuzzyMatch?: InputMaybe<Scalars['String']['input']>;
  lastFundingTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  operatingStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  searchFilters?: InputMaybe<CompanySearchFilters>;
};

export type CompanyInput = {
  companyTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  firmAttributes?: InputMaybe<FirmAttributes>;
  lastFundingTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  operatingStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  primaryAssignment?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyList = {
  __typename?: 'CompanyList';
  items: Array<Company>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyName = {
  __typename?: 'CompanyName';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type CompanySearchFilters = {
  COMPANY_ENTITY?: InputMaybe<EntitySearchFilter>;
  HEADQUARTERS?: InputMaybe<LocationFilter>;
  IMPACT?: InputMaybe<ImpactSearchFilter>;
  NAME?: InputMaybe<Scalars['String']['input']>;
  TAG_ENTITY?: InputMaybe<EntitySearchFilter>;
  YEAR_FOUNDED?: InputMaybe<IntRangeFilter>;
};

export type CompanySort = {
  field: CompanySortEnum;
  order: SortInput;
};

export enum CompanySortEnum {
  FuzzyRank = 'fuzzyRank',
  Id = 'id',
  LatestUpdate = 'latestUpdate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type CompanyTypeEnum = {
  __typename?: 'CompanyTypeEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompanyTypeEnumList = {
  __typename?: 'CompanyTypeEnumList';
  items: Array<CompanyTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyTypeEnumSort = {
  field: CompanyTypeEnumSortEnum;
  order: SortInput;
};

export enum CompanyTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type CompanyValuation = {
  __typename?: 'CompanyValuation';
  asOfDate: Scalars['Date']['output'];
  company?: Maybe<Company>;
  companyId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  valuation?: Maybe<Scalars['Float']['output']>;
};

export type CompanyValuationFilter = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyValuationInput = {
  asOfDate: Scalars['Date']['input'];
  companyId: Scalars['Int']['input'];
  valuation?: InputMaybe<Scalars['Float']['input']>;
};

export type CompanyValuationList = {
  __typename?: 'CompanyValuationList';
  items: Array<CompanyValuation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompanyValuationSort = {
  field: CompanyValuationSortEnum;
  order: SortInput;
};

export enum CompanyValuationSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type CompletenessSearchFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  subcategory?: InputMaybe<Scalars['String']['input']>;
};

export type CompoundingPeriodEnum = {
  __typename?: 'CompoundingPeriodEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CompoundingPeriodEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CompoundingPeriodEnumList = {
  __typename?: 'CompoundingPeriodEnumList';
  items: Array<CompoundingPeriodEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CompoundingPeriodEnumSort = {
  field: CompoundingPeriodEnumSortEnum;
  order: SortInput;
};

export enum CompoundingPeriodEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ComputeMetricsResult = {
  __typename?: 'ComputeMetricsResult';
  computed: Scalars['Int']['output'];
  errors: Scalars['Int']['output'];
};

export type ComputePortfolioBenchmarksResponse = {
  __typename?: 'ComputePortfolioBenchmarksResponse';
  csv: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  json: Scalars['JSON']['output'];
};

export type ConsultedExcerpts = {
  __typename?: 'ConsultedExcerpts';
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type ContactTypeEnum = {
  __typename?: 'ContactTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ContactTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ContactTypeEnumList = {
  __typename?: 'ContactTypeEnumList';
  items: Array<ContactTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ContactTypeEnumSort = {
  field: ContactTypeEnumSortEnum;
  order: SortInput;
};

export enum ContactTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Conversation = {
  __typename?: 'Conversation';
  agentId?: Maybe<Scalars['Int']['output']>;
  agentVersion?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUserId?: Maybe<Scalars['Int']['output']>;
  hasMutationPlans?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
  parentConversationId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<ConversationSource>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ConversationArtifact = {
  __typename?: 'ConversationArtifact';
  artifactName: Scalars['String']['output'];
  artifactType: ConversationArtifactType;
  contentType?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  downloadUrl: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
};

export enum ConversationArtifactType {
  Document = 'document',
  Export = 'export',
  Other = 'other',
  SkillOutput = 'skillOutput',
  ToolResult = 'toolResult'
}

export type ConversationHistory = {
  __typename?: 'ConversationHistory';
  answer?: Maybe<Scalars['String']['output']>;
  chatContext?: Maybe<Scalars['String']['output']>;
  conversationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type ConversationList = {
  __typename?: 'ConversationList';
  items: Array<Conversation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum ConversationSource {
  AgentChat = 'agentChat',
  BulkPersonProfileFromFilesBuilder = 'bulkPersonProfileFromFilesBuilder',
  ConversationSummary = 'conversationSummary',
  DocumentChat = 'documentChat',
  DocumentChatSpecific = 'documentChatSpecific',
  InvestmentProfileBuilder = 'investmentProfileBuilder',
  PersonProfileFromFilesBuilder = 'personProfileFromFilesBuilder',
  ScheduledSkillRun = 'scheduledSkillRun',
  ShareClassProfileBuilder = 'shareClassProfileBuilder',
  SiriusChat = 'siriusChat',
  SubAgent = 'subAgent'
}

export type CountryEnum = {
  __typename?: 'CountryEnum';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CountryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type CountryEnumList = {
  __typename?: 'CountryEnumList';
  items: Array<CountryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CountryEnumSort = {
  field: CountryEnumSortEnum;
  order: SortInput;
};

export enum CountryEnumSortEnum {
  Name = 'name'
}

export type CreateFieldDefinitionInput = {
  columns?: InputMaybe<Array<FieldColumnInput>>;
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  fieldKey: Scalars['String']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  ownerType: Scalars['String']['input'];
  questionText?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGuidelineInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  resultCardinality: Scalars['Int']['input'];
  resultType: Scalars['Int']['input'];
};

export type CreateGuidelineNodeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['Int']['input']>;
  siblingIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGuidelineSetInput = {
  copyGuidelines?: InputMaybe<Scalars['Boolean']['input']>;
  effectiveDate: Scalars['DateTime']['input'];
};

export type CreateTemplateAttachmentInput = {
  assetClassName?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  entityLevel: Scalars['String']['input'];
  fieldSetType: FieldSetType;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemplateInput = {
  content: Scalars['JSON']['input'];
  fieldSetGroup: Scalars['String']['input'];
  fieldSetType: FieldSetType;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditUsage = {
  __typename?: 'CreditUsage';
  allotment: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  remaining: Scalars['Float']['output'];
  used: Scalars['Float']['output'];
};

export type CurrencyDenominationEnum = {
  __typename?: 'CurrencyDenominationEnum';
  displayOrder?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  isPerformanceCurrency?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type CurrencyDenominationEnumFilter = {
  convertibleFromCurrency?: InputMaybe<Scalars['String']['input']>;
  isPerformanceCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CurrencyDenominationEnumList = {
  __typename?: 'CurrencyDenominationEnumList';
  items: Array<CurrencyDenominationEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CurrencyDenominationEnumSort = {
  field: CurrencyDenominationEnumSortEnum;
  order: SortInput;
};

export enum CurrencyDenominationEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  access: EntityAccess;
  assumedUserId?: Maybe<Scalars['Int']['output']>;
  commonName: Scalars['String']['output'];
  currentUserId: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  entryType: AdEntryType;
  entryTypeId: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags: UserFlags;
  groupEntityType?: Maybe<GroupEntityType>;
  groupIds?: Maybe<Array<Scalars['Int']['output']>>;
  groups?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  imageType?: Maybe<Scalars['String']['output']>;
  imageTypeSm?: Maybe<Scalars['String']['output']>;
  isAssumed?: Maybe<Scalars['Boolean']['output']>;
  isGroup: Scalars['Boolean']['output'];
  isPrimaryOrganizationGroup?: Maybe<Scalars['Boolean']['output']>;
  isUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  oktaUser?: Maybe<OktaUser>;
  organization: Organization;
  organizationId?: Maybe<Scalars['Int']['output']>;
  pushProfileChanges?: Maybe<Scalars['Boolean']['output']>;
  roleIds: Array<Scalars['Int']['output']>;
  roles: Array<ApplicationFlags>;
  sets?: Maybe<Array<Set>>;
  sub?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
  userName: Scalars['String']['output'];
  userSettings?: Maybe<UserSettings>;
  username?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};

export type CustomAnalytics = {
  __typename?: 'CustomAnalytics';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  digest?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  investment?: Maybe<Investment>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: FieldOwnerType;
  signedUrl?: Maybe<Scalars['String']['output']>;
  value: Scalars['JSON']['output'];
};

export type CustomAnalyticsFilter = {
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<FieldOwnerType>;
};

export type CustomAnalyticsInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<FieldOwnerType>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomAnalyticsList = {
  __typename?: 'CustomAnalyticsList';
  items: Array<CustomAnalytics>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomAnalyticsSort = {
  field: CustomAnalyticsSortEnum;
  order: SortInput;
};

export enum CustomAnalyticsSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  OwnerId = 'ownerId',
  OwnerType = 'ownerType'
}

export type CustomIndexGroup = {
  __typename?: 'CustomIndexGroup';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  geReturnDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  leReturnDate?: Maybe<Scalars['Date']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  outputInvestment: Investment;
  terms: CustomIndexTermList;
};


export type CustomIndexGroupTermsArgs = {
  filter?: InputMaybe<CustomIndexTermFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexTermSort>>;
};

export type CustomIndexGroupFilter = {
  outputInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  outputInvestmentName?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexGroupInput = {
  geReturnDate?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  leReturnDate?: InputMaybe<Scalars['Date']['input']>;
  terms: Array<CustomIndexTermInput>;
};

export type CustomIndexGroupList = {
  __typename?: 'CustomIndexGroupList';
  items: Array<CustomIndexGroup>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexGroupSort = {
  field: CustomIndexGroupSortEnum;
  order: SortInput;
};

export enum CustomIndexGroupSortEnum {
  GeReturnDate = 'geReturnDate',
  Id = 'id',
  LeReturnDate = 'leReturnDate',
  NameSearchRank = 'nameSearchRank',
  OutputInvestmentId = 'outputInvestmentId'
}

export type CustomIndexInvestment = {
  __typename?: 'CustomIndexInvestment';
  groups: CustomIndexGroupList;
  id: Scalars['Int']['output'];
  outputInvestment: Investment;
};


export type CustomIndexInvestmentGroupsArgs = {
  filter?: InputMaybe<CustomIndexGroupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexGroupSort>>;
};

export type CustomIndexInvestmentFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexInvestmentInput = {
  groups: Array<CustomIndexGroupInput>;
  outputInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomIndexInvestmentList = {
  __typename?: 'CustomIndexInvestmentList';
  items: Array<CustomIndexInvestment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexInvestmentSort = {
  field: CustomIndexInvestmentSortEnum;
  order: SortInput;
};

export enum CustomIndexInvestmentSortEnum {
  Id = 'id',
  NameSearchRank = 'nameSearchRank'
}

export type CustomIndexTerm = {
  __typename?: 'CustomIndexTerm';
  additionFactor: Scalars['Float']['output'];
  additionFactorAfter: Scalars['Float']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inputInvestment: Investment;
  inputInvestmentId: Scalars['Int']['output'];
  laggedMonths: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  multiplierFactor: Scalars['Float']['output'];
};

export type CustomIndexTermFilter = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  inputInvestmentName?: InputMaybe<Scalars['String']['input']>;
};

export type CustomIndexTermInput = {
  additionFactor?: InputMaybe<Scalars['Float']['input']>;
  additionFactorAfter?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  inputInvestmentId: Scalars['Int']['input'];
  laggedMonths?: InputMaybe<Scalars['Int']['input']>;
  multiplierFactor?: InputMaybe<Scalars['Float']['input']>;
};

export type CustomIndexTermList = {
  __typename?: 'CustomIndexTermList';
  items: Array<CustomIndexTerm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type CustomIndexTermSort = {
  field: CustomIndexTermSortEnum;
  order: SortInput;
};

export enum CustomIndexTermSortEnum {
  GroupId = 'groupId',
  Id = 'id',
  NameSearchRank = 'nameSearchRank'
}

export type CustomPromptsInput = {
  fieldKey: Scalars['String']['input'];
  prompt: Scalars['String']['input'];
};

export type DateRangeFilter = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
  relativeN?: InputMaybe<Scalars['Int']['input']>;
  relativeUnit?: InputMaybe<RelativeDateUnit>;
  roundToStart?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DatedAsset = {
  __typename?: 'DatedAsset';
  currency?: Maybe<CurrencyDenominationEnum>;
  date?: Maybe<Scalars['DateTime']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Deal = {
  __typename?: 'Deal';
  access: EntityAccess;
  amount?: Maybe<Scalars['Float']['output']>;
  assetClass?: Maybe<AssetClass2Enum>;
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  coInvestors?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dateReceived?: Maybe<Scalars['Date']['output']>;
  dealGroupId?: Maybe<Scalars['Int']['output']>;
  dealMarketing?: Maybe<DealMarketingEnum>;
  dealMarketingEnumId?: Maybe<Scalars['ID']['output']>;
  dealStructure?: Maybe<DealStructureEnum>;
  dealStructureEnumId?: Maybe<Scalars['ID']['output']>;
  dealTags: Array<DealTags>;
  documents?: Maybe<Array<Document>>;
  expectedCloseDate?: Maybe<Scalars['Date']['output']>;
  firm?: Maybe<Firm>;
  firmId: Scalars['Int']['output'];
  fundingRound?: Maybe<FundingTypeEnum>;
  fundingRoundEnumId?: Maybe<Scalars['ID']['output']>;
  headquarters?: Maybe<CountryEnum>;
  headquartersEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  isLeadInvestor?: Maybe<Scalars['Boolean']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  passedNote?: Maybe<Scalars['String']['output']>;
  preMoneyValuation?: Maybe<Scalars['Float']['output']>;
  rcSource?: Maybe<Scalars['String']['output']>;
  rcSourceUser?: Maybe<InvestmentAssignmentOption>;
  result?: Maybe<ResultEnum>;
  resultEnumId?: Maybe<Scalars['ID']['output']>;
  roundSize?: Maybe<Scalars['Float']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<StageEnum>;
  stageEnumId?: Maybe<Scalars['ID']['output']>;
  strategy?: Maybe<StrategyEnum>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  subStrategy?: Maybe<SubStrategyEnum>;
  subStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};


export type DealDealTagsArgs = {
  filter?: InputMaybe<DealTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealTagsSort>>;
};

export type DealFilter = {
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  closeDateRangeFrom?: InputMaybe<Scalars['String']['input']>;
  closeDateRangeTo?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  dealMarketingEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealStructureEnumId?: InputMaybe<Scalars['ID']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fundingRoundEnumId?: InputMaybe<Scalars['ID']['input']>;
  headquartersEnumId?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isBusinessApplication?: InputMaybe<Scalars['Boolean']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLeadInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcSource?: InputMaybe<Scalars['String']['input']>;
  resultEnumId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stageEnumId?: InputMaybe<Scalars['ID']['input']>;
};

export type DealFilterOptions = {
  __typename?: 'DealFilterOptions';
  assetClassOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  assetClassOptions?: Maybe<Array<AssetClass2Enum>>;
  dealMarketingOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  dealMarketingOptions?: Maybe<Array<DealMarketingEnum>>;
  dealStructureOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  dealStructureOptions?: Maybe<Array<DealStructureEnum>>;
  fundingTypeOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  fundingTypeOptions?: Maybe<Array<FundingTypeEnum>>;
  headQuarterOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  headQuarterOptions?: Maybe<Array<CountryEnum>>;
  rcSourceOptions?: Maybe<Array<Scalars['String']['output']>>;
  resultOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  resultOptions?: Maybe<Array<ResultEnum>>;
  stageOptionIds?: Maybe<Array<Scalars['Int']['output']>>;
  stageOptions?: Maybe<Array<StageEnum>>;
};

export type DealInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  coInvestors?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  dateReceived?: InputMaybe<Scalars['Date']['input']>;
  dealGroupId?: InputMaybe<Scalars['Int']['input']>;
  dealMarketingEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealStructureEnumId?: InputMaybe<Scalars['ID']['input']>;
  dealTags?: InputMaybe<Array<DealTagsInput>>;
  expectedCloseDate?: InputMaybe<Scalars['Date']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fundingRoundEnumId?: InputMaybe<Scalars['ID']['input']>;
  headquartersEnumId?: InputMaybe<Scalars['Int']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLeadInvestor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  passedNote?: InputMaybe<Scalars['String']['input']>;
  preMoneyValuation?: InputMaybe<Scalars['Float']['input']>;
  rcSource?: InputMaybe<Scalars['String']['input']>;
  resultEnumId?: InputMaybe<Scalars['ID']['input']>;
  roundSize?: InputMaybe<Scalars['Float']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  stageEnumId?: InputMaybe<Scalars['ID']['input']>;
  strategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  subStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type DealList = {
  __typename?: 'DealList';
  items: Array<Deal>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealMarketingEnum = {
  __typename?: 'DealMarketingEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DealMarketingEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DealMarketingEnumList = {
  __typename?: 'DealMarketingEnumList';
  items: Array<DealMarketingEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealMarketingEnumSort = {
  field: DealMarketingEnumSortEnum;
  order: SortInput;
};

export enum DealMarketingEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type DealSort = {
  field: DealSortEnum;
  order: SortInput;
};

export enum DealSortEnum {
  Amount = 'amount',
  AssetClassEnumId = 'assetClassEnumId',
  CompanyName = 'companyName',
  CompanyNameSearchRank = 'companyNameSearchRank',
  DealMarketingEnumId = 'dealMarketingEnumId',
  DealStructureEnumId = 'dealStructureEnumId',
  ExpectedCloseDate = 'expectedCloseDate',
  FundingRoundEnumId = 'fundingRoundEnumId',
  HeadquartersEnumId = 'headquartersEnumId',
  Id = 'id',
  IsImpact = 'isImpact',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  RcSource = 'rcSource',
  ResultEnumId = 'resultEnumId',
  Source = 'source',
  StageEnumDefault = 'stageEnumDefault',
  StageEnumId = 'stageEnumId'
}

export type DealStructureEnum = {
  __typename?: 'DealStructureEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DealStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DealStructureEnumList = {
  __typename?: 'DealStructureEnumList';
  items: Array<DealStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DealStructureEnumSort = {
  field: DealStructureEnumSortEnum;
  order: SortInput;
};

export enum DealStructureEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DealTags = {
  __typename?: 'DealTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dealId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['Int']['output'];
};

export type DealTagsFilter = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type DealTagsInput = {
  dealId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type DealTagsSort = {
  field: DealTagsSortEnum;
  order: SortInput;
};

export enum DealTagsSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DegreeEnum = {
  __typename?: 'DegreeEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  uniqueId: Scalars['String']['output'];
};

export type DegreeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DegreeEnumList = {
  __typename?: 'DegreeEnumList';
  items: Array<DegreeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DegreeEnumSort = {
  field: DegreeEnumSortEnum;
  order: SortInput;
};

export enum DegreeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DeiCategory1Enum = {
  __typename?: 'DeiCategory1Enum';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isAdditionalMinorityGroup: Scalars['Boolean']['output'];
};

export type DeiCategory1EnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAdditionalMinorityGroup?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeiCategory1EnumList = {
  __typename?: 'DeiCategory1EnumList';
  items: Array<DeiCategory1Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DeiCategory1EnumSort = {
  field: DeiCategory1EnumSortEnum;
  order: SortInput;
};

export enum DeiCategory1EnumSortEnum {
  Id = 'id',
  IsAdditionalMinorityGroup = 'isAdditionalMinorityGroup',
  Name = 'name'
}

export type DeiCategory2Enum = {
  __typename?: 'DeiCategory2Enum';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

export type DeiCategory2EnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type DeiCategory2EnumList = {
  __typename?: 'DeiCategory2EnumList';
  items: Array<DeiCategory2Enum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DeiCategory2EnumSort = {
  field: DeiCategory2EnumSortEnum;
  order: SortInput;
};

export enum DeiCategory2EnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DeiFilter = {
  category1?: InputMaybe<Scalars['Int']['input']>;
  category2?: InputMaybe<Scalars['Int']['input']>;
  max?: InputMaybe<Scalars['Float']['input']>;
  measures: Array<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum DeleteInvestmentRiskListType {
  Custom = 'CUSTOM',
  Database = 'DATABASE'
}

export type DiligenceAnswerNotFoundInput = {
  fieldKey: Scalars['String']['input'];
  ownerId: Scalars['Int']['input'];
  ownerType: FieldOwnerType;
};

export type DiligenceDraftRunInput = {
  answerNotFound: Array<DiligenceAnswerNotFoundInput>;
  runId: Scalars['String']['input'];
};

export type DiligenceGap = {
  __typename?: 'DiligenceGap';
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  investmentId: Scalars['Int']['output'];
  ownerType: FieldOwnerType;
  questionText: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  section?: Maybe<Scalars['String']['output']>;
  severity: DiligenceGapSeverity;
  status: DiligenceGapStatus;
  suggestedSources: Array<DiligenceGapSource>;
  whyItMatters: Scalars['String']['output'];
};

export type DiligenceGapAnalysis = {
  __typename?: 'DiligenceGapAnalysis';
  gaps: Array<DiligenceGap>;
  generatedAt: Scalars['DateTime']['output'];
  investmentId: Scalars['Int']['output'];
};

export enum DiligenceGapSeverity {
  HighRisk = 'HIGH_RISK',
  NiceToHave = 'NICE_TO_HAVE',
  Validation = 'VALIDATION'
}

export type DiligenceGapSource = {
  __typename?: 'DiligenceGapSource';
  kind: DiligenceGapSourceKind;
  label: Scalars['String']['output'];
};

export enum DiligenceGapSourceKind {
  CallTopic = 'CALL_TOPIC',
  Document = 'DOCUMENT',
  InternalDataset = 'INTERNAL_DATASET'
}

export enum DiligenceGapStatus {
  DrafterFoundNothing = 'DRAFTER_FOUND_NOTHING',
  NeverAnswered = 'NEVER_ANSWERED'
}

export type DisplayOptions = {
  __typename?: 'DisplayOptions';
  always_display_content?: Maybe<Scalars['Boolean']['output']>;
};

export type DisplaySort = {
  __typename?: 'DisplaySort';
  key: Scalars['String']['output'];
  order: Scalars['String']['output'];
};

export type DiversityStatsEnum = {
  __typename?: 'DiversityStatsEnum';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type DiversityStatsEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DiversityStatsEnumList = {
  __typename?: 'DiversityStatsEnumList';
  items: Array<DiversityStatsEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DiversityStatsEnumSort = {
  field: DiversityStatsEnumSortEnum;
  order: SortInput;
};

export enum DiversityStatsEnumSortEnum {
  Id = 'id'
}

export type Document = {
  __typename?: 'Document';
  access: EntityAccess;
  accessLevel: Scalars['Int']['output'];
  advSummaryEmailNotification?: Maybe<AdvSummaryEmailNotification>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  digest: Scalars['String']['output'];
  documentAccessLevel: DocumentAccessLevel;
  documentGroup?: Maybe<User>;
  documentGroupId?: Maybe<Scalars['Int']['output']>;
  documentSubTypeEnumId?: Maybe<Scalars['Int']['output']>;
  documentTextTaskId?: Maybe<Scalars['String']['output']>;
  documentTypeEnum: DocumentTypeEnum;
  documentTypeEnumId: Scalars['Int']['output'];
  entityAssociations: Array<DocumentXEntity>;
  extension: Scalars['String']['output'];
  hasDocumentText: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  isGallery?: Maybe<Scalars['Boolean']['output']>;
  isVectorized?: Maybe<Scalars['Boolean']['output']>;
  mercuryId?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  notifyUsers?: Maybe<Scalars['Boolean']['output']>;
  processingStatus: DocumentProcessingStatus;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  signedThumbnailUrl?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  tags: Array<KnowledgeBaseTags>;
  versions: Array<DocumentVersion>;
};


export type DocumentSignedUrlArgs = {
  inline?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentAccessLevel = {
  __typename?: 'DocumentAccessLevel';
  documents: Array<Document>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DocumentAccessLevelFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentAccessLevelList = {
  __typename?: 'DocumentAccessLevelList';
  items: Array<DocumentAccessLevel>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentAccessLevelSort = {
  field: DocumentAccessLevelSortEnum;
  order: SortInput;
};

export enum DocumentAccessLevelSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DocumentBatch = {
  __typename?: 'DocumentBatch';
  total: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type DocumentCountByDocumentType = {
  __typename?: 'DocumentCountByDocumentType';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type DocumentCountByDocumentTypeSort = {
  field: DocumentCountByDocumentTypeSortEnum;
  order: SortInput;
};

export enum DocumentCountByDocumentTypeSortEnum {
  Count = 'count',
  Name = 'name',
  Year = 'year'
}

export type DocumentFilter = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  date?: InputMaybe<Scalars['Date']['input']>;
  digest?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use documentCategoryEnumIds instead */
  documentCategoryEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentCategoryEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Use documentTypeEnumIds instead */
  documentTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  duplicates?: InputMaybe<Scalars['Upload']['input']>;
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  extensions?: InputMaybe<Array<Scalars['String']['input']>>;
  firmFilter?: InputMaybe<FirmFilterInput>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  gallery?: InputMaybe<Scalars['Boolean']['input']>;
  idNotIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includedInAdvSummaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use `name` instead */
  q?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['Date']['input'];
  documentGroupId?: InputMaybe<Scalars['Int']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumId: Scalars['Int']['input'];
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileFromBucket?: InputMaybe<BucketFileInput>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** The text content of the document, will be processed if not provided */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentList = {
  __typename?: 'DocumentList';
  items: Array<Document>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentProcessingItem = {
  __typename?: 'DocumentProcessingItem';
  label: Scalars['String']['output'];
  resultLabel?: Maybe<Scalars['String']['output']>;
  resultUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DocumentProcessingStatus = {
  __typename?: 'DocumentProcessingStatus';
  items: Array<DocumentProcessingItem>;
};

export type DocumentPublishResult = {
  __typename?: 'DocumentPublishResult';
  documentId?: Maybe<Scalars['Int']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  documentQueueId: Scalars['ID']['output'];
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DocumentQueue = {
  __typename?: 'DocumentQueue';
  document: Document;
  documentsId?: Maybe<Scalars['Float']['output']>;
  duplicateDocuments?: Maybe<Array<Document>>;
  emailMaps: Array<DocumentQueueEmailMap>;
  groupId?: Maybe<Scalars['Float']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  llmAsOfDate?: Maybe<Scalars['Date']['output']>;
  llmAsOfDateNotes?: Maybe<Scalars['String']['output']>;
  llmDocumentTypeEnumId?: Maybe<Scalars['Float']['output']>;
  llmDocumentTypeEnumNotes?: Maybe<Scalars['String']['output']>;
  llmEntityId?: Maybe<Scalars['Float']['output']>;
  llmEntityNotes?: Maybe<Scalars['String']['output']>;
  llmEntityTypeId?: Maybe<Scalars['Float']['output']>;
  llmEntityTypeNotes?: Maybe<Scalars['String']['output']>;
  llmProcessedAt?: Maybe<Scalars['Date']['output']>;
  llmSuggestedName?: Maybe<Scalars['String']['output']>;
  llmSuggestedNameNotes?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  queueDate: Scalars['Date']['output'];
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  signedUrl?: Maybe<Scalars['String']['output']>;
  /** A presigned url to upload the document to S3. */
  url?: Maybe<Scalars['String']['output']>;
  userId: Scalars['Int']['output'];
};

export type DocumentQueueEmailMap = {
  __typename?: 'DocumentQueueEmailMap';
  documentQueueId: Scalars['String']['output'];
  emailId: Scalars['String']['output'];
  emailMetadata: EmailMetadata;
  id: Scalars['String']['output'];
};

export type DocumentQueueFilter = {
  hasLLMData?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isArchiveAssistant?: InputMaybe<Scalars['Boolean']['input']>;
  isImage?: InputMaybe<Scalars['Boolean']['input']>;
  minQueueDate?: InputMaybe<Scalars['Date']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sharedQueueType?: InputMaybe<SharedQueueTypeEnum>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type DocumentQueueList = {
  __typename?: 'DocumentQueueList';
  items: Array<DocumentQueue>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentQueuePublishInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['Date']['input'];
  documentGroupId?: InputMaybe<Scalars['Int']['input']>;
  documentQueueId?: InputMaybe<Scalars['ID']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  documentTypeEnumId: Scalars['Int']['input'];
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Knowledge base tag IDs to associate with this document */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Override filename to use for the published Document. Falls back to DocumentQueue.name when not provided. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentQueueSort = {
  field: DocumentQueueSortEnum;
  order: SortInput;
};

export enum DocumentQueueSortEnum {
  EmailId = 'emailId',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  QueueDate = 'queueDate'
}

export type DocumentSort = {
  field: DocumentSortEnum;
  order: SortInput;
};

export enum DocumentSortEnum {
  AccessLevelId = 'accessLevelId',
  AccessLevelName = 'accessLevelName',
  CreateDate = 'createDate',
  Date = 'date',
  DocumentCategoryEnumId = 'documentCategoryEnumId',
  DocumentTypeEnumName = 'documentTypeEnumName',
  IsApproved = 'isApproved',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  TextSearchRank = 'textSearchRank'
}

export type DocumentTypeEnum = {
  __typename?: 'DocumentTypeEnum';
  description?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  documentCategoryEnumId?: Maybe<Scalars['Int']['output']>;
  documents: Array<Document>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type DocumentTypeEnumFilter = {
  documentCategoryEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isBusinessApplicantType?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentTypeEnumList = {
  __typename?: 'DocumentTypeEnumList';
  items: Array<DocumentTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type DocumentTypeEnumSort = {
  field: DocumentTypeEnumSortEnum;
  order: SortInput;
};

export enum DocumentTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type DocumentUpdateInput = {
  accessLevel?: InputMaybe<Scalars['Int']['input']>;
  /** Add entity associations incrementally (preserves existing ones) */
  addEntities?: InputMaybe<Array<EntityAssociationInput>>;
  allowDuplicateFile?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  documentSubTypeEnumId?: InputMaybe<Scalars['Float']['input']>;
  documentTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  /** Replace ALL entity associations (full replace semantics) */
  entities?: InputMaybe<Array<EntityAssociationInput>>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isGallery?: InputMaybe<Scalars['Boolean']['input']>;
  /** Knowledge base tag IDs to associate with this document */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Remove specific entity associations by type+id */
  removeEntities?: InputMaybe<Array<EntityAssociationInput>>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createUserFullName?: Maybe<Scalars['String']['output']>;
  digest: Scalars['String']['output'];
  documentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  versionNumber: Scalars['Int']['output'];
};

export type DocumentXEntity = {
  __typename?: 'DocumentXEntity';
  businessObjectTypeEnumId: Scalars['Int']['output'];
  company?: Maybe<Company>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  documentsId: Scalars['Int']['output'];
  entityId: Scalars['Int']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  firm?: Maybe<Firm>;
  firmEngagement?: Maybe<FirmEngagement>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
};

export type DocumentsDynamicShareRule = {
  documentTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type DocumentsDynamicShareRuleOutput = {
  __typename?: 'DocumentsDynamicShareRuleOutput';
  documentTypes?: Maybe<Array<Scalars['Int']['output']>>;
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type DryRunMutationStepResult = {
  __typename?: 'DryRunMutationStepResult';
  currentValues?: Maybe<Scalars['JSON']['output']>;
  errors: Array<ValidationError>;
  proposedValues: Scalars['JSON']['output'];
  valid: Scalars['Boolean']['output'];
};

/** Dynamic definition for group share rules. Exactly one entity rule type (investmentsDynamicShare, firmsDynamicShare, personsDynamicShare, documentsDynamicShare, or everything) must be specified. */
export type DynamicDefinitionInput = {
  description: Scalars['String']['input'];
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentsDynamicShare?: InputMaybe<DocumentsDynamicShareRule>;
  everything?: InputMaybe<Scalars['Boolean']['input']>;
  firmsDynamicShare?: InputMaybe<FirmsDynamicShareRule>;
  investmentsDynamicShare?: InputMaybe<InvestmentsDynamicShareRule>;
  personsDynamicShare?: InputMaybe<PersonsDynamicShareRule>;
};

export type DynamicDefinitionOutput = {
  __typename?: 'DynamicDefinitionOutput';
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  documentsDynamicShare?: Maybe<DocumentsDynamicShareRuleOutput>;
  everything?: Maybe<Scalars['Boolean']['output']>;
  firmsDynamicShare?: Maybe<FirmsDynamicShareRuleOutput>;
  investmentsDynamicShare?: Maybe<InvestmentsDynamicShareRuleOutput>;
  personsDynamicShare?: Maybe<PersonsDynamicShareRuleOutput>;
};

export enum DynamicList {
  FundedList = 'fundedList',
  ImpactList = 'impactList',
  PortalMigrationList = 'portalMigrationList',
  ProspectiveList = 'prospectiveList',
  ResearchList = 'researchList'
}

export type DynamicListFilter = {
  lists: Array<DynamicList>;
  operator?: InputMaybe<Scalars['String']['input']>;
};

/** A fund's estimate overrides. null clears one; a null spread saves the NAV model's spread, as the legacy page did. */
export type EarlyEstimateInput = {
  /** The version this edit started from. If someone else has saved the fund since, the save is refused. */
  expectedVersion?: InputMaybe<Scalars['String']['input']>;
  grossEndBal?: InputMaybe<Scalars['Float']['input']>;
  grossReturn?: InputMaybe<Scalars['Float']['input']>;
  netEndBal?: InputMaybe<Scalars['Float']['input']>;
  rcgFundId: Scalars['Int']['input'];
  spread?: InputMaybe<Scalars['Float']['input']>;
};

/** One RCG fund's early estimate for a month-end: the NAV model's figures (system*) beside the entered overrides. Balances in dollars; returns and spread as fractions (0.012 = 1.2%). */
export type EarlyEstimateRow = {
  __typename?: 'EarlyEstimateRow';
  grossEndBal?: Maybe<Scalars['Float']['output']>;
  grossReturn?: Maybe<Scalars['Float']['output']>;
  /** False once the month is reconciled: estimates can no longer be entered. */
  isEstimate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  netEndBal?: Maybe<Scalars['Float']['output']>;
  netReturn?: Maybe<Scalars['Float']['output']>;
  rcgFundId: Scalars['Int']['output'];
  spread?: Maybe<Scalars['Float']['output']>;
  systemGrossEndBal?: Maybe<Scalars['Float']['output']>;
  systemGrossReturn?: Maybe<Scalars['Float']['output']>;
  systemNetEndBal?: Maybe<Scalars['Float']['output']>;
  /** Gross return minus net return. */
  systemSpread?: Maybe<Scalars['Float']['output']>;
  /** Changes whenever anyone saves this fund's estimate; send it back as expectedVersion. Null before the first save. */
  version?: Maybe<Scalars['String']['output']>;
};

export type EffortBenchmark = {
  __typename?: 'EffortBenchmark';
  effort: Scalars['String']['output'];
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
};

export type EmRiskReportConfigInput = {
  accountName: Scalars['String']['input'];
  betaIndex: Scalars['Int']['input'];
  betaName: Scalars['String']['input'];
  customizedPerformanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['DateTime']['input'];
  fundId: Scalars['Int']['input'];
  inceptionDate?: InputMaybe<Scalars['DateTime']['input']>;
  managerRiskPages?: InputMaybe<Scalars['Boolean']['input']>;
  timePeriod?: Scalars['Int']['input'];
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAttachmentInput = {
  /** Temp-upload bucket (caller's own uploads only). */
  bucket?: InputMaybe<Scalars['String']['input']>;
  /** A file generated in one of the caller's own chats, e.g. an Atlas output (ownership-checked). */
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  /** Attach a platform document (entitlement-checked). */
  documentId?: InputMaybe<Scalars['Int']['input']>;
  /** Temp-upload key (caller's own uploads only). */
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type EmailDomainOrganizationFilter = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['String']['input']>;
};

export type EmailDomainOrganizationInput = {
  emailDomain: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
};

export type EmailDomainOrganizationList = {
  __typename?: 'EmailDomainOrganizationList';
  items: Array<PortalEmailDomainOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmailDomainOrganizationSort = {
  field: EmailDomainOrganizationSortEnum;
  order: SortInput;
};

export enum EmailDomainOrganizationSortEnum {
  EmailDomain = 'emailDomain',
  OrganizationId = 'organizationId'
}

export type EmailDomainXOrganization = {
  __typename?: 'EmailDomainXOrganization';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  emailDomain: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  organizationId: Scalars['Int']['output'];
};

export type EmailDomainXOrganizationFilter = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailDomainXOrganizationInput = {
  emailDomain?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type EmailDomainXOrganizationList = {
  __typename?: 'EmailDomainXOrganizationList';
  items: Array<EmailDomainXOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmailDomainXOrganizationSort = {
  field: EmailDomainXOrganizationSortEnum;
  order: SortInput;
};

export enum EmailDomainXOrganizationSortEnum {
  EmailDomain = 'emailDomain',
  Id = 'id',
  OrganizationId = 'organizationId'
}

export type EmailMetadata = {
  __typename?: 'EmailMetadata';
  attachmentCount?: Maybe<Scalars['Float']['output']>;
  ccAddresses?: Maybe<Scalars['String']['output']>;
  emailBody?: Maybe<Scalars['String']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  hasAttachments?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  importanceFlag?: Maybe<Scalars['String']['output']>;
  receivedDate?: Maybe<Scalars['Date']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  toAddress?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
};

export type EmailMetadataInput = {
  attachmentCount: Scalars['Int']['input'];
  ccAddresses?: InputMaybe<Scalars['String']['input']>;
  emailBody?: InputMaybe<Scalars['String']['input']>;
  fromAddress?: InputMaybe<Scalars['String']['input']>;
  fromName?: InputMaybe<Scalars['String']['input']>;
  hasAttachments: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  importanceFlag?: InputMaybe<Scalars['String']['input']>;
  receivedDate?: InputMaybe<Scalars['DateTime']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  toAddress?: InputMaybe<Scalars['String']['input']>;
  toName?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeRoleEnum = {
  __typename?: 'EmployeeRoleEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type EmployeeRoleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type EmployeeRoleEnumList = {
  __typename?: 'EmployeeRoleEnumList';
  items: Array<EmployeeRoleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type EmployeeRoleEnumSort = {
  field: EmployeeRoleEnumSortEnum;
  order: SortInput;
};

export enum EmployeeRoleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type EntityAccess = {
  __typename?: 'EntityAccess';
  delete?: Maybe<Scalars['Boolean']['output']>;
  preview?: Maybe<Scalars['Boolean']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityAccessSearchFilter = {
  values: Array<Prud>;
};

export type EntityAssociationInput = {
  businessObjectEnumId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
};

export type EntityKey = {
  id: Scalars['Int']['input'];
  label: Scalars['String']['input'];
};

export type EntitySearchFilter = {
  values: Array<EntityKey>;
};

export type Exposure = {
  __typename?: 'Exposure';
  assetClass: Array<ExposureRecord>;
  assetClassDetail: Array<ExposureDetailRecord>;
  byDimension: Array<ExposureRecord>;
  duration: Array<ExposureDurationRecord>;
  marketCap: Array<ExposureRecord>;
  portfolio: Array<ExposureRecord>;
  regional: Array<ExposureRecord>;
  regionalDetail: Array<ExposureDetailRecord>;
  sector: Array<ExposureRecord>;
};


export type ExposureByDimensionArgs = {
  dimension: ExposureDimension;
};

/** A raw category tuple for one exposure dimension. Unlike ExposureRecord, categories are not coalesced into a single label, so consumers that need the exact category hierarchy (e.g. asset category level 2 + 3 pairs, or country = category4-else-category3) can apply their own fallback rules. */
export type ExposureDetailRecord = {
  __typename?: 'ExposureDetailRecord';
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  month: Scalars['Int']['output'];
  weight: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

/** exposure dimensions */
export enum ExposureDimension {
  AssetClass = 'ASSET_CLASS',
  Capitalization = 'CAPITALIZATION',
  Currency = 'CURRENCY',
  Liquidity = 'LIQUIDITY',
  Region = 'REGION',
  Sector = 'SECTOR',
  SecurityType = 'SECURITY_TYPE',
  Strategy = 'STRATEGY'
}

/** Effective duration (IR) for one month. Values are raw durations in years, NOT percentages like ExposureRecord.weight. */
export type ExposureDurationRecord = {
  __typename?: 'ExposureDurationRecord';
  month: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ExposureRecord = {
  __typename?: 'ExposureRecord';
  month: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
  year: Scalars['Int']['output'];
};

export type ExternalUserInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
};

export type ExtractResult = {
  __typename?: 'ExtractResult';
  extractBodyKey: Scalars['String']['output'];
  extractHeadKey: Scalars['String']['output'];
  skipped: Scalars['Boolean']['output'];
  writeBodyResult?: Maybe<Scalars['JSONObject']['output']>;
  writeHeadResult?: Maybe<Scalars['JSONObject']['output']>;
};

export type FdpLogin = {
  __typename?: 'FDPLogin';
  authenticatorEnum?: Maybe<FdpLoginAuthenticatorEnum>;
  authenticatorEnumId?: Maybe<Scalars['Int']['output']>;
  authenticatorImage?: Maybe<Scalars['String']['output']>;
  authenticatorImageType?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  financialDataProvider: FinancialDataProvider;
  financialDataProviderId: Scalars['Int']['output'];
  firmFDPLogins?: Maybe<Array<FirmFdpLogins>>;
  firms?: Maybe<Array<Firm>>;
  id: Scalars['Int']['output'];
  imageLink?: Maybe<Scalars['String']['output']>;
  investmentFDPLogins?: Maybe<Array<InvestmentFdpLogins>>;
  investments?: Maybe<Array<Investment>>;
  mfaUser?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  portfolioFDPLogins?: Maybe<Array<PortfolioFdpLogins>>;
  portfolios?: Maybe<Array<Investment>>;
  securityQuestion?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type FdpLoginAuthenticatorEnum = {
  __typename?: 'FDPLoginAuthenticatorEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FdpLoginAuthenticatorEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginAuthenticatorEnumSort = {
  field: FdpLoginAuthenticatorEnumSortEnum;
  order: SortInput;
};

export enum FdpLoginAuthenticatorEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FdpLoginFilter = {
  authenticatorEnumId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeFirmIfNoInvestment?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  mfaUser?: InputMaybe<Scalars['String']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  qNotes?: InputMaybe<Scalars['String']['input']>;
  qWebsite?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginInput = {
  authenticatorEnumId?: InputMaybe<Scalars['Int']['input']>;
  authenticatorImage?: InputMaybe<Scalars['Upload']['input']>;
  authenticatorImageType?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  firmFDPLogins?: InputMaybe<Array<FirmFdpLoginsInput>>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentFDPLogins?: InputMaybe<Array<InvestmentFdpLoginsInput>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  mfaUser?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  portfolioFDPLogins?: InputMaybe<Array<PortfolioFdpLoginsInput>>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  securityQuestion?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type FdpLoginSort = {
  field: FdpLoginSortEnum;
  order: SortInput;
};

export enum FdpLoginSortEnum {
  Email = 'email',
  FdpName = 'fdpName',
  Id = 'id',
  MfaUser = 'mfaUser',
  NameSearchRank = 'nameSearchRank',
  Username = 'username'
}

export type FdpWebsites = {
  __typename?: 'FDPWebsites';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  financialDataProvider?: Maybe<FinancialDataProvider>;
  financialDataProviderId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  website: Scalars['String']['output'];
};

export type FdpWebsitesFilter = {
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FdpWebsitesInput = {
  financialDataProviderId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type FdpWebsitesSort = {
  field: FdpWebsitesSortEnum;
  order: SortInput;
};

export enum FdpWebsitesSortEnum {
  Id = 'id',
  Website = 'website',
  WebsiteSearchRank = 'websiteSearchRank'
}

export type FxRate = {
  __typename?: 'FXRate';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  exchangeRate: Scalars['Float']['output'];
  fromCurrency: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  toCurrency: Scalars['String']['output'];
};

export type FactorInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type Family = {
  __typename?: 'Family';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentsFamily: Array<InvestmentsFamily>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type FamilyInvestmentsFamilyArgs = {
  filter?: InputMaybe<InvestmentsFamilyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentsFamilySort>>;
};

export type FamilyFilterInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
};

export type FamilyInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentsFamily?: InputMaybe<Array<InvestmentInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FamilyList = {
  __typename?: 'FamilyList';
  items: Array<Family>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FamilySort = {
  field: FamilySortEnum;
  order: SortInput;
};

export enum FamilySortEnum {
  Name = 'name'
}

export type FdpLoginAuthenticatorEnumList = {
  __typename?: 'FdpLoginAuthenticatorEnumList';
  items: Array<FdpLoginAuthenticatorEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FdpLoginList = {
  __typename?: 'FdpLoginList';
  items: Array<FdpLogin>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FdpWebsitesList = {
  __typename?: 'FdpWebsitesList';
  items: Array<FdpWebsites>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeCalcEnum = {
  __typename?: 'FeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeCalcEnumList = {
  __typename?: 'FeeCalcEnumList';
  items: Array<FeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeCalcEnumSort = {
  field: FeeCalcEnumSortEnum;
  order: SortInput;
};

export enum FeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FeeFreqEnum = {
  __typename?: 'FeeFreqEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FeeFreqEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FeeFreqEnumList = {
  __typename?: 'FeeFreqEnumList';
  items: Array<FeeFreqEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FeeFreqEnumSort = {
  field: FeeFreqEnumSortEnum;
  order: SortInput;
};

export enum FeeFreqEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Field = {
  __typename?: 'Field';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents: Array<FieldDocument>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  owner: FieldOwner;
  ownerId: Scalars['Float']['output'];
  ownerType: FieldOwnerType;
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<FieldState>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldAccess = {
  __typename?: 'FieldAccess';
  canInput: Scalars['Boolean']['output'];
  field: Scalars['String']['output'];
  pointer?: Maybe<Scalars['String']['output']>;
};

export type FieldColumnInput = {
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  nullable?: InputMaybe<Scalars['Boolean']['input']>;
  propertyKey: Scalars['String']['input'];
};

export type FieldData = {
  __typename?: 'FieldData';
  assetClassName?: Maybe<Scalars['String']['output']>;
  businessObject: BusinessObject;
  fieldMeta: Scalars['JSON']['output'];
  fieldSet: Scalars['JSON']['output'];
  fieldSetType: FieldSetType;
  investmentId: Scalars['Int']['output'];
  strategyName?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type FieldDefinition = {
  __typename?: 'FieldDefinition';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  metadata: Scalars['JSON']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  ownerType: Scalars['String']['output'];
};

export type FieldDocument = {
  __typename?: 'FieldDocument';
  document?: Maybe<Document>;
  id: Scalars['Float']['output'];
};

export type FieldDocumentInput = {
  id: Scalars['Float']['input'];
};

export type FieldEntityWithMetadata = {
  __typename?: 'FieldEntityWithMetadata';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents: Array<FieldDocument>;
  fieldKey: Scalars['String']['output'];
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  owner?: Maybe<FieldOwner>;
  ownerId: Scalars['Float']['output'];
  ownerType: FieldOwnerType;
  periodType?: Maybe<Scalars['String']['output']>;
  semanticDistance?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<FieldState>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  fieldKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  knowledgeBaseId?: InputMaybe<Scalars['Int']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  owners?: InputMaybe<Array<FieldOwnerFilter>>;
  semanticQuery?: InputMaybe<Scalars['String']['input']>;
  showOnlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FieldHistoryFilter = {
  fieldKey: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  showOnlyPublished?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldHistorySort = {
  field: FieldHistorySortEnum;
  order: SortInput;
};

export enum FieldHistorySortEnum {
  Id = 'id',
  ModifyDate = 'modifyDate'
}

export type FieldKeySearchResult = {
  __typename?: 'FieldKeySearchResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<FieldKeyWithMetadata>;
  total: Scalars['Int']['output'];
};

export type FieldKeyWithMetadata = {
  __typename?: 'FieldKeyWithMetadata';
  category?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  fieldKey: Scalars['String']['output'];
  questionText: Scalars['String']['output'];
  section?: Maybe<Scalars['String']['output']>;
};

export type FieldList = {
  __typename?: 'FieldList';
  items: Array<FieldEntityWithMetadata>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FieldOwner = {
  __typename?: 'FieldOwner';
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
};

export type FieldOwnerFilter = {
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export enum FieldOwnerType {
  Company = 'company',
  Firm = 'firm',
  Investment = 'investment'
}

export type FieldSetConfig = {
  __typename?: 'FieldSetConfig';
  hide_image_upload?: Maybe<Scalars['Boolean']['output']>;
};

export type FieldSetMapping = {
  __typename?: 'FieldSetMapping';
  portal: Array<Scalars['Int']['output']>;
};

export enum FieldSetType {
  Affiliations = 'affiliations',
  Application = 'application',
  Impact = 'impact',
  Investment = 'investment',
  OngoingReporting = 'ongoingReporting',
  Operations = 'operations'
}

export type FieldSort = {
  field: FieldSortEnum;
  order: SortInput;
};

export enum FieldSortEnum {
  Id = 'id',
  ModifyDate = 'modifyDate',
  Owner = 'owner',
  SemanticRelevance = 'semanticRelevance',
  TextSearchRelevance = 'textSearchRelevance'
}

export enum FieldState {
  Draft = 'draft',
  Mgr = 'mgr',
  MgrDraft = 'mgrDraft',
  MgrDraftLegacy = 'mgrDraftLegacy',
  RangerGenerated = 'rangerGenerated'
}

export type FieldValue = {
  __typename?: 'FieldValue';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['JSON']['output']>;
};

export type FieldValueInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fieldKey: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type FinancialDataProvider = {
  __typename?: 'FinancialDataProvider';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['String']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  fdpWebsites: Array<FdpWebsites>;
  id: Scalars['Int']['output'];
  logins: Array<FdpLogin>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type FinancialDataProviderFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialDataProviderInput = {
  fdpWebsites?: InputMaybe<Array<FdpWebsitesInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FinancialDataProviderList = {
  __typename?: 'FinancialDataProviderList';
  items: Array<FinancialDataProvider>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FinancialDataProviderSort = {
  field: FinancialDataProviderSortEnum;
  order: SortInput;
};

export enum FinancialDataProviderSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FinancialPeriodEnum = {
  __typename?: 'FinancialPeriodEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FinancialPeriodEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FinancialPeriodEnumList = {
  __typename?: 'FinancialPeriodEnumList';
  items: Array<FinancialPeriodEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FinancialPeriodEnumSort = {
  field: FinancialPeriodEnumSortEnum;
  order: SortInput;
};

export enum FinancialPeriodEnumSortEnum {
  Id = 'id'
}

export type Firm = {
  __typename?: 'Firm';
  ITCount?: Maybe<Scalars['Int']['output']>;
  access: EntityAccess;
  administrativeCount?: Maybe<Scalars['Int']['output']>;
  analystCount?: Maybe<Scalars['Int']['output']>;
  assetResolutionAnalystCount?: Maybe<Scalars['Int']['output']>;
  cik?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['Int']['output']>;
  crd?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  dataOrganizationId?: Maybe<Scalars['Int']['output']>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  email?: Maybe<Scalars['String']['output']>;
  employeeTotal?: Maybe<Scalars['Int']['output']>;
  families?: Maybe<Array<Family>>;
  fdpLogins?: Maybe<Array<FdpLogin>>;
  fieldData?: Maybe<FieldData>;
  fieldHistory?: Maybe<Array<Field>>;
  fields?: Maybe<FirmFields>;
  firmDEIList?: Maybe<FirmDeiList>;
  firmDEIs?: Maybe<Array<FirmDei>>;
  firmEmailDomains?: Maybe<Array<Scalars['String']['output']>>;
  firmEmployments?: Maybe<Array<FirmEmployment>>;
  firmFDPLogins?: Maybe<Array<FirmFdpLogins>>;
  firmGroupId: Scalars['Int']['output'];
  firmInstitutionsList?: Maybe<FirmInstitutionsList>;
  firmIrEmail?: Maybe<Scalars['String']['output']>;
  firmTags?: Maybe<Array<FirmTags>>;
  firmXImpact?: Maybe<Array<FirmXImpact>>;
  generalCount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  impactTags?: Maybe<Array<ImpactEnum>>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `intraLinks` instead */
  intraLink?: Maybe<IntraLink>;
  /** @deprecated Use `firmFDPLogin` table instead */
  intraLinkId?: Maybe<Scalars['Int']['output']>;
  investmentCount?: Maybe<Scalars['Int']['output']>;
  investments?: Maybe<InvestmentList>;
  investorRelationsCount?: Maybe<Scalars['Int']['output']>;
  isCompany?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isStaffMWDBE?: Maybe<Scalars['Boolean']['output']>;
  latestFirmDEI?: Maybe<FirmDei>;
  latestNewsMonitoringPull?: Maybe<Scalars['DateTime']['output']>;
  legalCount?: Maybe<Scalars['Int']['output']>;
  lei?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  middleBackOfficeCount?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  newsMonitoringStartDate?: Maybe<Scalars['DateTime']['output']>;
  operationsCount?: Maybe<Scalars['Int']['output']>;
  otherAddresses?: Maybe<Array<Address>>;
  ownershipDiversity?: Maybe<FirmOwnershipDiversity>;
  portalFirm?: Maybe<PortalFirm>;
  portfolioManagerCount?: Maybe<Scalars['Int']['output']>;
  primaryAddress?: Maybe<Address>;
  primaryAddressId: Scalars['Int']['output'];
  registeredWithIds?: Maybe<Array<Scalars['Int']['output']>>;
  registeredWithOther?: Maybe<Scalars['String']['output']>;
  registrations?: Maybe<Array<FirmRegistration>>;
  researchAndUnderwritingAnalystCount?: Maybe<Scalars['Int']['output']>;
  riskCount?: Maybe<Scalars['Int']['output']>;
  sourcingAnalystCount?: Maybe<Scalars['Int']['output']>;
  stockSymbol?: Maybe<Scalars['String']['output']>;
  templateOptions?: Maybe<Array<Scalars['String']['output']>>;
  traderCount?: Maybe<Scalars['Int']['output']>;
  ukHfsbSignatory?: Maybe<Scalars['Boolean']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};


export type FirmFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type FirmFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type FirmFieldsArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


export type FirmFirmDeiListArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type FirmFirmDeIsArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type FirmFirmEmploymentsArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};


export type FirmFirmInstitutionsListArgs = {
  filter?: InputMaybe<FirmInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmInstitutionsSort>>;
};


export type FirmFirmTagsArgs = {
  filter?: InputMaybe<FirmTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmTagsSort>>;
};


export type FirmInvestmentsArgs = {
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type FirmLatestFirmDeiArgs = {
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
};


export type FirmTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};

export type FirmAttributes = {
  email?: InputMaybe<Scalars['String']['input']>;
  employeeTotal?: InputMaybe<Scalars['Int']['input']>;
  firmTags?: InputMaybe<Array<FirmTagsInput>>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  isStaffMWDBE?: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  primaryAddress?: InputMaybe<AddressInput>;
  stockSymbol?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmAum = {
  __typename?: 'FirmAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type FirmDei = {
  __typename?: 'FirmDEI';
  asOfDate: Scalars['Date']['output'];
  comments?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  diversityStatsEnum: DiversityStatsEnum;
  diversityStatsEnumId?: Maybe<Scalars['Int']['output']>;
  firm: Firm;
  firmDEIRecords: Array<FirmDeiRecord>;
  firmId: Scalars['Int']['output'];
  geographyEnum: GeographyEnum;
  geographyEnumId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isCompleted: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};


export type FirmDeiFirmDeiRecordsArgs = {
  filter?: InputMaybe<FirmDeiRecordFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiRecordSort>>;
};

export type FirmDeiCreateOrUpdate = {
  asOfDate: Scalars['Date']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  diversityStatsEnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIRecords?: InputMaybe<Array<FirmDeiRecordInput>>;
  firmId: Scalars['Int']['input'];
  geographyEnumId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmDeiFilter = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  mostRecentMeasure?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  throughCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmDeiList = {
  __typename?: 'FirmDEIList';
  items: Array<FirmDei>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmDeiRecord = {
  __typename?: 'FirmDEIRecord';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deiCategory1Enum: DeiCategory1Enum;
  deiCategory1EnumId: Scalars['Int']['output'];
  deiCategory2Enum: DeiCategory2Enum;
  deiCategory2EnumId?: Maybe<Scalars['Int']['output']>;
  firmDEI: FirmDei;
  firmDEIId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  measureEnum: MeasureEnum;
  measureEnumId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  percentValue?: Maybe<Scalars['Float']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FirmDeiRecordFilter = {
  deiCategory1EnumId?: InputMaybe<Scalars['Int']['input']>;
  deiCategory2EnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  measureEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmDeiRecordInput = {
  deiCategory1EnumId?: InputMaybe<Scalars['Int']['input']>;
  deiCategory2EnumId?: InputMaybe<Scalars['Int']['input']>;
  firmDEIId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  measureEnumId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type FirmDeiRecordSort = {
  field: FirmDeiRecordSortEnum;
  order: SortInput;
};

export enum FirmDeiRecordSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type FirmDeiSort = {
  field: FirmDeiSortEnum;
  order: SortInput;
};

export enum FirmDeiSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  IsCompleted = 'isCompleted'
}

export type FirmEmployment = {
  __typename?: 'FirmEmployment';
  auditContactTypeEnumId?: Maybe<Scalars['Int']['output']>;
  authToTrade?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<ContactTypeEnum>;
  contactTypeEnumId?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  dataContact?: Maybe<Scalars['Boolean']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  employeeRole?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  faceOfFirm?: Maybe<Scalars['Boolean']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  focusStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentFirmEmployments?: Maybe<Array<InvestmentFirmEmployment>>;
  isAdminContact?: Maybe<Scalars['Boolean']['output']>;
  isDataEntryContact?: Maybe<Scalars['Boolean']['output']>;
  isFounder?: Maybe<Scalars['Boolean']['output']>;
  isKeyPersonnel?: Maybe<Scalars['Boolean']['output']>;
  jobDesc?: Maybe<Scalars['String']['output']>;
  leftDate?: Maybe<Scalars['Date']['output']>;
  leftInd?: Maybe<Scalars['Boolean']['output']>;
  leftReason?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  outsideAffil?: Maybe<Scalars['Boolean']['output']>;
  person?: Maybe<Person>;
  personId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
  uniqueId: Scalars['String']['output'];
};


export type FirmEmploymentInvestmentFirmEmploymentsArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};

export type FirmEmploymentFilterInput = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  contactTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  employeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentEmployment?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIdOrIsKeyPersonnel?: InputMaybe<InvestmentIdOrIsKeyPersonnel>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isKeyPersonnel?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  targetInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmEmploymentFilters = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentEmployment?: InputMaybe<InvestmentFirmEmploymentFilters>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FirmEmploymentInput = {
  auditContactTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  authToTrade?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  dataContact?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  employeeRoleEnumId?: InputMaybe<Scalars['Int']['input']>;
  faceOfFirm?: InputMaybe<Scalars['Boolean']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  focusStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  isAdminContact?: InputMaybe<Scalars['Boolean']['input']>;
  isDataEntryContact?: InputMaybe<Scalars['Boolean']['input']>;
  isFounder?: InputMaybe<Scalars['Boolean']['input']>;
  isKeyPersonnel?: InputMaybe<Scalars['Boolean']['input']>;
  jobDesc?: InputMaybe<Scalars['String']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  leftInd?: InputMaybe<Scalars['Boolean']['input']>;
  leftReason?: InputMaybe<Scalars['String']['input']>;
  outsideAffil?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FirmEmploymentList = {
  __typename?: 'FirmEmploymentList';
  items: Array<FirmEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEmploymentSort = {
  field: FirmEmploymentSortEnum;
  order: SortInput;
};

export enum FirmEmploymentSortEnum {
  FirmDefault = 'firmDefault',
  FirmName = 'firmName',
  Id = 'id',
  PersonDefault = 'personDefault',
  PersonName = 'personName'
}

export type FirmEngagement = {
  __typename?: 'FirmEngagement';
  access: EntityAccess;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentCount: Scalars['Int']['output'];
  firm?: Maybe<Firm>;
  firmEngagementGroupId: Scalars['Int']['output'];
  firmEngagementType?: Maybe<FirmEngagementTypeEnum>;
  firmEngagementTypeEnumId: Scalars['Int']['output'];
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  imageDocument?: Maybe<Document>;
  imageDocumentId?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  noteCount: Scalars['Int']['output'];
};

export type FirmEngagementFilter = {
  firmEngagementTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmEngagementInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  firmEngagementGroupId?: InputMaybe<Scalars['Int']['input']>;
  firmEngagementTypeEnumId: Scalars['Int']['input'];
  firmId: Scalars['Int']['input'];
  imageDocumentId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
};

export type FirmEngagementList = {
  __typename?: 'FirmEngagementList';
  items: Array<FirmEngagement>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEngagementSort = {
  field: FirmEngagementSortEnum;
  order: SortInput;
};

export enum FirmEngagementSortEnum {
  CreateDate = 'createDate',
  FirmEngagementTypeEnumId = 'firmEngagementTypeEnumId',
  Id = 'id',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FirmEngagementTypeEnum = {
  __typename?: 'FirmEngagementTypeEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type FirmEngagementTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FirmEngagementTypeEnumList = {
  __typename?: 'FirmEngagementTypeEnumList';
  items: Array<FirmEngagementTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmEngagementTypeEnumSort = {
  field: FirmEngagementTypeEnumSortEnum;
  order: SortInput;
};

export enum FirmEngagementTypeEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type FirmFdpLogins = {
  __typename?: 'FirmFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentFDPLogins?: Maybe<Array<InvestmentFdpLogins>>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type FirmFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmFdpLoginsList = {
  __typename?: 'FirmFDPLoginsList';
  items: Array<FirmFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmFdpLoginsSort = {
  field: FirmFdpLoginsSortEnum;
  order: SortInput;
};

export enum FirmFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  FirmId = 'firmId',
  NameSearchRank = 'nameSearchRank'
}

export type FirmFields = {
  __typename?: 'FirmFields';
  firmAum?: Maybe<FirmAum>;
  firmId: Scalars['ID']['output'];
  state?: Maybe<Scalars['String']['output']>;
  values: Array<FieldValue>;
};

export type FirmFilterInput = {
  fuzzyTerm?: InputMaybe<Scalars['String']['input']>;
  includeCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isFunded?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type FirmFundAssets = {
  __typename?: 'FirmFundAssets';
  asOfDate: Scalars['DateTime']['output'];
  firmAUM?: Maybe<Scalars['Float']['output']>;
  firmAumCurrency?: Maybe<Scalars['String']['output']>;
  firmId: Scalars['Int']['output'];
  flow: AumFlow;
  investmentAUM?: Maybe<Scalars['Float']['output']>;
  investmentAumCurrency?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  prevInvestmentAUM?: Maybe<Scalars['Float']['output']>;
  prevStrategyAUM?: Maybe<Scalars['Float']['output']>;
  strategyAUM?: Maybe<Scalars['Float']['output']>;
  strategyAumCurrency?: Maybe<Scalars['String']['output']>;
};

export type FirmFundAssetsFilter = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FirmFundAssetsList = {
  __typename?: 'FirmFundAssetsList';
  items: Array<FirmFundAssets>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmFundAssetsSort = {
  field: FirmFundAssetsSortEnum;
  order: SortInput;
};

export enum FirmFundAssetsSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id'
}

export type FirmInput = {
  ITCount?: InputMaybe<Scalars['Int']['input']>;
  administrativeCount?: InputMaybe<Scalars['Int']['input']>;
  analystCount?: InputMaybe<Scalars['Int']['input']>;
  assetResolutionAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  cik?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  crd?: InputMaybe<Scalars['String']['input']>;
  dataOrganizationId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employeeTotal?: InputMaybe<Scalars['Int']['input']>;
  fdpLogins?: InputMaybe<Array<Scalars['Int']['input']>>;
  firmEmailDomains?: InputMaybe<Array<Scalars['String']['input']>>;
  firmIrEmail?: InputMaybe<Scalars['String']['input']>;
  firmTags?: InputMaybe<Array<FirmTagsInput>>;
  fundLinks?: InputMaybe<Array<FundLink>>;
  generalCount?: InputMaybe<Scalars['Int']['input']>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** @deprecated Use `fdpLoginIds` instead */
  intraLinkId?: InputMaybe<Scalars['Int']['input']>;
  investmentCount?: InputMaybe<Scalars['Int']['input']>;
  investorRelationsCount?: InputMaybe<Scalars['Int']['input']>;
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isStaffMWDBE?: InputMaybe<Scalars['Boolean']['input']>;
  legalCount?: InputMaybe<Scalars['Int']['input']>;
  lei?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  middleBackOfficeCount?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  operationsCount?: InputMaybe<Scalars['Int']['input']>;
  otherAddresses?: InputMaybe<Array<AddressInput>>;
  ownershipDiversity?: InputMaybe<FirmOwnershipDiversityInput>;
  portfolioManagerCount?: InputMaybe<Scalars['Int']['input']>;
  primaryAddress?: InputMaybe<AddressInput>;
  registeredWithIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  registeredWithOther?: InputMaybe<Scalars['String']['input']>;
  researchAndUnderwritingAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  riskCount?: InputMaybe<Scalars['Int']['input']>;
  sourcingAnalystCount?: InputMaybe<Scalars['Int']['input']>;
  stockSymbol?: InputMaybe<Scalars['String']['input']>;
  traderCount?: InputMaybe<Scalars['Int']['input']>;
  ukHfsbSignatory?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmInstitutions = {
  __typename?: 'FirmInstitutions';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  /** End date of engagement with service provider. */
  endDate?: Maybe<Scalars['Date']['output']>;
  firm: Firm;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  institutionInstitutionTypeEnumId?: Maybe<Scalars['Int']['output']>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  officeLocationServiceType?: Maybe<InstitutionsInstitutionTypeEnum>;
  /** Start date of engagement with service provider. */
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type FirmInstitutionsInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type FirmInstitutionsFilter = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmInstitutionsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionInstitutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type FirmInstitutionsList = {
  __typename?: 'FirmInstitutionsList';
  items: Array<FirmInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmInstitutionsSort = {
  field: FirmInstitutionsSortEnum;
  order: SortInput;
};

export enum FirmInstitutionsSortEnum {
  Id = 'id',
  InstitutionName = 'institutionName',
  Name = 'name'
}

export type FirmList = {
  __typename?: 'FirmList';
  items: Array<Firm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FirmOwnershipDiversity = {
  __typename?: 'FirmOwnershipDiversity';
  LGBTQPercent?: Maybe<Scalars['Float']['output']>;
  africanAmericanPercent?: Maybe<Scalars['Float']['output']>;
  asOfDate: Scalars['Date']['output'];
  asianPercent?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  disabledPercent?: Maybe<Scalars['Float']['output']>;
  diversePercent?: Maybe<Scalars['Float']['output']>;
  firmId: Scalars['Int']['output'];
  hispanicPercent?: Maybe<Scalars['Float']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  nativeAmericanPercent?: Maybe<Scalars['Float']['output']>;
  otherPercent?: Maybe<Scalars['Float']['output']>;
  veteranOrDisabledPercent?: Maybe<Scalars['Float']['output']>;
  veteranPercent?: Maybe<Scalars['Float']['output']>;
  womenPercent?: Maybe<Scalars['Float']['output']>;
};

export type FirmOwnershipDiversityInput = {
  LGBTQPercent?: InputMaybe<Scalars['Float']['input']>;
  africanAmericanPercent?: InputMaybe<Scalars['Float']['input']>;
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  asianPercent?: InputMaybe<Scalars['Float']['input']>;
  disabledPercent?: InputMaybe<Scalars['Float']['input']>;
  diversePercent?: InputMaybe<Scalars['Float']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  hispanicPercent?: InputMaybe<Scalars['Float']['input']>;
  nativeAmericanPercent?: InputMaybe<Scalars['Float']['input']>;
  otherPercent?: InputMaybe<Scalars['Float']['input']>;
  veteranOrDisabledPercent?: InputMaybe<Scalars['Float']['input']>;
  veteranPercent?: InputMaybe<Scalars['Float']['input']>;
  womenPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type FirmProfileBuilderResponse = {
  __typename?: 'FirmProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  firmProfile?: Maybe<GeneratedFirmProfile>;
};

export type FirmRegistration = {
  __typename?: 'FirmRegistration';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FirmSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
  DEI?: InputMaybe<DeiFilter>;
  FIRM_ENTITY?: InputMaybe<EntitySearchFilter>;
  HEADQUARTERS?: InputMaybe<LocationFilter>;
  MWDBE?: InputMaybe<MwdbeFilter>;
};

export type FirmSort = {
  field: FirmSortEnum;
  order: SortInput;
};

export enum FirmSortEnum {
  FuzzyRank = 'fuzzyRank',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type FirmTags = {
  __typename?: 'FirmTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firmId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagId: Scalars['Int']['output'];
};

export type FirmTagsFilter = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmTagsInput = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type FirmTagsSort = {
  field: FirmTagsSortEnum;
  order: SortInput;
};

export enum FirmTagsSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FirmTeamStructure = {
  __typename?: 'FirmTeamStructure';
  admin?: Maybe<Scalars['Int']['output']>;
  analyst?: Maybe<Scalars['Int']['output']>;
  general?: Maybe<Scalars['Int']['output']>;
  investment?: Maybe<Scalars['Int']['output']>;
  investorRelations?: Maybe<Scalars['Int']['output']>;
  legal?: Maybe<Scalars['Int']['output']>;
  operations?: Maybe<Scalars['Int']['output']>;
  portfolioManager?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  trader?: Maybe<Scalars['Int']['output']>;
};

export type FirmXImpact = {
  __typename?: 'FirmXImpact';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: Firm;
  firmId: Scalars['Int']['output'];
  impactEnum: ImpactEnum;
  impactEnumId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type FirmsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type FirmsDynamicShareRuleOutput = {
  __typename?: 'FirmsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type FloatRangeFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
};

export enum FormatOptions {
  Docx = 'docx',
  Pdf = 'pdf'
}

export type FundHoldingDetail = {
  __typename?: 'FundHoldingDetail';
  afsSecurityMappingId?: Maybe<Scalars['Int']['output']>;
  confidence?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Source AFS document ID for linking back to the document */
  documentId?: Maybe<Scalars['Int']['output']>;
  fairValue: Scalars['Float']['output'];
  fundLegalName: Scalars['String']['output'];
  /** AfsHolding row ID — used for delete/edit mutations */
  holdingId: Scalars['Int']['output'];
  /** Original holding name as it appears in this fund's AFS document */
  holdingName: Scalars['String']['output'];
  identifierType?: Maybe<Scalars['String']['output']>;
  identifierValue?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  /** Look-through value: (portfolioBalance / fundNetAssets) * holdingFairValue */
  lookthroughValue?: Maybe<Scalars['Float']['output']>;
  manuallyVerified?: Maybe<Scalars['Boolean']['output']>;
  /** Computed match type: 'aiMatched' (identifier-based automated match), 'proxy' (user-selected representative), 'manual' (user-verified), or null (unmatched) */
  matchType?: Maybe<Scalars['String']['output']>;
  percentageOfNav?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  /** Portfolio's balance in this fund at AFS period end */
  portfolioBalance?: Maybe<Scalars['Float']['output']>;
  securityMasterName?: Maybe<Scalars['String']['output']>;
  securityType?: Maybe<Scalars['String']['output']>;
  /** 1-based PDF page where this holding appears in the Schedule of Investments */
  sourcePage?: Maybe<Scalars['Int']['output']>;
  /** Short verbatim quote for highlighting the holding in the document viewer */
  sourceQuote?: Maybe<Scalars['String']['output']>;
  suggestedSecurityMasterId?: Maybe<Scalars['Int']['output']>;
  suggestedSecurityMasterName?: Maybe<Scalars['String']['output']>;
};

export type FundLink = {
  investmentId: Scalars['Int']['input'];
  linkId?: InputMaybe<Scalars['Int']['input']>;
};

export type FundLinks = {
  __typename?: 'FundLinks';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type FundingTypeEnum = {
  __typename?: 'FundingTypeEnum';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FundingTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type FundingTypeEnumList = {
  __typename?: 'FundingTypeEnumList';
  items: Array<FundingTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FundingTypeEnumSort = {
  field: FundingTypeEnumSortEnum;
  order: SortInput;
};

export enum FundingTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type FundsXProxies = {
  __typename?: 'FundsXProxies';
  createDate?: Maybe<Scalars['Date']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['Date']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  proxy: Investment;
  proxyId: Scalars['Int']['output'];
  proxyScalingFactor?: Maybe<Scalars['Float']['output']>;
  rank: Scalars['Int']['output'];
};

export type FundsXProxiesFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  proxyId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type FundsXProxiesInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  proxyId?: InputMaybe<Scalars['Int']['input']>;
  proxyScalingFactor?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type FundsXProxiesList = {
  __typename?: 'FundsXProxiesList';
  items: Array<FundsXProxies>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type FundsXProxiesSort = {
  field: FundsXProxiesSortEnum;
  order: SortInput;
};

export enum FundsXProxiesSortEnum {
  Id = 'id',
  Rank = 'rank'
}

export type GeneratedAddress = {
  __typename?: 'GeneratedAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryEnumId?: Maybe<Scalars['Int']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  line3?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  stateEnumId?: Maybe<Scalars['Int']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type GeneratedFirmEmployment = {
  __typename?: 'GeneratedFirmEmployment';
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  firmId?: Maybe<Scalars['Int']['output']>;
  firmName?: Maybe<Scalars['String']['output']>;
  isFounder?: Maybe<Scalars['Boolean']['output']>;
  isKeyPersonnel?: Maybe<Scalars['Boolean']['output']>;
  jobDescription?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type GeneratedFirmProfile = {
  __typename?: 'GeneratedFirmProfile';
  administrativeCount?: Maybe<Scalars['Int']['output']>;
  analystCount?: Maybe<Scalars['Int']['output']>;
  cik?: Maybe<Scalars['String']['output']>;
  crd?: Maybe<Scalars['String']['output']>;
  employeeTotal?: Maybe<Scalars['Int']['output']>;
  firmIrEmail?: Maybe<Scalars['String']['output']>;
  investmentCount?: Maybe<Scalars['Int']['output']>;
  investorRelationsCount?: Maybe<Scalars['Int']['output']>;
  legalCount?: Maybe<Scalars['Int']['output']>;
  lei?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  operationsCount?: Maybe<Scalars['Int']['output']>;
  portfolioManagerCount?: Maybe<Scalars['Int']['output']>;
  primaryAddress?: Maybe<GeneratedAddress>;
  registeredWithIds?: Maybe<Array<Scalars['Int']['output']>>;
  traderCount?: Maybe<Scalars['Int']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedInvestmentFees = {
  __typename?: 'GeneratedInvestmentFees';
  abnormalFees?: Maybe<Scalars['Boolean']['output']>;
  abnormalFeesNotes?: Maybe<Scalars['String']['output']>;
  annualReset?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChanged?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChangedNotes?: Maybe<Scalars['String']['output']>;
  hasMgmtFeeStepDown?: Maybe<Scalars['Boolean']['output']>;
  highWaterMark?: Maybe<Scalars['Boolean']['output']>;
  hurdle?: Maybe<Scalars['Boolean']['output']>;
  hurdleBenchmark?: Maybe<Scalars['String']['output']>;
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  incentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  incentiveFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  otherFee?: Maybe<Scalars['Float']['output']>;
  otherFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  otherFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  peIncentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringCommitment?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringCommitmentCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringHarvest?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringHarvestCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownPercent?: Maybe<Scalars['Float']['output']>;
  standardShareClassRates?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneratedInvestmentProfile = {
  __typename?: 'GeneratedInvestmentProfile';
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  committedCapital?: Maybe<Scalars['Float']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  firmId?: Maybe<Scalars['Int']['output']>;
  firmName?: Maybe<Scalars['String']['output']>;
  gpCommitted?: Maybe<Scalars['Float']['output']>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  marketEnumId?: Maybe<Scalars['Int']['output']>;
  maxTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  maxTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  minTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  minTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  peLegalLifeYrs?: Maybe<Scalars['Int']['output']>;
  peStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  primaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  primaryGeographicFocusId?: Maybe<Scalars['Int']['output']>;
  secondaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  vehicleTypeEnumId?: Maybe<Scalars['Int']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedLiquidity = {
  __typename?: 'GeneratedLiquidity';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  exceptions?: Maybe<Scalars['String']['output']>;
  gatePercentCapital?: Maybe<Scalars['Float']['output']>;
  gatePercentNav?: Maybe<Scalars['Float']['output']>;
  hasGate?: Maybe<Scalars['Boolean']['output']>;
  hasHoldback?: Maybe<Scalars['Boolean']['output']>;
  hasLockup?: Maybe<Scalars['Boolean']['output']>;
  hasRollover?: Maybe<Scalars['Boolean']['output']>;
  holdbackPercent?: Maybe<Scalars['Float']['output']>;
  liquidityMonthlyValue?: Maybe<Scalars['Int']['output']>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  lockupEndValueId?: Maybe<Scalars['Int']['output']>;
  lockupMonthlyValue?: Maybe<Scalars['Int']['output']>;
  lockupUnitId?: Maybe<Scalars['Int']['output']>;
  lockupValue?: Maybe<Scalars['Int']['output']>;
  modelingNotes?: Maybe<Scalars['String']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeUnitId?: Maybe<Scalars['Int']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  rolloverUnitId?: Maybe<Scalars['Int']['output']>;
  rolloverValue?: Maybe<Scalars['Int']['output']>;
  secondLockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndValueId?: Maybe<Scalars['Int']['output']>;
  subscriptionUnitId?: Maybe<Scalars['Int']['output']>;
  subscriptionValue?: Maybe<Scalars['Int']['output']>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};

export type GeneratedPeLiquidity = {
  __typename?: 'GeneratedPeLiquidity';
  catchupPercent?: Maybe<Scalars['Float']['output']>;
  compoundingPeriodId?: Maybe<Scalars['Int']['output']>;
  hasCatchupProvision?: Maybe<Scalars['Boolean']['output']>;
  isCompounded?: Maybe<Scalars['Boolean']['output']>;
  optionOfExtensionId?: Maybe<Scalars['Int']['output']>;
  preferredReturn?: Maybe<Scalars['Float']['output']>;
};

export type GeneratedPersonDiversity = {
  __typename?: 'GeneratedPersonDiversity';
  africanAmerican?: Maybe<Scalars['Boolean']['output']>;
  asian?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  hawaiianOrPacificIslander?: Maybe<Scalars['Boolean']['output']>;
  hispanic?: Maybe<Scalars['Boolean']['output']>;
  lgbtq?: Maybe<Scalars['Boolean']['output']>;
  nativeAmerican?: Maybe<Scalars['Boolean']['output']>;
  nonBinary?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  veteran?: Maybe<Scalars['Boolean']['output']>;
  woman?: Maybe<Scalars['Boolean']['output']>;
};

export type GeneratedPersonProfile = {
  __typename?: 'GeneratedPersonProfile';
  biography?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  diversity?: Maybe<GeneratedPersonDiversity>;
  educationSummary?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  firmEmployment?: Maybe<GeneratedFirmEmployment>;
  firstName?: Maybe<Scalars['String']['output']>;
  isCFA?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  titleEnumId?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  workExperienceSummary?: Maybe<Scalars['String']['output']>;
};

export type GeneratedShareClassProfile = {
  __typename?: 'GeneratedShareClassProfile';
  FAS157?: Maybe<Scalars['Int']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  investmentFees?: Maybe<GeneratedInvestmentFees>;
  isRcgNegotiated?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<GeneratedLiquidity>;
  name?: Maybe<Scalars['String']['output']>;
  otherFees?: Maybe<Scalars['String']['output']>;
  peLiquidity?: Maybe<GeneratedPeLiquidity>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type GenericContentItem = {
  __typename?: 'GenericContentItem';
  collapsed_text?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Array<GenericContentItem>>;
  display_name?: Maybe<Scalars['String']['output']>;
  display_options?: Maybe<DisplayOptions>;
  display_type?: Maybe<Scalars['String']['output']>;
  expanded?: Maybe<Scalars['Boolean']['output']>;
  expanded_text?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  question_text?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GenericField = {
  __typename?: 'GenericField';
  allowNotApplicable?: Maybe<Scalars['Boolean']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  conditionalDescriptionKey?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displaySort?: Maybe<DisplaySort>;
  displayType?: Maybe<Scalars['String']['output']>;
  editRoute?: Maybe<Scalars['String']['output']>;
  managerRestricted?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Scalars['String']['output']>>;
  period?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  readOnly?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  translations?: Maybe<GenericFieldTranslations>;
  value: GenericProp;
};

export type GenericFieldSet = {
  __typename?: 'GenericFieldSet';
  access_level: Scalars['String']['output'];
  config?: Maybe<FieldSetConfig>;
  content: Array<GenericContentItem>;
  description: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  key: Scalars['String']['output'];
  mapping?: Maybe<FieldSetMapping>;
  type: Scalars['String']['output'];
};

export type GenericFieldTranslations = {
  __typename?: 'GenericFieldTranslations';
  falseText?: Maybe<Scalars['String']['output']>;
  trueText?: Maybe<Scalars['String']['output']>;
};

export type GenericProp = {
  __typename?: 'GenericProp';
  arrayDepth: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  hideChangelog?: Maybe<Scalars['Boolean']['output']>;
  hideMultiStateView?: Maybe<Scalars['Boolean']['output']>;
  hideTimeStamp?: Maybe<Scalars['Boolean']['output']>;
  isEmail?: Maybe<Scalars['Boolean']['output']>;
  isNumericString?: Maybe<Scalars['Boolean']['output']>;
  isScalar: Scalars['Boolean']['output'];
  isUUID?: Maybe<Scalars['Boolean']['output']>;
  isUrl?: Maybe<Scalars['Boolean']['output']>;
  length?: Maybe<LengthConstraint>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nullable: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  propertyKey: Scalars['String']['output'];
  props: Array<GenericProp>;
  returnTypeName: Scalars['String']['output'];
};

export type GeographicFocusEnum = {
  __typename?: 'GeographicFocusEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investments: Array<Investment>;
  name: Scalars['String']['output'];
};

export type GeographicFocusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type GeographicFocusEnumList = {
  __typename?: 'GeographicFocusEnumList';
  items: Array<GeographicFocusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GeographicFocusEnumSort = {
  field: GeographicFocusEnumSortEnum;
  order: SortInput;
};

export enum GeographicFocusEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type GeographyEnum = {
  __typename?: 'GeographyEnum';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export type GeographyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type GeographyEnumList = {
  __typename?: 'GeographyEnumList';
  items: Array<GeographyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GeographyEnumSort = {
  field: GeographyEnumSortEnum;
  order: SortInput;
};

export enum GeographyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type GlobalProviderInstitutionInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalProviderInstitutions = {
  __typename?: 'GlobalProviderInstitutions';
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  isCorporate: Scalars['Boolean']['output'];
  provider: ServiceProviderFirm;
  providerId: Scalars['Int']['output'];
};

export type GlobalProviderInstitutionsFilterInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
};

export type GlobalProviderInstitutionsList = {
  __typename?: 'GlobalProviderInstitutionsList';
  items: Array<GlobalProviderInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GlobalProviderInstitutionsSort = {
  field: GlobalProviderInstitutionsSortEnum;
  order: SortInput;
};

export enum GlobalProviderInstitutionsSortEnum {
  Institution = 'institution',
  Provider = 'provider'
}

export type GlobalProviderNoteTypeEnum = {
  __typename?: 'GlobalProviderNoteTypeEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type GlobalProviderNoteTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type GlobalProviderNoteTypeEnumList = {
  __typename?: 'GlobalProviderNoteTypeEnumList';
  items: Array<GlobalProviderNoteTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GlobalProviderNoteTypeEnumSort = {
  field: GlobalProviderNoteTypeEnumSortEnum;
  order: SortInput;
};

export enum GlobalProviderNoteTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export enum GroupEntityType {
  ApplicationFlag = 'applicationFlag',
  Deal = 'deal',
  Document = 'document',
  Firm = 'firm',
  FirmEngagement = 'firmEngagement',
  Investment = 'investment',
  Person = 'person',
  Portfolio = 'portfolio'
}

export type GroupInvestmentSetSubscription = {
  __typename?: 'GroupInvestmentSetSubscription';
  group?: Maybe<User>;
  groupId: Scalars['Int']['output'];
};

export type GroupShareDefinition = {
  __typename?: 'GroupShareDefinition';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  dynamicDefinition?: Maybe<Scalars['String']['output']>;
  dynamicDefinitionStructured?: Maybe<DynamicDefinitionOutput>;
  entityAccessId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  lastExecuted?: Maybe<Scalars['DateTime']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  sourceGroup?: Maybe<User>;
  sourceGroupId: Scalars['Int']['output'];
  targetGroup?: Maybe<User>;
  targetGroupId: Scalars['Int']['output'];
};

export type GroupShareDefinitionFilter = {
  entityAccessId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sourceGroupId?: InputMaybe<Scalars['Int']['input']>;
  targetGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupShareDefinitionInput = {
  dynamicDefinition?: InputMaybe<DynamicDefinitionInput>;
  entityAccessId: Scalars['Int']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  sourceGroupId: Scalars['Int']['input'];
  targetGroupId: Scalars['Int']['input'];
};

export type GroupShareDefinitionList = {
  __typename?: 'GroupShareDefinitionList';
  items: Array<GroupShareDefinition>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type GroupShareDefinitionSort = {
  field: GroupShareDefinitionSortEnum;
  order: SortInput;
};

export enum GroupShareDefinitionSortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  LastExecuted = 'lastExecuted',
  ModifyDate = 'modifyDate'
}

export type GroupShareInvestmentSetFilter = {
  setId: Scalars['Int']['input'];
};

export type GroupShareInvestmentSetFilterOutput = {
  __typename?: 'GroupShareInvestmentSetFilterOutput';
  setId: Scalars['Int']['output'];
};

export type GroupStatsInvestment = {
  __typename?: 'GroupStatsInvestment';
  exposure?: Maybe<Exposure>;
  id: Scalars['Int']['output'];
  isEntitled: Scalars['Boolean']['output'];
  list?: Maybe<InvestmentListEnum>;
  name: Scalars['String']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  strategy: StrategyEnum;
  subStrategy?: Maybe<SubStrategyEnum>;
};


export type GroupStatsInvestmentExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GroupStatsList = {
  __typename?: 'GroupStatsList';
  items: Array<GroupStatsInvestment>;
  nextPage: NextPage;
  stats: StatsGroup;
  total: Scalars['Int']['output'];
};

export type Guideline = {
  __typename?: 'Guideline';
  arguments: Array<GuidelineArgument>;
  entitySourceId?: Maybe<Scalars['Float']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['Float']['output'];
  isInternal: Scalars['Boolean']['output'];
  limit?: Maybe<GuidelineLimit>;
  metricInfoId?: Maybe<Scalars['Float']['output']>;
  nodeId: Scalars['Float']['output'];
  resultCardinality: Scalars['Float']['output'];
  resultType: Scalars['Float']['output'];
  results: Array<GuidelineResult>;
};

export type GuidelineArgument = {
  __typename?: 'GuidelineArgument';
  guidelineId: Scalars['Float']['output'];
  parameterName: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GuidelineArgumentInput = {
  parameterName: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type GuidelineBreachSummary = {
  __typename?: 'GuidelineBreachSummary';
  breachCount: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  investmentName: Scalars['String']['output'];
  totalGuidelines: Scalars['Int']['output'];
};

export type GuidelineLimit = {
  __typename?: 'GuidelineLimit';
  guidelineId: Scalars['Float']['output'];
  limitValue: Scalars['String']['output'];
  relationToResult?: Maybe<Scalars['Float']['output']>;
};

export type GuidelineNode = {
  __typename?: 'GuidelineNode';
  children: Array<GuidelineNode>;
  description?: Maybe<Scalars['String']['output']>;
  guideline?: Maybe<Guideline>;
  id: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Float']['output']>;
  siblingIndex: Scalars['Float']['output'];
};

export type GuidelineNote = {
  __typename?: 'GuidelineNote';
  guidelineDate: Scalars['DateTime']['output'];
  investmentId: Scalars['Float']['output'];
  noteText?: Maybe<Scalars['String']['output']>;
};

export type GuidelineResult = {
  __typename?: 'GuidelineResult';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  date: Scalars['DateTime']['output'];
  guidelineId: Scalars['Float']['output'];
  isCompliant: Scalars['Boolean']['output'];
  isError: Scalars['Boolean']['output'];
  isOverride: Scalars['Boolean']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type GuidelineSet = {
  __typename?: 'GuidelineSet';
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  investmentId: Scalars['Float']['output'];
  nodes: Array<GuidelineNode>;
};

export type GuidelineSetDeleteResult = {
  __typename?: 'GuidelineSetDeleteResult';
  success: Scalars['Boolean']['output'];
};

export type HistoricalPeriodInput = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type IPieData = {
  name: Scalars['String']['input'];
  y: Scalars['Float']['input'];
};

export type IconEnum = {
  __typename?: 'IconEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type IconEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IconEnumList = {
  __typename?: 'IconEnumList';
  items: Array<IconEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type IconEnumSort = {
  field: IconEnumSortEnum;
  order: SortInput;
};

export enum IconEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type IdpInfo = {
  __typename?: 'IdpInfo';
  authType: UserAuthType;
  cognitoIdpIdentifier?: Maybe<Scalars['String']['output']>;
  found: Scalars['Boolean']['output'];
};

export type ImpactCategoryEnum = {
  __typename?: 'ImpactCategoryEnum';
  atlasKey: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  impactEnums: Array<ImpactEnum>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ImpactCategoryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ImpactCategoryEnumList = {
  __typename?: 'ImpactCategoryEnumList';
  items: Array<ImpactCategoryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ImpactCategoryEnumSort = {
  field: ImpactCategoryEnumSortEnum;
  order: SortInput;
};

export enum ImpactCategoryEnumSortEnum {
  Id = 'id'
}

export type ImpactEnum = {
  __typename?: 'ImpactEnum';
  atlasKey: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  impactCategory: ImpactCategoryEnum;
  impactEnumCategoryId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ImpactSearchFilter = {
  /** Defaults to false */
  isOr?: InputMaybe<Scalars['Boolean']['input']>;
  values: Array<EntityKey>;
};

export type ImportGuidelineNodeInput = {
  arguments?: InputMaybe<Array<GuidelineArgumentInput>>;
  children?: InputMaybe<Array<ImportGuidelineNodeInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  metricInfoId?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  resultCardinality?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportResult = {
  __typename?: 'ImportResult';
  guidelinesCreated: Scalars['Int']['output'];
  nodesCreated: Scalars['Int']['output'];
};

export type ImportRiskFromS3Input = {
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  errorRowLimit?: InputMaybe<Scalars['Int']['input']>;
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  s3Bucket?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  validateOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportRiskFromS3Result = {
  __typename?: 'ImportRiskFromS3Result';
  jobId?: Maybe<Scalars['String']['output']>;
  jobName: Scalars['String']['output'];
  queueName: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};

export type ImportRiskMeasuresStatus = {
  __typename?: 'ImportRiskMeasuresStatus';
  id: Scalars['ID']['output'];
  returnValue?: Maybe<RiskFileParse>;
  status: AsyncTaskStatus;
};

export type InactiveInvestmentFilter = {
  /** Defaults to false */
  hideInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndexCalcTypeEnum = {
  __typename?: 'IndexCalcTypeEnum';
  description: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  indexCalcType: Scalars['String']['output'];
};

export type IndexCalcTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type IndexCalcTypeEnumList = {
  __typename?: 'IndexCalcTypeEnumList';
  items: Array<IndexCalcTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type IndexCalcTypeEnumSort = {
  field: IndexCalcTypeEnumSortEnum;
  order: SortInput;
};

export enum IndexCalcTypeEnumSortEnum {
  Id = 'id',
  IndexCalcType = 'indexCalcType'
}

export type Institution = {
  __typename?: 'Institution';
  address: Address;
  addressesId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  globalProviderInstitution?: Maybe<GlobalProviderInstitutions>;
  globalProviderInstitutionsList?: Maybe<GlobalProviderInstitutionsList>;
  id: Scalars['Int']['output'];
  institutionInstitutionTypesList: Array<Scalars['Int']['output']>;
  institutionNameWithLocation: Scalars['String']['output'];
  institutionSelectionStatus?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnum?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnumId?: Maybe<Scalars['Int']['output']>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
};


export type InstitutionGlobalProviderInstitutionArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type InstitutionGlobalProviderInstitutionsListArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type InstitutionInstitutionInstitutionTypesListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};


export type InstitutionInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type InstitutionEmployment = {
  __typename?: 'InstitutionEmployment';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  isPrimaryContact?: Maybe<Scalars['Boolean']['output']>;
  leftDate?: Maybe<Scalars['Date']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  person: Person;
  personId: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type InstitutionEmploymentFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type InstitutionEmploymentInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  isPrimaryContact?: InputMaybe<Scalars['Boolean']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InstitutionEmploymentList = {
  __typename?: 'InstitutionEmploymentList';
  items: Array<InstitutionEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionEmploymentSort = {
  field: InstitutionEmploymentSortEnum;
  order: SortInput;
};

export enum InstitutionEmploymentSortEnum {
  Id = 'id'
}

export type InstitutionFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionInput = {
  address?: InputMaybe<AddressInput>;
  globalProviderInstitution?: InputMaybe<GlobalProviderInstitutionInput>;
  institutionInstitutionTypesList?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionSelectionStatusEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionList = {
  __typename?: 'InstitutionList';
  items: Array<Institution>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionSelectionStatusEnum = {
  __typename?: 'InstitutionSelectionStatusEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InstitutionSelectionStatusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionSelectionStatusEnumList = {
  __typename?: 'InstitutionSelectionStatusEnumList';
  items: Array<InstitutionSelectionStatusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionSelectionStatusEnumSort = {
  field: InstitutionSelectionStatusEnumSortEnum;
  order: SortInput;
};

export enum InstitutionSelectionStatusEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InstitutionSort = {
  field: InstitutionSortEnum;
  order: SortInput;
};

export enum InstitutionSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InstitutionTypeEnum = {
  __typename?: 'InstitutionTypeEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InstitutionTypeEnumFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionTypeEnumList = {
  __typename?: 'InstitutionTypeEnumList';
  items: Array<InstitutionTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionTypeEnumSort = {
  field: InstitutionTypeEnumSortEnum;
  order: SortInput;
};

export enum InstitutionTypeEnumSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InstitutionsInstitutionTypeEnum = {
  __typename?: 'InstitutionsInstitutionTypeEnum';
  id: Scalars['Int']['output'];
  institutionId: Scalars['Int']['output'];
  institutionTypeEnum: InstitutionTypeEnum;
  institutionTypeEnumId: Scalars['Int']['output'];
};

export type InstitutionsInstitutionTypeEnumFilterInput = {
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InstitutionsInstitutionTypeEnumList = {
  __typename?: 'InstitutionsInstitutionTypeEnumList';
  items: Array<InstitutionsInstitutionTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InstitutionsInstitutionTypeEnumSort = {
  field: InstitutionsInstitutionTypeEnumSortEnum;
  order: SortInput;
};

export enum InstitutionsInstitutionTypeEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type IntRangeFilter = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type IntraLink = {
  __typename?: 'IntraLink';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  securityQuestion?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type Investment = {
  __typename?: 'Investment';
  HFRIInvestmentId?: Maybe<Scalars['Int']['output']>;
  NAVClassification?: Maybe<NavClassificationEnum>;
  NAVClassificationEnumId?: Maybe<Scalars['Int']['output']>;
  RICId?: Maybe<Scalars['String']['output']>;
  access?: Maybe<EntityAccess>;
  accessRequest?: Maybe<Scalars['Boolean']['output']>;
  accountTypeEnumId?: Maybe<Scalars['Int']['output']>;
  accountingIsCommodityFuture?: Maybe<Scalars['Boolean']['output']>;
  advisor?: Maybe<Firm>;
  advisorId?: Maybe<Scalars['Int']['output']>;
  advisorTypeEnumId?: Maybe<Scalars['Int']['output']>;
  alphaVantageTicker?: Maybe<Scalars['String']['output']>;
  assetClass?: Maybe<AssetClass2Enum>;
  assetClassEnumId?: Maybe<Scalars['Int']['output']>;
  assets?: Maybe<Array<FirmFundAssets>>;
  atlasInvestmentId?: Maybe<Scalars['ID']['output']>;
  axysCodes: Array<InvestmentAxysCode>;
  bloombergCode?: Maybe<Scalars['String']['output']>;
  bloombergField?: Maybe<Scalars['String']['output']>;
  burgissId?: Maybe<Scalars['UUID']['output']>;
  closeDateFundSize?: Maybe<Array<CloseDateFundSize>>;
  cogencyLink?: Maybe<CogencyLink>;
  committedCapital?: Maybe<Scalars['Float']['output']>;
  committedCapitalCurrency?: Maybe<CurrencyDenominationEnum>;
  committedCapitalCurrencyId?: Maybe<Scalars['Int']['output']>;
  completeness?: Maybe<Array<MemoizedInvestmentCompletenessSummary>>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  currencyDenominationEnum?: Maybe<CurrencyDenominationEnum>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  derivedPrivateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  diligenceTabs?: Maybe<Array<TemplateAttachment>>;
  domicileCountry?: Maybe<CountryEnum>;
  domicileCountryId?: Maybe<Scalars['Int']['output']>;
  domicileFundLinkId?: Maybe<Scalars['Int']['output']>;
  domicileLink?: Maybe<FundLinks>;
  domicileUSState?: Maybe<StateEnum>;
  domicileUSStateId?: Maybe<Scalars['Int']['output']>;
  evestmentId?: Maybe<Scalars['Int']['output']>;
  exposure?: Maybe<Exposure>;
  extensionPeriodYrs?: Maybe<Scalars['Int']['output']>;
  faceOfInvestment?: Maybe<InvestmentFirmEmployment>;
  family?: Maybe<Family>;
  familyId?: Maybe<Scalars['Int']['output']>;
  fdpLogins?: Maybe<Array<FdpLogin>>;
  fieldData?: Maybe<FieldData>;
  fieldHistory?: Maybe<Array<Field>>;
  fields?: Maybe<InvestmentFields>;
  firm?: Maybe<Firm>;
  firmId?: Maybe<Scalars['Int']['output']>;
  fiscalYearEndMonth?: Maybe<Scalars['Int']['output']>;
  fundLinkId?: Maybe<Scalars['Int']['output']>;
  fundsXProxies?: Maybe<Array<FundsXProxies>>;
  gapAnalysis?: Maybe<DiligenceGapAnalysis>;
  gpCommitted?: Maybe<Scalars['Float']['output']>;
  gpCommittedCurrency?: Maybe<CurrencyDenominationEnum>;
  gpCommittedCurrencyId?: Maybe<Scalars['Int']['output']>;
  groupStats: GroupStatsList;
  hardCap?: Maybe<Scalars['Float']['output']>;
  harvestPeriodYrs?: Maybe<Scalars['Int']['output']>;
  hasPricingData?: Maybe<Scalars['Boolean']['output']>;
  holdingPortfolios: BalancesList;
  id: Scalars['Int']['output'];
  impactTags?: Maybe<Array<ImpactEnum>>;
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  indexCalcTypeEnum?: Maybe<IndexCalcTypeEnum>;
  indexCalcTypeEnumId?: Maybe<Scalars['Int']['output']>;
  investmentFirmEmployments: Array<InvestmentFirmEmployment>;
  investmentGroupId?: Maybe<Scalars['Int']['output']>;
  investmentInstitutionsList?: Maybe<InvestmentInstitutionsList>;
  investmentPeriodYrs?: Maybe<Scalars['Int']['output']>;
  investmentRegulatorsList?: Maybe<InvestmentRegulatorsList>;
  investmentStructure?: Maybe<InvestmentStructureEnum>;
  investmentStructureEnumId?: Maybe<Scalars['Int']['output']>;
  investmentTags?: Maybe<Array<InvestmentTags>>;
  investmentXImpact?: Maybe<Array<InvestmentXImpact>>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isESG?: Maybe<Scalars['Boolean']['output']>;
  isEntitled?: Maybe<Scalars['Boolean']['output']>;
  isImpact?: Maybe<Scalars['Boolean']['output']>;
  isInActive?: Maybe<Scalars['Boolean']['output']>;
  isLiquidated?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvideAUM?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvidePerformance?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvidePositions?: Maybe<Scalars['Boolean']['output']>;
  isManagerUnwillingToProvideRisk?: Maybe<Scalars['Boolean']['output']>;
  isOffshore?: Maybe<Scalars['Boolean']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  isPortfolio?: Maybe<Scalars['Boolean']['output']>;
  isRegisteredInvestmentCompany?: Maybe<Scalars['Boolean']['output']>;
  isSubAdvised?: Maybe<Scalars['Boolean']['output']>;
  isWorkInProgress?: Maybe<Scalars['Boolean']['output']>;
  latestFirmAUM?: Maybe<DatedAsset>;
  latestInvestmentAUM?: Maybe<DatedAsset>;
  latestNote?: Maybe<Notes>;
  latestStrategyAUM?: Maybe<DatedAsset>;
  legalStructure?: Maybe<LegalStructureEnum>;
  legalStructureEnumId?: Maybe<Scalars['Int']['output']>;
  links?: Maybe<FundLinks>;
  liquidationDate?: Maybe<Scalars['Date']['output']>;
  liquidationNote?: Maybe<Scalars['String']['output']>;
  list?: Maybe<InvestmentListEnum>;
  listEnumId?: Maybe<Scalars['Int']['output']>;
  listItems?: Maybe<Array<InvestmentSetItems>>;
  llmPerformanceMTD?: Maybe<Array<LlmPerformance>>;
  managerAttributes?: Maybe<Array<VManagerAttribute>>;
  market?: Maybe<AssetClassEnum>;
  marketEnumId?: Maybe<Scalars['Int']['output']>;
  maxExpectedVolatility?: Maybe<Scalars['Float']['output']>;
  maxGrossExposure?: Maybe<Scalars['Float']['output']>;
  maxNetExposure?: Maybe<Scalars['Float']['output']>;
  maxTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  maxTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  minExpectedVolatility?: Maybe<Scalars['Float']['output']>;
  minGrossExposure?: Maybe<Scalars['Float']['output']>;
  minNetExposure?: Maybe<Scalars['Float']['output']>;
  minTargetNetIRR?: Maybe<Scalars['Float']['output']>;
  minTargetNetMOIC?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Has RockCreek signed an NDA precluding them from sharing fund data with 3rd Parties? */
  ndaSigned?: Maybe<Scalars['Boolean']['output']>;
  notesList?: Maybe<NotesList>;
  organizationStructure?: Maybe<OrganizationStructureEnum>;
  organizationStructureEnumId?: Maybe<Scalars['Int']['output']>;
  otherGeographicFocusIds?: Maybe<Array<Scalars['Int']['output']>>;
  otherGeographicFocuses?: Maybe<Array<GeographicFocusEnum>>;
  peFundNumber?: Maybe<PeFundNumberEnum>;
  peFundNumberEnumId?: Maybe<Scalars['Int']['output']>;
  peLegalLifeYrs?: Maybe<Scalars['Int']['output']>;
  peStrategy?: Maybe<PeStrategyEnum>;
  peStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  peSubStrategy?: Maybe<PeSubStrategyEnum>;
  peSubStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  peersAutoList: InvestmentList;
  peersList: InvestmentList;
  peersStats: GroupStatsList;
  performanceAnalysis?: Maybe<PerformanceAnalytics>;
  performanceMTD?: Maybe<Array<PerformanceMtd>>;
  performanceMTDCurrencyConverted?: Maybe<Array<PerformanceMtd>>;
  performancePeriodRange?: Maybe<PerformancePeriodRange>;
  performancePrivate?: Maybe<Array<PerformancePrivate>>;
  performanceQuarterly?: Maybe<Array<PerformanceQuarterly>>;
  performanceSource?: Maybe<Scalars['String']['output']>;
  performanceSourceEnum: Array<PerformanceSourceEnum>;
  performanceSourceEnumId?: Maybe<Scalars['Int']['output']>;
  performanceStats?: Maybe<PerformanceStatistics>;
  portalSubmitted?: Maybe<PortalSubmitted>;
  portfolioConfig?: Maybe<PortfolioConfig>;
  positions?: Maybe<PositionList>;
  pricingFrequency?: Maybe<PricingFrequencyEnum>;
  pricingFrequencyEnumId?: Maybe<Scalars['Int']['output']>;
  primaryAssignment?: Maybe<Scalars['String']['output']>;
  primaryBenchmark?: Maybe<Investment>;
  primaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  primaryFundAdvisor?: Maybe<User>;
  primaryGeographicFocus?: Maybe<GeographicFocusEnum>;
  primaryGeographicFocusId?: Maybe<Scalars['Int']['output']>;
  primaryPortfolio?: Maybe<Portfolio>;
  primaryPortfolioManager?: Maybe<InvestmentFirmEmployment>;
  publishedFieldState?: Maybe<Scalars['String']['output']>;
  registeredAddressProvider?: Maybe<Institution>;
  reportingDate?: Maybe<Scalars['Date']['output']>;
  reportingDateReason?: Maybe<Scalars['String']['output']>;
  reportingLinkId?: Maybe<Scalars['Int']['output']>;
  secondaryAssignment?: Maybe<Scalars['String']['output']>;
  secondaryBenchmark?: Maybe<Investment>;
  secondaryBenchmarkId?: Maybe<Scalars['Int']['output']>;
  secondaryFundAdvisor?: Maybe<User>;
  shareClassNote?: Maybe<Scalars['String']['output']>;
  shareClasses?: Maybe<Array<ShareClass>>;
  sharingOrganizationIconUrl?: Maybe<Scalars['String']['output']>;
  sharingOrganizationName?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<StrategyEnum>;
  strategyEnumId?: Maybe<Scalars['Int']['output']>;
  subStrategy?: Maybe<SubStrategyEnum>;
  subStrategyEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  tagAttributes?: Maybe<TagAttributes>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  templateOptions?: Maybe<Array<Scalars['String']['output']>>;
  uniqueSecurityCode?: Maybe<Scalars['String']['output']>;
  vehicleType?: Maybe<VehicleTypeEnum>;
  vehicleTypeEnumId?: Maybe<Scalars['Int']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};


export type InvestmentAssetsArgs = {
  filter?: InputMaybe<FirmFundAssetsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmFundAssetsSort>>;
};


export type InvestmentCompletenessArgs = {
  memoized: Scalars['Boolean']['input'];
};


export type InvestmentExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type InvestmentFdpLoginsArgs = {
  filter?: InputMaybe<FdpLoginFilter>;
};


export type InvestmentFieldDataArgs = {
  fieldSetType: FieldSetType;
  state?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type InvestmentFieldHistoryArgs = {
  filter?: InputMaybe<FieldHistoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldHistorySort>>;
};


export type InvestmentFieldsArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type InvestmentGroupStatsArgs = {
  asOfDate: Scalars['Date']['input'];
  dependentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<InvestmentFilterInput>;
  includeBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<InvestmentSort>>;
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type InvestmentHoldingPortfoliosArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
};


export type InvestmentInvestmentFirmEmploymentsArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};


export type InvestmentInvestmentInstitutionsListArgs = {
  filter?: InputMaybe<InvestmentInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentInstitutionsSort>>;
};


export type InvestmentInvestmentRegulatorsListArgs = {
  filter?: InputMaybe<InvestmentRegulatorsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRegulatorsSort>>;
};


export type InvestmentLatestNoteArgs = {
  noteMetaId: Scalars['Int']['input'];
};


export type InvestmentLlmPerformanceMtdArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
};


export type InvestmentNotesListArgs = {
  filter?: InputMaybe<NotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NotesSort>>;
};


export type InvestmentPeersAutoListArgs = {
  filter?: InputMaybe<InvestmentPeersFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type InvestmentPeersListArgs = {
  filter?: InputMaybe<InvestmentPeersFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type InvestmentPeersStatsArgs = {
  asOfDate: Scalars['Date']['input'];
  filter?: InputMaybe<InvestmentFilterInput>;
  includeBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};


export type InvestmentPerformanceAnalysisArgs = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
};


export type InvestmentPerformanceMtdArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
};


export type InvestmentPerformanceMtdCurrencyConvertedArgs = {
  filter?: InputMaybe<PerformanceMtdFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceMtdSort>>;
  toCurrencyId: Scalars['Int']['input'];
};


export type InvestmentPerformancePeriodRangeArgs = {
  returnType?: InputMaybe<ReturnTypes>;
};


export type InvestmentPerformancePrivateArgs = {
  filter?: InputMaybe<PerformancePrivateFilter>;
  page?: InputMaybe<PageInput>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformancePrivateSort>>;
};


export type InvestmentPerformanceQuarterlyArgs = {
  filter?: InputMaybe<PerformanceQuarterlyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceQuarterlySort>>;
};


export type InvestmentPerformanceStatsArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
};


export type InvestmentPositionsArgs = {
  filter?: InputMaybe<PositionFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PositionSort>>;
};


export type InvestmentShareClassesArgs = {
  filter?: InputMaybe<ShareClassFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ShareClassSort>>;
};


export type InvestmentTemplateOptionsArgs = {
  fieldSetType: FieldSetType;
};

export type InvestmentAccessRequest = {
  __typename?: 'InvestmentAccessRequest';
  completeDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  requestDate: Scalars['Date']['output'];
  userId: Scalars['Int']['output'];
};

export type InvestmentAccessRequestInput = {
  investmentId: Scalars['Int']['input'];
};

export type InvestmentAssignmentOption = {
  __typename?: 'InvestmentAssignmentOption';
  commonName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isPrimary: Scalars['Boolean']['output'];
  isSecondary: Scalars['Boolean']['output'];
  userName: Scalars['String']['output'];
};

export type InvestmentAssignmentOptionFilter = {
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  isSecondary?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentAssignmentOptionList = {
  __typename?: 'InvestmentAssignmentOptionList';
  items: Array<InvestmentAssignmentOption>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentAssignmentOptionSort = {
  field: InvestmentAssignmentOptionSortEnum;
  order: SortInput;
};

export enum InvestmentAssignmentOptionSortEnum {
  CommonName = 'commonName',
  Id = 'id',
  NameSearchRank = 'nameSearchRank',
  UserName = 'userName'
}

export type InvestmentAum = {
  __typename?: 'InvestmentAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type InvestmentAxysCode = {
  __typename?: 'InvestmentAxysCode';
  axysCode: AxysCode;
  axysCodeId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
};

export type InvestmentAxysCodeFilter = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentAxysCodeInput = {
  code: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
};

export type InvestmentAxysCodeList = {
  __typename?: 'InvestmentAxysCodeList';
  items: Array<InvestmentAxysCode>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentAxysCodeSort = {
  field: InvestmentAxysCodeSortEnum;
  order: SortInput;
};

export enum InvestmentAxysCodeSortEnum {
  Id = 'id'
}

export type InvestmentBulk = {
  __typename?: 'InvestmentBulk';
  atlasInvestmentId: Scalars['ID']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentCalculation = {
  __typename?: 'InvestmentCalculation';
  categoryId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentCalculationFilter = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentSetId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentCalculationList = {
  __typename?: 'InvestmentCalculationList';
  items: Array<InvestmentCalculation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentCalculationSort = {
  field: InvestmentCalculationSortEnum;
  order: SortInput;
};

export enum InvestmentCalculationSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentFdpLogins = {
  __typename?: 'InvestmentFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  firmFDPLogin: FirmFdpLogins;
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
};

export type InvestmentFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFdpLoginsList = {
  __typename?: 'InvestmentFDPLoginsList';
  items: Array<InvestmentFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFdpLoginsSort = {
  field: InvestmentFdpLoginsSortEnum;
  order: SortInput;
};

export enum InvestmentFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  InvestmentId = 'investmentId'
}

export type InvestmentFamilyInvestment = {
  __typename?: 'InvestmentFamilyInvestment';
  committedCapital?: Maybe<Scalars['Float']['output']>;
  firmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  inceptionDate?: Maybe<Scalars['Date']['output']>;
  isEntitled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  performancePrivate?: Maybe<Array<PerformancePrivate>>;
  shortName?: Maybe<Scalars['String']['output']>;
  targetRaise?: Maybe<Scalars['Float']['output']>;
  vintageYear?: Maybe<Scalars['Int']['output']>;
};


export type InvestmentFamilyInvestmentPerformancePrivateArgs = {
  filter?: InputMaybe<PerformancePrivateFilter>;
  page?: InputMaybe<PageInput>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<PerformancePrivateSort>>;
};

export type InvestmentFees = {
  __typename?: 'InvestmentFees';
  abnormalFees?: Maybe<Scalars['Boolean']['output']>;
  abnormalFeesNotes?: Maybe<Scalars['String']['output']>;
  annualReset?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  feeStructureChanged?: Maybe<Scalars['Boolean']['output']>;
  feeStructureChangedNotes?: Maybe<Scalars['String']['output']>;
  hasMgmtFeeStepDown?: Maybe<Scalars['Boolean']['output']>;
  highWaterMark?: Maybe<Scalars['Boolean']['output']>;
  hurdle?: Maybe<Scalars['Boolean']['output']>;
  hurdleBenchmark?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  incentiveFee?: Maybe<Scalars['Float']['output']>;
  incentiveFeeCalc?: Maybe<FeeCalcEnum>;
  incentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  incentiveFeeFreq?: Maybe<FeeFreqEnum>;
  incentiveFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFee?: Maybe<Scalars['Float']['output']>;
  mgmtFeeCalc?: Maybe<FeeCalcEnum>;
  mgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  mgmtFeeFreq?: Maybe<FeeFreqEnum>;
  mgmtFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  otherFee?: Maybe<Scalars['Float']['output']>;
  otherFeeCalc?: Maybe<FeeCalcEnum>;
  otherFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  otherFeeFreq?: Maybe<FeeFreqEnum>;
  otherFeeFreqEnumId?: Maybe<Scalars['Int']['output']>;
  peGP?: Maybe<Scalars['Float']['output']>;
  peIncentiveFeeCalc?: Maybe<PeInctFeeCalcEnum>;
  peIncentiveFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peLP?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringCommitment?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringCommitmentCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeDuringCommitmentCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeDuringHarvest?: Maybe<Scalars['Float']['output']>;
  peMgmtFeeDuringHarvestCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeDuringHarvestCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownCalc?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeStepDownCalcEnumId?: Maybe<Scalars['Int']['output']>;
  peMgmtFeeStepDownPercent?: Maybe<Scalars['Float']['output']>;
  pePlacementFeesPaid?: Maybe<Scalars['Boolean']['output']>;
  shareClassId: Scalars['Int']['output'];
  standardShareClassRates?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentFeesFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFeesInput = {
  abnormalFees?: InputMaybe<Scalars['Boolean']['input']>;
  abnormalFeesNotes?: InputMaybe<Scalars['String']['input']>;
  annualReset?: InputMaybe<Scalars['Boolean']['input']>;
  feeStructureChanged?: InputMaybe<Scalars['Boolean']['input']>;
  feeStructureChangedNotes?: InputMaybe<Scalars['String']['input']>;
  hasMgmtFeeStepDown?: InputMaybe<Scalars['Boolean']['input']>;
  highWaterMark?: InputMaybe<Scalars['Boolean']['input']>;
  hurdle?: InputMaybe<Scalars['Boolean']['input']>;
  hurdleBenchmark?: InputMaybe<Scalars['String']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  incentiveFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  incentiveFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  mgmtFee?: InputMaybe<Scalars['Float']['input']>;
  mgmtFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  mgmtFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherFee?: InputMaybe<Scalars['Float']['input']>;
  otherFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherFeeFreqEnumId?: InputMaybe<Scalars['Int']['input']>;
  peIncentiveFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeDuringCommitment?: InputMaybe<Scalars['Float']['input']>;
  peMgmtFeeDuringCommitmentCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeDuringHarvest?: InputMaybe<Scalars['Float']['input']>;
  peMgmtFeeDuringHarvestCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeStepDownCalcEnumId?: InputMaybe<Scalars['Int']['input']>;
  peMgmtFeeStepDownPercent?: InputMaybe<Scalars['Float']['input']>;
  standardShareClassRates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentFeesList = {
  __typename?: 'InvestmentFeesList';
  items: Array<InvestmentFees>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFeesSort = {
  field: InvestmentFeesSortEnum;
  order: SortInput;
};

export enum InvestmentFeesSortEnum {
  Id = 'id'
}

export type InvestmentFields = {
  __typename?: 'InvestmentFields';
  investmentAum?: Maybe<InvestmentAum>;
  investmentId: Scalars['ID']['output'];
  investmentImpactAgricultureGoodsConsumerProducts?: Maybe<InvestmentImpactAgricultureGoodsConsumerProducts>;
  investmentImpactAgricultureGoodsFoodAccess?: Maybe<InvestmentImpactAgricultureGoodsFoodAccess>;
  investmentImpactAgricultureGoodsFoodtech?: Maybe<InvestmentImpactAgricultureGoodsFoodtech>;
  investmentImpactAgricultureGoodsSustainableAgriculture?: Maybe<InvestmentImpactAgricultureGoodsSustainableAgriculture>;
  investmentImpactBusinessQualityGovernanceBoardComposition?: Maybe<InvestmentImpactBusinessQualityGovernanceBoardComposition>;
  investmentImpactBusinessQualityGovernanceCorporateGovernance?: Maybe<InvestmentImpactBusinessQualityGovernanceCorporateGovernance>;
  investmentImpactBusinessQualityGovernanceCorporateSocialResponsibility?: Maybe<InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility>;
  investmentImpactBusinessQualityGovernanceFairTrade?: Maybe<InvestmentImpactBusinessQualityGovernanceFairTrade>;
  investmentImpactBusinessQualityGovernanceHumanCapitalManagement?: Maybe<InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement>;
  investmentImpactBusinessQualityGovernanceSupplyChainManagement?: Maybe<InvestmentImpactBusinessQualityGovernanceSupplyChainManagement>;
  investmentImpactCommunityCitiesCommunityDevelopment?: Maybe<InvestmentImpactCommunityCitiesCommunityDevelopment>;
  investmentImpactCommunityCitiesHousing?: Maybe<InvestmentImpactCommunityCitiesHousing>;
  investmentImpactCommunityCitiesInfrastructure?: Maybe<InvestmentImpactCommunityCitiesInfrastructure>;
  investmentImpactCommunityCitiesTransportation?: Maybe<InvestmentImpactCommunityCitiesTransportation>;
  investmentImpactCommunityCitiesWasteManagementRecycling?: Maybe<InvestmentImpactCommunityCitiesWasteManagementRecycling>;
  investmentImpactCommunityCitiesWorkforceDevelopment?: Maybe<InvestmentImpactCommunityCitiesWorkforceDevelopment>;
  investmentImpactDiversityEmpowermentImmigrantsRefugees?: Maybe<InvestmentImpactDiversityEmpowermentImmigrantsRefugees>;
  investmentImpactDiversityEmpowermentUnderrepresentedMinorities?: Maybe<InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities>;
  investmentImpactDiversityEmpowermentUnderservedCommunities?: Maybe<InvestmentImpactDiversityEmpowermentUnderservedCommunities>;
  investmentImpactDiversityEmpowermentWomenGirls?: Maybe<InvestmentImpactDiversityEmpowermentWomenGirls>;
  investmentImpactEducationWellnessEducation?: Maybe<InvestmentImpactEducationWellnessEducation>;
  investmentImpactEducationWellnessHealth?: Maybe<InvestmentImpactEducationWellnessHealth>;
  investmentImpactEducationWellnessInformationAccess?: Maybe<InvestmentImpactEducationWellnessInformationAccess>;
  investmentImpactEnergyProductionTechnologyEnergyEfficiency?: Maybe<InvestmentImpactEnergyProductionTechnologyEnergyEfficiency>;
  investmentImpactEnergyProductionTechnologyGeothermal?: Maybe<InvestmentImpactEnergyProductionTechnologyGeothermal>;
  investmentImpactEnergyProductionTechnologyGreenTech?: Maybe<InvestmentImpactEnergyProductionTechnologyGreenTech>;
  investmentImpactEnergyProductionTechnologyRecycling?: Maybe<InvestmentImpactEnergyProductionTechnologyRecycling>;
  investmentImpactEnergyProductionTechnologySolar?: Maybe<InvestmentImpactEnergyProductionTechnologySolar>;
  investmentImpactEnergyProductionTechnologyWind?: Maybe<InvestmentImpactEnergyProductionTechnologyWind>;
  investmentImpactEnvironmentNaturalResourceCarbon?: Maybe<InvestmentImpactEnvironmentNaturalResourceCarbon>;
  investmentImpactEnvironmentNaturalResourceConservation?: Maybe<InvestmentImpactEnvironmentNaturalResourceConservation>;
  investmentImpactEnvironmentNaturalResourceLandUsage?: Maybe<InvestmentImpactEnvironmentNaturalResourceLandUsage>;
  investmentImpactEnvironmentNaturalResourceWasteManagement?: Maybe<InvestmentImpactEnvironmentNaturalResourceWasteManagement>;
  investmentImpactEnvironmentNaturalResourceWater?: Maybe<InvestmentImpactEnvironmentNaturalResourceWater>;
  investmentImpactExclusionsAdultEntertainment?: Maybe<InvestmentImpactExclusionsAdultEntertainment>;
  investmentImpactExclusionsAlcohol?: Maybe<InvestmentImpactExclusionsAlcohol>;
  investmentImpactExclusionsCoal?: Maybe<InvestmentImpactExclusionsCoal>;
  investmentImpactExclusionsDefense?: Maybe<InvestmentImpactExclusionsDefense>;
  investmentImpactExclusionsGambling?: Maybe<InvestmentImpactExclusionsGambling>;
  investmentImpactExclusionsOil?: Maybe<InvestmentImpactExclusionsOil>;
  investmentImpactExclusionsTobacco?: Maybe<InvestmentImpactExclusionsTobacco>;
  investmentImpactExclusionsWeapons?: Maybe<InvestmentImpactExclusionsWeapons>;
  investmentImpactFinanceAccessFintech?: Maybe<InvestmentImpactFinanceAccessFintech>;
  investmentImpactFinanceAccessMicrofinancing?: Maybe<InvestmentImpactFinanceAccessMicrofinancing>;
  investmentImpactFinanceAccessMicroinsurance?: Maybe<InvestmentImpactFinanceAccessMicroinsurance>;
  investmentImpactFinanceAccessSmeBizdev?: Maybe<InvestmentImpactFinanceAccessSmeBizdev>;
  investmentOrEnvironmentOpportunitySet?: Maybe<InvestmentOrEnvironmentOpportunitySet>;
  investmentOrExposuresPortfolioActivity?: Maybe<InvestmentOrExposuresPortfolioActivity>;
  investmentOrFactSheet?: Maybe<InvestmentOrFactSheet>;
  investmentOrFirmAndTeamChanges?: Maybe<InvestmentOrFirmAndTeamChanges>;
  investmentOrFirmUpdate?: Maybe<InvestmentOrFirmUpdate>;
  investmentOrHeadlines?: Maybe<InvestmentOrHeadlines>;
  investmentOrLongTermPerformanceAttribution?: Maybe<InvestmentOrLongTermPerformanceAttribution>;
  investmentOrPerformanceAttribution?: Maybe<InvestmentOrPerformanceAttribution>;
  investmentOrThingsToMonitor?: Maybe<InvestmentOrThingsToMonitor>;
  investmentStrategyAum?: Maybe<InvestmentStrategyAum>;
  state?: Maybe<Scalars['String']['output']>;
  values: Array<FieldValue>;
};

export type InvestmentFieldsInput = {
  investmentOrEnvironmentOpportunitySet?: InputMaybe<InvestmentOrEnvironmentOpportunitySetInput>;
  investmentOrExposuresPortfolioActivity?: InputMaybe<InvestmentOrExposuresPortfolioActivityInput>;
  investmentOrFactSheet?: InputMaybe<InvestmentOrFactSheetInput>;
  investmentOrFirmAndTeamChanges?: InputMaybe<InvestmentOrFirmAndTeamChangesInput>;
  investmentOrFirmUpdate?: InputMaybe<InvestmentOrFirmUpdateInput>;
  investmentOrHeadlines?: InputMaybe<InvestmentOrHeadlinesInput>;
  investmentOrLongTermPerformanceAttribution?: InputMaybe<InvestmentOrLongTermPerformanceAttributionInput>;
  investmentOrPerformanceAttribution?: InputMaybe<InvestmentOrPerformanceAttributionInput>;
  investmentOrThingsToMonitor?: InputMaybe<InvestmentOrThingsToMonitorInput>;
};

export type InvestmentFilterInput = {
  HFRIInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  burgissId?: InputMaybe<Scalars['UUID']['input']>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  evestmentId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  marketId?: InputMaybe<Scalars['Int']['input']>;
  peFundNumberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  portfolioFilters?: InputMaybe<RcgPortfolioFilters>;
  q?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<InvestmentStrategyFilterInput>;
};

export type InvestmentFirmEmployment = {
  __typename?: 'InvestmentFirmEmployment';
  employeeRole?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumId?: Maybe<Scalars['Int']['output']>;
  faceOfInvestment?: Maybe<Scalars['Boolean']['output']>;
  firmEmployment?: Maybe<FirmEmployment>;
  firmEmploymentId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  leftDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type InvestmentFirmEmploymentFilterInput = {
  employeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  firmEmploymentId?: InputMaybe<Scalars['Int']['input']>;
  fundEmployeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentFirmEmploymentFilters = {
  atlasInvestmentId?: InputMaybe<Scalars['String']['input']>;
  employeeRole?: InputMaybe<Scalars['String']['input']>;
  fundEmployeeRoleId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isCurrent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentFirmEmploymentInput = {
  employeeRoleEnumId?: InputMaybe<Scalars['Int']['input']>;
  faceOfInvestment?: InputMaybe<Scalars['Boolean']['input']>;
  firmEmploymentId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  leftDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InvestmentFirmEmploymentList = {
  __typename?: 'InvestmentFirmEmploymentList';
  items: Array<InvestmentFirmEmployment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFirmEmploymentRoleEnum = {
  __typename?: 'InvestmentFirmEmploymentRoleEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentFirmEmploymentRoleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentFirmEmploymentRoleEnumList = {
  __typename?: 'InvestmentFirmEmploymentRoleEnumList';
  items: Array<InvestmentFirmEmploymentRoleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentFirmEmploymentRoleEnumSort = {
  field: InvestmentFirmEmploymentRoleEnumSortEnum;
  order: SortInput;
};

export enum InvestmentFirmEmploymentRoleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentFirmEmploymentSort = {
  field: InvestmentFirmEmploymentSortEnum;
  order: SortInput;
};

export enum InvestmentFirmEmploymentSortEnum {
  EmployeeRole = 'employeeRole',
  FirmEmploymentDefault = 'firmEmploymentDefault',
  Id = 'id',
  InvestmentDefault = 'investmentDefault'
}

export type InvestmentIdOrIsKeyPersonnel = {
  investmentId: Scalars['Int']['input'];
};

export type InvestmentIdToRefresh = {
  __typename?: 'InvestmentIdToRefresh';
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
};

export type InvestmentImpactAgricultureGoodsConsumerProducts = {
  __typename?: 'InvestmentImpactAgricultureGoodsConsumerProducts';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsFoodAccess = {
  __typename?: 'InvestmentImpactAgricultureGoodsFoodAccess';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsFoodtech = {
  __typename?: 'InvestmentImpactAgricultureGoodsFoodtech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactAgricultureGoodsSustainableAgriculture = {
  __typename?: 'InvestmentImpactAgricultureGoodsSustainableAgriculture';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceBoardComposition = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceBoardComposition';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceCorporateGovernance = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceCorporateGovernance';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceCorporateSocialResponsibility';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceFairTrade = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceFairTrade';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceHumanCapitalManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactBusinessQualityGovernanceSupplyChainManagement = {
  __typename?: 'InvestmentImpactBusinessQualityGovernanceSupplyChainManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesCommunityDevelopment = {
  __typename?: 'InvestmentImpactCommunityCitiesCommunityDevelopment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesHousing = {
  __typename?: 'InvestmentImpactCommunityCitiesHousing';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesInfrastructure = {
  __typename?: 'InvestmentImpactCommunityCitiesInfrastructure';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesTransportation = {
  __typename?: 'InvestmentImpactCommunityCitiesTransportation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesWasteManagementRecycling = {
  __typename?: 'InvestmentImpactCommunityCitiesWasteManagementRecycling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactCommunityCitiesWorkforceDevelopment = {
  __typename?: 'InvestmentImpactCommunityCitiesWorkforceDevelopment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentImmigrantsRefugees = {
  __typename?: 'InvestmentImpactDiversityEmpowermentImmigrantsRefugees';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities = {
  __typename?: 'InvestmentImpactDiversityEmpowermentUnderrepresentedMinorities';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentUnderservedCommunities = {
  __typename?: 'InvestmentImpactDiversityEmpowermentUnderservedCommunities';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactDiversityEmpowermentWomenGirls = {
  __typename?: 'InvestmentImpactDiversityEmpowermentWomenGirls';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessEducation = {
  __typename?: 'InvestmentImpactEducationWellnessEducation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessHealth = {
  __typename?: 'InvestmentImpactEducationWellnessHealth';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEducationWellnessInformationAccess = {
  __typename?: 'InvestmentImpactEducationWellnessInformationAccess';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyEnergyEfficiency = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyEnergyEfficiency';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyGeothermal = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyGeothermal';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyGreenTech = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyGreenTech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyRecycling = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyRecycling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologySolar = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologySolar';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnergyProductionTechnologyWind = {
  __typename?: 'InvestmentImpactEnergyProductionTechnologyWind';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceCarbon = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceCarbon';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceConservation = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceConservation';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceLandUsage = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceLandUsage';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceWasteManagement = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceWasteManagement';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactEnvironmentNaturalResourceWater = {
  __typename?: 'InvestmentImpactEnvironmentNaturalResourceWater';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsAdultEntertainment = {
  __typename?: 'InvestmentImpactExclusionsAdultEntertainment';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsAlcohol = {
  __typename?: 'InvestmentImpactExclusionsAlcohol';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsCoal = {
  __typename?: 'InvestmentImpactExclusionsCoal';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsDefense = {
  __typename?: 'InvestmentImpactExclusionsDefense';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsGambling = {
  __typename?: 'InvestmentImpactExclusionsGambling';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsOil = {
  __typename?: 'InvestmentImpactExclusionsOil';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsTobacco = {
  __typename?: 'InvestmentImpactExclusionsTobacco';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactExclusionsWeapons = {
  __typename?: 'InvestmentImpactExclusionsWeapons';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessFintech = {
  __typename?: 'InvestmentImpactFinanceAccessFintech';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessMicrofinancing = {
  __typename?: 'InvestmentImpactFinanceAccessMicrofinancing';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessMicroinsurance = {
  __typename?: 'InvestmentImpactFinanceAccessMicroinsurance';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentImpactFinanceAccessSmeBizdev = {
  __typename?: 'InvestmentImpactFinanceAccessSmeBizdev';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentInput = {
  HFRIInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  NAVClassificationEnumId?: InputMaybe<Scalars['Int']['input']>;
  RICId?: InputMaybe<Scalars['String']['input']>;
  accountTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  accountingIsCommodityFuture?: InputMaybe<Scalars['Boolean']['input']>;
  advisorId?: InputMaybe<Scalars['Int']['input']>;
  advisorTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  alphaVantageTicker?: InputMaybe<Scalars['String']['input']>;
  assetClassEnumId?: InputMaybe<Scalars['Int']['input']>;
  atlasInvestmentId?: InputMaybe<Scalars['ID']['input']>;
  bloombergCode?: InputMaybe<Scalars['String']['input']>;
  bloombergField?: InputMaybe<Scalars['String']['input']>;
  burgissId?: InputMaybe<Scalars['UUID']['input']>;
  committedCapital?: InputMaybe<Scalars['Float']['input']>;
  committedCapitalCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  currencyDenominationEnumId?: InputMaybe<Scalars['Int']['input']>;
  /** used to save LLM Profile Builder source documents to investment. */
  documents?: InputMaybe<Array<DocumentInput>>;
  domicileCountryId?: InputMaybe<Scalars['Int']['input']>;
  domicileFundLinkId?: InputMaybe<Scalars['Int']['input']>;
  domicileUSStateId?: InputMaybe<Scalars['Int']['input']>;
  evestmentId?: InputMaybe<Scalars['Int']['input']>;
  extensionPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  fiscalYearEndMonth?: InputMaybe<Scalars['Int']['input']>;
  fundLinkId?: InputMaybe<Scalars['Int']['input']>;
  gpCommitted?: InputMaybe<Scalars['Float']['input']>;
  gpCommittedCurrencyId?: InputMaybe<Scalars['Int']['input']>;
  hardCap?: InputMaybe<Scalars['Float']['input']>;
  harvestPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  impactTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  inceptionDate?: InputMaybe<Scalars['Date']['input']>;
  indexCalcTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentGroupId?: InputMaybe<Scalars['Int']['input']>;
  investmentPeriodYrs?: InputMaybe<Scalars['Int']['input']>;
  investmentStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentTags?: InputMaybe<Array<TagsInput>>;
  isESG?: InputMaybe<Scalars['Boolean']['input']>;
  isImpact?: InputMaybe<Scalars['Boolean']['input']>;
  isLiquidated?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvideAUM?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvidePerformance?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvidePositions?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerUnwillingToProvideRisk?: InputMaybe<Scalars['Boolean']['input']>;
  isOffshore?: InputMaybe<Scalars['Boolean']['input']>;
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  isRegisteredInvestmentCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isSubAdvised?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  legalStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  liquidationDate?: InputMaybe<Scalars['Date']['input']>;
  liquidationNote?: InputMaybe<Scalars['String']['input']>;
  listEnumId?: InputMaybe<Scalars['Int']['input']>;
  marketEnumId?: InputMaybe<Scalars['Int']['input']>;
  maxExpectedVolatility?: InputMaybe<Scalars['Float']['input']>;
  maxGrossExposure?: InputMaybe<Scalars['Float']['input']>;
  maxNetExposure?: InputMaybe<Scalars['Float']['input']>;
  maxTargetNetIRR?: InputMaybe<Scalars['Float']['input']>;
  maxTargetNetMOIC?: InputMaybe<Scalars['Float']['input']>;
  minExpectedVolatility?: InputMaybe<Scalars['Float']['input']>;
  minGrossExposure?: InputMaybe<Scalars['Float']['input']>;
  minNetExposure?: InputMaybe<Scalars['Float']['input']>;
  minTargetNetIRR?: InputMaybe<Scalars['Float']['input']>;
  minTargetNetMOIC?: InputMaybe<Scalars['Float']['input']>;
  modifyDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ndaSigned?: InputMaybe<Scalars['Boolean']['input']>;
  organizationStructureEnumId?: InputMaybe<Scalars['Int']['input']>;
  otherGeographicFocusIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  peFundNumberEnumId?: InputMaybe<Scalars['Int']['input']>;
  peLegalLifeYrs?: InputMaybe<Scalars['Int']['input']>;
  peStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  peSubStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  peerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  performanceSourceEnumId?: InputMaybe<Scalars['Int']['input']>;
  pricingFrequencyEnumId?: InputMaybe<Scalars['Int']['input']>;
  primaryAssignment?: InputMaybe<Scalars['String']['input']>;
  primaryBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  primaryGeographicFocusId?: InputMaybe<Scalars['Int']['input']>;
  reportingDate?: InputMaybe<Scalars['Date']['input']>;
  reportingDateReason?: InputMaybe<Scalars['String']['input']>;
  reportingLinkId?: InputMaybe<Scalars['Int']['input']>;
  secondaryAssignment?: InputMaybe<Scalars['String']['input']>;
  secondaryBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  shareClassNote?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  strategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  subStrategyEnumId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  targetRaise?: InputMaybe<Scalars['Float']['input']>;
  vehicleTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  vintageYear?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentInstitutions = {
  __typename?: 'InvestmentInstitutions';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  /** End date of engagement with service provider. */
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  institution: Institution;
  institutionId: Scalars['Int']['output'];
  institutionInstitutionTypeEnumId: Scalars['Int']['output'];
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  officeLocationServiceType: InstitutionsInstitutionTypeEnum;
  /** Start date of engagement with service provider. */
  startDate?: Maybe<Scalars['Date']['output']>;
};


export type InvestmentInstitutionsInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};

export type InvestmentInstitutionsFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentInstitutionsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  institutionId?: InputMaybe<Scalars['Int']['input']>;
  institutionInstitutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type InvestmentInstitutionsList = {
  __typename?: 'InvestmentInstitutionsList';
  items: Array<InvestmentInstitutions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentInstitutionsSort = {
  field: InvestmentInstitutionsSortEnum;
  order: SortInput;
};

export enum InvestmentInstitutionsSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InvestmentList = {
  __typename?: 'InvestmentList';
  items: Array<Investment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentListEnum = {
  __typename?: 'InvestmentListEnum';
  count?: Maybe<Scalars['Int']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentListEnumFilter = {
  availableOnCreation?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentListEnumList = {
  __typename?: 'InvestmentListEnumList';
  items: Array<InvestmentListEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentListEnumSort = {
  field: InvestmentListEnumSortEnum;
  order: SortInput;
};

export enum InvestmentListEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentMatchResult = {
  __typename?: 'InvestmentMatchResult';
  firmName?: Maybe<Scalars['String']['output']>;
  fuzzyScore: Scalars['Float']['output'];
  investmentId: Scalars['Int']['output'];
  investmentName: Scalars['String']['output'];
};

export enum InvestmentMatchStatus {
  Matched = 'MATCHED',
  NotFound = 'NOT_FOUND',
  NoAccess = 'NO_ACCESS'
}

export type InvestmentNoteUsers = {
  __typename?: 'InvestmentNoteUsers';
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type InvestmentNoteUsersFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentNoteUsersList = {
  __typename?: 'InvestmentNoteUsersList';
  items: Array<InvestmentNoteUsers>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentNoteUsersSort = {
  field: InvestmentNoteUsersSortEnum;
  order: SortInput;
};

export enum InvestmentNoteUsersSortEnum {
  CreateUser = 'createUser',
  Id = 'id'
}

export type InvestmentOrEnvironmentOpportunitySet = {
  __typename?: 'InvestmentOrEnvironmentOpportunitySet';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrEnvironmentOpportunitySetInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrExposuresPortfolioActivity = {
  __typename?: 'InvestmentOrExposuresPortfolioActivity';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrExposuresPortfolioActivityInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFactSheet = {
  __typename?: 'InvestmentOrFactSheet';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFactSheetInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFirmAndTeamChanges = {
  __typename?: 'InvestmentOrFirmAndTeamChanges';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFirmAndTeamChangesInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrFirmUpdate = {
  __typename?: 'InvestmentOrFirmUpdate';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrFirmUpdateInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrHeadlines = {
  __typename?: 'InvestmentOrHeadlines';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrHeadlinesInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrLongTermPerformanceAttribution = {
  __typename?: 'InvestmentOrLongTermPerformanceAttribution';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrLongTermPerformanceAttributionInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrPerformanceAttribution = {
  __typename?: 'InvestmentOrPerformanceAttribution';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrPerformanceAttributionInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentOrThingsToMonitor = {
  __typename?: 'InvestmentOrThingsToMonitor';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type InvestmentOrThingsToMonitorInput = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  citations?: InputMaybe<Array<CitationInput>>;
  createDate: Scalars['DateTime']['input'];
  createUser: Scalars['String']['input'];
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Used for reading, not for writing. */
  documents?: InputMaybe<Array<FieldDocumentInput>>;
  fieldKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
  modifyDate: Scalars['DateTime']['input'];
  modifyUser: Scalars['String']['input'];
  notApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  ownerId: Scalars['Int']['input'];
  ownerType: Scalars['String']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentPeersFilterInput = {
  excludeSelf?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilter?: InputMaybe<InvestmentFilterInput>;
};

export type InvestmentPrivateQuartileGroupCategory = {
  __typename?: 'InvestmentPrivateQuartileGroupCategory';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryId: Scalars['Int']['output'];
};

export type InvestmentPrivateQuartileGroupCategoryFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isDerived?: InputMaybe<Scalars['Boolean']['input']>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentPrivateQuartileGroupCategoryInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentPrivateQuartileGroupCategoryList = {
  __typename?: 'InvestmentPrivateQuartileGroupCategoryList';
  items: Array<InvestmentPrivateQuartileGroupCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentPrivateQuartileGroupCategorySort = {
  field: InvestmentPrivateQuartileGroupCategorySortEnum;
  order: SortInput;
};

export enum InvestmentPrivateQuartileGroupCategorySortEnum {
  Id = 'id',
  Rank = 'rank'
}

export type InvestmentRegulators = {
  __typename?: 'InvestmentRegulators';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  inspectionDate?: Maybe<Scalars['Date']['output']>;
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  registrationDate?: Maybe<Scalars['Date']['output']>;
  registrationNum?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['String']['output']>;
};

export type InvestmentRegulatorsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentRegulatorsList = {
  __typename?: 'InvestmentRegulatorsList';
  items: Array<InvestmentRegulators>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentRegulatorsSort = {
  field: InvestmentRegulatorsSortEnum;
  order: SortInput;
};

export enum InvestmentRegulatorsSortEnum {
  Name = 'name'
}

export type InvestmentRiskCategoryFilter = {
  level: Scalars['Int']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentRiskCategorySort = {
  field: InvestmentRiskCategorySortEnum;
  order: SortInput;
};

export enum InvestmentRiskCategorySortEnum {
  Id = 'id',
  Name = 'name'
}

export type InvestmentRiskInvestmentFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type InvestmentRiskInvestmentSort = {
  field: InvestmentRiskInvestmentSortEnum;
  order: SortInput;
};

export enum InvestmentRiskInvestmentSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type InvestmentSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
  ASSET_CLASS_STRATEGY?: InputMaybe<AssetClassStrategyFilter>;
  COMPLETENESS?: InputMaybe<CompletenessSearchFilter>;
  DYNAMIC_LIST?: InputMaybe<DynamicListFilter>;
  FIRM_ENTITY?: InputMaybe<EntitySearchFilter>;
  FUZZY_TERM?: InputMaybe<QuerySearchFilter>;
  IMPACT?: InputMaybe<ImpactSearchFilter>;
  INACTIVE?: InputMaybe<InactiveInvestmentFilter>;
  INCEPTION_DATE?: InputMaybe<DateRangeFilter>;
  INVESTMENT_ENTITY?: InputMaybe<EntitySearchFilter>;
  INVESTMENT_LIST?: InputMaybe<EntitySearchFilter>;
  INVESTMENT_SET?: InputMaybe<InvestmentSetSearchFilter>;
  PERFORMANCE?: InputMaybe<PerformanceSearchFilter>;
  PERFORMANCE_PRIVATE?: InputMaybe<PerformancePrivateSearchFilter>;
  PORTFOLIO?: InputMaybe<PortfolioSearchFilter>;
  POSITIONS?: InputMaybe<PositionsSearchFilter>;
  PRIMARY_GEOGRAPHY?: InputMaybe<EntitySearchFilter>;
  SEARCH_TERM?: InputMaybe<QuerySearchFilter>;
  SET?: InputMaybe<SetSearchFilter>;
  SHARED_CONTENT?: InputMaybe<SharedContentFilter>;
  SIZE?: InputMaybe<FloatRangeFilter>;
  TAG_ENTITY?: InputMaybe<EntitySearchFilter>;
  TYPE?: InputMaybe<EntitySearchFilter>;
  VINTAGE_YEAR?: InputMaybe<IntRangeFilter>;
  VOLATILITY?: InputMaybe<VolatilitySearchFilter>;
  VOLATILITY_PRIVATE?: InputMaybe<VolatilityPrivateSearchFilter>;
};

export type InvestmentSet = {
  __typename?: 'InvestmentSet';
  accessLevel: AccessLevel;
  accessLevelId?: Maybe<Scalars['Int']['output']>;
  calculations: InvestmentCalculationList;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description: Scalars['String']['output'];
  groupSubscriptions: Array<GroupInvestmentSetSubscription>;
  id: Scalars['Int']['output'];
  investmentSetItems: Array<InvestmentSetItems>;
  investments: InvestmentList;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDynamic?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationSubscriptions: Array<OrganizationInvestmentSetSubscription>;
  setId?: Maybe<Scalars['Int']['output']>;
  updateDate?: Maybe<Scalars['String']['output']>;
  updateUser?: Maybe<Scalars['String']['output']>;
  userSubscriptions: Array<UserInvestmentSetSubscription>;
};


export type InvestmentSetCalculationsArgs = {
  filter?: InputMaybe<InvestmentCalculationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentCalculationSort>>;
};


export type InvestmentSetInvestmentsArgs = {
  filters?: InputMaybe<Array<InvestmentSearchFilters>>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};

export type InvestmentSetFilter = {
  createUser?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  subscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvestmentSetInput = {
  accessLevelId?: InputMaybe<Scalars['Int']['input']>;
  calculationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isDynamic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subscriptionOrganizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subscriptionUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentSetItems = {
  __typename?: 'InvestmentSetItems';
  investmentId: Scalars['Int']['output'];
  investmentSetId: Scalars['Int']['output'];
};

export type InvestmentSetList = {
  __typename?: 'InvestmentSetList';
  items: Array<InvestmentSet>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentSetSearchFilter = {
  investmentSetId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentSetSort = {
  field: InvestmentSetSortEnum;
  order: SortInput;
};

export enum InvestmentSetSortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  Name = 'name'
}

export type InvestmentSort = {
  field: InvestmentSortEnum;
  order: SortInput;
};

export enum InvestmentSortEnum {
  AssetClass = 'assetClass',
  AssetClassAndStrategy = 'assetClassAndStrategy',
  FundLinkDefault = 'fundLinkDefault',
  FuzzyRank = 'fuzzyRank',
  GeographicFocus = 'geographicFocus',
  Id = 'id',
  ModifyDate = 'modifyDate',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  Strategy = 'strategy',
  VintageYear = 'vintageYear'
}

export type InvestmentStrategyAum = {
  __typename?: 'InvestmentStrategyAum';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  citations?: Maybe<Array<Citation>>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  documentIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** Used for reading, not for writing. */
  documents?: Maybe<Array<FieldDocument>>;
  fieldKey: Scalars['String']['output'];
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  notApplicable?: Maybe<Scalars['Boolean']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  periodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Array<AumRecord>>;
};

export type InvestmentStrategyFilterInput = {
  strategyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subStrategyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentStructureEnum = {
  __typename?: 'InvestmentStructureEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InvestmentStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvestmentStructureEnumList = {
  __typename?: 'InvestmentStructureEnumList';
  items: Array<InvestmentStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentStructureEnumSort = {
  field: InvestmentStructureEnumSortEnum;
  order: SortInput;
};

export enum InvestmentStructureEnumSortEnum {
  Id = 'id'
}

export type InvestmentTags = {
  __typename?: 'InvestmentTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  tag: Tag;
  tagClassId: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
};

export type InvestmentTagsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentTagsList = {
  __typename?: 'InvestmentTagsList';
  items: Array<InvestmentTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type InvestmentTagsSort = {
  field: InvestmentTagsSortEnum;
  order: SortInput;
};

export enum InvestmentTagsSortEnum {
  Id = 'id'
}

export type InvestmentXImpact = {
  __typename?: 'InvestmentXImpact';
  impactEnum: ImpactEnum;
  impactEnumId: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
};

export type InvestmentsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type InvestmentsDynamicShareRuleOutput = {
  __typename?: 'InvestmentsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type InvestmentsFamily = {
  __typename?: 'InvestmentsFamily';
  family: Family;
  familyFirmId: Scalars['Int']['output'];
  familyId: Scalars['Int']['output'];
  fundFirmId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<InvestmentFamilyInvestment>;
  investmentId: Scalars['Int']['output'];
};

export type InvestmentsFamilyFilterInput = {
  familyId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type InvestmentsFamilyInput = {
  familyId: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};

export type InvestmentsFamilySort = {
  field: InvestmentsFamilySortEnum;
  order: SortInput;
};

export enum InvestmentsFamilySortEnum {
  Id = 'id',
  VintageYear = 'vintageYear'
}

export type JobSchedule = {
  __typename?: 'JobSchedule';
  args?: Maybe<Scalars['JSON']['output']>;
  cron: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  isPreview: Scalars['Boolean']['output'];
  jobName: Scalars['String']['output'];
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  previewAllowed: Scalars['Boolean']['output'];
};

export type JobScheduleUpdateInput = {
  args?: InputMaybe<Scalars['JSON']['input']>;
  cron: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};

export type KnowledgeBaseEntity = {
  __typename?: 'KnowledgeBaseEntity';
  document?: Maybe<Document>;
  note?: Maybe<Notes>;
};

export enum KnowledgeBaseEntityType {
  Company = 'COMPANY',
  Document = 'DOCUMENT',
  Engagement = 'ENGAGEMENT',
  Firm = 'FIRM',
  Investment = 'INVESTMENT',
  Note = 'NOTE'
}

export type KnowledgeBaseFilter = {
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  date?: InputMaybe<DateRangeFilter>;
  dealFilter?: InputMaybe<DealFilter>;
  documentsFilter?: InputMaybe<DocumentFilter>;
  entityTypes?: InputMaybe<Array<KnowledgeBaseEntityType>>;
  firmEngagementId?: InputMaybe<Scalars['Int']['input']>;
  firmFilter?: InputMaybe<FirmFilterInput>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  modifyDate?: InputMaybe<DateRangeFilter>;
  notesFilter?: InputMaybe<NotesFilter>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseItem = {
  __typename?: 'KnowledgeBaseItem';
  entity: KnowledgeBaseEntity;
  entityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  tags: Array<KnowledgeBaseTags>;
  type: KnowledgeBaseEntityType;
};

export type KnowledgeBaseList = {
  __typename?: 'KnowledgeBaseList';
  items: Array<KnowledgeBaseItem>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type KnowledgeBaseSort = {
  field: KnowledgeBaseSortEnum;
  order: SortInput;
};

export enum KnowledgeBaseSortEnum {
  CreateDate = 'createDate',
  Date = 'date',
  ModifyDate = 'modifyDate',
  Relevance = 'relevance'
}

export enum KnowledgeBaseStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Ready = 'READY'
}

export type KnowledgeBaseTags = {
  __typename?: 'KnowledgeBaseTags';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
};

export type KnowledgeBaseTagsFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseTagsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeBaseTagsList = {
  __typename?: 'KnowledgeBaseTagsList';
  items: Array<KnowledgeBaseTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type KnowledgeBaseTagsSort = {
  field: KnowledgeBaseTagsSortEnum;
  order: SortInput;
};

export enum KnowledgeBaseTagsSortEnum {
  Id = 'id'
}

export enum KnowledgeBaseType {
  General = 'GENERAL',
  PublishedDiligence = 'PUBLISHED_DILIGENCE'
}

export type LlmPerformance = {
  __typename?: 'LLMPerformance';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<CurrencyDenominationEnum>;
  currencyId: Scalars['Float']['output'];
  documentId?: Maybe<Scalars['Int']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  performanceCommentary?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type LegalStructureEnum = {
  __typename?: 'LegalStructureEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LegalStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type LegalStructureEnumList = {
  __typename?: 'LegalStructureEnumList';
  items: Array<LegalStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LegalStructureEnumSort = {
  field: LegalStructureEnumSortEnum;
  order: SortInput;
};

export enum LegalStructureEnumSortEnum {
  Id = 'id'
}

export type LengthConstraint = {
  __typename?: 'LengthConstraint';
  max?: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
};

export type LexSendMessageInput = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  requestId: Scalars['String']['input'];
  sessionAttributes?: InputMaybe<Scalars['JSONObject']['input']>;
  sessionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type LexSendMessageResult = {
  __typename?: 'LexSendMessageResult';
  conversationId: Scalars['Int']['output'];
};

export type Links = {
  __typename?: 'Links';
  iconEnum?: Maybe<IconEnum>;
  iconEnumId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orgLinks: Array<OrgLinks>;
  url: Scalars['String']['output'];
};

export type LinksFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinksInput = {
  iconEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLinks?: InputMaybe<Array<OrgLinksInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LinksList = {
  __typename?: 'LinksList';
  items: Array<Links>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LinksSort = {
  field: LinksSortEnum;
  order: SortInput;
};

export enum LinksSortEnum {
  Id = 'id',
  Name = 'name',
  Url = 'url'
}

export type Liquidity = {
  __typename?: 'Liquidity';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  exceptions?: Maybe<Scalars['String']['output']>;
  gatePercentCapital?: Maybe<Scalars['Float']['output']>;
  gatePercentNav?: Maybe<Scalars['Float']['output']>;
  hasGate?: Maybe<Scalars['Boolean']['output']>;
  hasHoldback?: Maybe<Scalars['Boolean']['output']>;
  hasLockup?: Maybe<Scalars['Boolean']['output']>;
  hasRollover?: Maybe<Scalars['Boolean']['output']>;
  holdbackPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  liquidityMonthlyValue: Scalars['Int']['output'];
  liquidityUnit?: Maybe<CalendarUnitEnum>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndBasisDate?: Maybe<Scalars['DateTime']['output']>;
  lockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  lockupEndUnit?: Maybe<CalendarUnitEnum>;
  lockupEndUnitId?: Maybe<Scalars['Int']['output']>;
  lockupEndValue?: Maybe<LockupEndValueEnum>;
  lockupEndValueId?: Maybe<Scalars['Int']['output']>;
  lockupMonthlyValue: Scalars['Int']['output'];
  lockupUnit?: Maybe<CalendarUnitEnum>;
  lockupUnitId?: Maybe<Scalars['Int']['output']>;
  lockupValue?: Maybe<Scalars['Int']['output']>;
  masterLevelFundGate?: Maybe<Scalars['Boolean']['output']>;
  modelingNotes?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeUnit?: Maybe<CalendarUnitEnum>;
  noticeUnitId?: Maybe<Scalars['Int']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  rolloverUnit?: Maybe<CalendarUnitEnum>;
  rolloverUnitId?: Maybe<Scalars['Int']['output']>;
  rolloverValue?: Maybe<Scalars['Int']['output']>;
  secondLockupEndBasisDate?: Maybe<Scalars['DateTime']['output']>;
  secondLockupEndBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndUnit?: Maybe<CalendarUnitEnum>;
  secondLockupEndUnitId?: Maybe<Scalars['Int']['output']>;
  secondLockupEndValue?: Maybe<LockupEndValueEnum>;
  secondLockupEndValueId?: Maybe<Scalars['Int']['output']>;
  secondLockupUnit?: Maybe<CalendarUnitEnum>;
  secondLockupUnitId?: Maybe<Scalars['Int']['output']>;
  secondLockupValue?: Maybe<Scalars['Int']['output']>;
  shareClassId: Scalars['Int']['output'];
  softLockups: Array<SoftLockup>;
  subscriptionUnit?: Maybe<CalendarUnitEnum>;
  subscriptionUnitId?: Maybe<Scalars['Int']['output']>;
  subscriptionValue?: Maybe<Scalars['Int']['output']>;
  workout?: Maybe<WorkoutEnum>;
  workoutId?: Maybe<Scalars['Int']['output']>;
};


export type LiquiditySoftLockupsArgs = {
  filter?: InputMaybe<SoftLockupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SoftLockupSort>>;
};

export type LiquidityFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidityInput = {
  cashAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  exceptions?: InputMaybe<Scalars['String']['input']>;
  gatePercentCapital?: InputMaybe<Scalars['Float']['input']>;
  gatePercentNav?: InputMaybe<Scalars['Float']['input']>;
  hasGate?: InputMaybe<Scalars['Boolean']['input']>;
  hasHoldback?: InputMaybe<Scalars['Boolean']['input']>;
  hasLockup?: InputMaybe<Scalars['Boolean']['input']>;
  hasRollover?: InputMaybe<Scalars['Boolean']['input']>;
  holdbackPercent?: InputMaybe<Scalars['Float']['input']>;
  liquidityMonthlyValue?: InputMaybe<Scalars['Int']['input']>;
  liquidityUnitId?: InputMaybe<Scalars['Int']['input']>;
  liquidityValue?: InputMaybe<Scalars['Int']['input']>;
  lockupEndBasisDate?: InputMaybe<Scalars['DateTime']['input']>;
  lockupEndBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  lockupEndValueId?: InputMaybe<Scalars['Int']['input']>;
  lockupMonthlyValue?: InputMaybe<Scalars['Int']['input']>;
  lockupUnitId?: InputMaybe<Scalars['Int']['input']>;
  lockupValue?: InputMaybe<Scalars['Int']['input']>;
  masterLevelFundGate?: InputMaybe<Scalars['Boolean']['input']>;
  modelingNotes?: InputMaybe<Scalars['String']['input']>;
  noticeBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  noticeUnitId?: InputMaybe<Scalars['Int']['input']>;
  noticeValue?: InputMaybe<Scalars['Int']['input']>;
  rolloverUnitId?: InputMaybe<Scalars['Int']['input']>;
  rolloverValue?: InputMaybe<Scalars['Int']['input']>;
  secondLockupEndBasisDate?: InputMaybe<Scalars['DateTime']['input']>;
  secondLockupEndBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  secondLockupEndValueId?: InputMaybe<Scalars['Int']['input']>;
  secondLockupUnitId?: InputMaybe<Scalars['Int']['input']>;
  secondLockupValue?: InputMaybe<Scalars['Int']['input']>;
  subscriptionUnitId?: InputMaybe<Scalars['Int']['input']>;
  subscriptionValue?: InputMaybe<Scalars['Int']['input']>;
  workoutId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidityList = {
  __typename?: 'LiquidityList';
  items: Array<Liquidity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LiquiditySort = {
  field: LiquiditySortEnum;
  order: SortInput;
};

export enum LiquiditySortEnum {
  Id = 'id'
}

export type LlmCandidatePerformance = {
  __typename?: 'LlmCandidatePerformance';
  baselineCostUsd?: Maybe<Scalars['Float']['output']>;
  baselineLatencyMs: Scalars['Float']['output'];
  candidateCostUsd?: Maybe<Scalars['Float']['output']>;
  candidateLatencyMs: Scalars['Float']['output'];
};

export type LlmCandidateScore = {
  __typename?: 'LlmCandidateScore';
  baseline: Scalars['Float']['output'];
  candidate: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LlmEvaluator = {
  __typename?: 'LlmEvaluator';
  description: Scalars['String']['output'];
  key: Scalars['String']['output'];
  langfuseSyncedVersion?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  scoreType: Scalars['String']['output'];
  taskKeys: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type LlmEvaluatorInput = {
  description: Scalars['String']['input'];
  key: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  scoreType: Scalars['String']['input'];
};

export type LlmModel = {
  __typename?: 'LlmModel';
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['output'];
  behavior: Array<LlmModelBehavior>;
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  benchmarksFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  blendedPricePer1M?: Maybe<Scalars['Float']['output']>;
  cachePoint: Scalars['Boolean']['output'];
  cacheReadPer1M?: Maybe<Scalars['Float']['output']>;
  cacheWritePer1M?: Maybe<Scalars['Float']['output']>;
  contextWindow: Scalars['Int']['output'];
  costPerIntelligence?: Maybe<Scalars['Float']['output']>;
  defaultEffort?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  effortBenchmarks?: Maybe<Array<EffortBenchmark>>;
  effortField?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  inputPer1M?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  isDefault: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  maxOutputTokens: Scalars['Int']['output'];
  outputPer1M?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  pricesFetchedAt?: Maybe<Scalars['DateTime']['output']>;
  rating?: Maybe<Scalars['JSON']['output']>;
  roles: Array<LlmModelRole>;
  secondsToFirstAnswerToken?: Maybe<Scalars['Float']['output']>;
  supportsEffort: Scalars['Boolean']['output'];
  supportsVision: Scalars['Boolean']['output'];
  thinkingOff?: Maybe<Scalars['String']['output']>;
  usage: LlmModelUsage;
  verification?: Maybe<Scalars['JSON']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedRoles: Array<LlmModelRole>;
};

export enum LlmModelApi {
  Converse = 'Converse',
  Messages = 'Messages'
}

export type LlmModelBehavior = {
  __typename?: 'LlmModelBehavior';
  behavior: Scalars['String']['output'];
  feature: Scalars['String']['output'];
  limited: Scalars['Boolean']['output'];
};

export type LlmModelCatalogEntry = {
  __typename?: 'LlmModelCatalogEntry';
  bedrockModelId: Scalars['String']['output'];
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  blendedPricePer1M?: Maybe<Scalars['Float']['output']>;
  costPerIntelligence?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  modelName: Scalars['String']['output'];
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  priceSource?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  requiresHumanReview?: Maybe<Scalars['Boolean']['output']>;
};

export type LlmModelInput = {
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['input'];
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
  cacheReadPer1M?: InputMaybe<Scalars['Float']['input']>;
  cacheWritePer1M?: InputMaybe<Scalars['Float']['input']>;
  contextWindow: Scalars['Int']['input'];
  defaultEffort?: InputMaybe<ChatEffort>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  inputPer1M?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  maxOutputTokens: Scalars['Int']['input'];
  outputPer1M?: InputMaybe<Scalars['Float']['input']>;
  roles: Array<LlmModelRole>;
  supportsEffort: Scalars['Boolean']['input'];
  supportsVision: Scalars['Boolean']['input'];
};

export type LlmModelPreview = {
  __typename?: 'LlmModelPreview';
  accountRetentionMode: Scalars['String']['output'];
  api: LlmModelApi;
  bedrockModelId: Scalars['String']['output'];
  benchmarkSlug?: Maybe<Scalars['String']['output']>;
  benchmarksAvailable: Scalars['Boolean']['output'];
  cacheReadPer1M?: Maybe<Scalars['Float']['output']>;
  cacheWritePer1M?: Maybe<Scalars['Float']['output']>;
  contextWindow?: Maybe<Scalars['Int']['output']>;
  displayName: Scalars['String']['output'];
  inputPer1M?: Maybe<Scalars['Float']['output']>;
  intelligenceIndex?: Maybe<Scalars['Float']['output']>;
  lifecycleStatus: Scalars['String']['output'];
  limitsFound: Scalars['Boolean']['output'];
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  outputPer1M?: Maybe<Scalars['Float']['output']>;
  outputTokensPerSecond?: Maybe<Scalars['Float']['output']>;
  priceSource?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  refused: Scalars['Boolean']['output'];
  retentionModes?: Maybe<Array<Scalars['String']['output']>>;
  retentionProblem?: Maybe<Scalars['String']['output']>;
  secondsToFirstAnswerToken?: Maybe<Scalars['Float']['output']>;
  suggestedKey: Scalars['String']['output'];
  supportsEffort: Scalars['Boolean']['output'];
  supportsVision: Scalars['Boolean']['output'];
};

export enum LlmModelRole {
  Background = 'Background',
  Chat = 'Chat',
  Subagent = 'Subagent'
}

export type LlmModelUpdateInput = {
  api?: InputMaybe<LlmModelApi>;
  bedrockModelId?: InputMaybe<Scalars['String']['input']>;
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
  cacheReadPer1M?: InputMaybe<Scalars['Float']['input']>;
  cacheWritePer1M?: InputMaybe<Scalars['Float']['input']>;
  contextWindow?: InputMaybe<Scalars['Int']['input']>;
  defaultEffort?: InputMaybe<ChatEffort>;
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  inputPer1M?: InputMaybe<Scalars['Float']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  outputPer1M?: InputMaybe<Scalars['Float']['input']>;
  roles?: InputMaybe<Array<LlmModelRole>>;
  supportsEffort?: InputMaybe<Scalars['Boolean']['input']>;
  supportsVision?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LlmModelUsage = {
  __typename?: 'LlmModelUsage';
  agents: Array<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  tasks: Array<Scalars['String']['output']>;
};

export type LlmTask = {
  __typename?: 'LlmTask';
  candidates: Array<LlmTaskCandidate>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  eligibleModelKeys: Array<Scalars['String']['output']>;
  evaluatorKeys: Array<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  langfuseDatasetName: Scalars['String']['output'];
  modelKey: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  prompts: Array<LlmTaskPrompt>;
  requiresMessagesApi: Scalars['Boolean']['output'];
  requiresVision: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
  versions: Array<LlmTaskVersion>;
};

export type LlmTaskCandidate = {
  __typename?: 'LlmTaskCandidate';
  baseVersion: Scalars['Int']['output'];
  baselineRunUrl?: Maybe<Scalars['String']['output']>;
  candidateRunUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  decidedAt?: Maybe<Scalars['DateTime']['output']>;
  decidedBy?: Maybe<Scalars['String']['output']>;
  evaluatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  itemCount?: Maybe<Scalars['Int']['output']>;
  modelKey?: Maybe<Scalars['String']['output']>;
  overrideReason?: Maybe<Scalars['String']['output']>;
  performance?: Maybe<LlmCandidatePerformance>;
  promotedVersion?: Maybe<Scalars['Int']['output']>;
  prompts: Array<LlmTaskCandidatePrompt>;
  scores?: Maybe<Array<LlmCandidateScore>>;
  status: Scalars['String']['output'];
  statusMessage?: Maybe<Scalars['String']['output']>;
  taskKey: Scalars['String']['output'];
};

export type LlmTaskCandidatePrompt = {
  __typename?: 'LlmTaskCandidatePrompt';
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
};

export type LlmTaskPrompt = {
  __typename?: 'LlmTaskPrompt';
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['String']['output'];
  description: Scalars['String']['output'];
  history: Array<LlmTaskPrompt>;
  langfuseName: Scalars['String']['output'];
  langfuseSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  langfuseVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  taskKey: Scalars['String']['output'];
  template: Scalars['String']['output'];
  variables: Array<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type LlmTaskPromptInput = {
  name: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type LlmTaskVersion = {
  __typename?: 'LlmTaskVersion';
  changedAt: Scalars['DateTime']['output'];
  changedBy: Scalars['String']['output'];
  modelKey: Scalars['String']['output'];
  taskKey: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type LocationFilter = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryEnum?: InputMaybe<Scalars['Int']['input']>;
  stateEnum?: InputMaybe<Scalars['Int']['input']>;
};

export type LockupEndValueEnum = {
  __typename?: 'LockupEndValueEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LockupEndValueEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type LockupEndValueEnumList = {
  __typename?: 'LockupEndValueEnumList';
  items: Array<LockupEndValueEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type LockupEndValueEnumSort = {
  field: LockupEndValueEnumSortEnum;
  order: SortInput;
};

export enum LockupEndValueEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ManagerSummary = {
  __typename?: 'ManagerSummary';
  auditOpinionType?: Maybe<Scalars['String']['output']>;
  auditorName?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['Int']['output']>;
  extractionId?: Maybe<Scalars['Int']['output']>;
  /** Fund legal name as reported in the AFS document */
  fundLegalName?: Maybe<Scalars['String']['output']>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  /** Investment name from portfolio (Sirius name) */
  investmentName?: Maybe<Scalars['String']['output']>;
  level3SharePct?: Maybe<Scalars['Float']['output']>;
  leverageRatio?: Maybe<Scalars['Float']['output']>;
  netAssets?: Maybe<Scalars['Float']['output']>;
  periodEndDate?: Maybe<Scalars['String']['output']>;
  portfolioBalance?: Maybe<Scalars['Float']['output']>;
  /** Document ID of an uploaded but unextracted AFS document */
  unextractedDocumentId?: Maybe<Scalars['Int']['output']>;
};

export type ManagerTags = {
  __typename?: 'ManagerTags';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  portfolioId: Scalars['Int']['output'];
  tag: Scalars['String']['output'];
  tag2?: Maybe<Scalars['String']['output']>;
  tag3?: Maybe<Scalars['String']['output']>;
  tag4?: Maybe<Scalars['String']['output']>;
};

export type ManagerTagsFilter = {
  managerId?: InputMaybe<Scalars['Int']['input']>;
  modelStartDate?: InputMaybe<Scalars['Date']['input']>;
  modelStopDate?: InputMaybe<Scalars['Date']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type ManagerTagsList = {
  __typename?: 'ManagerTagsList';
  items: Array<ManagerTags>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ManagerTagsSort = {
  field: ManagerTagsSortEnum;
  order: SortInput;
};

export enum ManagerTagsSortEnum {
  Date = 'date',
  ManagerId = 'managerId',
  PortfolioId = 'portfolioId'
}

export type ManyCloseDateFundSize = {
  closeDates: Array<CloseDateShort>;
  investmentId: Scalars['Int']['input'];
};

export type ManyPerformanceMtd = {
  /** If omitted, uses the currency of the latest record. */
  currencyId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
  months: Array<PerformanceMtdShort>;
  returnType: ReturnTypes;
};

export type ManyPerformancePrivate = {
  investmentId: Scalars['Int']['input'];
  quarters: Array<PerformancePrivateShort>;
};

export type ManyPerformanceQuarterly = {
  investmentId: Scalars['Int']['input'];
  quarters: Array<PerformanceQuarterlyShort>;
  returnType: ReturnTypes;
};

export type McpToolBundleType = {
  __typename?: 'McpToolBundleType';
  description: Scalars['String']['output'];
  key: SiriusMcpCategory;
  title: Scalars['String']['output'];
  tools: Array<McpToolRefType>;
};

export type McpToolRefType = {
  __typename?: 'McpToolRefType';
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MeasureEnum = {
  __typename?: 'MeasureEnum';
  description: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  measureTypeEnum?: Maybe<MeasureTypeEnum>;
  measureTypeEnumId?: Maybe<Scalars['Int']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
};

export type MeasureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  measureTypeEnumIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MeasureEnumList = {
  __typename?: 'MeasureEnumList';
  items: Array<MeasureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type MeasureEnumSort = {
  field: MeasureEnumSortEnum;
  order: SortInput;
};

export enum MeasureEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type MeasureTypeEnum = {
  __typename?: 'MeasureTypeEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type MeasureTypeEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MeasureTypeEnumList = {
  __typename?: 'MeasureTypeEnumList';
  items: Array<MeasureTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type MeasureTypeEnumSort = {
  field: MeasureTypeEnumSortEnum;
  order: SortInput;
};

export enum MeasureTypeEnumSortEnum {
  Id = 'id'
}

export type MemoizedInvestmentCompletenessSummary = {
  __typename?: 'MemoizedInvestmentCompletenessSummary';
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  percentComplete: Scalars['Float']['output'];
  subcategory: Scalars['String']['output'];
  weight: Scalars['Float']['output'];
};

export type MessageStream = {
  __typename?: 'MessageStream';
  /** position of chunk within a content block */
  blockIndex?: Maybe<Scalars['Int']['output']>;
  contentType?: Maybe<MessageType>;
  event: MessageStreamEvent;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  /** position of message within an array of messages (mostly relevant for tool-use) */
  messageIndex?: Maybe<Scalars['Int']['output']>;
};

export enum MessageStreamEvent {
  ContextCompressing = 'contextCompressing',
  ContextEditing = 'contextEditing',
  Heartbeat = 'heartbeat',
  Message = 'message',
  Retrying = 'retrying',
  Start = 'start',
  Stop = 'stop',
  ToolCall = 'toolCall',
  ToolStart = 'toolStart'
}

export enum MessageType {
  CustomPayload = 'CustomPayload',
  ImageResponseCard = 'ImageResponseCard',
  PlainText = 'PlainText',
  Ssml = 'SSML'
}

export type MetricInfo = {
  __typename?: 'MetricInfo';
  category: Scalars['String']['output'];
  defaultFormat?: Maybe<Scalars['String']['output']>;
  defaultResultType: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  implemented: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parameters: Array<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  aamOptimizationRun: AamOptimizationRun;
  /** Activates the user in Okta. */
  activateUser: User;
  addAdEntriesXApplicationFlags: AdEntriesXApplicationFlags;
  addAdEntriesXApplicationsXSets: AdEntriesXApplicationsXSets;
  addAsyncTaskStatus: AsyncTaskStatus;
  addChatSkillSchedule: ChatSkillSchedule;
  addCogencyLink: CogencyLink;
  addCompany: Company;
  addCompanyValuation: CompanyValuation;
  addCustomAnalytics: CustomAnalytics;
  addCustomIndexInvestment: CustomIndexInvestment;
  addDeal: Deal;
  addDocument?: Maybe<Document>;
  addDocumentQueueSignedURI: Array<DocumentQueue>;
  addEmailDomainXOrganization: EmailDomainXOrganization;
  addFamily: Family;
  addFdpLogin: FdpLogin;
  addFdpWebsites: FdpWebsites;
  addFinancialDataProvider: FinancialDataProvider;
  addFirm?: Maybe<Firm>;
  addFirmEmployment?: Maybe<FirmEmployment>;
  addFirmEngagement: FirmEngagement;
  addFirmFDPLogins: FirmFdpLogins;
  addFirmInstitutions?: Maybe<FirmInstitutions>;
  addFundsXProxies: FundsXProxies;
  addGroupShareDefinition: GroupShareDefinition;
  addInstitution: Institution;
  addInstitutionEmployment: InstitutionEmployment;
  addInvestment?: Maybe<Investment>;
  addInvestmentAccessRequest: InvestmentAccessRequest;
  addInvestmentAxysCode: InvestmentAxysCode;
  addInvestmentFDPLogins: InvestmentFdpLogins;
  addInvestmentFirmEmployment: InvestmentFirmEmployment;
  addInvestmentFirmEmploymentRecords: Array<InvestmentFirmEmployment>;
  addInvestmentInstitutions?: Maybe<InvestmentInstitutions>;
  addInvestmentPrivateQuartileGroupCategory: InvestmentPrivateQuartileGroupCategory;
  addInvestmentSet: InvestmentSet;
  addInvestmentsFamily: InvestmentsFamily;
  addKnowledgeBaseTags: KnowledgeBaseTags;
  addLinks: Links;
  addNote: Notes;
  /** Subscribe a user or a group to an event type. Exactly one of userId or groupId. */
  addNotificationSubscription: NotificationSubscription;
  addOrUpdateAUM?: Maybe<FirmFundAssetsList>;
  addOrUpdateAssumeUser?: Maybe<Scalars['Int']['output']>;
  addOrUpdateCloseDateSize: Array<CloseDateFundSize>;
  addOrUpdateCogencyLink: CogencyLink;
  /** @deprecated Use `bulkUpsertPerformanceMTD` instead */
  addOrUpdatePerformanceMTD: PerformanceMtdList;
  addOrUpdatePerformancePrivate: PerformancePrivateList;
  /** @deprecated Use `bulkUpsertPerformanceQuarterly` instead */
  addOrUpdatePerformanceQuarterly: PerformanceQuarterlyList;
  addOrUpdateUserSettings: UserSettings;
  addPerson?: Maybe<Person>;
  addPersonEducation: PersonEducation;
  addPersonWorkExperience: PersonWorkExperience;
  addPortalOrganization: PortalOrganization;
  addPortalServiceProviderFirm: PortalServiceProviderFirms;
  addPortfolioConfig: PortfolioConfig;
  addPortfolioFDPLogins: PortfolioFdpLogins;
  addRecentlyViewedInvestment: RecentlyViewedInvestment;
  addSavedEntitySearch: SavedEntitySearch;
  addSavedKnowledgeBase: SavedKnowledgeBase;
  addServiceProviderDocuments: ServiceProviderDocuments;
  addServiceProviderFirm: ServiceProviderFirm;
  addServiceProviderNotes: ServiceProviderNotes;
  addSet: Set;
  addShareClass?: Maybe<ShareClass>;
  addStoredPrompts: StoredPrompts;
  addTempFiles: Array<TempFile>;
  addUserActivity: UserActivity;
  addUsersXGroups: UsersXGroups;
  advPull: AsyncTaskStatus;
  advServiceProviderParse: AsyncTaskStatus;
  alphaVantage_extract_fxMonthly: ExtractResult;
  alphaVantage_load_fxMonthly: Scalars['Boolean']['output'];
  alphaVantage_transform_fxMonthly: TransformResult;
  analyseDiligenceGaps: DiligenceGapAnalysis;
  approveMutationPlan: MutationPlan;
  assignAfsHoldingMapping: AfsSecurityMapping;
  bloombergDiligenceExtract: Array<BloombergPullResponse>;
  bloombergDiligenceLoad: Scalars['Boolean']['output'];
  bulkAddAdvSummaryEmailNotification: Array<AdvSummaryEmailNotification>;
  bulkHardDeleteDocuments: Array<Scalars['Int']['output']>;
  bulkUpsertPerformanceMTD?: Maybe<PerformanceMtdList>;
  bulkUpsertPerformancePrivate: PerformancePrivateList;
  bulkUpsertPerformanceQuarterly: PerformanceQuarterlyList;
  cancelMutationPlan: Scalars['Boolean']['output'];
  caseStudySlides: AsyncTaskStatus;
  clearUserSetting: UserSettings;
  computeGuidelineMetrics: ComputeMetricsResult;
  confirmNoticeFundMapping: NoticeFundMapping;
  /** Confirm organization icon upload, validate the uploaded object, and store the key */
  confirmOrganizationIconUpload: Organization;
  confirmPmeMappings: PmeUpload;
  copyInvestmentOverview: AsyncTaskStatus;
  copyPortfolio?: Maybe<Portfolio>;
  copyRiskMeasures: Scalars['Int']['output'];
  createChatAgent: ChatAgent;
  createChatSkill: ChatSkill;
  createFieldDefinition: FieldDefinition;
  createGuidelineNode: GuidelineNode;
  createGuidelineSet: GuidelineSet;
  createLlmModel: LlmModel;
  createOrUpdateFirmDEI: FirmDei;
  createOrganization: Organization;
  createPortfolio?: Maybe<Portfolio>;
  createTemplate: Template;
  createTemplateAttachment: TemplateAttachment;
  createUser: User;
  createUserGroup: User;
  /** Deletes the user in Okta. This is an aggressive operation, all configuration will be lost. */
  deactivateUser: User;
  deleteAdEntriesXApplicationFlags: Scalars['Int']['output'];
  deleteAdEntriesXApplicationsXSets: Scalars['Int']['output'];
  deleteAfsHolding: AfsHolding;
  deleteAssumeUser?: Maybe<Scalars['Int']['output']>;
  deleteChatAgent: Scalars['Boolean']['output'];
  deleteChatSkill: Scalars['Boolean']['output'];
  deleteChatSkillSchedule: Scalars['Int']['output'];
  /** Delete a share class nothing refers to. */
  deleteClientShareClass: Scalars['Boolean']['output'];
  deleteCompanyFieldValues: CompanyFields;
  deleteCompanyValuation: Scalars['Int']['output'];
  deleteConversation: Scalars['Int']['output'];
  deleteDocument: Scalars['Int']['output'];
  deleteDocumentQueue: Scalars['ID']['output'];
  deleteEmailDomainXOrganization: Scalars['Int']['output'];
  deleteFdpLogin: Scalars['Int']['output'];
  deleteFdpWebsites: Scalars['Int']['output'];
  deleteFieldDefinition: Scalars['Boolean']['output'];
  deleteFirm: Scalars['ID']['output'];
  deleteFirmDei: Scalars['ID']['output'];
  deleteFirmEmployment: Scalars['Int']['output'];
  deleteFirmEngagement: Scalars['Int']['output'];
  deleteFirmFieldValues: FirmFields;
  deleteFirmInstitutions: Scalars['Int']['output'];
  deleteFundsXProxies: Scalars['Int']['output'];
  deleteGroupShareDefinition: Scalars['Int']['output'];
  deleteGuidelineNode: Scalars['Boolean']['output'];
  deleteGuidelineSet: GuidelineSetDeleteResult;
  deleteInvestment: Scalars['Boolean']['output'];
  deleteInvestmentAxysCode: Scalars['Int']['output'];
  deleteInvestmentFieldValues: InvestmentFields;
  deleteInvestmentFields: InvestmentFields;
  deleteInvestmentFirmEmployment: Scalars['Int']['output'];
  deleteInvestmentInstitutions: Scalars['Int']['output'];
  deleteInvestmentPrivateQuartileGroupCategory: Scalars['Int']['output'];
  deleteInvestmentSet: Scalars['Int']['output'];
  deleteInvestmentsFamily: Scalars['Int']['output'];
  deleteLinks: Scalars['Int']['output'];
  deleteNote: Notes;
  deleteNoticeNotificationConfig: Scalars['Boolean']['output'];
  deletePersonEducation: Scalars['Int']['output'];
  deletePersonWorkExperience: Scalars['Int']['output'];
  deletePortalFirm: Scalars['ID']['output'];
  deletePortalOrganization: Scalars['ID']['output'];
  deletePortalServiceProviderFirm: Scalars['Int']['output'];
  deletePortalSubmitted: Scalars['ID']['output'];
  deletePortalUser: Scalars['ID']['output'];
  deletePortfolio?: Maybe<Scalars['Boolean']['output']>;
  /** Remove a report's recipients row. */
  deleteReportRecipient: Scalars['Boolean']['output'];
  deleteRiskMeasures: Scalars['Int']['output'];
  deleteSavedKnowledgeBase: Scalars['Int']['output'];
  deleteShareClass: Scalars['Int']['output'];
  deleteStoredPrompts: Scalars['ID']['output'];
  deleteTemplateAttachment: Scalars['Boolean']['output'];
  deleteUsersXGroups: Scalars['ID']['output'];
  discardLlmTaskCandidate: LlmTaskCandidate;
  documentText_archiveAssistant?: Maybe<AsyncTaskStatus>;
  embedNotes: AsyncTaskStatus;
  evaluateLlmTaskCandidate: LlmTaskCandidate;
  firmNewsLoad: AsyncTaskStatus;
  flipSolutionsToPostgres: Scalars['Boolean']['output'];
  gDeltProjectNewsLoad: AsyncTaskStatus;
  generateEmRiskReports: Scalars['Boolean']['output'];
  generateEmbeddings: Scalars['Boolean']['output'];
  /** Give every member of a group write access to an organization skill. Owner (or super user) only. */
  grantChatSkillGroupAccess: ChatSkillGroup;
  importCalculatedIndices: AsyncTaskStatus;
  importCitcoHoldings: AsyncTaskStatus;
  /** Import Portfolio Returns: copy funds' monthly returns from the NAV model, then refresh their share classes from `start` (omit for their whole history). Omit rcgFundIds for every fund with a share class. Runs in the background. */
  importClientPortfolioReturns: AsyncTaskStatus;
  importGuidelineDefinitions: ImportResult;
  importHfrPerformance: AsyncTaskStatus;
  importRiskFromS3?: Maybe<ImportRiskFromS3Result>;
  importRiskMeasures: AsyncTaskStatus;
  importSalesforceSnapshot: AsyncTaskStatus;
  importSecurityMaster: AsyncTaskStatus;
  investmentReport: AsyncTaskStatus;
  /** Streams an LLM answer to the chatMessages subscription for sessionId */
  lexSendMessage: LexSendMessageResult;
  /** Link a queue item you own to the recorded email it came from. A no-op if already linked. Returns the link id. */
  linkDocumentQueueEmail: Scalars['String']['output'];
  /** Mark the given notifications read. Returns how many rows changed; ids belonging to another user match nothing. */
  markNotificationsRead: Scalars['Int']['output'];
  markRangerFieldsStale: Array<RangerStaleFieldInfo>;
  modifyGuidelineSetDate: GuidelineSet;
  moveGuidelineNode: GuidelineNode;
  newsNotify: AsyncTaskStatus;
  /** Leave the current user a notification. The recipient is always the caller — there is no way to notify anyone else. conversationId links the notification back to the conversation it came from and must belong to the caller. Returns false when the identical message already landed today (a retry), true when a new one was written. */
  notifyCurrentUser: Scalars['Boolean']['output'];
  optInToChatSkill: UserChatSkill;
  /** Deactivate an organization skill for the current user only — it stays active for everyone else */
  optOutOfChatSkill: Scalars['Boolean']['output'];
  persistConversationArtifact: ConversationArtifact;
  processDocumentQueue: Scalars['ID']['output'];
  promoteIntakeFirms: AsyncTaskStatus;
  promoteIntakeInvestments: AsyncTaskStatus;
  promoteLlmTaskCandidate: LlmTask;
  proposeLlmTaskChange: LlmTaskCandidate;
  publishDocumentQueues: Array<DocumentPublishResult>;
  publishFirmFieldDrafts: FirmFields;
  publishInvestmentFieldDrafts: InvestmentFields;
  rangerDueDilligenceDrafts: AsyncTaskStatus;
  reconcileNewPortalFirm: Scalars['Int']['output'];
  /** Record an inbound email's metadata, keyed by the mail provider's message id. A no-op if it is already recorded. Returns the email id. */
  recordEmailMetadata: Scalars['String']['output'];
  refreshAssetAllocation: AsyncTaskStatus;
  refreshInvestmentRisk: AsyncTaskStatus;
  refreshLlmModelBenchmarks: Array<LlmModel>;
  refreshLlmModelPrices: Array<LlmModel>;
  /** Refresh NAV model statements for a month from the prior month and the managers' returns, then rebuild the sub-portfolios and primary portfolios that read them. Requires the primary-portfolio editor role, and update access to each fund named; without rcgFundIds, refreshes every fund not fed from Solovis/Cogency and not a sub-portfolio. */
  refreshNavModel: AsyncTaskStatus;
  rematchDocumentQueueEntities: Array<Scalars['ID']['output']>;
  rematerializeSavedKnowledgeBase: Scalars['Int']['output'];
  removeNotificationSubscription: Scalars['Boolean']['output'];
  reorderGuidelineNode: GuidelineNode;
  replaceLlmModel: Array<LlmTaskCandidate>;
  reprocessDocumentQueues: Array<Scalars['ID']['output']>;
  rerunStaleRangerFields: AsyncTaskStatus;
  resaveDocuments: Scalars['JSONObject']['output'];
  resetSystemConfiguration: Scalars['Boolean']['output'];
  restoreAfsHolding: AfsHolding;
  retryFailedSteps: MutationPlan;
  revokeChatSkillGroupAccess: Scalars['Boolean']['output'];
  rollbackSolutionsToSqlServer: Scalars['Boolean']['output'];
  /** Enqueue an out-of-cycle run for this schedule immediately, without affecting its recurrence. */
  runChatSkillScheduleNow: Scalars['Boolean']['output'];
  /** Set a share class's addition and redemption for a month, both entered as positive amounts; both zero or null deletes the month's cash flow. */
  saveClientCashFlow: Scalars['Boolean']['output'];
  /** Save a month's actual end balances, entered fees and final returns for some share classes. Send only the rows that changed. For a derived share class only the final returns may be sent. */
  saveClientMonthEntries: Scalars['Boolean']['output'];
  /** Create or edit a share class and its fee schedules. Returns its id. */
  saveClientShareClass: Scalars['Int']['output'];
  /** Set a switch between two share classes for a month; an amount of zero deletes it. */
  saveClientSwitch: Scalars['Boolean']['output'];
  /** Save funds' estimate overrides for a month. Send only the funds that changed; a reconciled month is refused. */
  saveEarlyEstimates: Scalars['Boolean']['output'];
  saveFirmFieldDrafts: FirmFields;
  saveInvestmentFieldDrafts: InvestmentFields;
  saveLlmEvaluator: LlmEvaluator;
  /** Add a report's recipients, or edit them. */
  saveReportRecipient: ReportRecipientRow;
  /** Sends an email from the notification sender to users in the caller's organization. The body (text and/or html) is always prefixed with an automated-email disclaimer naming the user it was sent on behalf of. Attachments must be entitlement-checked documents or the caller's own temp uploads. */
  sendUserEmail: Scalars['Boolean']['output'];
  setCurrentTemplateVersion: Template;
  /** Hand a queue item you own to the user it was uploaded for. Returns the queue item id. */
  setDocumentQueueUser: Scalars['ID']['output'];
  setGuidelineArguments: Array<GuidelineArgument>;
  setJobScheduleEnabled: Scalars['Boolean']['output'];
  setJobSchedulePreviewAllowed: Scalars['Boolean']['output'];
  setLlmTaskDataset: LlmTask;
  setLlmTaskEvaluators: LlmTask;
  /** Set how the current user is told about one kind of event. Affects only their own delivery. */
  setNotificationChannels: Scalars['Boolean']['output'];
  setOrganizationSubscriber: Organization;
  setSolutionsShadowReads: Scalars['Boolean']['output'];
  setSolutionsSyncEnabled: Scalars['Boolean']['output'];
  /** Upsert a system configuration. Creates if key doesn't exist, updates if it does. */
  setSystemConfiguration: SystemConfiguration;
  sharePortfolio?: Maybe<Portfolio>;
  solovisCommitments: AsyncTaskStatus;
  solovisIdLoad: AsyncTaskStatus;
  solovisLiquidityLoad: AsyncTaskStatus;
  solovisPerformance: AsyncTaskStatus;
  solovisTrans: AsyncTaskStatus;
  stageMutationPlan: MutationPlan;
  stopChat: Scalars['Boolean']['output'];
  swapGuidelineNodeOrder: GuidelineNode;
  triggerAfsExtraction: Scalars['Int']['output'];
  triggerBatchReports: AsyncTaskStatus;
  triggerBoardDocumentProcessing: Scalars['String']['output'];
  triggerNoticeLegExtraction: Scalars['Int']['output'];
  triggerSolutionsSyncReconcile: Scalars['Boolean']['output'];
  updateAdEntriesXApplicationFlags: AdEntriesXApplicationFlags;
  updateAdEntriesXApplicationsXSets: AdEntriesXApplicationsXSets;
  updateAfsHolding: AfsHolding;
  updateAfsSecurityMapping: AfsSecurityMapping;
  updateChatAgent: ChatAgent;
  updateChatSkill: ChatSkill;
  updateChatSkillSchedule: ChatSkillSchedule;
  updateCompany: Company;
  updateCompanyFieldValues: CompanyFields;
  updateCompanyValuation: CompanyValuation;
  updateCustomAnalytics: CustomAnalytics;
  updateCustomIndexInvestment: CustomIndexInvestment;
  updateDeal: Deal;
  updateDocument: Document;
  updateEmailDomainXOrganization: EmailDomainXOrganization;
  updateFamily: Family;
  updateFdpLogin: FdpLogin;
  updateFdpWebsites: FdpWebsites;
  updateFieldDefinition: FieldDefinition;
  updateFinancialDataProvider: FinancialDataProvider;
  updateFirm: Firm;
  updateFirmEmployment: FirmEmployment;
  updateFirmEngagement: FirmEngagement;
  updateFirmFDPLogins: FirmFdpLogins;
  updateFirmFieldValues: FirmFields;
  updateFirmInstitutions: FirmInstitutions;
  updateFundsXProxies: FundsXProxies;
  updateGroupShareDefinition: GroupShareDefinition;
  updateGuideline: Guideline;
  updateGuidelineNode: GuidelineNode;
  updateGuidelineNote: GuidelineNote;
  updateGuidelineResult: GuidelineResult;
  updateInstitution: Institution;
  updateInstitutionEmployment: InstitutionEmployment;
  updateInvestment: Investment;
  updateInvestmentFDPLogins: InvestmentFdpLogins;
  updateInvestmentFieldValues: InvestmentFields;
  updateInvestmentFields: InvestmentFields;
  updateInvestmentFirmEmployment: InvestmentFirmEmployment;
  updateInvestmentInstitutions: InvestmentInstitutions;
  updateInvestmentPrivateQuartileGroupCategory: InvestmentPrivateQuartileGroupCategory;
  updateInvestmentSet: InvestmentSet;
  updateJobSchedule: JobSchedule;
  updateKnowledgeBaseTags: KnowledgeBaseTags;
  updateLinks: Links;
  updateLlmModel: LlmModel;
  updateMutationStepInput: MutationStep;
  updateNote: Notes;
  updateNoticeExtractionClient: NoticeExtraction;
  updateNoticeLeg: NoticeLeg;
  updateOrganization: Organization;
  updatePerformanceCommentary: PerformanceMtd;
  updatePerson: Person;
  updatePersonEducation: PersonEducation;
  updatePersonWorkExperience: PersonWorkExperience;
  updatePortalFirm: PortalFirm;
  updatePortalOrganization: PortalOrganization;
  updatePortalSubmitted: PortalSubmitted;
  updatePortalUser: PortalUser;
  updatePortfolio?: Maybe<Portfolio>;
  updatePortfolioConfig: PortfolioConfig;
  updatePortfolioEntries?: Maybe<Scalars['Boolean']['output']>;
  updatePortfolioFDPLogins: PortfolioFdpLogins;
  updateRiskRefreshList: RiskRefreshListList;
  updateSavedEntitySearch: SavedEntitySearch;
  updateSavedKnowledgeBase: SavedKnowledgeBase;
  updateServiceProviderDocuments: ServiceProviderDocuments;
  updateServiceProviderFirm: ServiceProviderFirm;
  updateServiceProviderNotes: ServiceProviderNotes;
  updateSet: Set;
  updateShareClass: ShareClass;
  updateTemplateAttachment: TemplateAttachment;
  updateUser: User;
  updateUserGroup: User;
  updateUsersXGroups: UsersXGroups;
  uploadPmeFile: AsyncTaskStatus;
  upsertNoticeNotificationConfig: NoticeNotificationConfig;
  verifyLlmModel: LlmModel;
};


export type MutationAamOptimizationRunArgs = {
  config: AamOptimizationInput;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId: Scalars['Int']['input'];
};


export type MutationActivateUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationAddAdEntriesXApplicationFlagsArgs = {
  input: AdEntriesXApplicationFlagsInput;
};


export type MutationAddAdEntriesXApplicationsXSetsArgs = {
  input: AdEntriesXApplicationsXSetsInput;
};


export type MutationAddAsyncTaskStatusArgs = {
  input: AsyncTaskStatusInput;
};


export type MutationAddChatSkillScheduleArgs = {
  input: ChatSkillScheduleInput;
};


export type MutationAddCogencyLinkArgs = {
  input: CogencyLinkInput;
};


export type MutationAddCompanyArgs = {
  input: CompanyInput;
};


export type MutationAddCompanyValuationArgs = {
  input: CompanyValuationInput;
};


export type MutationAddCustomAnalyticsArgs = {
  input: CustomAnalyticsInput;
};


export type MutationAddCustomIndexInvestmentArgs = {
  input: CustomIndexInvestmentInput;
};


export type MutationAddDealArgs = {
  input: DealInput;
};


export type MutationAddDocumentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: DocumentInput;
};


export type MutationAddDocumentQueueSignedUriArgs = {
  names: Array<Scalars['String']['input']>;
};


export type MutationAddEmailDomainXOrganizationArgs = {
  input: EmailDomainXOrganizationInput;
};


export type MutationAddFamilyArgs = {
  input: FamilyInput;
};


export type MutationAddFdpLoginArgs = {
  input: FdpLoginInput;
};


export type MutationAddFdpWebsitesArgs = {
  input: FdpWebsitesInput;
};


export type MutationAddFinancialDataProviderArgs = {
  input: FinancialDataProviderInput;
};


export type MutationAddFirmArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmInput;
};


export type MutationAddFirmEmploymentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmEmploymentInput;
};


export type MutationAddFirmEngagementArgs = {
  input: FirmEngagementInput;
};


export type MutationAddFirmFdpLoginsArgs = {
  input: FirmFdpLoginsInput;
};


export type MutationAddFirmInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: FirmInstitutionsInput;
};


export type MutationAddFundsXProxiesArgs = {
  input: FundsXProxiesInput;
};


export type MutationAddGroupShareDefinitionArgs = {
  input: GroupShareDefinitionInput;
};


export type MutationAddInstitutionArgs = {
  input: InstitutionInput;
};


export type MutationAddInstitutionEmploymentArgs = {
  input: InstitutionEmploymentInput;
};


export type MutationAddInvestmentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: InvestmentInput;
};


export type MutationAddInvestmentAccessRequestArgs = {
  input: InvestmentAccessRequestInput;
};


export type MutationAddInvestmentAxysCodeArgs = {
  input: InvestmentAxysCodeInput;
};


export type MutationAddInvestmentFdpLoginsArgs = {
  input: InvestmentFdpLoginsInput;
};


export type MutationAddInvestmentFirmEmploymentArgs = {
  input: InvestmentFirmEmploymentInput;
};


export type MutationAddInvestmentFirmEmploymentRecordsArgs = {
  input: Array<InvestmentFirmEmploymentInput>;
};


export type MutationAddInvestmentInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: InvestmentInstitutionsInput;
};


export type MutationAddInvestmentPrivateQuartileGroupCategoryArgs = {
  input: InvestmentPrivateQuartileGroupCategoryInput;
};


export type MutationAddInvestmentSetArgs = {
  input: InvestmentSetInput;
};


export type MutationAddInvestmentsFamilyArgs = {
  input: InvestmentsFamilyInput;
};


export type MutationAddKnowledgeBaseTagsArgs = {
  input: KnowledgeBaseTagsInput;
};


export type MutationAddLinksArgs = {
  input: LinksInput;
};


export type MutationAddNoteArgs = {
  input: NotesInput;
};


export type MutationAddNotificationSubscriptionArgs = {
  eventType: NotificationEventType;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddOrUpdateAumArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<AumEntry>;
  investmentId: Scalars['Int']['input'];
};


export type MutationAddOrUpdateAssumeUserArgs = {
  input: AssumeUserInput;
};


export type MutationAddOrUpdateCloseDateSizeArgs = {
  input: ManyCloseDateFundSize;
};


export type MutationAddOrUpdateCogencyLinkArgs = {
  id: Scalars['Int']['input'];
  input: CogencyLinkInput;
};


export type MutationAddOrUpdatePerformanceMtdArgs = {
  input: ManyPerformanceMtd;
};


export type MutationAddOrUpdatePerformancePrivateArgs = {
  input: ManyPerformancePrivate;
};


export type MutationAddOrUpdatePerformanceQuarterlyArgs = {
  input: ManyPerformanceQuarterly;
};


export type MutationAddOrUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};


export type MutationAddPersonArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  input: PersonInput;
};


export type MutationAddPersonEducationArgs = {
  input: PersonEducationInput;
};


export type MutationAddPersonWorkExperienceArgs = {
  input: PersonWorkExperienceInput;
};


export type MutationAddPortalOrganizationArgs = {
  input: PortalOrganizationCreateInput;
};


export type MutationAddPortalServiceProviderFirmArgs = {
  input: PortalServiceProviderFirmInput;
};


export type MutationAddPortfolioConfigArgs = {
  input: PortfolioConfigInput;
};


export type MutationAddPortfolioFdpLoginsArgs = {
  input: PortfolioFdpLoginsInput;
};


export type MutationAddRecentlyViewedInvestmentArgs = {
  input: RecentlyViewedInvestmentInput;
};


export type MutationAddSavedEntitySearchArgs = {
  input: SavedEntitySearchInput;
};


export type MutationAddSavedKnowledgeBaseArgs = {
  input: SavedKnowledgeBaseInput;
};


export type MutationAddServiceProviderDocumentsArgs = {
  input: ServiceProviderDocumentsInput;
};


export type MutationAddServiceProviderFirmArgs = {
  input: ServiceProviderFirmInput;
};


export type MutationAddServiceProviderNotesArgs = {
  input: ServiceProviderNotesInput;
};


export type MutationAddSetArgs = {
  input: SetInput;
};


export type MutationAddShareClassArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: ShareClassInput;
};


export type MutationAddStoredPromptsArgs = {
  input: StoredPromptsInput;
};


export type MutationAddTempFilesArgs = {
  input: Array<TempFileUpload>;
};


export type MutationAddUserActivityArgs = {
  input: UserActivityInput;
};


export type MutationAddUsersXGroupsArgs = {
  input: UsersXGroupsInput;
};


export type MutationAdvPullArgs = {
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeStamp: Scalars['String']['input'];
};


export type MutationAdvServiceProviderParseArgs = {
  docId: Scalars['Int']['input'];
};


export type MutationAlphaVantage_Extract_FxMonthlyArgs = {
  fromCurrency: Scalars['String']['input'];
  replace: Scalars['Boolean']['input'];
  toCurrency: Scalars['String']['input'];
};


export type MutationAlphaVantage_Load_FxMonthlyArgs = {
  transformKey: Scalars['String']['input'];
};


export type MutationAlphaVantage_Transform_FxMonthlyArgs = {
  extractBodyKey: Scalars['String']['input'];
  extractHeadKey: Scalars['String']['input'];
  replace: Scalars['Boolean']['input'];
};


export type MutationAnalyseDiligenceGapsArgs = {
  investmentId: Scalars['Int']['input'];
  run?: InputMaybe<DiligenceDraftRunInput>;
};


export type MutationApproveMutationPlanArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationAssignAfsHoldingMappingArgs = {
  holdingId: Scalars['Int']['input'];
  isProxy?: Scalars['Boolean']['input'];
  securityMasterId: Scalars['Int']['input'];
};


export type MutationBloombergDiligenceExtractArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBloombergDiligenceLoadArgs = {
  inputs: Array<BloombergPullLoadInput>;
};


export type MutationBulkAddAdvSummaryEmailNotificationArgs = {
  input: AdvSummaryEmailNotificationBulkInput;
};


export type MutationBulkHardDeleteDocumentsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationBulkUpsertPerformanceMtdArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ManyPerformanceMtd>;
};


export type MutationBulkUpsertPerformancePrivateArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: Array<ManyPerformancePrivate>;
};


export type MutationBulkUpsertPerformanceQuarterlyArgs = {
  input: Array<ManyPerformanceQuarterly>;
};


export type MutationCancelMutationPlanArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationCaseStudySlidesArgs = {
  aiShorten?: InputMaybe<Scalars['Boolean']['input']>;
  asOfDate?: InputMaybe<Scalars['String']['input']>;
  assetType: CaseStudyAssetType;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationClearUserSettingArgs = {
  input: ClearSettingInput;
};


export type MutationComputeGuidelineMetricsArgs = {
  date: Scalars['DateTime']['input'];
  investmentId: Scalars['Int']['input'];
  setId: Scalars['Int']['input'];
};


export type MutationConfirmNoticeFundMappingArgs = {
  investmentId: Scalars['Int']['input'];
  mappingId: Scalars['Int']['input'];
};


export type MutationConfirmOrganizationIconUploadArgs = {
  organizationId: Scalars['Int']['input'];
};


export type MutationConfirmPmeMappingsArgs = {
  mappings: Array<PmeMappingConfirmationInput>;
  uploadId: Scalars['Int']['input'];
};


export type MutationCopyInvestmentOverviewArgs = {
  destFirmGroupId: Scalars['Int']['input'];
  destInvestmentGroupId: Scalars['Int']['input'];
  fundIds: Array<Scalars['Int']['input']>;
};


export type MutationCopyPortfolioArgs = {
  asOfDate?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['Int']['input'];
  input: PortfolioInput;
};


export type MutationCopyRiskMeasuresArgs = {
  sourceInvestmentId: Scalars['Int']['input'];
  targetInvestmentId: Scalars['Int']['input'];
};


export type MutationCreateChatAgentArgs = {
  input: ChatAgentInput;
};


export type MutationCreateChatSkillArgs = {
  input: ChatSkillInput;
};


export type MutationCreateFieldDefinitionArgs = {
  input: CreateFieldDefinitionInput;
};


export type MutationCreateGuidelineNodeArgs = {
  guidelineInput?: InputMaybe<CreateGuidelineInput>;
  input: CreateGuidelineNodeInput;
  investmentId: Scalars['Int']['input'];
  setId: Scalars['Int']['input'];
};


export type MutationCreateGuidelineSetArgs = {
  input: CreateGuidelineSetInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationCreateLlmModelArgs = {
  input: LlmModelInput;
};


export type MutationCreateOrUpdateFirmDeiArgs = {
  input: FirmDeiCreateOrUpdate;
};


export type MutationCreateOrganizationArgs = {
  input: OrganizationCreateInput;
};


export type MutationCreatePortfolioArgs = {
  input: PortfolioInput;
};


export type MutationCreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateTemplateAttachmentArgs = {
  input: CreateTemplateAttachmentInput;
};


export type MutationCreateUserArgs = {
  input: UserCreateInput;
};


export type MutationCreateUserGroupArgs = {
  input: UserGroupCreateInput;
};


export type MutationDeactivateUserArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteAfsHoldingArgs = {
  holdingId: Scalars['Int']['input'];
};


export type MutationDeleteChatAgentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteChatSkillArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteClientShareClassArgs = {
  shareClassId: Scalars['Int']['input'];
};


export type MutationDeleteCompanyFieldValuesArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteCompanyValuationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteDocumentQueueArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFdpLoginArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFieldDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFirmDeiArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmEngagementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFirmFieldValuesArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteFirmInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type MutationDeleteGuidelineSetArgs = {
  investmentId: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentFieldValuesArgs = {
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationDeleteInvestmentFieldsArgs = {
  fields: InvestmentFieldsInput;
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentSetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteInvestmentsFamilyArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteLinksArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteNoticeNotificationConfigArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePersonEducationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePortalFirmArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePortalSubmittedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortalUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePortfolioArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteReportRecipientArgs = {
  reportId: Scalars['Int']['input'];
};


export type MutationDeleteRiskMeasuresArgs = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listType: DeleteInvestmentRiskListType;
  maxDate?: InputMaybe<Scalars['DateTime']['input']>;
  minDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationDeleteSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteShareClassArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteStoredPromptsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateAttachmentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDiscardLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDocumentText_ArchiveAssistantArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  forceIfSameText?: InputMaybe<Scalars['Boolean']['input']>;
  needsExtraction?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEmbedNotesArgs = {
  timeStamp: Scalars['String']['input'];
};


export type MutationEvaluateLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFlipSolutionsToPostgresArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationGenerateEmRiskReportsArgs = {
  emailRecipients?: Array<Scalars['String']['input']>;
  reports: Array<EmRiskReportConfigInput>;
};


export type MutationGenerateEmbeddingsArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationGrantChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
};


export type MutationImportCalculatedIndicesArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportCitcoHoldingsArgs = {
  asOfDate: Scalars['Date']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationImportClientPortfolioReturnsArgs = {
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  start?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationImportGuidelineDefinitionsArgs = {
  investmentId: Scalars['Int']['input'];
  nodes: Array<ImportGuidelineNodeInput>;
  setId: Scalars['Int']['input'];
};


export type MutationImportHfrPerformanceArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportRiskFromS3Args = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  input: ImportRiskFromS3Input;
};


export type MutationImportRiskMeasuresArgs = {
  conversationArtifactId?: InputMaybe<Scalars['Int']['input']>;
  errorRowLimit?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  isEstimated: Scalars['Boolean']['input'];
  notify?: InputMaybe<Scalars['Boolean']['input']>;
  validateOnly: Scalars['Boolean']['input'];
};


export type MutationImportSalesforceSnapshotArgs = {
  file: Scalars['Upload']['input'];
};


export type MutationImportSecurityMasterArgs = {
  file: Scalars['Upload']['input'];
  target: SecurityMasterImportTarget;
};


export type MutationInvestmentReportArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  elements?: InputMaybe<Array<ReportStructure>>;
  format: FormatOptions;
  includeHoldings?: InputMaybe<Scalars['Boolean']['input']>;
  includeImpactAreas?: InputMaybe<Scalars['Boolean']['input']>;
  includeReportFund?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  reportType: ReportTypeOptions;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  subSections?: InputMaybe<Array<SubSections>>;
};


export type MutationLexSendMessageArgs = {
  input: LexSendMessageInput;
};


export type MutationLinkDocumentQueueEmailArgs = {
  documentQueueId: Scalars['ID']['input'];
  emailId: Scalars['String']['input'];
};


export type MutationMarkNotificationsReadArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationMarkRangerFieldsStaleArgs = {
  documentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentId: Scalars['Int']['input'];
  noteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationModifyGuidelineSetDateArgs = {
  effectiveDate: Scalars['DateTime']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationMoveGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  newParentId?: InputMaybe<Scalars['Int']['input']>;
  nodeId: Scalars['Int']['input'];
  siblingIndex: Scalars['Int']['input'];
};


export type MutationNotifyCurrentUserArgs = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  detail?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationOptInToChatSkillArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type MutationOptOutOfChatSkillArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type MutationPersistConversationArtifactArgs = {
  input: PersistConversationArtifactInput;
};


export type MutationProcessDocumentQueueArgs = {
  documentQueueId: Scalars['ID']['input'];
};


export type MutationPromoteIntakeFirmsArgs = {
  dei: Scalars['Boolean']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firms: Scalars['Boolean']['input'];
  resetShouldUpdate: Scalars['Boolean']['input'];
};


export type MutationPromoteIntakeInvestmentsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  steps?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationPromoteLlmTaskCandidateArgs = {
  id: Scalars['Int']['input'];
  overrideReason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProposeLlmTaskChangeArgs = {
  key: Scalars['String']['input'];
  modelKey?: InputMaybe<Scalars['String']['input']>;
  prompts?: Array<LlmTaskPromptInput>;
};


export type MutationPublishDocumentQueuesArgs = {
  input: Array<DocumentQueuePublishInput>;
};


export type MutationPublishFirmFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKeys: Array<Scalars['String']['input']>;
  firmId: Scalars['Int']['input'];
};


export type MutationPublishInvestmentFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  fieldKeys: Array<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type MutationRangerDueDilligenceDraftsArgs = {
  customPromptsInput?: InputMaybe<Array<CustomPromptsInput>>;
  fieldKeys: Array<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  ragLimits?: InputMaybe<Scalars['Int']['input']>;
  retain?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationReconcileNewPortalFirmArgs = {
  input: ReconcileNewPortalFirmInput;
};


export type MutationRecordEmailMetadataArgs = {
  input: EmailMetadataInput;
};


export type MutationRefreshAssetAllocationArgs = {
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationRefreshInvestmentRiskArgs = {
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  listType: RefreshInvestmentRiskListType;
  partitionCount?: InputMaybe<Scalars['Int']['input']>;
  partitionIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRefreshNavModelArgs = {
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tranDate: Scalars['Date']['input'];
};


export type MutationRematchDocumentQueueEntitiesArgs = {
  documentQueueIds: Array<Scalars['ID']['input']>;
};


export type MutationRematerializeSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveNotificationSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationReorderGuidelineNodeArgs = {
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
  siblingIndex: Scalars['Int']['input'];
};


export type MutationReplaceLlmModelArgs = {
  id: Scalars['Int']['input'];
  replacementKey: Scalars['String']['input'];
};


export type MutationReprocessDocumentQueuesArgs = {
  documentQueueIds: Array<Scalars['ID']['input']>;
};


export type MutationRerunStaleRangerFieldsArgs = {
  fieldKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  investmentId: Scalars['Int']['input'];
};


export type MutationResaveDocumentsArgs = {
  credentials: ResaveDocumentCredentials;
  ids: Array<Scalars['Int']['input']>;
};


export type MutationResetSystemConfigurationArgs = {
  key: SystemConfigurationKey;
};


export type MutationRestoreAfsHoldingArgs = {
  holdingId: Scalars['Int']['input'];
};


export type MutationRetryFailedStepsArgs = {
  planId: Scalars['Int']['input'];
};


export type MutationRevokeChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
};


export type MutationRollbackSolutionsToSqlServerArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRunChatSkillScheduleNowArgs = {
  id: Scalars['Int']['input'];
};


export type MutationSaveClientCashFlowArgs = {
  addition?: InputMaybe<Scalars['Float']['input']>;
  month: Scalars['Date']['input'];
  redemption?: InputMaybe<Scalars['Float']['input']>;
  shareClassId: Scalars['Int']['input'];
};


export type MutationSaveClientMonthEntriesArgs = {
  entries: Array<ClientMonthEntryInput>;
  month: Scalars['Date']['input'];
};


export type MutationSaveClientShareClassArgs = {
  input: ClientShareClassInput;
};


export type MutationSaveClientSwitchArgs = {
  amount: Scalars['Float']['input'];
  fromShareClassId: Scalars['Int']['input'];
  month: Scalars['Date']['input'];
  toShareClassId: Scalars['Int']['input'];
};


export type MutationSaveEarlyEstimatesArgs = {
  estimates: Array<EarlyEstimateInput>;
  month: Scalars['Date']['input'];
};


export type MutationSaveFirmFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  firmId: Scalars['Int']['input'];
  values: Array<FieldValueInput>;
};


export type MutationSaveInvestmentFieldDraftsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  values: Array<FieldValueInput>;
};


export type MutationSaveLlmEvaluatorArgs = {
  input: LlmEvaluatorInput;
};


export type MutationSaveReportRecipientArgs = {
  input: ReportRecipientInput;
};


export type MutationSendUserEmailArgs = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<Scalars['String']['input']>>;
  emails: Array<Scalars['String']['input']>;
  html?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationSetCurrentTemplateVersionArgs = {
  templateId: Scalars['Int']['input'];
};


export type MutationSetDocumentQueueUserArgs = {
  documentQueueId: Scalars['ID']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationSetGuidelineArgumentsArgs = {
  arguments: Array<GuidelineArgumentInput>;
  guidelineId: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationSetJobScheduleEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetJobSchedulePreviewAllowedArgs = {
  allowed: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationSetLlmTaskDatasetArgs = {
  dataset?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};


export type MutationSetLlmTaskEvaluatorsArgs = {
  evaluatorKeys: Array<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};


export type MutationSetNotificationChannelsArgs = {
  email: Scalars['Boolean']['input'];
  eventType: NotificationEventType;
  muted?: InputMaybe<Scalars['Boolean']['input']>;
  toast: Scalars['Boolean']['input'];
};


export type MutationSetOrganizationSubscriberArgs = {
  organizationId: Scalars['Int']['input'];
  subscriberOrganizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetSolutionsShadowReadsArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationSetSolutionsSyncEnabledArgs = {
  enabled: Scalars['Boolean']['input'];
  entity: Scalars['String']['input'];
};


export type MutationSetSystemConfigurationArgs = {
  input: SystemConfigurationInput;
};


export type MutationSharePortfolioArgs = {
  id: Scalars['Int']['input'];
  input: SharePortfolioInput;
};


export type MutationSolovisPerformanceArgs = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};


export type MutationSolovisTransArgs = {
  endMonth: Scalars['Int']['input'];
  endYear: Scalars['Int']['input'];
  startMonth: Scalars['Int']['input'];
  startYear: Scalars['Int']['input'];
};


export type MutationStageMutationPlanArgs = {
  input: StageMutationPlanInput;
};


export type MutationStopChatArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationSwapGuidelineNodeOrderArgs = {
  direction: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  nodeId: Scalars['Int']['input'];
};


export type MutationTriggerAfsExtractionArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationTriggerBatchReportsArgs = {
  input: BatchReportsInput;
};


export type MutationTriggerBoardDocumentProcessingArgs = {
  documentQueueIds: Array<Scalars['String']['input']>;
  existingSpreadsheetId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type MutationTriggerNoticeLegExtractionArgs = {
  documentId: Scalars['Int']['input'];
};


export type MutationTriggerSolutionsSyncReconcileArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  deep?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['String']['input']>;
  maxBatchesPerEntity?: InputMaybe<Scalars['Int']['input']>;
  maxOrphanFraction?: InputMaybe<Scalars['Float']['input']>;
  mode: SyncMode;
  throttleMs?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationFlagsInput;
};


export type MutationUpdateAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
  input: AdEntriesXApplicationsXSetsInput;
};


export type MutationUpdateAfsHoldingArgs = {
  fairValue?: InputMaybe<Scalars['Float']['input']>;
  holdingId: Scalars['Int']['input'];
  holdingName?: InputMaybe<Scalars['String']['input']>;
  holdingType?: InputMaybe<Scalars['String']['input']>;
  percentageOfNav?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateAfsSecurityMappingArgs = {
  isProxy?: Scalars['Boolean']['input'];
  mappingId: Scalars['Int']['input'];
  securityMasterId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateChatAgentArgs = {
  id: Scalars['Int']['input'];
  input: ChatAgentUpdateInput;
};


export type MutationUpdateChatSkillArgs = {
  id: Scalars['Int']['input'];
  input: ChatSkillUpdateInput;
};


export type MutationUpdateChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
  input: ChatSkillScheduleInput;
};


export type MutationUpdateCompanyArgs = {
  id: Scalars['Int']['input'];
  input: CompanyInput;
};


export type MutationUpdateCompanyFieldValuesArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateCompanyValuationArgs = {
  id: Scalars['Int']['input'];
  input: CompanyValuationInput;
};


export type MutationUpdateCustomAnalyticsArgs = {
  id: Scalars['String']['input'];
  input: CustomAnalyticsInput;
};


export type MutationUpdateCustomIndexInvestmentArgs = {
  id: Scalars['Int']['input'];
  input: CustomIndexInvestmentInput;
};


export type MutationUpdateDealArgs = {
  id: Scalars['Int']['input'];
  input: DealInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['Int']['input'];
  input: DocumentUpdateInput;
};


export type MutationUpdateEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
  input: EmailDomainXOrganizationInput;
};


export type MutationUpdateFamilyArgs = {
  id: Scalars['Int']['input'];
  input: FamilyInput;
};


export type MutationUpdateFdpLoginArgs = {
  id: Scalars['Int']['input'];
  input: FdpLoginInput;
};


export type MutationUpdateFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
  input: FdpWebsitesInput;
};


export type MutationUpdateFieldDefinitionArgs = {
  input: UpdateFieldDefinitionInput;
};


export type MutationUpdateFinancialDataProviderArgs = {
  id: Scalars['Int']['input'];
  input: FinancialDataProviderInput;
};


export type MutationUpdateFirmArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: FirmInput;
};


export type MutationUpdateFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: FirmEmploymentInput;
};


export type MutationUpdateFirmEngagementArgs = {
  id: Scalars['Int']['input'];
  input: FirmEngagementInput;
};


export type MutationUpdateFirmFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: FirmFdpLoginsInput;
};


export type MutationUpdateFirmFieldValuesArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateFirmInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: FirmInstitutionsInput;
};


export type MutationUpdateFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
  input: FundsXProxiesInput;
};


export type MutationUpdateGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
  input: GroupShareDefinitionInput;
};


export type MutationUpdateGuidelineArgs = {
  guidelineId: Scalars['Int']['input'];
  input: UpdateGuidelineInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineNodeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nodeId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineNoteArgs = {
  date: Scalars['DateTime']['input'];
  input: UpdateGuidelineNoteInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateGuidelineResultArgs = {
  date: Scalars['DateTime']['input'];
  guidelineId: Scalars['Int']['input'];
  input: UpdateGuidelineResultInput;
  investmentId: Scalars['Int']['input'];
};


export type MutationUpdateInstitutionArgs = {
  id: Scalars['Int']['input'];
  input: InstitutionInput;
};


export type MutationUpdateInstitutionEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: InstitutionEmploymentInput;
};


export type MutationUpdateInvestmentArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: InvestmentInput;
};


export type MutationUpdateInvestmentFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentFdpLoginsInput;
};


export type MutationUpdateInvestmentFieldValuesArgs = {
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  values: Array<FieldValueInput>;
};


export type MutationUpdateInvestmentFieldsArgs = {
  fields: InvestmentFieldsInput;
  investmentId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentFirmEmploymentInput;
};


export type MutationUpdateInvestmentInstitutionsArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: InvestmentInstitutionsInput;
};


export type MutationUpdateInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentPrivateQuartileGroupCategoryInput;
};


export type MutationUpdateInvestmentSetArgs = {
  id: Scalars['Int']['input'];
  input: InvestmentSetInput;
};


export type MutationUpdateJobScheduleArgs = {
  input: JobScheduleUpdateInput;
};


export type MutationUpdateKnowledgeBaseTagsArgs = {
  id: Scalars['Int']['input'];
  input: KnowledgeBaseTagsInput;
};


export type MutationUpdateLinksArgs = {
  id: Scalars['Int']['input'];
  input: LinksInput;
};


export type MutationUpdateLlmModelArgs = {
  id: Scalars['Int']['input'];
  input: LlmModelUpdateInput;
};


export type MutationUpdateMutationStepInputArgs = {
  input: Scalars['JSON']['input'];
  stepId: Scalars['Int']['input'];
};


export type MutationUpdateNoteArgs = {
  id: Scalars['Int']['input'];
  input: NotesInput;
};


export type MutationUpdateNoticeExtractionClientArgs = {
  clientInvestmentId: Scalars['Int']['input'];
  extractionId: Scalars['Int']['input'];
};


export type MutationUpdateNoticeLegArgs = {
  input: UpdateNoticeLegInput;
  legId: Scalars['Int']['input'];
};


export type MutationUpdateOrganizationArgs = {
  id: Scalars['Int']['input'];
  input: OrganizationInput;
};


export type MutationUpdatePerformanceCommentaryArgs = {
  input: PerformanceCommentaryInput;
};


export type MutationUpdatePersonArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: PersonInput;
};


export type MutationUpdatePersonEducationArgs = {
  id: Scalars['Int']['input'];
  input: PersonEducationInput;
};


export type MutationUpdatePersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
  input: PersonWorkExperienceInput;
};


export type MutationUpdatePortalFirmArgs = {
  id: Scalars['String']['input'];
  input: PortalFirmInput;
};


export type MutationUpdatePortalOrganizationArgs = {
  id: Scalars['ID']['input'];
  input: PortalOrganizationInput;
};


export type MutationUpdatePortalSubmittedArgs = {
  id: Scalars['String']['input'];
  input: PortalSubmittedInput;
};


export type MutationUpdatePortalUserArgs = {
  id: Scalars['ID']['input'];
  input: PortalUserInput;
};


export type MutationUpdatePortfolioArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioInput;
};


export type MutationUpdatePortfolioConfigArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioConfigInput;
};


export type MutationUpdatePortfolioEntriesArgs = {
  input: Array<PortfolioEntryInput>;
  portfolioId: Scalars['Int']['input'];
};


export type MutationUpdatePortfolioFdpLoginsArgs = {
  id: Scalars['Int']['input'];
  input: PortfolioFdpLoginsInput;
};


export type MutationUpdateRiskRefreshListArgs = {
  input: RiskRefreshListInput;
};


export type MutationUpdateSavedEntitySearchArgs = {
  id: Scalars['Int']['input'];
  input: SavedEntitySearchInput;
};


export type MutationUpdateSavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
  input: SavedKnowledgeBaseInput;
};


export type MutationUpdateServiceProviderDocumentsArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderDocumentsInput;
};


export type MutationUpdateServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderFirmInput;
};


export type MutationUpdateServiceProviderNotesArgs = {
  id: Scalars['Int']['input'];
  input: ServiceProviderNotesInput;
};


export type MutationUpdateSetArgs = {
  id: Scalars['Int']['input'];
  input: SetInput;
};


export type MutationUpdateShareClassArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  input: ShareClassInput;
};


export type MutationUpdateTemplateAttachmentArgs = {
  input: UpdateTemplateAttachmentInput;
};


export type MutationUpdateUserArgs = {
  id: Scalars['Int']['input'];
  input: UserUpdateInput;
};


export type MutationUpdateUserGroupArgs = {
  id: Scalars['Int']['input'];
  input: UserGroupUpdateInput;
};


export type MutationUpdateUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
  input: UsersXGroupsInput;
};


export type MutationUploadPmeFileArgs = {
  file: Scalars['Upload']['input'];
  investmentId: Scalars['Int']['input'];
};


export type MutationUpsertNoticeNotificationConfigArgs = {
  input: NoticeNotificationConfigInput;
};


export type MutationVerifyLlmModelArgs = {
  id: Scalars['Int']['input'];
};

export type MutationAccess = {
  __typename?: 'MutationAccess';
  canAccess: Scalars['Boolean']['output'];
  fieldAccess?: Maybe<Array<FieldAccess>>;
};

export type MutationPlan = {
  __typename?: 'MutationPlan';
  approvedBy?: Maybe<Scalars['Int']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  createdBy: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  executedAt?: Maybe<Scalars['DateTime']['output']>;
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  rolledBackAt?: Maybe<Scalars['DateTime']['output']>;
  status: MutationPlanStatus;
  steps: Array<MutationStep>;
  title: Scalars['String']['output'];
};

export enum MutationPlanStatus {
  Completed = 'COMPLETED',
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  RolledBack = 'ROLLED_BACK',
  Staged = 'STAGED'
}

export type MutationStep = {
  __typename?: 'MutationStep';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dataSources?: Maybe<Scalars['JSON']['output']>;
  dependsOnStepId?: Maybe<Scalars['Int']['output']>;
  description: Scalars['String']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldSchema?: Maybe<Scalars['JSON']['output']>;
  filePreviewUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  input: Scalars['JSON']['output'];
  liveSnapshot?: Maybe<Scalars['JSON']['output']>;
  lockedFields?: Maybe<Array<Scalars['String']['output']>>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  mutationName: Scalars['String']['output'];
  outputMapping?: Maybe<Scalars['JSON']['output']>;
  planId: Scalars['Int']['output'];
  previousState?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  resultLinks?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int']['output'];
  status: MutationStepStatus;
  valueLabels?: Maybe<Scalars['JSON']['output']>;
};

export type MutationStepInput = {
  dataSources?: InputMaybe<Scalars['JSON']['input']>;
  dependsOnStepIndex?: InputMaybe<Scalars['Int']['input']>;
  description: Scalars['String']['input'];
  input: Scalars['JSON']['input'];
  mutationName: Scalars['String']['input'];
  outputMapping?: InputMaybe<Scalars['JSON']['input']>;
};

export enum MutationStepStatus {
  Executing = 'EXECUTING',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RolledBack = 'ROLLED_BACK',
  Succeeded = 'SUCCEEDED'
}

export type MwdbeFilter = {
  categories?: InputMaybe<Array<OwnershipDiversityType>>;
  ownershipPercentage: OwnershipPercentageType;
};

export type NavClassificationEnum = {
  __typename?: 'NAVClassificationEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NavClassificationEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NavClassificationEnumList = {
  __typename?: 'NAVClassificationEnumList';
  items: Array<NavClassificationEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NavClassificationEnumSort = {
  field: NavClassificationEnumSortEnum;
  order: SortInput;
};

export enum NavClassificationEnumSortEnum {
  Id = 'id'
}

/** One NAV model row: a manager's (or accounting entity's) allocation within an RCG fund for a month. */
export type NavModelAllocation = {
  __typename?: 'NavModelAllocation';
  endingAllocation?: Maybe<Scalars['Float']['output']>;
  managerId: Scalars['Int']['output'];
  managerName?: Maybe<Scalars['String']['output']>;
  rcgFundName?: Maybe<Scalars['String']['output']>;
  /** The manager's strategy code, or 'Acct' for accounting rows. */
  strategy?: Maybe<Scalars['String']['output']>;
};

/** One row of a primary portfolio's monthly NAV statement: a manager or accounting line, a subtotal, or the portfolio summary. date is the statement month-end; isAccounting marks accounting lines (cash, receivables, liabilities) and their subtotal; redemptions are negative; isFinal means reconciled rather than estimated. Returns are fractions (0.012 = 1.2%); balances are in the portfolio's base currency. */
export type NavStatementRow = {
  __typename?: 'NavStatementRow';
  /** The reconciled return on a line; P/L over net beginning allocation on a subtotal. */
  actualReturn?: Maybe<Scalars['Float']['output']>;
  additions: Scalars['Float']['output'];
  /** Net beginning allocation: prior month-end balance + additions + redemptions. */
  adjBegBal?: Maybe<Scalars['Float']['output']>;
  /** The manager's Diligence asset class. Null on subtotal rows and on lines whose fund has none. */
  assetClass?: Maybe<Scalars['String']['output']>;
  /** Prior month-end balance. */
  begBal?: Maybe<Scalars['Float']['output']>;
  begWeight: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  /** Actual return when final, else the estimate. */
  effectiveReturn?: Maybe<Scalars['Float']['output']>;
  endBal?: Maybe<Scalars['Float']['output']>;
  endWeight: Scalars['Float']['output'];
  estimatedReturn?: Maybe<Scalars['Float']['output']>;
  estimatedReturnDate?: Maybe<Scalars['Date']['output']>;
  isAccounting: Scalars['Boolean']['output'];
  isFinal: Scalars['Boolean']['output'];
  manager?: Maybe<Scalars['String']['output']>;
  /** Null on subtotal rows. */
  managerId?: Maybe<Scalars['Int']['output']>;
  managerShortName?: Maybe<Scalars['String']['output']>;
  profitLoss?: Maybe<Scalars['Float']['output']>;
  redemptions: Scalars['Float']['output'];
  rowType: NavStatementRowType;
  sidePocketAmount?: Maybe<Scalars['Float']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  strategyId?: Maybe<Scalars['Int']['output']>;
};

/** The level of a NAV statement row. */
export enum NavStatementRowType {
  Accounting = 'ACCOUNTING',
  Manager = 'MANAGER',
  Portfolio = 'PORTFOLIO',
  Strategy = 'STRATEGY'
}

export type NextPage = {
  __typename?: 'NextPage';
  hasMore: Scalars['Boolean']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
};

export type NoteCategoryEnum = {
  __typename?: 'NoteCategoryEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  noteCategory?: Maybe<Scalars['String']['output']>;
  noteTypes: Array<NoteTypeEnum>;
};

export type NoteCategoryEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NoteCategoryEnumList = {
  __typename?: 'NoteCategoryEnumList';
  items: Array<NoteCategoryEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NoteCategoryEnumSort = {
  field: NoteCategoryEnumSortEnum;
  order: SortInput;
};

export enum NoteCategoryEnumSortEnum {
  Id = 'id'
}

export type NoteEntityAssignmentInput = {
  businessObjectEnumId: Scalars['Int']['input'];
  entityId: Scalars['Int']['input'];
};

export type NoteMetaEnum = {
  __typename?: 'NoteMetaEnum';
  amtLabel?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int']['output'];
  hideExternally: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isAmt?: Maybe<Scalars['Boolean']['output']>;
  isAvg?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isDeprecated?: Maybe<Scalars['Boolean']['output']>;
  isForPartnerFund?: Maybe<Scalars['Boolean']['output']>;
  isMax?: Maybe<Scalars['Boolean']['output']>;
  isMin?: Maybe<Scalars['Boolean']['output']>;
  isYesNo?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteType: NoteTypeEnum;
  noteTypeEnumId: Scalars['Int']['output'];
  textRequiredIf?: Maybe<Scalars['Boolean']['output']>;
};

export type NoteMetaEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteCategoryEnumId?: InputMaybe<Scalars['Int']['input']>;
  noteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type NoteMetaEnumList = {
  __typename?: 'NoteMetaEnumList';
  items: Array<NoteMetaEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NoteMetaEnumSort = {
  field: NoteMetaEnumSortEnum;
  order: SortInput;
};

export enum NoteMetaEnumSortEnum {
  Id = 'id'
}

export type NoteTypeEnum = {
  __typename?: 'NoteTypeEnum';
  alias?: Maybe<Scalars['String']['output']>;
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  noteCategory: NoteCategoryEnum;
  noteCategoryEnumId: Scalars['Int']['output'];
  noteMetaEnums: Array<NoteMetaEnum>;
  noteType?: Maybe<Scalars['String']['output']>;
};

export type Notes = {
  __typename?: 'Notes';
  accessLevelId: Scalars['Int']['output'];
  amtValue?: Maybe<Scalars['Float']['output']>;
  avgValue?: Maybe<Scalars['Float']['output']>;
  canEdit: Scalars['Boolean']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  createUserFullName?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  editedText?: Maybe<Scalars['String']['output']>;
  entityAssignments: Array<NotesXEntity>;
  id: Scalars['Int']['output'];
  isVectorized?: Maybe<Scalars['Boolean']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteDate?: Maybe<Scalars['Date']['output']>;
  noteMeta: NoteMetaEnum;
  noteMetaId: Scalars['Float']['output'];
  organizationId: Scalars['Int']['output'];
  tags: Array<KnowledgeBaseTags>;
  text?: Maybe<Scalars['String']['output']>;
  yesNoResponse?: Maybe<Scalars['Boolean']['output']>;
};

export type NotesDateRange = {
  max?: InputMaybe<Scalars['DateTime']['input']>;
  min?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotesFilter = {
  accessLevelIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyFilters?: InputMaybe<Array<CompanySearchFilters>>;
  companyId?: InputMaybe<Scalars['Int']['input']>;
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  createDate?: InputMaybe<NotesDateRange>;
  createUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  dealId?: InputMaybe<Scalars['Int']['input']>;
  dealIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  firmEngagementId?: InputMaybe<Scalars['Int']['input']>;
  firmFilters?: InputMaybe<Array<FirmSearchFilters>>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  firmIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  investmentFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteDate?: InputMaybe<NotesDateRange>;
  noteMetaId?: InputMaybe<Scalars['Int']['input']>;
  noteMetaIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotesInput = {
  accessLevelId: Scalars['Float']['input'];
  editedText?: InputMaybe<Scalars['String']['input']>;
  /** Entity assignments for this note. Zero-to-many — a note may be attached to multiple investments, firms, companies, and/or deals. Replace semantics: the supplied list becomes the full set on update. */
  entityAssignments?: InputMaybe<Array<NoteEntityAssignmentInput>>;
  /** Knowledge base tag IDs to associate with this note */
  knowledgeBaseTagIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  noteDate?: InputMaybe<Scalars['Date']['input']>;
  noteMetaId: Scalars['Float']['input'];
  notifyTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization IDs to notify. If not provided, all organizations with shouldReceiveInvestmentEmails users will be notified. */
  notifyTeamOrganizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type NotesList = {
  __typename?: 'NotesList';
  items: Array<Notes>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type NotesMetaCount = {
  __typename?: 'NotesMetaCount';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  noteMeta: NoteMetaEnum;
};

export type NotesSort = {
  field: NotesSortEnum;
  order: SortInput;
};

export enum NotesSortEnum {
  Id = 'id',
  TextSearchRank = 'textSearchRank'
}

export type NotesXEntity = {
  __typename?: 'NotesXEntity';
  businessObjectTypeEnumId: Scalars['Int']['output'];
  company?: Maybe<Company>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  entityId: Scalars['Int']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  firm?: Maybe<Firm>;
  firmEngagement?: Maybe<FirmEngagement>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  notesId: Scalars['Int']['output'];
};

export type NoticeExtraction = {
  __typename?: 'NoticeExtraction';
  administrator?: Maybe<Scalars['String']['output']>;
  clientInvestment?: Maybe<Investment>;
  clientManuallyCorrected: Scalars['Boolean']['output'];
  clientMapping?: Maybe<NoticeFundMapping>;
  clientMatchConfidence?: Maybe<Scalars['Float']['output']>;
  clientMatchStatus?: Maybe<InvestmentMatchStatus>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Document>;
  documentId: Scalars['Int']['output'];
  dueDate?: Maybe<Scalars['Date']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  fieldSources?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['Int']['output'];
  legs: Array<NoticeLeg>;
  legsBalance: Scalars['Boolean']['output'];
  legsTotal: Scalars['Float']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  noticeDate?: Maybe<Scalars['Date']['output']>;
  noticeType?: Maybe<NoticeType>;
  rawClientName?: Maybe<Scalars['String']['output']>;
  reviewReasons: Array<NoticeReviewReason>;
  status: NoticeExtractionStatus;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

export type NoticeExtractionList = {
  __typename?: 'NoticeExtractionList';
  items: Array<NoticeExtraction>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export enum NoticeExtractionStatus {
  Completed = 'completed',
  Failed = 'failed',
  NotApplicable = 'not_applicable',
  Pending = 'pending',
  Processing = 'processing'
}

export type NoticeFundMapping = {
  __typename?: 'NoticeFundMapping';
  confidence?: Maybe<Scalars['Float']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  llmReasoning?: Maybe<Scalars['String']['output']>;
  manuallyVerified: Scalars['Boolean']['output'];
  mappingKind: NoticeMappingKind;
  matchStatus: InvestmentMatchStatus;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  needsReview: Scalars['Boolean']['output'];
  rawFundName: Scalars['String']['output'];
  verifiedBy?: Maybe<Scalars['String']['output']>;
  verifiedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type NoticeLeg = {
  __typename?: 'NoticeLeg';
  amount: Scalars['Float']['output'];
  category: NoticeLegCategory;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  fundMapping?: Maybe<NoticeFundMapping>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  manuallyCorrected: Scalars['Boolean']['output'];
  matchConfidence?: Maybe<Scalars['Float']['output']>;
  matchStatus?: Maybe<InvestmentMatchStatus>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  noticeExtraction: NoticeExtraction;
  noticeExtractionId: Scalars['Int']['output'];
  rawFundName: Scalars['String']['output'];
  sourcePage?: Maybe<Scalars['Int']['output']>;
  sourceQuote?: Maybe<Scalars['String']['output']>;
};

export enum NoticeLegCategory {
  CcForManagementFee = 'CCForManagementFee',
  CcForPartnershipExpense = 'CCForPartnershipExpense',
  CapitalCall = 'CapitalCall',
  CapitalCallForInvestment = 'CapitalCallForInvestment',
  CarriedInterest = 'CarriedInterest',
  DistributionOfIncome = 'DistributionOfIncome',
  EqualizationInterestExpense = 'EqualizationInterestExpense',
  EqualizationInterestIncome = 'EqualizationInterestIncome',
  Interest = 'Interest',
  Redemption = 'Redemption',
  ReturnOfCapital = 'ReturnOfCapital',
  Subscription = 'Subscription',
  TaxWithholding = 'TaxWithholding',
  Unsure = 'Unsure'
}

export type NoticeLegCategoryTotal = {
  __typename?: 'NoticeLegCategoryTotal';
  category: NoticeLegCategory;
  total: Scalars['Float']['output'];
};

export type NoticeLegsByInvestmentResult = {
  __typename?: 'NoticeLegsByInvestmentResult';
  categoryTotals: Array<NoticeLegCategoryTotal>;
  clients: Array<Investment>;
  items: Array<NoticeLeg>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
  truncated: Scalars['Boolean']['output'];
};

export enum NoticeMappingKind {
  Client = 'CLIENT',
  Fund = 'FUND'
}

export type NoticeNotificationConfig = {
  __typename?: 'NoticeNotificationConfig';
  clientInvestment?: Maybe<Investment>;
  clientInvestmentId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  includeAttachment: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  noticeType?: Maybe<NoticeType>;
  powerAutomateOverlaps: Array<Scalars['String']['output']>;
  recipients: Scalars['String']['output'];
};

export type NoticeNotificationConfigInput = {
  clientInvestmentId: Scalars['Int']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  includeAttachment: Scalars['Boolean']['input'];
  noticeType?: InputMaybe<NoticeType>;
  recipients: Scalars['String']['input'];
};

export enum NoticeReviewReason {
  ExtractionFailed = 'EXTRACTION_FAILED',
  LowConfidenceClient = 'LOW_CONFIDENCE_CLIENT',
  LowConfidenceFund = 'LOW_CONFIDENCE_FUND',
  Unbalanced = 'UNBALANCED',
  UnmappedClient = 'UNMAPPED_CLIENT',
  UnmappedFund = 'UNMAPPED_FUND',
  UnsureCategory = 'UNSURE_CATEGORY'
}

export enum NoticeType {
  CapitalCall = 'CAPITAL_CALL',
  Distribution = 'DISTRIBUTION'
}

export type Notification = {
  __typename?: 'Notification';
  createdAt: Scalars['DateTime']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  eventType: NotificationEventType;
  hasArtifact: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  reason: Scalars['String']['output'];
  subjectId: Scalars['BigInt']['output'];
  subjectType: NotificationSubjectType;
  userId: Scalars['Int']['output'];
};

export enum NotificationCategory {
  Collaboration = 'COLLABORATION',
  Compliance = 'COMPLIANCE',
  YourWork = 'YOUR_WORK'
}

export type NotificationEventPreference = {
  __typename?: 'NotificationEventPreference';
  category: NotificationCategory;
  email: Scalars['Boolean']['output'];
  emailable: Scalars['Boolean']['output'];
  eventType: NotificationEventType;
  muted: Scalars['Boolean']['output'];
  requiresSubscription: Scalars['Boolean']['output'];
  subscribedDirectly: Scalars['Boolean']['output'];
  subscribedViaGroup: Scalars['Boolean']['output'];
  toast: Scalars['Boolean']['output'];
  usingDefaults: Scalars['Boolean']['output'];
};

export enum NotificationEventType {
  AgentMessage = 'AGENT_MESSAGE',
  GuidelineBreach = 'GUIDELINE_BREACH',
  NoteAdded = 'NOTE_ADDED',
  NoteMention = 'NOTE_MENTION',
  SkillRunCompleted = 'SKILL_RUN_COMPLETED',
  SkillRunFailed = 'SKILL_RUN_FAILED',
  TaskCompleted = 'TASK_COMPLETED',
  TaskFailed = 'TASK_FAILED'
}

export type NotificationFilter = {
  eventTypes?: InputMaybe<Array<NotificationEventType>>;
  search?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  unreadOnly?: InputMaybe<Scalars['Boolean']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NotificationRecipientOrganization = {
  __typename?: 'NotificationRecipientOrganization';
  id: Scalars['Int']['output'];
  /** True if this org appears because it has a group share on one of the note's entities */
  isShared?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  users: Array<NotificationRecipientUser>;
};

export type NotificationRecipientUser = {
  __typename?: 'NotificationRecipientUser';
  commonName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
};

export type NotificationRecipientsList = {
  __typename?: 'NotificationRecipientsList';
  organizations: Array<NotificationRecipientOrganization>;
};

export enum NotificationSubjectType {
  AsyncTask = 'ASYNC_TASK',
  Conversation = 'CONVERSATION',
  Investment = 'INVESTMENT',
  Note = 'NOTE'
}

export type NotificationSubscription = {
  __typename?: 'NotificationSubscription';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  eventType: NotificationEventType;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  subscriberName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export type OktaUser = {
  __typename?: 'OktaUser';
  activated?: Maybe<Scalars['DateTime']['output']>;
  created: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  passwordChanged?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  statusChanged?: Maybe<Scalars['DateTime']['output']>;
};

export type OperatingStatusEnum = {
  __typename?: 'OperatingStatusEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OperatingStatusEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OperatingStatusEnumList = {
  __typename?: 'OperatingStatusEnumList';
  items: Array<OperatingStatusEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OperatingStatusEnumSort = {
  field: OperatingStatusEnumSortEnum;
  order: SortInput;
};

export enum OperatingStatusEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type OrgLinks = {
  __typename?: 'OrgLinks';
  expirationDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<Links>;
  linkId: Scalars['Int']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['Int']['output'];
};

export type OrgLinksFilter = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  linkId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgLinksInput = {
  expirationDate?: InputMaybe<Scalars['Date']['input']>;
  linkId?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrgLinksList = {
  __typename?: 'OrgLinksList';
  items: Array<OrgLinks>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrgLinksSort = {
  field: OrgLinksSortEnum;
  order: SortInput;
};

export enum OrgLinksSortEnum {
  Id = 'id',
  LinkId = 'linkId',
  OrganizationId = 'organizationId'
}

export type Organization = {
  __typename?: 'Organization';
  clientId?: Maybe<Scalars['ID']['output']>;
  cognitoIdpIdentifier?: Maybe<Scalars['String']['output']>;
  emailDomainMappings: Array<EmailDomainXOrganization>;
  id: Scalars['Int']['output'];
  intakeOrganizationId?: Maybe<Scalars['ID']['output']>;
  managedOrganizations: Array<Organization>;
  name: Scalars['String']['output'];
  orgLinks: Array<OrgLinks>;
  smallIconUrl?: Maybe<Scalars['String']['output']>;
};

export type OrganizationCreateInput = {
  createDefaultEntityGroups?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type OrganizationFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInput = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orgLinks?: InputMaybe<Array<OrgLinksInput>>;
};

export type OrganizationInvestmentSetSubscription = {
  __typename?: 'OrganizationInvestmentSetSubscription';
  organization: Organization;
  organizationId: Scalars['Int']['output'];
};

export type OrganizationList = {
  __typename?: 'OrganizationList';
  items: Array<Organization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrganizationSort = {
  field: OrganizationSortEnum;
  order: SortInput;
};

export enum OrganizationSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type OrganizationStructureEnum = {
  __typename?: 'OrganizationStructureEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OrganizationStructureEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type OrganizationStructureEnumList = {
  __typename?: 'OrganizationStructureEnumList';
  items: Array<OrganizationStructureEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type OrganizationStructureEnumSort = {
  field: OrganizationStructureEnumSortEnum;
  order: SortInput;
};

export enum OrganizationStructureEnumSortEnum {
  Id = 'id'
}

export enum OwnershipDiversityType {
  AfricanAmerican = 'africanAmerican',
  Asian = 'asian',
  Disabled = 'disabled',
  Hispanic = 'hispanic',
  Lgbtq = 'lgbtq',
  NativeAmerican = 'nativeAmerican',
  Other = 'other',
  Veteran = 'veteran',
  Women = 'women'
}

export enum OwnershipPercentageType {
  Any = 'any',
  Majority = 'majority',
  Minority = 'minority'
}

export type PeFundNumberEnum = {
  __typename?: 'PEFundNumberEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PeFundNumberEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PeFundNumberEnumList = {
  __typename?: 'PEFundNumberEnumList';
  items: Array<PeFundNumberEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeFundNumberEnumSort = {
  field: PeFundNumberEnumSortEnum;
  order: SortInput;
};

export enum PeFundNumberEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PeStrategyEnum = {
  __typename?: 'PEStrategyEnum';
  code: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  peSubStrategies: Array<PeStrategyEnum>;
  subStrategies: Array<PeSubStrategyEnum>;
};

export type PeStrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeStrategyEnumList = {
  __typename?: 'PEStrategyEnumList';
  items: Array<PeStrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeStrategyEnumSort = {
  field: PeStrategyEnumSortEnum;
  order: SortInput;
};

export enum PeStrategyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeSubStrategyEnum = {
  __typename?: 'PESubStrategyEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  peStrategy: PeStrategyEnum;
  peStrategyEnumId: Scalars['Int']['output'];
};

export enum Prud {
  Delete = 'delete',
  Preview = 'preview',
  Read = 'read',
  Update = 'update'
}

export type PageContentItem = {
  anchor?: InputMaybe<Scalars['String']['input']>;
  data: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['String']['input'];
  type: PageContentType;
};

export enum PageContentType {
  Html = 'html',
  Json = 'json',
  Text = 'text'
}

export type PageContext = {
  items: Array<PageContentItem>;
  params: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type PageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type PeInctFeeCalcEnum = {
  __typename?: 'PeInctFeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PeInctFeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeInctFeeCalcEnumList = {
  __typename?: 'PeInctFeeCalcEnumList';
  items: Array<PeInctFeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeInctFeeCalcEnumSort = {
  field: PeInctFeeCalcEnumSortEnum;
  order: SortInput;
};

export enum PeInctFeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeLiquidity = {
  __typename?: 'PeLiquidity';
  catchupPercent?: Maybe<Scalars['Float']['output']>;
  compoundingPeriod?: Maybe<CompoundingPeriodEnum>;
  compoundingPeriodId?: Maybe<Scalars['Int']['output']>;
  hasCatchupProvision?: Maybe<Scalars['Boolean']['output']>;
  hasExtensionOption?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isCompounded?: Maybe<Scalars['Boolean']['output']>;
  optionOfExtension?: Maybe<RightOfExtensionEnum>;
  optionOfExtensionId?: Maybe<Scalars['Int']['output']>;
  preferredReturn?: Maybe<Scalars['Float']['output']>;
  shareClassId: Scalars['Int']['output'];
};

export type PeLiquidityFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type PeLiquidityInput = {
  catchupPercent?: InputMaybe<Scalars['Float']['input']>;
  compoundingPeriodId?: InputMaybe<Scalars['Int']['input']>;
  hasCatchupProvision?: InputMaybe<Scalars['Boolean']['input']>;
  isCompounded?: InputMaybe<Scalars['Boolean']['input']>;
  optionOfExtensionId?: InputMaybe<Scalars['Int']['input']>;
  preferredReturn?: InputMaybe<Scalars['Float']['input']>;
};

export type PeLiquidityList = {
  __typename?: 'PeLiquidityList';
  items: Array<PeLiquidity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeLiquiditySort = {
  field: PeLiquiditySortEnum;
  order: SortInput;
};

export enum PeLiquiditySortEnum {
  Id = 'id'
}

export type PeMgmtFeeCalcEnum = {
  __typename?: 'PeMgmtFeeCalcEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PeMgmtFeeCalcEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PeMgmtFeeCalcEnumList = {
  __typename?: 'PeMgmtFeeCalcEnumList';
  items: Array<PeMgmtFeeCalcEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PeMgmtFeeCalcEnumSort = {
  field: PeMgmtFeeCalcEnumSortEnum;
  order: SortInput;
};

export enum PeMgmtFeeCalcEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PeersList = {
  __typename?: 'PeersList';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  type: PeersListEnum;
  typeEnumId: Scalars['Int']['output'];
};

export type PeersListEnum = {
  __typename?: 'PeersListEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PeersSummaryDetail = {
  DPIQuartile?: InputMaybe<Scalars['Float']['input']>;
  IRRQuartile?: InputMaybe<Scalars['Float']['input']>;
  TVPIQuartile?: InputMaybe<Scalars['Float']['input']>;
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  dpi?: InputMaybe<Scalars['Float']['input']>;
  grouping?: InputMaybe<Scalars['String']['input']>;
  investment_name: Scalars['String']['input'];
  irr?: InputMaybe<Scalars['Float']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  tvpi?: InputMaybe<Scalars['Float']['input']>;
  vintage?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformanceAnalytics = {
  __typename?: 'PerformanceAnalytics';
  cumulative: BenchmarkTimeSeries;
  drawdown?: Maybe<Array<TimeSeriesRecord>>;
  growth1000?: Maybe<BenchmarkTimeSeries>;
  investmentId: Scalars['Int']['output'];
  returnDistribution?: Maybe<ReturnDistributionRecord>;
};


export type PerformanceAnalyticsCumulativeArgs = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PerformanceAnalyticsDrawdownArgs = {
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
};


export type PerformanceAnalyticsGrowth1000Args = {
  benchmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  defaultBenchmarks?: InputMaybe<Scalars['Boolean']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PerformanceAnalyticsReturnDistributionArgs = {
  excessReturnBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceCommentaryInput = {
  comment: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PerformanceDateRange = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Combined Performance Lag and Unit so types match the check constraint (both defined or both null) */
export type PerformanceLag = {
  __typename?: 'PerformanceLag';
  lag: Scalars['Int']['output'];
  lagUnit: CalendarUnitEnum;
  lagUnitId: Scalars['Int']['output'];
};

export type PerformanceLagInput = {
  lag?: InputMaybe<Scalars['Int']['input']>;
  lagUnitId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformanceMtd = {
  __typename?: 'PerformanceMTD';
  asOfDate: Scalars['DateTime']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser: Scalars['String']['output'];
  currency: CurrencyDenominationEnum;
  currencyId: Scalars['Float']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  performanceCommentary?: Maybe<Scalars['String']['output']>;
  /** The commentary note entity for this month, for consumers that need editedText (edited commentary takes precedence over the original text). performanceCommentary above resolves the original text only. */
  performanceCommentaryNote?: Maybe<Notes>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceMtdFilter = {
  /**
   * Matches on the year and month
   * @deprecated Use dateRange instead
   */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  /** Matches on the year and month */
  dateRange?: InputMaybe<PerformanceMtdDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Matches on the year and month */
  returnRange?: InputMaybe<PerformanceDateRange>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceMtdList = {
  __typename?: 'PerformanceMTDList';
  items: Array<PerformanceMtd>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceMtdShort = {
  asOfDate: Scalars['DateTime']['input'];
  /** Null values are treated as deletes. */
  fundReturn?: InputMaybe<Scalars['Float']['input']>;
  performanceCommentary?: InputMaybe<Scalars['String']['input']>;
  returnMonth: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
};

export type PerformanceMtdSort = {
  field: PerformanceMtdSortEnum;
  order: SortInput;
};

export enum PerformanceMtdSortEnum {
  AsOfDate = 'asOfDate',
  Id = 'id',
  Return = 'return'
}

export type PerformanceMtdBulkFilter = {
  /** Matches on year and month, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  /** Matches on year and month, inclusive. */
  dateRange?: InputMaybe<PerformanceMtdDateRange>;
  investmentIds: Array<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceMtdBulkInvestment = {
  __typename?: 'PerformanceMtdBulkInvestment';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  performanceMTD: Array<PerformanceMtdBulkPerformance>;
};

export type PerformanceMtdBulkPerformance = {
  __typename?: 'PerformanceMtdBulkPerformance';
  asOfDate: Scalars['DateTime']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  currencyId?: Maybe<Scalars['Float']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnMonth: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceMtdBulkSort = {
  field: PerformanceMtdBulkSortEnum;
  order: SortInput;
};

export enum PerformanceMtdBulkSortEnum {
  AsOfDate = 'asOfDate'
}

export type PerformanceMtdDateRange = {
  end?: InputMaybe<Scalars['Date']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type PerformancePeriodRange = {
  __typename?: 'PerformancePeriodRange';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

export type PerformancePrivate = {
  __typename?: 'PerformancePrivate';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dpi?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  netIRR?: Maybe<Scalars['Float']['output']>;
  relativeStats?: Maybe<PerformancePrivateRelativeStats>;
  returnQuarter: Scalars['Int']['output'];
  returnYear: Scalars['Int']['output'];
  tvpi?: Maybe<Scalars['Float']['output']>;
};


export type PerformancePrivateRelativeStatsArgs = {
  privateQuartileGroupCategoryId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformancePrivateFilter = {
  /** Matches on the year and quarter, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type PerformancePrivateList = {
  __typename?: 'PerformancePrivateList';
  items: Array<PerformancePrivate>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformancePrivateRelativeStats = {
  __typename?: 'PerformancePrivateRelativeStats';
  asOfDate: Scalars['DateTime']['output'];
  investmentId?: Maybe<Scalars['Int']['output']>;
  privateQuartileGroup?: Maybe<PrivateQuartileGroup>;
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryId?: Maybe<Scalars['Int']['output']>;
  privateQuartileGroupId?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative DPI. */
  relativeDPIQuartile?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative IRR. */
  relativeIRRQuartile?: Maybe<Scalars['Int']['output']>;
  /** Value between 1 and 4 describing the quartile of the relative TVPI. */
  relativeTVPIQuartile?: Maybe<Scalars['Int']['output']>;
};

export type PerformancePrivateSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformancePrivateStatType;
};

export type PerformancePrivateShort = {
  dpi?: InputMaybe<Scalars['Float']['input']>;
  netIRR?: InputMaybe<Scalars['Float']['input']>;
  returnQuarter: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
  tvpi?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformancePrivateSort = {
  field: PerformancePrivateSortEnum;
  order: SortInput;
};

export enum PerformancePrivateSortEnum {
  AsOfDate = 'asOfDate'
}

export enum PerformancePrivateStatType {
  Dpi = 'dpi',
  NetIrr = 'netIRR',
  Tvpi = 'tvpi'
}

export type PerformanceQuarterly = {
  __typename?: 'PerformanceQuarterly';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  return?: Maybe<Scalars['Float']['output']>;
  returnQuarter: Scalars['Int']['output'];
  returnType: Scalars['String']['output'];
  returnYear: Scalars['Int']['output'];
};

export type PerformanceQuarterlyFilterInput = {
  /** Matches on year and quarter, inclusive. */
  asOfDateRange?: InputMaybe<PerformanceDateRange>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  returnRange?: InputMaybe<PerformanceReturnRange>;
  returnType?: InputMaybe<ReturnTypes>;
};

export type PerformanceQuarterlyList = {
  __typename?: 'PerformanceQuarterlyList';
  items: Array<PerformanceQuarterly>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceQuarterlyShort = {
  /** Null values act as deletes */
  fundReturn?: InputMaybe<Scalars['Float']['input']>;
  returnQuarter: Scalars['Int']['input'];
  returnYear: Scalars['Int']['input'];
};

export type PerformanceQuarterlySort = {
  field: PerformanceQuarterlySortEnum;
  order: SortInput;
};

export enum PerformanceQuarterlySortEnum {
  AsOfDate = 'asOfDate',
  Return = 'return'
}

export type PerformanceReturnRange = {
  end?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Float']['input']>;
};

export type PerformanceSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformanceStatType;
};

export type PerformanceSourceEnum = {
  __typename?: 'PerformanceSourceEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type PerformanceSourceEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceSourceEnumList = {
  __typename?: 'PerformanceSourceEnumList';
  items: Array<PerformanceSourceEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PerformanceSourceEnumSort = {
  field: PerformanceSourceEnumSortEnum;
  order: SortInput;
};

export enum PerformanceSourceEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export enum PerformanceStatType {
  CompoundReturn1m = 'compoundReturn1m',
  CompoundReturn1y = 'compoundReturn1y',
  CompoundReturn1yAnnualized = 'compoundReturn1yAnnualized',
  CompoundReturn3y = 'compoundReturn3y',
  CompoundReturn3yAnnualized = 'compoundReturn3yAnnualized',
  CompoundReturn5y = 'compoundReturn5y',
  CompoundReturn5yAnnualized = 'compoundReturn5yAnnualized',
  CompoundReturnItd = 'compoundReturnItd',
  CompoundReturnItdAnnualized = 'compoundReturnItdAnnualized',
  CompoundReturnYtd = 'compoundReturnYtd',
  MaxDrawDown3y = 'maxDrawDown3y',
  MaxDrawDown5y = 'maxDrawDown5y',
  PercentProfitablePeriods3y = 'percentProfitablePeriods3y',
  SharpeRatio3y = 'sharpeRatio3y',
  SharpeRatio3yAnnualized = 'sharpeRatio3yAnnualized',
  SharpeRatio5y = 'sharpeRatio5y',
  SharpeRatio5yAnnualized = 'sharpeRatio5yAnnualized',
  StandardDeviation1yAnnualized = 'standardDeviation1yAnnualized',
  StandardDeviation3y = 'standardDeviation3y',
  StandardDeviation3yAnnualized = 'standardDeviation3yAnnualized',
  StandardDeviation5yAnnualized = 'standardDeviation5yAnnualized',
  StandardDeviationItd = 'standardDeviationItd',
  StandardDeviationYtd = 'standardDeviationYtd'
}

export type PerformanceStatistics = {
  __typename?: 'PerformanceStatistics';
  compoundReturn1m?: Maybe<Scalars['Float']['output']>;
  compoundReturn1y?: Maybe<Scalars['Float']['output']>;
  compoundReturn1yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturn3m?: Maybe<Scalars['Float']['output']>;
  compoundReturn3y?: Maybe<Scalars['Float']['output']>;
  compoundReturn3yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturn5y?: Maybe<Scalars['Float']['output']>;
  compoundReturn5yAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturnItd?: Maybe<Scalars['Float']['output']>;
  compoundReturnItdAnnualized?: Maybe<Scalars['Float']['output']>;
  compoundReturnYtd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  maxDrawDown3y?: Maybe<Scalars['Float']['output']>;
  percentProfitablePeriods3y?: Maybe<Scalars['Float']['output']>;
  sharpeRatio3y?: Maybe<Scalars['Float']['output']>;
  sharpeRatio3yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation1yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation3y?: Maybe<Scalars['Float']['output']>;
  standardDeviation3yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviation5yAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviationItdAnnualized?: Maybe<Scalars['Float']['output']>;
  standardDeviationYtd?: Maybe<Scalars['Float']['output']>;
  startDate: Scalars['Date']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PersistConversationArtifactInput = {
  /** Human-readable name, e.g. a filename */
  artifactName: Scalars['String']['input'];
  artifactType: ConversationArtifactType;
  /** The artifact payload to persist (text/JSON string). */
  content: Scalars['String']['input'];
  /** MIME content type, e.g. application/json. Defaults to text/plain. */
  contentType?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['Int']['input'];
  /** Optional structured metadata about the artifact. */
  metadata?: InputMaybe<Scalars['JSON']['input']>;
};

export type Person = {
  __typename?: 'Person';
  biography?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  diversity?: Maybe<PersonDiversity>;
  education: Array<PersonEducation>;
  educationSummary?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fax2?: Maybe<Scalars['String']['output']>;
  firmEmployment: Array<FirmEmployment>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  hasPhoto: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isCFA?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  latestNewsMonitoringPull?: Maybe<Scalars['DateTime']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['String']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  newsMonitoringStartDate?: Maybe<Scalars['DateTime']['output']>;
  personGroupId: Scalars['Int']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  phone2?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
  photoType?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Scalars['String']['output']>;
  titleEnum?: Maybe<TitleEnum>;
  titleEnumId?: Maybe<Scalars['Int']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  workExperience: Array<PersonWorkExperience>;
  workExperienceSummary?: Maybe<Scalars['String']['output']>;
};


export type PersonFirmEmploymentArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};

export type PersonDiversity = {
  __typename?: 'PersonDiversity';
  africanAmerican?: Maybe<Scalars['Boolean']['output']>;
  asian?: Maybe<Scalars['Boolean']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  hawaiianOrPacificIslander?: Maybe<Scalars['Boolean']['output']>;
  hispanic?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  lgbtq?: Maybe<Scalars['Boolean']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  nativeAmerican?: Maybe<Scalars['Boolean']['output']>;
  nonBinary?: Maybe<Scalars['Boolean']['output']>;
  other?: Maybe<Scalars['Boolean']['output']>;
  person: Person;
  veteran?: Maybe<Scalars['Boolean']['output']>;
  woman?: Maybe<Scalars['Boolean']['output']>;
};

export type PersonDiversityInput = {
  africanAmerican?: InputMaybe<Scalars['Boolean']['input']>;
  asian?: InputMaybe<Scalars['Boolean']['input']>;
  createDate?: InputMaybe<Scalars['DateTime']['input']>;
  createUser?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  hawaiianOrPacificIslander?: InputMaybe<Scalars['Boolean']['input']>;
  hispanic?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lgbtq?: InputMaybe<Scalars['Boolean']['input']>;
  modifyDate?: InputMaybe<Scalars['DateTime']['input']>;
  modifyUser?: InputMaybe<Scalars['String']['input']>;
  nativeAmerican?: InputMaybe<Scalars['Boolean']['input']>;
  nonBinary?: InputMaybe<Scalars['Boolean']['input']>;
  other?: InputMaybe<Scalars['Boolean']['input']>;
  veteran?: InputMaybe<Scalars['Boolean']['input']>;
  woman?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PersonEducation = {
  __typename?: 'PersonEducation';
  degree?: Maybe<DegreeEnum>;
  degreeEnumId?: Maybe<Scalars['Int']['output']>;
  graduationYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
  personId: Scalars['Int']['output'];
  school: SchoolEnum;
  schoolEnumId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type PersonEducationFilterInput = {
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonEducationInput = {
  degreeEnumId?: InputMaybe<Scalars['Int']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  personId?: InputMaybe<Scalars['Int']['input']>;
  schoolEnumId?: InputMaybe<Scalars['Int']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type PersonEducationList = {
  __typename?: 'PersonEducationList';
  items: Array<PersonEducation>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonEducationSort = {
  field: PersonEducationSortEnum;
  order: SortInput;
};

export enum PersonEducationSortEnum {
  GraduationYear = 'graduationYear',
  Id = 'id'
}

export type PersonFilterInput = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PersonInput = {
  biography?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  diversity?: InputMaybe<PersonDiversityInput>;
  educationSummary?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email2?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  fax2?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isCFA?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  newsMonitoringStartDate?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  phone2?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['Upload']['input']>;
  photoType?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  titleEnumId?: InputMaybe<Scalars['Int']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  workExperienceSummary?: InputMaybe<Scalars['String']['input']>;
};

export type PersonList = {
  __typename?: 'PersonList';
  items: Array<Person>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonProfileBuilderResponse = {
  __typename?: 'PersonProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  personProfile?: Maybe<GeneratedPersonProfile>;
};

export type PersonSearchFilters = {
  ACCESS?: InputMaybe<EntityAccessSearchFilter>;
};

export type PersonSort = {
  field: PersonSortEnum;
  order: SortInput;
};

export enum PersonSortEnum {
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  MiddleName = 'middleName',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  Phone = 'phone'
}

export type PersonWorkExperience = {
  __typename?: 'PersonWorkExperience';
  company?: Maybe<CompanyEnum>;
  companyEnumId?: Maybe<Scalars['Int']['output']>;
  fromYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  person: Person;
  personId: Scalars['Int']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  toYear?: Maybe<Scalars['Int']['output']>;
};

export type PersonWorkExperienceFilterInput = {
  personId?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWorkExperienceInput = {
  companyName: Scalars['String']['input'];
  fromYear?: InputMaybe<Scalars['Int']['input']>;
  personId: Scalars['Int']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  toYear?: InputMaybe<Scalars['Int']['input']>;
};

export type PersonWorkExperienceList = {
  __typename?: 'PersonWorkExperienceList';
  items: Array<PersonWorkExperience>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PersonWorkExperienceSort = {
  field: PersonWorkExperienceSortEnum;
  order: SortInput;
};

export enum PersonWorkExperienceSortEnum {
  Default = 'default',
  FromYear = 'fromYear',
  Id = 'id',
  ToYear = 'toYear'
}

export type PersonsDynamicShareRule = {
  investmentSet?: InputMaybe<GroupShareInvestmentSetFilter>;
};

export type PersonsDynamicShareRuleOutput = {
  __typename?: 'PersonsDynamicShareRuleOutput';
  investmentSet?: Maybe<GroupShareInvestmentSetFilterOutput>;
};

export type PieChartSeries = {
  colorByPoint: Scalars['Boolean']['input'];
  data: Array<IPieData>;
  name?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type PmeAttributeStratification = {
  __typename?: 'PmeAttributeStratification';
  attributeName: Scalars['String']['output'];
  groups: Array<PmeMetricGroup>;
};

export type PmeCashflow = {
  __typename?: 'PmeCashflow';
  amount: Scalars['Float']['output'];
  cashflowDate: Scalars['Date']['output'];
  cashflowType: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  feeBasis: PmeCashflowFeeBasis;
  fund?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  mappedInvestmentId?: Maybe<Scalars['Int']['output']>;
  mappedInvestmentName?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  uploadId: Scalars['Int']['output'];
};

export enum PmeCashflowFeeBasis {
  Gross = 'GROSS',
  Net = 'NET'
}

export type PmeCashflowListResult = {
  __typename?: 'PmeCashflowListResult';
  items: Array<PmeCashflow>;
  summary: PmeCashflowSummary;
  totalCount: Scalars['Int']['output'];
};

export type PmeCashflowSummary = {
  __typename?: 'PmeCashflowSummary';
  count: Scalars['Int']['output'];
  totalContributions: Scalars['Float']['output'];
  totalDistributions: Scalars['Float']['output'];
};

export type PmeFileParse = {
  __typename?: 'PmeFileParse';
  cashflowCount: Scalars['Int']['output'];
  parsingErrors: Array<PmeParsingError>;
  positionCount: Scalars['Int']['output'];
  uniqueFunds: Array<Scalars['String']['output']>;
  uploadId: Scalars['Int']['output'];
};

export type PmeMappingConfirmationInput = {
  confirmedInvestmentId: Scalars['Int']['input'];
  sourceFundName: Scalars['String']['input'];
};

export type PmeMappingSuggestionResult = {
  __typename?: 'PmeMappingSuggestionResult';
  confidence: Scalars['Float']['output'];
  confirmedInvestmentId?: Maybe<Scalars['Int']['output']>;
  confirmedInvestmentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  matchStatus: InvestmentMatchStatus;
  sourceFundName: Scalars['String']['output'];
  suggestedInvestmentId?: Maybe<Scalars['Int']['output']>;
  suggestedInvestmentName?: Maybe<Scalars['String']['output']>;
};

export type PmeMetricGroup = {
  __typename?: 'PmeMetricGroup';
  dealCount: Scalars['Int']['output'];
  directAlpha?: Maybe<Scalars['Float']['output']>;
  dpi?: Maybe<Scalars['Float']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  groupName: Scalars['String']['output'];
  invested: Scalars['Float']['output'];
  irr?: Maybe<Scalars['Float']['output']>;
  ksPme?: Maybe<Scalars['Float']['output']>;
  loss?: Maybe<Scalars['Float']['output']>;
  lossRate?: Maybe<Scalars['Float']['output']>;
  moic?: Maybe<Scalars['Float']['output']>;
  realized: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  unrealized: Scalars['Float']['output'];
};

export type PmeParsingError = {
  __typename?: 'PmeParsingError';
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  tab: Scalars['String']['output'];
};

export type PmePositionAttribute = {
  __typename?: 'PmePositionAttribute';
  attributeName: Scalars['String']['output'];
  attributeValue?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  positionId: Scalars['Int']['output'];
};

export type PmePositionListResult = {
  __typename?: 'PmePositionListResult';
  items: Array<PmePositionWithAttributes>;
  summary: PmePositionSummary;
  totalCount: Scalars['Int']['output'];
};

export type PmePositionSummary = {
  __typename?: 'PmePositionSummary';
  count: Scalars['Int']['output'];
  totalInvested: Scalars['Float']['output'];
  totalRealized: Scalars['Float']['output'];
  totalUnrealized: Scalars['Float']['output'];
  totalValue: Scalars['Float']['output'];
  weightedMoic?: Maybe<Scalars['Float']['output']>;
};

export type PmePositionWithAttributes = {
  __typename?: 'PmePositionWithAttributes';
  attributes: Array<PmePositionAttribute>;
  company?: Maybe<Scalars['String']['output']>;
  dpi?: Maybe<Scalars['Float']['output']>;
  fund?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invested?: Maybe<Scalars['Float']['output']>;
  irr?: Maybe<Scalars['Float']['output']>;
  mappedInvestmentId?: Maybe<Scalars['Int']['output']>;
  mappedInvestmentName?: Maybe<Scalars['String']['output']>;
  moic?: Maybe<Scalars['Float']['output']>;
  realized?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  strategy?: Maybe<Scalars['String']['output']>;
  totalValue?: Maybe<Scalars['Float']['output']>;
  tvpi?: Maybe<Scalars['Float']['output']>;
  unrealized?: Maybe<Scalars['Float']['output']>;
  uploadId: Scalars['Int']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type PmeSummaryResult = {
  __typename?: 'PmeSummaryResult';
  asOfDate?: Maybe<Scalars['DateTime']['output']>;
  byAttribute: Array<PmeAttributeStratification>;
  byFund: Array<PmeMetricGroup>;
  byStatus: Array<PmeMetricGroup>;
  byStrategy: Array<PmeMetricGroup>;
  byYear: Array<PmeMetricGroup>;
  netByFund: Array<PmeMetricGroup>;
  total: PmeMetricGroup;
};

export type PmeUpload = {
  __typename?: 'PmeUpload';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type PmeUploadStatusResult = {
  __typename?: 'PmeUploadStatusResult';
  id: Scalars['ID']['output'];
  returnValue?: Maybe<PmeFileParse>;
  status: AsyncTaskStatus;
};

export type PortalEmailDomainOrganization = {
  __typename?: 'PortalEmailDomainOrganization';
  emailDomain: Scalars['String']['output'];
  id: Scalars['String']['output'];
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
};

export type PortalFirm = {
  __typename?: 'PortalFirm';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  firmType?: Maybe<PortalFirmTypeEnum>;
  firmTypeEnumId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  migratedAt?: Maybe<Scalars['DateTime']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
  portalServiceProviderFirms: Array<PortalServiceProviderFirms>;
  profileInput?: Maybe<Scalars['JSON']['output']>;
  rcgFirm?: Maybe<Firm>;
  rcgFirmId?: Maybe<Scalars['ID']['output']>;
  shouldUpdate?: Maybe<Scalars['Boolean']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  sizeSymbol?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PortalFirmFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcgFirmId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalFirmInput = {
  firmTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rcgFirmId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalFirmList = {
  __typename?: 'PortalFirmList';
  items: Array<PortalFirm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalFirmSort = {
  field: PortalFirmSortEnum;
  order: SortInput;
};

export enum PortalFirmSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalFirmTypeEnum = {
  __typename?: 'PortalFirmTypeEnum';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PortalFirmTypeEnumFilter = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PortalFirmTypeEnumList = {
  __typename?: 'PortalFirmTypeEnumList';
  items: Array<PortalFirmTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalFirmTypeEnumSort = {
  field: PortalFirmTypeEnumSortEnum;
  order: SortInput;
};

export enum PortalFirmTypeEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type PortalOrganization = {
  __typename?: 'PortalOrganization';
  allowMultiFirm?: Maybe<Scalars['Boolean']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  emailDomainMappings: Array<PortalEmailDomainOrganization>;
  id: Scalars['String']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  portalServiceProviderFirms: Array<PortalServiceProviderFirms>;
  primaryFirm?: Maybe<PortalFirm>;
  users: Array<PortalUser>;
};

export type PortalOrganizationCreateInput = {
  name: Scalars['String']['input'];
};

export type PortalOrganizationFilter = {
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PortalOrganizationInput = {
  allowMultiFirm?: InputMaybe<Scalars['Boolean']['input']>;
  emailDomainMappings?: InputMaybe<Array<EmailDomainOrganizationInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  portalServiceProviderFirms?: InputMaybe<Array<PortalServiceProviderFirmInput>>;
  users?: InputMaybe<Array<PortalOrganizationUserInput>>;
};

export type PortalOrganizationList = {
  __typename?: 'PortalOrganizationList';
  items: Array<PortalOrganization>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalOrganizationSort = {
  field: PortalOrganizationSortEnum;
  order: SortInput;
};

export enum PortalOrganizationSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalOrganizationUserInput = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalServiceProviderFirmFilter = {
  firmId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalServiceProviderFirmInput = {
  firmId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type PortalServiceProviderFirmSort = {
  field: PortalServiceProviderFirmSortEnum;
  order: SortInput;
};

export enum PortalServiceProviderFirmSortEnum {
  Name = 'name'
}

export type PortalServiceProviderFirms = {
  __typename?: 'PortalServiceProviderFirms';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  firm: PortalFirm;
  firmId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organization: PortalOrganization;
  organizationId: Scalars['String']['output'];
};

export type PortalServiceProviderFirmsList = {
  __typename?: 'PortalServiceProviderFirmsList';
  items: Array<PortalServiceProviderFirms>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalSubmitted = {
  __typename?: 'PortalSubmitted';
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firm: PortalFirm;
  firmId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  migratedAt?: Maybe<Scalars['DateTime']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rcgFund?: Maybe<Investment>;
  rcgFundId?: Maybe<Scalars['ID']['output']>;
  shouldUpdate?: Maybe<Scalars['Boolean']['output']>;
  source_id?: Maybe<Scalars['ID']['output']>;
  user_id?: Maybe<Scalars['String']['output']>;
  user_input?: Maybe<Scalars['JSON']['output']>;
};

export type PortalSubmittedFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  rcgFundId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalSubmittedInput = {
  firmId?: InputMaybe<Scalars['ID']['input']>;
  rcgFundId?: InputMaybe<Scalars['ID']['input']>;
  shouldUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortalSubmittedList = {
  __typename?: 'PortalSubmittedList';
  items: Array<PortalSubmitted>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalSubmittedSort = {
  field: PortalSubmittedSortEnum;
  order: SortInput;
};

export enum PortalSubmittedSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortalUser = {
  __typename?: 'PortalUser';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<PortalOrganization>;
  organizationId?: Maybe<Scalars['String']['output']>;
};

export type PortalUserFilter = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PortalUserInput = {
  deleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type PortalUserList = {
  __typename?: 'PortalUserList';
  items: Array<PortalUser>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortalUserSort = {
  field: PortalUserSortEnum;
  order: SortInput;
};

export enum PortalUserSortEnum {
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  NameSearchRank = 'nameSearchRank',
  OrganizationId = 'organizationId',
  OrganizationName = 'organizationName'
}

export type Portfolio = {
  __typename?: 'Portfolio';
  baseCurrency?: Maybe<Scalars['String']['output']>;
  briefNm: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dateRange: PortfolioDateRange;
  entries?: Maybe<Array<PortfolioEntry>>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  isEntitledToEdit?: Maybe<Scalars['Boolean']['output']>;
  isPrimary: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** The months this portfolio has a NAV statement for (ascending month-ends); empty unless it is a primary portfolio linked to an RCG fund. Requires read access to that fund. */
  navDates?: Maybe<Array<Scalars['Date']['output']>>;
  portfolioGroupId?: Maybe<Scalars['Int']['output']>;
  shareType: Scalars['Int']['output'];
  sharedWith?: Maybe<Array<User>>;
  sharedWithAll?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};


export type PortfolioEntriesArgs = {
  date: Scalars['Date']['input'];
  lookthrough?: InputMaybe<Scalars['Boolean']['input']>;
  periods: Scalars['Int']['input'];
};

export type PortfolioAfsLookthroughResult = {
  __typename?: 'PortfolioAfsLookthroughResult';
  aggregatedHoldings: Array<AggregatedHoldingResult>;
  /** Number of managers with completed AFS extractions */
  extractionCount: Scalars['Int']['output'];
  managers: Array<ManagerSummary>;
  significantExposureCount: Scalars['Int']['output'];
  /** Total number of managers in the portfolio */
  totalManagerCount: Scalars['Int']['output'];
  totalNetAssets: Scalars['Float']['output'];
  totalPortfolioValue: Scalars['Float']['output'];
  weightedLevel3Pct?: Maybe<Scalars['Float']['output']>;
  weightedLeverage?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioAllocationInput = {
  additions: Scalars['Float']['input'];
  date: Scalars['Date']['input'];
  redemptions: Scalars['Float']['input'];
};

export enum PortfolioCategoryEnum {
  Primary = 'primary',
  Shared = 'shared',
  User = 'user'
}

export type PortfolioCommitment = {
  __typename?: 'PortfolioCommitment';
  amount: Scalars['Float']['output'];
  isPreInvestment: Scalars['Boolean']['output'];
};

export type PortfolioConfig = {
  __typename?: 'PortfolioConfig';
  clientVisibleTabs?: Maybe<Array<ClientVisibleTabs>>;
  id: Scalars['Int']['output'];
  lag?: Maybe<Scalars['Int']['output']>;
  lagUnitId?: Maybe<Scalars['Int']['output']>;
  lookthroughEnabled?: Maybe<Scalars['Boolean']['output']>;
  lookthroughInvestments?: Maybe<Array<Investment>>;
  /** Combined Performance Lag and Unit so types match the check constraint (both defined or both null) */
  performanceLag?: Maybe<PerformanceLag>;
  portfolio: Investment;
  portfolioId: Scalars['Int']['output'];
  showInvestments?: Maybe<Scalars['Boolean']['output']>;
  tileImage?: Maybe<Document>;
  tileImageId?: Maybe<Scalars['Int']['output']>;
};

export type PortfolioConfigFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  lookthroughEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  showInvestments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PortfolioConfigInput = {
  clientVisibleTabs?: InputMaybe<Array<ClientVisibleTabs>>;
  lookthroughEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  lookthroughInvestmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  performanceLag?: InputMaybe<PerformanceLagInput>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
  showInvestments?: InputMaybe<Scalars['Boolean']['input']>;
  tileImageId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioConfigList = {
  __typename?: 'PortfolioConfigList';
  items: Array<PortfolioConfig>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioConfigSort = {
  field: PortfolioConfigSortEnum;
  order: SortInput;
};

export enum PortfolioConfigSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortfolioDateRange = {
  __typename?: 'PortfolioDateRange';
  end: Scalars['Date']['output'];
  start: Scalars['Date']['output'];
};

export type PortfolioEntry = {
  __typename?: 'PortfolioEntry';
  balances: Array<WeightedBalance>;
  commitment?: Maybe<PortfolioCommitment>;
  initBalance: WeightedBalance;
  initTran?: Maybe<PortfolioTran>;
  isLinked?: Maybe<Scalars['Boolean']['output']>;
  isLookthrough?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<PortfolioLiquidity>;
  managerId: Scalars['Int']['output'];
};

export type PortfolioEntryInput = {
  allocations?: InputMaybe<Array<PortfolioAllocationInput>>;
  link?: InputMaybe<Scalars['Boolean']['input']>;
  managerId: Scalars['Int']['input'];
  tag?: InputMaybe<PortfolioTagInput>;
};

export type PortfolioFdpLogins = {
  __typename?: 'PortfolioFDPLogins';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fdpLogin: FdpLogin;
  fdpLoginId: Scalars['Int']['output'];
  fdpWebsite?: Maybe<FdpWebsites>;
  fdpWebsiteId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  portfolio: Investment;
  portfolioId: Scalars['Int']['output'];
};

export type PortfolioFdpLoginsFilter = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioFdpLoginsInput = {
  fdpLoginId?: InputMaybe<Scalars['Int']['input']>;
  fdpWebsiteId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  portfolioId?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioFdpLoginsList = {
  __typename?: 'PortfolioFDPLoginsList';
  items: Array<PortfolioFdpLogins>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioFdpLoginsSort = {
  field: PortfolioFdpLoginsSortEnum;
  order: SortInput;
};

export enum PortfolioFdpLoginsSortEnum {
  FdpLoginId = 'fdpLoginId',
  Id = 'id',
  PortfolioId = 'portfolioId'
}

export type PortfolioFilter = {
  category?: InputMaybe<PortfolioCategoryEnum>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioInput = {
  baseCurrency?: InputMaybe<Scalars['String']['input']>;
  briefNm: Scalars['String']['input'];
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  portfolioGroupId?: InputMaybe<Scalars['Int']['input']>;
  shareType?: InputMaybe<PortfolioShareEnum>;
  shareUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PortfolioLiquidity = {
  __typename?: 'PortfolioLiquidity';
  frequency?: Maybe<Scalars['Int']['output']>;
  nextNotice?: Maybe<Scalars['Date']['output']>;
  nextRedemption?: Maybe<Scalars['Date']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioList = {
  __typename?: 'PortfolioList';
  items: Array<Portfolio>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PortfolioSearchFilter = {
  isPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PortfolioShareEnum {
  All = 'all',
  None = 'none',
  Some = 'some'
}

export type PortfolioSort = {
  field: PortfolioSortEnum;
  order: SortInput;
};

export enum PortfolioSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type PortfolioTagInput = {
  clientTag?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  guidelineTag?: InputMaybe<Scalars['String']['input']>;
  openTag?: InputMaybe<Scalars['String']['input']>;
  teamTag?: InputMaybe<Scalars['String']['input']>;
};

export type PortfolioTran = {
  __typename?: 'PortfolioTran';
  beginBalance: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  estimatedReturn?: Maybe<Scalars['Float']['output']>;
  estimatedReturnDate?: Maybe<Scalars['Date']['output']>;
};

export type Position = {
  __typename?: 'Position';
  DPI?: Maybe<Scalars['Float']['output']>;
  MOIC?: Maybe<Scalars['Float']['output']>;
  RVPI?: Maybe<Scalars['Float']['output']>;
  assetClass?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  /** The position's category4 label. 'proxy' marks a modelled (proxy) position rather than a reported holding, which top-holdings reports exclude. */
  category4?: Maybe<Scalars['String']['output']>;
  categoryLevel: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  gicsSubSector?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialInvestmentDate?: Maybe<Scalars['Date']['output']>;
  investedAmount?: Maybe<Scalars['Float']['output']>;
  investmentId: Scalars['Int']['output'];
  isin?: Maybe<Scalars['String']['output']>;
  marketCap?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  percentChange?: Maybe<PositionPercentChange>;
  realizedAmount?: Maybe<Scalars['Float']['output']>;
  reportDate: Scalars['DateTime']['output'];
  ric?: Maybe<Scalars['String']['output']>;
  secType?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  securityMasterId?: Maybe<Scalars['Int']['output']>;
  sourceDate: Scalars['DateTime']['output'];
  ticker: Scalars['String']['output'];
  totalValue?: Maybe<Scalars['Float']['output']>;
  unrealizedAmount?: Maybe<Scalars['Float']['output']>;
  weight: Scalars['Float']['output'];
};

export type PositionFilterInput = {
  /** Optionally restrict the search to a subset of investments. Entitlements still apply on top of this list. */
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** When true (default), only consider each investment's most recent snapshot. Ignored if reportDate is provided. */
  mostRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to a specific position report date. If omitted and mostRecent is true (default), the latest report date per investment is used. */
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
  riskTier?: InputMaybe<Scalars['String']['input']>;
};

export type PositionList = {
  __typename?: 'PositionList';
  items: Array<Position>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PositionPercentChange = {
  __typename?: 'PositionPercentChange';
  categoryLevel: Scalars['String']['output'];
  percentChange?: Maybe<Scalars['Float']['output']>;
  priorReportDate?: Maybe<Scalars['DateTime']['output']>;
  priorWeight?: Maybe<Scalars['Float']['output']>;
  reportDate: Scalars['DateTime']['output'];
  weight: Scalars['Float']['output'];
};

export type PositionSort = {
  field: PositionSortEnum;
  order: SortInput;
};

export enum PositionSortEnum {
  Name = 'name',
  ReportDate = 'reportDate',
  Weight = 'weight'
}

/** exposure position types */
export enum PositionType {
  Gross = 'GROSS',
  Long = 'LONG',
  Net = 'NET',
  PercentGross = 'PERCENT_GROSS',
  Short = 'SHORT'
}

export type PositionsSearchFilter = {
  /** When true (default), only consider each investment's most recent position snapshot. Ignored if reportDate is provided. */
  mostRecent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit position exposure to a specific report date. If omitted and mostRecent is true (default), the latest report date per investment is used. */
  reportDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Match positions whose security issuer name contains any of these substrings (case-insensitive, min 3 chars each). */
  securityNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Match positions whose ticker equals any of these values (case-insensitive). */
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PresignedTempUrlInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
};

export type PresignedTempUrlResult = {
  __typename?: 'PresignedTempUrlResult';
  bucket?: Maybe<Scalars['String']['output']>;
  /** The s3 key containing the auto-generated unique filename. Will have the same file extension as the original filename, if provided. */
  key?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type PricingFrequencyEnum = {
  __typename?: 'PricingFrequencyEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type PricingFrequencyEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PricingFrequencyEnumList = {
  __typename?: 'PricingFrequencyEnumList';
  items: Array<PricingFrequencyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PricingFrequencyEnumSort = {
  field: PricingFrequencyEnumSortEnum;
  order: SortInput;
};

export enum PricingFrequencyEnumSortEnum {
  Id = 'id'
}

export type PrivateQuartileGroup = {
  __typename?: 'PrivateQuartileGroup';
  asOfDate: Scalars['DateTime']['output'];
  capitalization: Scalars['Float']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  dpi5th: Scalars['Float']['output'];
  dpi25th: Scalars['Float']['output'];
  dpi50th: Scalars['Float']['output'];
  dpi75th: Scalars['Float']['output'];
  dpi95th: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  irr5th: Scalars['Float']['output'];
  irr25th: Scalars['Float']['output'];
  irr50th: Scalars['Float']['output'];
  irr75th: Scalars['Float']['output'];
  irr95th: Scalars['Float']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  numberOfFunds: Scalars['Int']['output'];
  numberOfResults: Scalars['Int']['output'];
  pooledDPI: Scalars['Float']['output'];
  pooledIRR: Scalars['Float']['output'];
  pooledTVPI: Scalars['Float']['output'];
  privateQuartileGroupCategoryId: Scalars['Int']['output'];
  tvpi5th: Scalars['Float']['output'];
  tvpi25th: Scalars['Float']['output'];
  tvpi50th: Scalars['Float']['output'];
  tvpi75th: Scalars['Float']['output'];
  tvpi95th: Scalars['Float']['output'];
};

export type PrivateQuartileGroupCategory = {
  __typename?: 'PrivateQuartileGroupCategory';
  assetClassTier1: Scalars['String']['output'];
  assetClassTier2: Scalars['String']['output'];
  assetClassTier3: Scalars['String']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  displayLabel?: Maybe<Scalars['String']['output']>;
  geographyTier1: Scalars['String']['output'];
  geographyTier2: Scalars['String']['output'];
  geographyTier3: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  uniqueLabel: Scalars['String']['output'];
  vintageYear: Scalars['Int']['output'];
};

export type PrivateQuartileGroupCategoryFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type PrivateQuartileGroupCategoryList = {
  __typename?: 'PrivateQuartileGroupCategoryList';
  items: Array<PrivateQuartileGroupCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type PrivateQuartileGroupCategorySort = {
  field: PrivateQuartileGroupCategorySortEnum;
  order: SortInput;
};

export enum PrivateQuartileGroupCategorySortEnum {
  Id = 'id'
}

export type ProfileBuilderResponse = {
  __typename?: 'ProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  investmentProfile?: Maybe<GeneratedInvestmentProfile>;
};

export type Query = {
  __typename?: 'Query';
  aamOptimizationOptions: AamOptimizationOptions;
  aamOptimizationReport: Scalars['String']['output'];
  accountTypeEnum?: Maybe<AccountTypeEnum>;
  accountTypeEnumList: AccountTypeEnumList;
  accountTypeEnumMany: Array<Maybe<AccountTypeEnum>>;
  accountingManagerList: AccountingManagerList;
  adEntriesXApplicationFlags?: Maybe<AdEntriesXApplicationFlags>;
  adEntriesXApplicationFlagsList: AdEntriesXApplicationFlagsList;
  adEntriesXApplicationFlagsMany: Array<Maybe<AdEntriesXApplicationFlags>>;
  adEntriesXApplicationsXSets?: Maybe<AdEntriesXApplicationsXSets>;
  adEntriesXApplicationsXSetsList: AdEntriesXApplicationsXSetsList;
  adEntriesXApplicationsXSetsMany: Array<Maybe<AdEntriesXApplicationsXSets>>;
  address?: Maybe<Address>;
  addressSearch: Array<AddressSearchItem>;
  /** What changed between the firm's two most recent stored Form ADV filings, per item (default: every item) */
  advCompare: AdvComparison;
  /** The review of the firm's latest Form ADV Part 1. When it has not been reviewed yet, a review is queued and returned as `task`. */
  advReview: AdvReview;
  advSummaryEmailNotification?: Maybe<AdvSummaryEmailNotification>;
  advisorTypeEnum?: Maybe<AdvisorTypeEnum>;
  advisorTypeEnumList: AdvisorTypeEnumList;
  advisorTypeEnumMany: Array<Maybe<AdvisorTypeEnum>>;
  afsAccountingReview: Scalars['String']['output'];
  afsExtraction?: Maybe<AfsExtraction>;
  afsExtractionsByInvestment: Array<AfsExtraction>;
  afsExtractionsByPortfolio: Array<AfsExtraction>;
  afsHoldingsList: AfsHoldingList;
  agency?: Maybe<Agency>;
  agencyList: AgencyList;
  agencyMany: Array<Maybe<Agency>>;
  /** Every notification subscription, for the administration screen. */
  allNotificationSubscriptions: Array<NotificationSubscription>;
  application?: Maybe<Application>;
  applicationFlag?: Maybe<ApplicationFlags>;
  applicationFlagList: ApplicationFlagList;
  applicationFlagMany: Array<Maybe<ApplicationFlags>>;
  applicationList: ApplicationList;
  applicationMany: Array<Maybe<Application>>;
  assetClass2Enum?: Maybe<AssetClass2Enum>;
  assetClass2EnumList: AssetClass2EnumList;
  assetClass2EnumMany: Array<Maybe<AssetClass2Enum>>;
  assetClassEnum?: Maybe<AssetClassEnum>;
  assetClassEnumList: AssetClassEnumList;
  assetClassEnumMany: Array<Maybe<AssetClassEnum>>;
  assetClassOptions: AssetClass2EnumList;
  asyncDocumentProcess?: Maybe<Scalars['String']['output']>;
  asyncTaskStatus?: Maybe<AsyncTaskStatus>;
  auditContactTypeEnum?: Maybe<AuditContactTypeEnum>;
  auditContactTypeEnumList: AuditContactTypeEnumList;
  auditContactTypeEnumMany: Array<Maybe<AuditContactTypeEnum>>;
  availableFields: Array<FieldDefinition>;
  availableMetrics: Array<MetricInfo>;
  /** Browse every organization skill, active or deactivated for the caller */
  availableOrgChatSkills: Array<ChatSkill>;
  axysCode?: Maybe<AxysCode>;
  axysCodeList: AxysCodeList;
  axysCodeMany: Array<Maybe<AxysCode>>;
  /** Sorted Desc, available dates for the balances. */
  balanceDates: Array<Scalars['Date']['output']>;
  balancesList: BalancesList;
  bloombergDiligenceExtractStatus: Array<BbgDistributionsResponse>;
  bulkPersonProfileFromFilesBuilder: BulkPersonProfileBuilderResponse;
  businessObjectEnum?: Maybe<BusinessObjectEnum>;
  businessObjectEnumList: BusinessObjectEnumList;
  businessObjectEnumMany: Array<Maybe<BusinessObjectEnum>>;
  calendarUnitEnum?: Maybe<CalendarUnitEnum>;
  calendarUnitEnumList: CalendarUnitEnumList;
  calendarUnitEnumMany: Array<Maybe<CalendarUnitEnum>>;
  caseStudyReport?: Maybe<Scalars['String']['output']>;
  chat: QuestionResponse;
  chatAgent?: Maybe<ChatAgent>;
  chatAgentCapabilities: ChatAgentCapabilities;
  chatAgentHistory: Array<ChatAgentHistory>;
  chatAgentList: ChatAgentList;
  chatAgentMany: Array<Maybe<ChatAgent>>;
  chatAgentsByScope: Array<ChatAgent>;
  chatSkill?: Maybe<ChatSkill>;
  /** Groups in an organization that can be granted write access to a skill */
  chatSkillGrantableGroups: Array<ChatSkillGrantableGroup>;
  /** Groups holding write access on a skill — visible to anyone who may edit it */
  chatSkillGroupAccess: Array<ChatSkillGroup>;
  /** Version history snapshots for a skill, newest first — restricted to users who may edit it */
  chatSkillHistory: Array<ChatSkillHistory>;
  chatSkillList: ChatSkillList;
  chatSkillMany: Array<Maybe<ChatSkill>>;
  chatSkillSchedule?: Maybe<ChatSkillSchedule>;
  chatSkillScheduleList: ChatSkillScheduleList;
  chatSkillScheduleMany: Array<Maybe<ChatSkillSchedule>>;
  chatSkillsByScope: Array<ChatSkill>;
  client?: Maybe<Client>;
  /** Allocation rows: for some funds (omit for all), one share class, and/or one month. withFlowsOnly keeps months with an addition, redemption or switch. */
  clientAllocations: Array<ClientAllocationRow>;
  /** A client's capital changes in a fund, by share class and month, newest first. */
  clientCapitalFlows: Array<ClientCapitalFlowRow>;
  clientFeeOptions: ClientFeeOptions;
  /** The clients with a share class in the fund, or every client when rcgFundId is omitted. */
  clientInvestmentClients: Array<ClientInvestmentClient>;
  /** Every RCG fund a client can hold share classes in. */
  clientInvestmentFunds: Array<ClientInvestmentFund>;
  clientList: ClientList;
  clientMany: Array<Maybe<Client>>;
  /** A fund's share classes, optionally one client's. */
  clientShareClasses: Array<ClientShareClassRow>;
  /** The switches between a client's share classes in a fund. */
  clientSwitches: Array<ClientSwitchRow>;
  closeDateFundSize: Array<CloseDateFundSize>;
  clusterReport: Scalars['String']['output'];
  cogencyLink?: Maybe<CogencyLink>;
  company?: Maybe<Company>;
  companyEnum?: Maybe<CompanyEnum>;
  companyEnumList: CompanyEnumList;
  companyEnumMany: Array<Maybe<CompanyEnum>>;
  companyFields: CompanyFields;
  companyList: CompanyList;
  companyMany: Array<Maybe<Company>>;
  companyTypeEnum: CompanyTypeEnum;
  companyTypeEnumList: CompanyTypeEnumList;
  companyTypeEnumMany: Array<Maybe<CompanyTypeEnum>>;
  companyValuation?: Maybe<CompanyValuation>;
  companyValuationList: CompanyValuationList;
  companyValuationMany: Array<Maybe<CompanyValuation>>;
  compoundingPeriodEnum?: Maybe<CompoundingPeriodEnum>;
  compoundingPeriodEnumList: CompoundingPeriodEnumList;
  compoundingPeriodEnumMany: Array<Maybe<CompoundingPeriodEnum>>;
  contactTypeEnum?: Maybe<ContactTypeEnum>;
  contactTypeEnumList: ContactTypeEnumList;
  contactTypeEnumMany: Array<Maybe<ContactTypeEnum>>;
  conversationArtifacts: Array<ConversationArtifact>;
  countryEnum?: Maybe<CountryEnum>;
  countryEnumList: CountryEnumList;
  countryEnumMany: Array<Maybe<CountryEnum>>;
  /** Credit position of every user in an organization for this month. */
  creditUsageByUser: Array<UserCreditUsage>;
  currencyDenominationEnum?: Maybe<CurrencyDenominationEnum>;
  currencyDenominationEnumList: CurrencyDenominationEnumList;
  currencyDenominationEnumMany: Array<Maybe<CurrencyDenominationEnum>>;
  currentUser: CurrentUser;
  currentUserPrimaryOrganizationGroupId?: Maybe<Scalars['Int']['output']>;
  currentUserSettings?: Maybe<UserSettings>;
  customAnalytics: CustomAnalytics;
  customAnalyticsList: CustomAnalyticsList;
  customIndexGroup?: Maybe<CustomIndexGroup>;
  customIndexInvestment?: Maybe<CustomIndexInvestment>;
  customIndexInvestmentList: CustomIndexInvestmentList;
  customIndexInvestmentMany: Array<Maybe<CustomIndexInvestment>>;
  customIndexPreview: Array<PerformanceMtd>;
  cusumReport: Scalars['String']['output'];
  deal?: Maybe<Deal>;
  dealAvailableFilterOptions: DealFilterOptions;
  dealList: DealList;
  dealMany: Array<Maybe<Deal>>;
  dealMarketingEnum?: Maybe<DealMarketingEnum>;
  dealMarketingEnumList: DealMarketingEnumList;
  dealMarketingEnumMany: Array<Maybe<DealMarketingEnum>>;
  dealStructureEnum?: Maybe<DealStructureEnum>;
  dealStructureEnumList: DealStructureEnumList;
  dealStructureEnumMany: Array<Maybe<DealStructureEnum>>;
  dealTags?: Maybe<DealTags>;
  degreeEnum?: Maybe<DegreeEnum>;
  degreeEnumList: DegreeEnumList;
  degreeEnumMany: Array<Maybe<DegreeEnum>>;
  deiCategory1Enum?: Maybe<DeiCategory1Enum>;
  deiCategory1EnumList: DeiCategory1EnumList;
  deiCategory1EnumMany: Array<Maybe<DeiCategory1Enum>>;
  deiCategory2Enum?: Maybe<DeiCategory2Enum>;
  deiCategory2EnumList: DeiCategory2EnumList;
  deiCategory2EnumMany: Array<Maybe<DeiCategory2Enum>>;
  differenceRiskReport: Scalars['String']['output'];
  diversityStatsEnum?: Maybe<DiversityStatsEnum>;
  diversityStatsEnumList: DiversityStatsEnumList;
  diversityStatsEnumMany: Array<Maybe<DiversityStatsEnum>>;
  document?: Maybe<Document>;
  documentAccessLevel?: Maybe<DocumentAccessLevel>;
  documentAccessLevelList: DocumentAccessLevelList;
  documentAccessLevelMany: Array<Maybe<DocumentAccessLevel>>;
  documentCountByDocumentType: Array<DocumentCountByDocumentType>;
  documentDownloadBatch: DocumentBatch;
  documentFileExtensions: Array<Scalars['String']['output']>;
  documentMany: Array<Maybe<Document>>;
  documentQueue?: Maybe<DocumentQueue>;
  documentQueueList: DocumentQueueList;
  documentQueueMany: Array<Maybe<DocumentQueue>>;
  documentTypeEnum?: Maybe<DocumentTypeEnum>;
  documentTypeEnumList: DocumentTypeEnumList;
  documentTypeEnumMany: Array<Maybe<DocumentTypeEnum>>;
  documentTypeSuggestion: Scalars['Float']['output'];
  documents: DocumentList;
  dryRunMutationStep: DryRunMutationStepResult;
  /** Every RCG fund in the NAV model with its estimate for the month (any day of it; the month-end is used). */
  earlyEstimates: Array<EarlyEstimateRow>;
  emRiskReport: Scalars['String']['output'];
  emailDomainXOrganization?: Maybe<EmailDomainXOrganization>;
  emailDomainXOrganizationList: EmailDomainXOrganizationList;
  emailDomainXOrganizationMany: Array<Maybe<EmailDomainXOrganization>>;
  employeeRoleEnum?: Maybe<EmployeeRoleEnum>;
  employeeRoleEnumList: EmployeeRoleEnumList;
  employeeRoleEnumMany: Array<Maybe<EmployeeRoleEnum>>;
  exceptionReport: Scalars['String']['output'];
  exposure: Exposure;
  exposureReport: Scalars['String']['output'];
  family?: Maybe<Family>;
  familyList: FamilyList;
  familyMany: Array<Maybe<Family>>;
  fdpLogin?: Maybe<FdpLogin>;
  fdpLoginAuthenticatorEnum?: Maybe<FdpLoginAuthenticatorEnum>;
  fdpLoginAuthenticatorEnumList: FdpLoginAuthenticatorEnumList;
  fdpLoginAuthenticatorEnumMany: Array<Maybe<FdpLoginAuthenticatorEnum>>;
  fdpLoginList: FdpLoginList;
  fdpLoginMany: Array<Maybe<FdpLogin>>;
  fdpWebsites?: Maybe<FdpWebsites>;
  fdpWebsitesList: FdpWebsitesList;
  fdpWebsitesMany: Array<Maybe<FdpWebsites>>;
  feeCalcEnum?: Maybe<FeeCalcEnum>;
  feeCalcEnumList: FeeCalcEnumList;
  feeCalcEnumMany: Array<Maybe<FeeCalcEnum>>;
  feeFreqEnum?: Maybe<FeeFreqEnum>;
  feeFreqEnumList: FeeFreqEnumList;
  feeFreqEnumMany: Array<Maybe<FeeFreqEnum>>;
  fieldKeysByQuestion: FieldKeySearchResult;
  fieldList: FieldList;
  fieldListDownload: FieldList;
  financialDataProvider?: Maybe<FinancialDataProvider>;
  financialDataProviderList: FinancialDataProviderList;
  financialDataProviderMany: Array<Maybe<FinancialDataProvider>>;
  financialPeriodEnum?: Maybe<FinancialPeriodEnum>;
  financialPeriodEnumList: FinancialPeriodEnumList;
  financialPeriodEnumMany: Array<Maybe<FinancialPeriodEnum>>;
  findSavedKnowledgeBaseByFilters?: Maybe<SavedKnowledgeBase>;
  firm?: Maybe<Firm>;
  firmDEI?: Maybe<FirmDei>;
  firmDEIList: FirmDeiList;
  firmDEIMany: Array<Maybe<FirmDei>>;
  firmEmployment?: Maybe<FirmEmployment>;
  firmEmploymentList: FirmEmploymentList;
  firmEmploymentMany: Array<Maybe<FirmEmployment>>;
  firmEmployments?: Maybe<Array<FirmEmployment>>;
  firmEngagement?: Maybe<FirmEngagement>;
  firmEngagementList: FirmEngagementList;
  firmEngagementMany: Array<Maybe<FirmEngagement>>;
  firmEngagementTypeEnum?: Maybe<FirmEngagementTypeEnum>;
  firmEngagementTypeEnumList: FirmEngagementTypeEnumList;
  firmFDPLogins?: Maybe<FirmFdpLogins>;
  firmFDPLoginsList: FirmFdpLoginsList;
  firmFDPLoginsMany: Array<Maybe<FirmFdpLogins>>;
  firmFields: FirmFields;
  firmInstitutions?: Maybe<FirmInstitutions>;
  firmInstitutionsList: FirmInstitutionsList;
  firmInstitutionsMany: Array<Maybe<FirmInstitutions>>;
  firmList: FirmList;
  firmMany: Array<Maybe<Firm>>;
  firmProfileFromUrlBuilder: FirmProfileBuilderResponse;
  firmTags?: Maybe<FirmTags>;
  firmTeamStructure: FirmTeamStructure;
  fundingTypeEnum?: Maybe<FundingTypeEnum>;
  fundingTypeEnumList: FundingTypeEnumList;
  fundingTypeEnumMany: Array<Maybe<FundingTypeEnum>>;
  fundsXProxies?: Maybe<FundsXProxies>;
  fundsXProxiesList: FundsXProxiesList;
  fxRate?: Maybe<FxRate>;
  generateNoteEmbedding: Scalars['Boolean']['output'];
  geographicFocusEnum?: Maybe<GeographicFocusEnum>;
  geographicFocusEnumList: GeographicFocusEnumList;
  geographicFocusEnumMany: Array<Maybe<GeographicFocusEnum>>;
  geographyEnum?: Maybe<GeographyEnum>;
  geographyEnumList: GeographyEnumList;
  geographyEnumMany: Array<Maybe<GeographyEnum>>;
  getDocumentQueueUploadUrl: Scalars['String']['output'];
  /** Get a presigned URL to upload an organization icon. contentType must be image/png or image/jpeg. */
  getOrganizationIconUploadUrl: Scalars['String']['output'];
  getRangerDueDiligenceDrafts?: Maybe<Scalars['String']['output']>;
  globalProviderInstitutions?: Maybe<GlobalProviderInstitutions>;
  globalProviderInstitutionsList: GlobalProviderInstitutionsList;
  globalProviderNoteTypeEnum?: Maybe<GlobalProviderNoteTypeEnum>;
  globalProviderNoteTypeEnumList: GlobalProviderNoteTypeEnumList;
  globalProviderNoteTypeEnumMany: Array<Maybe<GlobalProviderNoteTypeEnum>>;
  groupShareDefinition?: Maybe<GroupShareDefinition>;
  groupShareDefinitionList: GroupShareDefinitionList;
  groupShareDefinitionMany: Array<Maybe<GroupShareDefinition>>;
  guidelineBreaches: Array<GuidelineBreachSummary>;
  guidelineNotes: Array<GuidelineNote>;
  guidelineSet?: Maybe<GuidelineSet>;
  guidelineSets: Array<GuidelineSet>;
  heatmapReport: Scalars['String']['output'];
  highChart: Chart;
  iconEnum?: Maybe<IconEnum>;
  iconEnumList: IconEnumList;
  iconEnumMany: Array<Maybe<IconEnum>>;
  impactCategoryEnumList: ImpactCategoryEnumList;
  impactEnum?: Maybe<ImpactEnum>;
  importRiskMeasuresStatus?: Maybe<ImportRiskMeasuresStatus>;
  indexCalcTypeEnum?: Maybe<IndexCalcTypeEnum>;
  indexCalcTypeEnumList: IndexCalcTypeEnumList;
  indexCalcTypeEnumMany: Array<Maybe<IndexCalcTypeEnum>>;
  institution?: Maybe<Institution>;
  institutionEmployment?: Maybe<InstitutionEmployment>;
  institutionEmploymentList: InstitutionEmploymentList;
  institutionEmploymentMany: Array<Maybe<InstitutionEmployment>>;
  institutionList: InstitutionList;
  institutionMany: Array<Maybe<Institution>>;
  institutionSelectionStatusEnum?: Maybe<InstitutionSelectionStatusEnum>;
  institutionSelectionStatusEnumList: InstitutionSelectionStatusEnumList;
  institutionSelectionStatusEnumMany: Array<Maybe<InstitutionSelectionStatusEnum>>;
  institutionTypeEnum?: Maybe<InstitutionTypeEnum>;
  institutionTypeEnumList: InstitutionTypeEnumList;
  institutionTypeEnumMany: Array<Maybe<InstitutionTypeEnum>>;
  institutionsInstitutionTypeEnum?: Maybe<InstitutionsInstitutionTypeEnum>;
  institutionsInstitutionTypeEnumList: InstitutionsInstitutionTypeEnumList;
  institutionsInstitutionTypeEnumMany: Array<Maybe<InstitutionsInstitutionTypeEnum>>;
  intraLink?: Maybe<IntraLink>;
  investment: Investment;
  investmentAccessRequest?: Maybe<InvestmentAccessRequest>;
  investmentAssignmentOption?: Maybe<InvestmentAssignmentOption>;
  investmentAssignmentOptionList: InvestmentAssignmentOptionList;
  investmentAssignmentOptionMany: Array<Maybe<InvestmentAssignmentOption>>;
  investmentAxysCode?: Maybe<InvestmentAxysCode>;
  investmentAxysCodeList: InvestmentAxysCodeList;
  investmentAxysCodeMany: Array<Maybe<InvestmentAxysCode>>;
  investmentBulk: Array<InvestmentBulk>;
  investmentCompletenessHead: Array<MemoizedInvestmentCompletenessSummary>;
  investmentFDPLogins?: Maybe<InvestmentFdpLogins>;
  investmentFDPLoginsList: InvestmentFdpLoginsList;
  investmentFDPLoginsMany: Array<Maybe<InvestmentFdpLogins>>;
  investmentFees: InvestmentFees;
  investmentFeesList: InvestmentFeesList;
  investmentFeesMany: Array<InvestmentFees>;
  investmentFields: InvestmentFields;
  investmentFirmEmployment?: Maybe<InvestmentFirmEmployment>;
  investmentFirmEmploymentList: InvestmentFirmEmploymentList;
  investmentFirmEmploymentMany: Array<Maybe<InvestmentFirmEmployment>>;
  investmentFirmEmploymentRoleEnum?: Maybe<InvestmentFirmEmploymentRoleEnum>;
  investmentFirmEmploymentRoleEnumList: InvestmentFirmEmploymentRoleEnumList;
  investmentFirmEmploymentRoleEnumMany: Array<Maybe<InvestmentFirmEmploymentRoleEnum>>;
  investmentFirmEmployments: Array<Maybe<InvestmentFirmEmployment>>;
  investmentInstitutions?: Maybe<InvestmentInstitutions>;
  investmentInstitutionsList: InvestmentInstitutionsList;
  investmentInstitutionsMany: Array<Maybe<InvestmentInstitutions>>;
  investmentList: InvestmentList;
  investmentListEnum?: Maybe<InvestmentListEnum>;
  investmentListEnumList: InvestmentListEnumList;
  investmentListEnumMany: Array<Maybe<InvestmentListEnum>>;
  investmentMany: Array<Maybe<Investment>>;
  investmentMatch: Array<InvestmentMatchResult>;
  investmentNoteUsersList?: Maybe<InvestmentNoteUsersList>;
  investmentPrivateQuartileGroupCategory?: Maybe<InvestmentPrivateQuartileGroupCategory>;
  investmentPrivateQuartileGroupCategoryList: InvestmentPrivateQuartileGroupCategoryList;
  investmentPrivateQuartileGroupCategoryMany: Array<Maybe<InvestmentPrivateQuartileGroupCategory>>;
  investmentProfileBuilder: ProfileBuilderResponse;
  investmentReportSync: Scalars['String']['output'];
  investmentRiskCategoryList: StringIdNameList;
  investmentRiskInvestmentList: InvestmentList;
  investmentSet?: Maybe<InvestmentSet>;
  investmentSetList: InvestmentSetList;
  investmentStructureEnum?: Maybe<InvestmentStructureEnum>;
  investmentStructureEnumList: InvestmentStructureEnumList;
  investmentStructureEnumMany: Array<Maybe<InvestmentStructureEnum>>;
  investmentSummary?: Maybe<NotesList>;
  investmentTags?: Maybe<InvestmentTags>;
  investmentTagsList: InvestmentTagsList;
  investmentTagsMany: Array<Maybe<InvestmentTags>>;
  investments: Array<Investment>;
  jobSchedules: Array<JobSchedule>;
  knowledgeBaseList: KnowledgeBaseList;
  knowledgeBaseTags?: Maybe<KnowledgeBaseTags>;
  knowledgeBaseTagsList: KnowledgeBaseTagsList;
  knowledgeBaseTagsMany: Array<Maybe<KnowledgeBaseTags>>;
  latestFirmAUM?: Maybe<DatedAsset>;
  latestFirmDEI?: Maybe<FirmDei>;
  latestInvestmentAUM?: Maybe<DatedAsset>;
  latestStrategyAUM?: Maybe<DatedAsset>;
  legalStructureEnum?: Maybe<LegalStructureEnum>;
  legalStructureEnumList: LegalStructureEnumList;
  legalStructureEnumMany: Array<Maybe<LegalStructureEnum>>;
  links?: Maybe<Links>;
  linksList: LinksList;
  linksMany: Array<Maybe<Links>>;
  liquidity?: Maybe<Liquidity>;
  liquidityList: LiquidityList;
  liquidityMany: Array<Maybe<Liquidity>>;
  llmEvaluators: Array<LlmEvaluator>;
  llmModelCatalog: Array<LlmModelCatalogEntry>;
  llmModels: Array<LlmModel>;
  llmTaskLangfuseEnabled: Scalars['Boolean']['output'];
  llmTasks: Array<LlmTask>;
  loadConversation: Array<ConversationHistory>;
  lockupEndValueEnum?: Maybe<LockupEndValueEnum>;
  lockupEndValueEnumList: LockupEndValueEnumList;
  lockupEndValueEnumMany: Array<Maybe<LockupEndValueEnum>>;
  lookupIdpByEmail: IdpInfo;
  managerQuarterlyReport: Scalars['String']['output'];
  managerTagsList: ManagerTagsList;
  measureEnum?: Maybe<MeasureEnum>;
  measureEnumList: MeasureEnumList;
  measureEnumMany: Array<Maybe<MeasureEnum>>;
  measureTypeEnum?: Maybe<MeasureTypeEnum>;
  measureTypeEnumList: MeasureTypeEnumList;
  measureTypeEnumMany: Array<Maybe<MeasureTypeEnum>>;
  mentionableUsers: UserList;
  multiCusumReport: Scalars['String']['output'];
  multiperiodRiskReport: Scalars['String']['output'];
  mutationPlan?: Maybe<MutationPlan>;
  mutationPlansByConversation: Array<MutationPlan>;
  /** How many of the current user's notifications are hidden by muted event types. */
  mutedNotificationCount: Scalars['Int']['output'];
  /** Get all skills active for the current user: system + personal + every org skill in their organization they have not deactivated */
  myActiveChatSkills: Array<ChatSkill>;
  myConversations: ConversationList;
  /** The current user's credit allotment, use and remainder for this calendar month (UTC). Charged to the assumed user when impersonating. */
  myCreditUsage: CreditUsage;
  myMutationPlans: Array<MutationPlan>;
  mySpawnableChatAgents: Array<ChatAgent>;
  navClassificationEnum?: Maybe<NavClassificationEnum>;
  navClassificationEnumList: NavClassificationEnumList;
  navClassificationEnumMany: Array<Maybe<NavClassificationEnum>>;
  /** Every NAV model allocation row for an RCG fund on a month-end transaction date. */
  navModelAllocations: Array<NavModelAllocation>;
  /** The RCG fund's NAV model inception: its earliest manager-row transaction date. */
  navModelInceptionDate?: Maybe<Scalars['Date']['output']>;
  /** A primary portfolio's NAV statement for one month: its RCG fund's managers grouped by strategy with subtotals, the accounting lines and their subtotal when includeCash, and the portfolio summary. Requires read access to the portfolio and to its RCG fund. */
  navStatement: Array<NavStatementRow>;
  noteCategoryEnum?: Maybe<NoteCategoryEnum>;
  noteCategoryEnumList?: Maybe<NoteCategoryEnumList>;
  noteMetaEnum?: Maybe<NoteMetaEnum>;
  noteMetaEnumList: NoteMetaEnumList;
  noteMetaEnumMany: Array<Maybe<NoteMetaEnum>>;
  noteTypeEnum?: Maybe<NoteTypeEnum>;
  notes?: Maybe<Notes>;
  notesList: NotesList;
  notesMany: Array<Maybe<Notes>>;
  notesMetaCounts: Array<NotesMetaCount>;
  notesReportFile: AsyncTaskStatus;
  noticeExtraction: NoticeExtraction;
  noticeExtractionByDocument?: Maybe<NoticeExtraction>;
  noticeExtractionsNeedingReview: NoticeExtractionList;
  noticeLegsByInvestment: NoticeLegsByInvestmentResult;
  noticeNotificationConfigs: Array<NoticeNotificationConfig>;
  noticeNotificationOverlaps: Array<Scalars['String']['output']>;
  /** A fresh download link for a notification's file. Null when the notification has no file or the file has expired from its bucket. */
  notificationArtifactUrl?: Maybe<Scalars['String']['output']>;
  /** Every event type the current user can receive, with their effective delivery settings. */
  notificationEventPreferences: Array<NotificationEventPreference>;
  notificationRecipients?: Maybe<NotificationRecipientsList>;
  /** The caller's own notifications, newest first. Optional filter narrows by event type, read state, arrival time or text — all applied in SQL, so a match outside the most recent page is still found. */
  notifications: Array<Notification>;
  operatingStatusEnum?: Maybe<OperatingStatusEnum>;
  operatingStatusEnumList: OperatingStatusEnumList;
  operatingStatusEnumMany: Array<Maybe<OperatingStatusEnum>>;
  orgLinks?: Maybe<OrgLinks>;
  orgLinksList: OrgLinksList;
  orgLinksMany: Array<Maybe<OrgLinks>>;
  organization?: Maybe<Organization>;
  organizationList: OrganizationList;
  organizationStructureEnum?: Maybe<OrganizationStructureEnum>;
  organizationStructureEnumList: OrganizationStructureEnumList;
  organizationStructureEnumMany: Array<Maybe<OrganizationStructureEnum>>;
  organizationTemplates: Array<Template>;
  peFundNumberEnum?: Maybe<PeFundNumberEnum>;
  peFundNumberEnumList: PeFundNumberEnumList;
  peFundNumberEnumMany: Array<Maybe<PeFundNumberEnum>>;
  peInctFeeCalcEnum?: Maybe<PeInctFeeCalcEnum>;
  peInctFeeCalcEnumList: PeInctFeeCalcEnumList;
  peInctFeeCalcEnumMany: Array<Maybe<PeInctFeeCalcEnum>>;
  peLiquidity: PeLiquidity;
  peLiquidityList: PeLiquidityList;
  peLiquidityMany: Array<PeLiquidity>;
  peMgmtFeeCalcEnum?: Maybe<PeMgmtFeeCalcEnum>;
  peMgmtFeeCalcEnumList: PeMgmtFeeCalcEnumList;
  peMgmtFeeCalcEnumMany: Array<Maybe<PeMgmtFeeCalcEnum>>;
  peStrategyEnum?: Maybe<PeStrategyEnum>;
  peStrategyEnumList: PeStrategyEnumList;
  peStrategyEnumMany: Array<Maybe<PeStrategyEnum>>;
  peersList: PeersList;
  peersListEnum?: Maybe<PeersListEnum>;
  peersStatSummary: Scalars['String']['output'];
  performanceAnalytics: PerformanceAnalytics;
  performanceMTDBulk: Array<PerformanceMtdBulkInvestment>;
  performanceReport: Scalars['String']['output'];
  performanceSourceEnum?: Maybe<PerformanceSourceEnum>;
  performanceSourceEnumList: PerformanceSourceEnumList;
  performanceSourceEnumMany: Array<Maybe<PerformanceSourceEnum>>;
  person?: Maybe<Person>;
  personEducation?: Maybe<PersonEducation>;
  personEducationList: PersonEducationList;
  personEducationMany: Array<Maybe<PersonEducation>>;
  personList: PersonList;
  personMany: Array<Maybe<Person>>;
  personProfileFromFilesBuilder: PersonProfileBuilderResponse;
  personProfileFromUrlBuilder: PersonProfileBuilderResponse;
  personWorkExperience?: Maybe<PersonWorkExperience>;
  personWorkExperienceList: PersonWorkExperienceList;
  personWorkExperienceMany: Array<Maybe<PersonWorkExperience>>;
  pieChart: Chart;
  pmeCashflows: PmeCashflowListResult;
  pmeLatestUpload?: Maybe<PmeUpload>;
  pmeMappingSuggestions: Array<PmeMappingSuggestionResult>;
  pmePositions: PmePositionListResult;
  pmeSummaryMetrics?: Maybe<PmeSummaryResult>;
  pmeUploadStatus?: Maybe<PmeUploadStatusResult>;
  porfolioConfigByPortfolioId?: Maybe<PortfolioConfig>;
  portalEmailDomainOrganizationList: EmailDomainOrganizationList;
  portalFirm?: Maybe<PortalFirm>;
  portalFirmList: PortalFirmList;
  portalFirmMany: Array<Maybe<PortalFirm>>;
  portalFirmTypeEnum?: Maybe<PortalFirmTypeEnum>;
  portalFirmTypeEnumList: PortalFirmTypeEnumList;
  portalFirmTypeEnumMany: Array<Maybe<PortalFirmTypeEnum>>;
  portalOrganization?: Maybe<PortalOrganization>;
  portalOrganizationList: PortalOrganizationList;
  portalOrganizationMany: Array<Maybe<PortalOrganization>>;
  portalServiceProviderFirm: PortalServiceProviderFirms;
  portalServiceProviderFirmsList: PortalServiceProviderFirmsList;
  portalSubmitted?: Maybe<PortalSubmitted>;
  portalSubmittedList: PortalSubmittedList;
  portalUser?: Maybe<PortalUser>;
  portalUserList: PortalUserList;
  portalUserMany: Array<Maybe<PortalUser>>;
  portfolio?: Maybe<Portfolio>;
  portfolioAfsLookthrough: PortfolioAfsLookthroughResult;
  portfolioConfig?: Maybe<PortfolioConfig>;
  portfolioConfigList: PortfolioConfigList;
  portfolioConfigMany: Array<Maybe<PortfolioConfig>>;
  portfolioFDPLogins?: Maybe<PortfolioFdpLogins>;
  portfolioFDPLoginsList: PortfolioFdpLoginsList;
  portfolioFDPLoginsMany: Array<Maybe<PortfolioFdpLogins>>;
  portfolioFactSheet: Scalars['String']['output'];
  portfolioGenomeReport: Scalars['String']['output'];
  portfolioList: PortfolioList;
  /** Sorted Desc, available position dates */
  positionReportDates: Array<Scalars['Date']['output']>;
  positionsReport: Scalars['String']['output'];
  presignedTempUrl?: Maybe<PresignedTempUrlResult>;
  previewLlmModel: LlmModelPreview;
  pricingFrequencyEnum?: Maybe<PricingFrequencyEnum>;
  pricingFrequencyEnumList: PricingFrequencyEnumList;
  pricingFrequencyEnumMany: Array<Maybe<PricingFrequencyEnum>>;
  privateQuartileGroupCategory?: Maybe<PrivateQuartileGroupCategory>;
  privateQuartileGroupCategoryList: PrivateQuartileGroupCategoryList;
  privateQuartileGroupCategoryMany: Array<Maybe<PrivateQuartileGroupCategory>>;
  proxyPositionsReport: Scalars['String']['output'];
  rangerDraftStatus: RangerDraftStatus;
  recentlyViewedInvestmentList: RecentlyViewedInvestmentList;
  report?: Maybe<Scalars['String']['output']>;
  /** Every scheduled report's recipients. */
  reportRecipients: Array<ReportRecipientRow>;
  resultEnum?: Maybe<ResultEnum>;
  resultEnumList: ResultEnumList;
  resultEnumMany: Array<Maybe<ResultEnum>>;
  rightOfExtensionEnum?: Maybe<RightOfExtensionEnum>;
  rightOfExtensionEnumList: RightOfExtensionEnumList;
  rightOfExtensionEnumMany: Array<Maybe<RightOfExtensionEnum>>;
  riskCategory?: Maybe<RiskCategory>;
  riskCategoryList?: Maybe<RiskCategoryList>;
  riskCategoryPartitions?: Maybe<Array<RiskCategoryPartition>>;
  /** Every risk measure recorded for one investment on one report date, as raw tier/category tuples. Zero and null measures are omitted. */
  riskMeasures: Array<RiskMeasureRecord>;
  riskRefreshList?: Maybe<RiskRefreshListList>;
  riskTiers: Array<RiskTierInfo>;
  riskVisualizationsData: ComputePortfolioBenchmarksResponse;
  savedEntitySearch?: Maybe<SavedEntitySearch>;
  savedEntitySearchList: SavedEntitySearchList;
  savedKnowledgeBase?: Maybe<SavedKnowledgeBase>;
  savedKnowledgeBaseList: SavedKnowledgeBaseList;
  schoolEnum?: Maybe<SchoolEnum>;
  schoolEnumList: SchoolEnumList;
  schoolEnumMany: Array<Maybe<SchoolEnum>>;
  securityMasterList: SecurityMasterList;
  securityMasterMeasurements?: Maybe<SecurityMasterMeasurements>;
  sendDocumentsNotifications: ClientDocumentNotificationStatus;
  serviceProviderDocumentType?: Maybe<ServiceProviderDocumentType>;
  serviceProviderDocumentTypeList: ServiceProviderDocumentTypeList;
  serviceProviderDocumentTypeMany: Array<Maybe<ServiceProviderDocumentType>>;
  serviceProviderDocuments?: Maybe<ServiceProviderDocuments>;
  serviceProviderDocumentsList: ServiceProviderDocumentsList;
  serviceProviderDocumentsMany: Array<Maybe<ServiceProviderDocuments>>;
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
  serviceProviderFirmList: ServiceProviderFirmList;
  serviceProviderFirmMany: Array<Maybe<ServiceProviderFirm>>;
  serviceProviderNotes?: Maybe<ServiceProviderNotes>;
  serviceProviderNotesList: ServiceProviderNotesList;
  serviceProviderNotesMany: Array<Maybe<ServiceProviderNotes>>;
  set?: Maybe<Set>;
  setList: SetList;
  setMany: Array<Maybe<Set>>;
  shareClass?: Maybe<ShareClass>;
  shareClassList: ShareClassList;
  shareClassMany: Array<Maybe<ShareClass>>;
  shareClassProfileBuilder: ShareClassProfileBuilderResponse;
  sharedGroupEntity?: Maybe<SharedGroupEntity>;
  sharedGroupEntityList: SharedGroupEntityList;
  sharedGroupEntityMany: Array<Maybe<SharedGroupEntity>>;
  siriusChat: SiriusChat;
  softLockup?: Maybe<SoftLockup>;
  softLockupList: SoftLockupList;
  softLockupMany: Array<Maybe<SoftLockup>>;
  solutionsCutoverReadiness: SolutionsCutoverReadiness;
  solutionsSyncStatus: Array<SyncEntityStatus>;
  stageEnum?: Maybe<StageEnum>;
  stageEnumList: StageEnumList;
  stageEnumMany: Array<Maybe<StageEnum>>;
  stateEnum?: Maybe<StateEnum>;
  stateEnumList: StateEnumList;
  stateEnumMany: Array<Maybe<StateEnum>>;
  statsGroup: StatsGroup;
  storedPromptFromFieldKey?: Maybe<StoredPrompts>;
  storedPrompts?: Maybe<StoredPrompts>;
  storedPromptsList: StoredPromptsList;
  storyboardGen: Scalars['String']['output'];
  strategyEnum?: Maybe<StrategyEnum>;
  strategyEnumList: StrategyEnumList;
  strategyEnumMany: Array<Maybe<StrategyEnum>>;
  strategyOptions: StrategyEnumList;
  stressTestReport: Scalars['String']['output'];
  subStrategyEnum?: Maybe<SubStrategyEnum>;
  subStrategyEnumList: SubStrategyEnumList;
  subStrategyEnumMany: Array<Maybe<SubStrategyEnum>>;
  summaryRiskReport: Scalars['String']['output'];
  /** Get a configuration value by key. Returns cached value with fallback to database and defaults. */
  systemConfigValue?: Maybe<Scalars['JSON']['output']>;
  systemConfiguration?: Maybe<SystemConfiguration>;
  systemConfigurationByKey?: Maybe<SystemConfiguration>;
  systemConfigurationList: SystemConfigurationList;
  systemConfigurationMany: Array<Maybe<SystemConfiguration>>;
  systemConfigurations: Array<SystemConfigEntry>;
  tableauToken: Scalars['String']['output'];
  tag?: Maybe<Tag>;
  tagClass?: Maybe<TagClass>;
  tagClassList: TagClassList;
  tagClassMany: Array<Maybe<TagClass>>;
  tagList: TagList;
  tagMany: Array<Maybe<Tag>>;
  teamMemberList: PersonList;
  templateAttachments: Array<TemplateAttachment>;
  titleEnum?: Maybe<TitleEnum>;
  titleEnumList: TitleEnumList;
  titleEnumMany: Array<Maybe<TitleEnum>>;
  typeAssetClassStrategyOptions?: Maybe<TypeAssetClassStrategyOptions>;
  typeAssetClassStrategyOptionsList: TypeAssetClassStrategyOptionsList;
  user?: Maybe<User>;
  userActivity?: Maybe<UserActivity>;
  userActivityList: UserActivityList;
  userList: UserList;
  userMutationAccessible: MutationAccess;
  userSettings?: Maybe<UserSettings>;
  users: Array<User>;
  usersXGroups?: Maybe<UsersXGroups>;
  usersXGroupsList: UsersXGroupsList;
  usersXGroupsMany: Array<Maybe<UsersXGroups>>;
  vehicleTypeEnum?: Maybe<VehicleTypeEnum>;
  vehicleTypeEnumList: VehicleTypeEnumList;
  vehicleTypeEnumMany: Array<Maybe<VehicleTypeEnum>>;
  vehicleTypeOptions: VehicleTypeEnumList;
  workoutEnum?: Maybe<WorkoutEnum>;
  workoutEnumList: WorkoutEnumList;
  workoutEnumMany: Array<Maybe<WorkoutEnum>>;
};


export type QueryAamOptimizationReportArgs = {
  config: AamOptimizationInput;
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryAccountTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAccountTypeEnumListArgs = {
  filter?: InputMaybe<AccountTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AccountTypeEnumSort>>;
};


export type QueryAccountTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAccountingManagerListArgs = {
  filter?: InputMaybe<AccountingManagerFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AccountingManagerSort>>;
};


export type QueryAdEntriesXApplicationFlagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdEntriesXApplicationFlagsListArgs = {
  filter?: InputMaybe<AdEntriesXApplicationFlagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationFlagsSort>>;
};


export type QueryAdEntriesXApplicationFlagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAdEntriesXApplicationsXSetsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdEntriesXApplicationsXSetsListArgs = {
  filter?: InputMaybe<AdEntriesXApplicationsXSetsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdEntriesXApplicationsXSetsSort>>;
};


export type QueryAdEntriesXApplicationsXSetsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAddressArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAddressSearchArgs = {
  isCompany?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdvCompareArgs = {
  firmId: Scalars['Int']['input'];
  items?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAdvReviewArgs = {
  firmId: Scalars['Int']['input'];
};


export type QueryAdvSummaryEmailNotificationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdvisorTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdvisorTypeEnumListArgs = {
  filter?: InputMaybe<AdvisorTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AdvisorTypeEnumSort>>;
};


export type QueryAdvisorTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAfsAccountingReviewArgs = {
  key: Scalars['String']['input'];
};


export type QueryAfsExtractionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAfsExtractionsByInvestmentArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryAfsExtractionsByPortfolioArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QueryAfsHoldingsListArgs = {
  afsExtractionId: Scalars['Int']['input'];
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AfsHoldingSortInput>>;
};


export type QueryAgencyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAgencyListArgs = {
  filter?: InputMaybe<AgencyFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AgencySort>>;
};


export type QueryAgencyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryApplicationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationFlagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryApplicationFlagListArgs = {
  filter?: InputMaybe<ApplicationFlagFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationFlagSort>>;
};


export type QueryApplicationFlagManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryApplicationListArgs = {
  filter?: InputMaybe<ApplicationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ApplicationSort>>;
};


export type QueryApplicationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClass2EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssetClass2EnumListArgs = {
  filter?: InputMaybe<AssetClass2EnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClass2EnumSort>>;
};


export type QueryAssetClass2EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClassEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAssetClassEnumListArgs = {
  filter?: InputMaybe<AssetClassEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AssetClassEnumSort>>;
};


export type QueryAssetClassEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAssetClassOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryAsyncDocumentProcessArgs = {
  documentId: Scalars['Int']['input'];
  processName: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryAsyncTaskStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuditContactTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuditContactTypeEnumListArgs = {
  filter?: InputMaybe<AuditContactTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AuditContactTypeEnumSort>>;
};


export type QueryAuditContactTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAvailableFieldsArgs = {
  entityLevel: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableOrgChatSkillsArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAxysCodeListArgs = {
  filter?: InputMaybe<AxysCodeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<AxysCodeSort>>;
};


export type QueryAxysCodeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryBalanceDatesArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QueryBalancesListArgs = {
  filter?: InputMaybe<BalancesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<BalancesSort>>;
};


export type QueryBloombergDiligenceExtractStatusArgs = {
  datasetIds: Array<Scalars['String']['input']>;
};


export type QueryBulkPersonProfileFromFilesBuilderArgs = {
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  firmId?: InputMaybe<Scalars['Int']['input']>;
  keys: Array<Scalars['String']['input']>;
};


export type QueryBusinessObjectEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBusinessObjectEnumListArgs = {
  filter?: InputMaybe<BusinessObjectEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<BusinessObjectEnumSort>>;
};


export type QueryBusinessObjectEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCalendarUnitEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCalendarUnitEnumListArgs = {
  filter?: InputMaybe<CalendarUnitEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CalendarUnitEnumSort>>;
};


export type QueryCalendarUnitEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCaseStudyReportArgs = {
  id: Scalars['String']['input'];
};


export type QueryChatArgs = {
  chatContext?: InputMaybe<ChatContext>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  effort?: InputMaybe<ChatEffort>;
  excludedMcpCategories?: InputMaybe<Array<SiriusMcpCategory>>;
  model?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tools?: InputMaybe<Array<ChatToolType>>;
};


export type QueryChatAgentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatAgentHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatAgentListArgs = {
  filter?: InputMaybe<ChatAgentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatAgentSort>>;
};


export type QueryChatAgentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatAgentsByScopeArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope: ChatSkillScope;
};


export type QueryChatSkillArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillGrantableGroupsArgs = {
  organizationId: Scalars['Int']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatSkillGroupAccessArgs = {
  chatSkillId: Scalars['Int']['input'];
};


export type QueryChatSkillHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillListArgs = {
  filter?: InputMaybe<ChatSkillFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatSkillSort>>;
};


export type QueryChatSkillManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatSkillScheduleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatSkillScheduleListArgs = {
  filter?: InputMaybe<ChatSkillScheduleFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ChatSkillScheduleSort>>;
};


export type QueryChatSkillScheduleManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryChatSkillsByScopeArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  scope: ChatSkillScope;
};


export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryClientAllocationsArgs = {
  month?: InputMaybe<Scalars['Date']['input']>;
  rcgFundIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
  withFlowsOnly?: Scalars['Boolean']['input'];
};


export type QueryClientCapitalFlowsArgs = {
  clientId: Scalars['Int']['input'];
  rcgFundId: Scalars['Int']['input'];
};


export type QueryClientInvestmentClientsArgs = {
  rcgFundId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClientListArgs = {
  filter?: InputMaybe<ClientFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ClientSort>>;
};


export type QueryClientManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryClientShareClassesArgs = {
  clientId?: InputMaybe<Scalars['Int']['input']>;
  rcgFundId: Scalars['Int']['input'];
};


export type QueryClientSwitchesArgs = {
  clientId: Scalars['Int']['input'];
  rcgFundId: Scalars['Int']['input'];
};


export type QueryCloseDateFundSizeArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryClusterReportArgs = {
  benchmarks?: InputMaybe<Array<BenchmarkWeightInput>>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryCogencyLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyEnumListArgs = {
  filter?: InputMaybe<CompanyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyEnumSort>>;
};


export type QueryCompanyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyFieldsArgs = {
  companyId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyListArgs = {
  filter?: InputMaybe<CompanyFilter>;
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<CompanySearchFilters>>;
  sort?: InputMaybe<Array<CompanySort>>;
};


export type QueryCompanyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyTypeEnumListArgs = {
  filter?: InputMaybe<CompanyTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyTypeEnumSort>>;
};


export type QueryCompanyTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompanyValuationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyValuationListArgs = {
  filter?: InputMaybe<CompanyValuationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompanyValuationSort>>;
};


export type QueryCompanyValuationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCompoundingPeriodEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompoundingPeriodEnumListArgs = {
  filter?: InputMaybe<CompoundingPeriodEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CompoundingPeriodEnumSort>>;
};


export type QueryCompoundingPeriodEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryContactTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryContactTypeEnumListArgs = {
  filter?: InputMaybe<ContactTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ContactTypeEnumSort>>;
};


export type QueryContactTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryConversationArtifactsArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryCountryEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCountryEnumListArgs = {
  filter?: InputMaybe<CountryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CountryEnumSort>>;
};


export type QueryCountryEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCreditUsageByUserArgs = {
  organizationId: Scalars['Int']['input'];
};


export type QueryCurrencyDenominationEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCurrencyDenominationEnumListArgs = {
  filter?: InputMaybe<CurrencyDenominationEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CurrencyDenominationEnumSort>>;
};


export type QueryCurrencyDenominationEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCustomAnalyticsArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomAnalyticsListArgs = {
  filter?: InputMaybe<CustomAnalyticsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomAnalyticsSort>>;
};


export type QueryCustomIndexGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomIndexInvestmentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCustomIndexInvestmentListArgs = {
  filter?: InputMaybe<CustomIndexInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<CustomIndexInvestmentSort>>;
};


export type QueryCustomIndexInvestmentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryCustomIndexPreviewArgs = {
  input: CustomIndexInvestmentInput;
};


export type QueryCusumReportArgs = {
  benchmarkId: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  sendEmail?: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};


export type QueryDealArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealAvailableFilterOptionsArgs = {
  filter?: InputMaybe<DealFilter>;
};


export type QueryDealListArgs = {
  filter?: InputMaybe<DealFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealSort>>;
};


export type QueryDealManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealMarketingEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealMarketingEnumListArgs = {
  filter?: InputMaybe<DealMarketingEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealMarketingEnumSort>>;
};


export type QueryDealMarketingEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDealStructureEnumListArgs = {
  filter?: InputMaybe<DealStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DealStructureEnumSort>>;
};


export type QueryDealStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDealTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDegreeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDegreeEnumListArgs = {
  filter?: InputMaybe<DegreeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DegreeEnumSort>>;
};


export type QueryDegreeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDeiCategory1EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeiCategory1EnumListArgs = {
  filter?: InputMaybe<DeiCategory1EnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory1EnumSort>>;
};


export type QueryDeiCategory1EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDeiCategory2EnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDeiCategory2EnumListArgs = {
  filter?: InputMaybe<DeiCategory2EnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DeiCategory2EnumSort>>;
};


export type QueryDeiCategory2EnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDifferenceRiskReportArgs = {
  alloc1: AllocationInput;
  alloc2: AllocationInput;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryDiversityStatsEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDiversityStatsEnumListArgs = {
  filter?: InputMaybe<DiversityStatsEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DiversityStatsEnumSort>>;
};


export type QueryDiversityStatsEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentAccessLevelArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentAccessLevelListArgs = {
  filter?: InputMaybe<DocumentAccessLevelFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentAccessLevelSort>>;
};


export type QueryDocumentAccessLevelManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentCountByDocumentTypeArgs = {
  filter?: InputMaybe<DocumentFilter>;
  includeYear?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentCountByDocumentTypeSort>>;
};


export type QueryDocumentDownloadBatchArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentQueueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentQueueListArgs = {
  filter?: InputMaybe<DocumentQueueFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentQueueSort>>;
};


export type QueryDocumentQueueManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryDocumentTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDocumentTypeEnumListArgs = {
  filter?: InputMaybe<DocumentTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentTypeEnumSort>>;
};


export type QueryDocumentTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryDocumentTypeSuggestionArgs = {
  text: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<DocumentSort>>;
};


export type QueryDryRunMutationStepArgs = {
  input: Scalars['JSON']['input'];
  mutationName: Scalars['String']['input'];
};


export type QueryEarlyEstimatesArgs = {
  month: Scalars['Date']['input'];
};


export type QueryEmRiskReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  performanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  performanceBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryEmailDomainXOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmailDomainXOrganizationListArgs = {
  filter?: InputMaybe<EmailDomainXOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainXOrganizationSort>>;
};


export type QueryEmailDomainXOrganizationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryEmployeeRoleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryEmployeeRoleEnumListArgs = {
  filter?: InputMaybe<EmployeeRoleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmployeeRoleEnumSort>>;
};


export type QueryEmployeeRoleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryExceptionReportArgs = {
  calculationTimePeriod?: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  timePeriod?: Scalars['Int']['input'];
};


export type QueryExposureArgs = {
  categoryId: Scalars['Int']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId: Scalars['Int']['input'];
  positionType: PositionType;
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryExposureReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  exposureTypes?: Array<Scalars['String']['input']>;
  includeRiskReport?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};


export type QueryFamilyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFamilyListArgs = {
  filter?: InputMaybe<FamilyFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FamilySort>>;
};


export type QueryFamilyManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpLoginArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpLoginAuthenticatorEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpLoginAuthenticatorEnumListArgs = {
  filter?: InputMaybe<FdpLoginAuthenticatorEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginAuthenticatorEnumSort>>;
};


export type QueryFdpLoginAuthenticatorEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpLoginListArgs = {
  filter?: InputMaybe<FdpLoginFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpLoginSort>>;
};


export type QueryFdpLoginManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFdpWebsitesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFdpWebsitesListArgs = {
  filter?: InputMaybe<FdpWebsitesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FdpWebsitesSort>>;
};


export type QueryFdpWebsitesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeeCalcEnumListArgs = {
  filter?: InputMaybe<FeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeCalcEnumSort>>;
};


export type QueryFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFeeFreqEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFeeFreqEnumListArgs = {
  filter?: InputMaybe<FeeFreqEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FeeFreqEnumSort>>;
};


export type QueryFeeFreqEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFieldKeysByQuestionArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  ownerType?: InputMaybe<Scalars['String']['input']>;
  q: Scalars['String']['input'];
};


export type QueryFieldListArgs = {
  filter?: InputMaybe<FieldFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldSort>>;
};


export type QueryFieldListDownloadArgs = {
  filter?: InputMaybe<FieldFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FieldSort>>;
};


export type QueryFinancialDataProviderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialDataProviderListArgs = {
  filter?: InputMaybe<FinancialDataProviderFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialDataProviderSort>>;
};


export type QueryFinancialDataProviderManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFinancialPeriodEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFinancialPeriodEnumListArgs = {
  filter?: InputMaybe<FinancialPeriodEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FinancialPeriodEnumSort>>;
};


export type QueryFinancialPeriodEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFindSavedKnowledgeBaseByFiltersArgs = {
  filters: KnowledgeBaseFilter;
};


export type QueryFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmDeiArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmDeiListArgs = {
  filter?: InputMaybe<FirmDeiFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmDeiSort>>;
};


export type QueryFirmDeiManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEmploymentListArgs = {
  filter?: InputMaybe<FirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEmploymentSort>>;
};


export type QueryFirmEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEmploymentsArgs = {
  filters?: InputMaybe<FirmEmploymentFilters>;
};


export type QueryFirmEngagementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEngagementListArgs = {
  filter?: InputMaybe<FirmEngagementFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEngagementSort>>;
};


export type QueryFirmEngagementManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmEngagementTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmEngagementTypeEnumListArgs = {
  filter?: InputMaybe<FirmEngagementTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmEngagementTypeEnumSort>>;
};


export type QueryFirmFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmFdpLoginsListArgs = {
  filter?: InputMaybe<FirmFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmFdpLoginsSort>>;
};


export type QueryFirmFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmFieldsArgs = {
  firmId: Scalars['Int']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFirmInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmInstitutionsListArgs = {
  filter?: InputMaybe<FirmInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmInstitutionsSort>>;
};


export type QueryFirmInstitutionsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmListArgs = {
  filter?: InputMaybe<FirmFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  investmentSearchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FirmSort>>;
};


export type QueryFirmManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFirmProfileFromUrlBuilderArgs = {
  firmId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFirmTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFirmTeamStructureArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFundingTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundingTypeEnumListArgs = {
  filter?: InputMaybe<FundingTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundingTypeEnumSort>>;
};


export type QueryFundingTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFundsXProxiesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFundsXProxiesListArgs = {
  filter?: InputMaybe<FundsXProxiesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<FundsXProxiesSort>>;
};


export type QueryFxRateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGenerateNoteEmbeddingArgs = {
  noteId: Scalars['Int']['input'];
};


export type QueryGeographicFocusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGeographicFocusEnumListArgs = {
  filter?: InputMaybe<GeographicFocusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographicFocusEnumSort>>;
};


export type QueryGeographicFocusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGeographyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGeographyEnumListArgs = {
  filter?: InputMaybe<GeographyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GeographyEnumSort>>;
};


export type QueryGeographyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGetDocumentQueueUploadUrlArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationIconUploadUrlArgs = {
  contentType: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};


export type QueryGetRangerDueDiligenceDraftsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGlobalProviderInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGlobalProviderInstitutionsListArgs = {
  filter?: InputMaybe<GlobalProviderInstitutionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderInstitutionsSort>>;
};


export type QueryGlobalProviderNoteTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGlobalProviderNoteTypeEnumListArgs = {
  filter?: InputMaybe<GlobalProviderNoteTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GlobalProviderNoteTypeEnumSort>>;
};


export type QueryGlobalProviderNoteTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGroupShareDefinitionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupShareDefinitionListArgs = {
  filter?: InputMaybe<GroupShareDefinitionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<GroupShareDefinitionSort>>;
};


export type QueryGroupShareDefinitionManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryGuidelineBreachesArgs = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};


export type QueryGuidelineNotesArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryGuidelineSetArgs = {
  id: Scalars['Int']['input'];
  investmentId: Scalars['Int']['input'];
};


export type QueryGuidelineSetsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryHeatmapReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QueryHighChartArgs = {
  chartOptions?: InputMaybe<Scalars['JSON']['input']>;
  chartType: ChartType;
};


export type QueryIconEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIconEnumListArgs = {
  filter?: InputMaybe<IconEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IconEnumSort>>;
};


export type QueryIconEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryImpactCategoryEnumListArgs = {
  filter?: InputMaybe<ImpactCategoryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ImpactCategoryEnumSort>>;
};


export type QueryImpactEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryImportRiskMeasuresStatusArgs = {
  id: Scalars['ID']['input'];
};


export type QueryIndexCalcTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIndexCalcTypeEnumListArgs = {
  filter?: InputMaybe<IndexCalcTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<IndexCalcTypeEnumSort>>;
};


export type QueryIndexCalcTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionEmploymentListArgs = {
  filter?: InputMaybe<InstitutionEmploymentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionEmploymentSort>>;
};


export type QueryInstitutionEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionListArgs = {
  filter?: InputMaybe<InstitutionFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSort>>;
};


export type QueryInstitutionManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionSelectionStatusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionSelectionStatusEnumListArgs = {
  filter?: InputMaybe<InstitutionSelectionStatusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionSelectionStatusEnumSort>>;
};


export type QueryInstitutionSelectionStatusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionTypeEnumSort>>;
};


export type QueryInstitutionTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInstitutionsInstitutionTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInstitutionsInstitutionTypeEnumListArgs = {
  filter?: InputMaybe<InstitutionsInstitutionTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InstitutionsInstitutionTypeEnumSort>>;
};


export type QueryInstitutionsInstitutionTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryIntraLinkArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentArgs = {
  atlasInvestmentId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvestmentAccessRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentAssignmentOptionArgs = {
  id: Scalars['String']['input'];
};


export type QueryInvestmentAssignmentOptionListArgs = {
  filter?: InputMaybe<InvestmentAssignmentOptionFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAssignmentOptionSort>>;
};


export type QueryInvestmentAssignmentOptionManyArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryInvestmentAxysCodeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentAxysCodeListArgs = {
  filter?: InputMaybe<InvestmentAxysCodeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentAxysCodeSort>>;
};


export type QueryInvestmentAxysCodeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentBulkArgs = {
  filter?: InputMaybe<InvestmentFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type QueryInvestmentFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFdpLoginsListArgs = {
  filter?: InputMaybe<InvestmentFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFdpLoginsSort>>;
};


export type QueryInvestmentFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFeesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFeesListArgs = {
  filter?: InputMaybe<InvestmentFeesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFeesSort>>;
};


export type QueryInvestmentFeesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFieldsArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  investmentId: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvestmentFirmEmploymentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFirmEmploymentListArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentSort>>;
};


export type QueryInvestmentFirmEmploymentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFirmEmploymentRoleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentFirmEmploymentRoleEnumListArgs = {
  filter?: InputMaybe<InvestmentFirmEmploymentRoleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentFirmEmploymentRoleEnumSort>>;
};


export type QueryInvestmentFirmEmploymentRoleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentFirmEmploymentsArgs = {
  filters?: InputMaybe<InvestmentFirmEmploymentFilters>;
};


export type QueryInvestmentInstitutionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentInstitutionsListArgs = {
  filter?: InputMaybe<InvestmentInstitutionsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentInstitutionsSort>>;
};


export type QueryInvestmentInstitutionsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentListArgs = {
  filter?: InputMaybe<InvestmentFilterInput>;
  firmSearchFilters?: InputMaybe<Array<FirmSearchFilters>>;
  page?: InputMaybe<PageInput>;
  searchFilters?: InputMaybe<Array<InvestmentSearchFilters>>;
  sort?: InputMaybe<Array<InvestmentSort>>;
};


export type QueryInvestmentListEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentListEnumListArgs = {
  filter?: InputMaybe<InvestmentListEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentListEnumSort>>;
};


export type QueryInvestmentListEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentMatchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QueryInvestmentNoteUsersListArgs = {
  filter?: InputMaybe<InvestmentNoteUsersFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentNoteUsersSort>>;
};


export type QueryInvestmentPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentPrivateQuartileGroupCategoryListArgs = {
  filter?: InputMaybe<InvestmentPrivateQuartileGroupCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentPrivateQuartileGroupCategorySort>>;
};


export type QueryInvestmentPrivateQuartileGroupCategoryManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentProfileBuilderArgs = {
  Keys: Array<Scalars['String']['input']>;
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryInvestmentReportSyncArgs = {
  asOfDate?: InputMaybe<Scalars['DateTime']['input']>;
  elements?: InputMaybe<Array<ReportStructure>>;
  format: FormatOptions;
  includeHoldings?: InputMaybe<Scalars['Boolean']['input']>;
  includeImpactAreas?: InputMaybe<Scalars['Boolean']['input']>;
  includeReportFund?: InputMaybe<Scalars['Boolean']['input']>;
  investmentId: Scalars['Int']['input'];
  reportType: ReportTypeOptions;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  subSections?: InputMaybe<Array<SubSections>>;
};


export type QueryInvestmentRiskCategoryListArgs = {
  filter?: InputMaybe<InvestmentRiskCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskCategorySort>>;
};


export type QueryInvestmentRiskInvestmentListArgs = {
  filter?: InputMaybe<InvestmentRiskInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentRiskInvestmentSort>>;
};


export type QueryInvestmentSetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentSetListArgs = {
  filter?: InputMaybe<InvestmentSetFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentSetSort>>;
};


export type QueryInvestmentStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentStructureEnumListArgs = {
  filter?: InputMaybe<InvestmentStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentStructureEnumSort>>;
};


export type QueryInvestmentStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentSummaryArgs = {
  investmentId: Array<Scalars['Int']['input']>;
};


export type QueryInvestmentTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryInvestmentTagsListArgs = {
  filter?: InputMaybe<InvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<InvestmentTagsSort>>;
};


export type QueryInvestmentTagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryKnowledgeBaseListArgs = {
  filter?: InputMaybe<KnowledgeBaseFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<KnowledgeBaseSort>>;
};


export type QueryKnowledgeBaseTagsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryKnowledgeBaseTagsListArgs = {
  filter?: InputMaybe<KnowledgeBaseTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<KnowledgeBaseTagsSort>>;
};


export type QueryKnowledgeBaseTagsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLatestFirmAumArgs = {
  firmId: Scalars['Int']['input'];
};


export type QueryLatestFirmDeiArgs = {
  entityId: Scalars['Int']['input'];
  geographyEnumId?: InputMaybe<Scalars['Int']['input']>;
  isCompany: Scalars['Boolean']['input'];
};


export type QueryLatestInvestmentAumArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryLatestStrategyAumArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryLegalStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLegalStructureEnumListArgs = {
  filter?: InputMaybe<LegalStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LegalStructureEnumSort>>;
};


export type QueryLegalStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLinksArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLinksListArgs = {
  filter?: InputMaybe<LinksFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LinksSort>>;
};


export type QueryLinksManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLiquidityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiquidityListArgs = {
  filter?: InputMaybe<LiquidityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LiquiditySort>>;
};


export type QueryLiquidityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLoadConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryLockupEndValueEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLockupEndValueEnumListArgs = {
  filter?: InputMaybe<LockupEndValueEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<LockupEndValueEnumSort>>;
};


export type QueryLockupEndValueEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryLookupIdpByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QueryManagerQuarterlyReportArgs = {
  asOfDate: Scalars['Date']['input'];
  calculationBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  comparableBetaBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  performanceBenchmarkId?: InputMaybe<Scalars['Int']['input']>;
  sections?: InputMaybe<Array<Scalars['String']['input']>>;
  sendEmail?: Scalars['Boolean']['input'];
};


export type QueryManagerTagsListArgs = {
  filter?: InputMaybe<ManagerTagsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ManagerTagsSort>>;
};


export type QueryMeasureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeasureEnumListArgs = {
  filter?: InputMaybe<MeasureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureEnumSort>>;
};


export type QueryMeasureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMeasureTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMeasureTypeEnumListArgs = {
  filter?: InputMaybe<MeasureTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<MeasureTypeEnumSort>>;
};


export type QueryMeasureTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryMentionableUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMultiCusumReportArgs = {
  allocationDate: Scalars['Date']['input'];
  analysisDate: Scalars['Date']['input'];
  benchmarks: Array<BenchmarkWeightInput>;
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  exportAs?: Scalars['String']['input'];
  periods?: Scalars['Int']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
};


export type QueryMultiperiodRiskReportArgs = {
  allocations: Array<AllocationInput>;
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  includeManagers?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryMutationPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMutationPlansByConversationArgs = {
  conversationId: Scalars['Int']['input'];
};


export type QueryMyConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<ConversationSource>>;
};


export type QueryNavClassificationEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNavClassificationEnumListArgs = {
  filter?: InputMaybe<NavClassificationEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NavClassificationEnumSort>>;
};


export type QueryNavClassificationEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNavModelAllocationsArgs = {
  investmentId: Scalars['Int']['input'];
  tranDate: Scalars['Date']['input'];
};


export type QueryNavModelInceptionDateArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryNavStatementArgs = {
  date: Scalars['Date']['input'];
  includeCash?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
};


export type QueryNoteCategoryEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoteCategoryEnumListArgs = {
  filter?: InputMaybe<NoteCategoryEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NoteCategoryEnumSort>>;
};


export type QueryNoteMetaEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoteMetaEnumListArgs = {
  filter?: InputMaybe<NoteMetaEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NoteMetaEnumSort>>;
};


export type QueryNoteMetaEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNoteTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotesListArgs = {
  filter?: InputMaybe<NotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<NotesSort>>;
};


export type QueryNotesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryNotesMetaCountsArgs = {
  filter?: InputMaybe<NotesFilter>;
};


export type QueryNotesReportFileArgs = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  notesFilter?: InputMaybe<NotesFilter>;
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type QueryNoticeExtractionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNoticeExtractionByDocumentArgs = {
  documentId: Scalars['Int']['input'];
};


export type QueryNoticeExtractionsNeedingReviewArgs = {
  page?: InputMaybe<PageInput>;
};


export type QueryNoticeLegsByInvestmentArgs = {
  category?: InputMaybe<NoticeLegCategory>;
  clientInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<PageInput>;
};


export type QueryNoticeNotificationOverlapsArgs = {
  clientInvestmentId?: InputMaybe<Scalars['Int']['input']>;
  noticeType?: InputMaybe<NoticeType>;
};


export type QueryNotificationArtifactUrlArgs = {
  id: Scalars['Int']['input'];
};


export type QueryNotificationRecipientsArgs = {
  entityAssignments?: InputMaybe<Array<NoteEntityAssignmentInput>>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryOperatingStatusEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOperatingStatusEnumListArgs = {
  filter?: InputMaybe<OperatingStatusEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OperatingStatusEnumSort>>;
};


export type QueryOperatingStatusEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrgLinksArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrgLinksListArgs = {
  filter?: InputMaybe<OrgLinksFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrgLinksSort>>;
};


export type QueryOrgLinksManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrganizationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationListArgs = {
  filter?: InputMaybe<OrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationSort>>;
};


export type QueryOrganizationStructureEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationStructureEnumListArgs = {
  filter?: InputMaybe<OrganizationStructureEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<OrganizationStructureEnumSort>>;
};


export type QueryOrganizationStructureEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryOrganizationTemplatesArgs = {
  fieldSetGroup?: InputMaybe<Scalars['String']['input']>;
  fieldSetType?: InputMaybe<FieldSetType>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPeFundNumberEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeFundNumberEnumListArgs = {
  filter?: InputMaybe<PeFundNumberEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeFundNumberEnumSort>>;
};


export type QueryPeFundNumberEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeInctFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeInctFeeCalcEnumListArgs = {
  filter?: InputMaybe<PeInctFeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeInctFeeCalcEnumSort>>;
};


export type QueryPeInctFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeLiquidityArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeLiquidityListArgs = {
  filter?: InputMaybe<PeLiquidityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeLiquiditySort>>;
};


export type QueryPeLiquidityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeMgmtFeeCalcEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeMgmtFeeCalcEnumListArgs = {
  filter?: InputMaybe<PeMgmtFeeCalcEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeMgmtFeeCalcEnumSort>>;
};


export type QueryPeMgmtFeeCalcEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeStrategyEnumListArgs = {
  filter?: InputMaybe<PeStrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PeStrategyEnumSort>>;
};


export type QueryPeStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPeersListArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeersListEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPeersStatSummaryArgs = {
  peersData: Array<PeersSummaryDetail>;
};


export type QueryPerformanceAnalyticsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPerformanceMtdBulkArgs = {
  filter: PerformanceMtdBulkFilter;
  sort?: InputMaybe<Array<PerformanceMtdBulkSort>>;
};


export type QueryPerformanceReportArgs = {
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
  timePeriod?: Scalars['Int']['input'];
};


export type QueryPerformanceSourceEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPerformanceSourceEnumListArgs = {
  filter?: InputMaybe<PerformanceSourceEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PerformanceSourceEnumSort>>;
};


export type QueryPerformanceSourceEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonEducationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonEducationListArgs = {
  filter?: InputMaybe<PersonEducationFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonEducationSort>>;
};


export type QueryPersonEducationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonListArgs = {
  filter?: InputMaybe<PersonFilterInput>;
  page?: InputMaybe<PageInput>;
  personSearchFilters?: InputMaybe<Array<PersonSearchFilters>>;
  sort?: InputMaybe<Array<PersonSort>>;
};


export type QueryPersonManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPersonProfileFromFilesBuilderArgs = {
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  keys: Array<Scalars['String']['input']>;
};


export type QueryPersonProfileFromUrlBuilderArgs = {
  personId?: InputMaybe<Scalars['Int']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPersonWorkExperienceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPersonWorkExperienceListArgs = {
  filter?: InputMaybe<PersonWorkExperienceFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PersonWorkExperienceSort>>;
};


export type QueryPersonWorkExperienceManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPieChartArgs = {
  allowDecimals?: InputMaybe<Scalars['Boolean']['input']>;
  dataSeries: Array<PieChartSeries>;
  diameter?: InputMaybe<Scalars['Int']['input']>;
  fontSize: Scalars['Int']['input'];
  formatSuffix?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Float']['input'];
  innerSize?: InputMaybe<Scalars['Int']['input']>;
  legendAlign?: InputMaybe<AlignValue>;
  legendItemMarginTop?: InputMaybe<Scalars['Int']['input']>;
  legendSymbolHeight?: InputMaybe<Scalars['Int']['input']>;
  showAnimation?: InputMaybe<Scalars['Boolean']['input']>;
  subTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryPmeCashflowsArgs = {
  cashflowType?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPmeLatestUploadArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPmeMappingSuggestionsArgs = {
  uploadId: Scalars['Int']['input'];
};


export type QueryPmePositionsArgs = {
  company?: InputMaybe<Scalars['String']['input']>;
  fundName?: InputMaybe<Scalars['String']['input']>;
  investmentId: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPmeSummaryMetricsArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPmeUploadStatusArgs = {
  id: Scalars['ID']['input'];
  investmentId: Scalars['Int']['input'];
};


export type QueryPorfolioConfigByPortfolioIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalEmailDomainOrganizationListArgs = {
  filter?: InputMaybe<EmailDomainOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<EmailDomainOrganizationSort>>;
};


export type QueryPortalFirmArgs = {
  id: Scalars['String']['input'];
};


export type QueryPortalFirmListArgs = {
  filter?: InputMaybe<PortalFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmSort>>;
};


export type QueryPortalFirmManyArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPortalFirmTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalFirmTypeEnumListArgs = {
  filter?: InputMaybe<PortalFirmTypeEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalFirmTypeEnumSort>>;
};


export type QueryPortalFirmTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortalOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortalOrganizationListArgs = {
  filter?: InputMaybe<PortalOrganizationFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalOrganizationSort>>;
};


export type QueryPortalOrganizationManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPortalServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortalServiceProviderFirmsListArgs = {
  filter?: InputMaybe<PortalServiceProviderFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalServiceProviderFirmSort>>;
};


export type QueryPortalSubmittedArgs = {
  id: Scalars['String']['input'];
};


export type QueryPortalSubmittedListArgs = {
  filter?: InputMaybe<PortalSubmittedFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalSubmittedSort>>;
};


export type QueryPortalUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPortalUserListArgs = {
  filter?: InputMaybe<PortalUserFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortalUserSort>>;
};


export type QueryPortalUserManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPortfolioArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioAfsLookthroughArgs = {
  periodEnd?: InputMaybe<Scalars['String']['input']>;
  periodStart?: InputMaybe<Scalars['String']['input']>;
  portfolioId: Scalars['Int']['input'];
};


export type QueryPortfolioConfigArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioConfigListArgs = {
  filter?: InputMaybe<PortfolioConfigFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioConfigSort>>;
};


export type QueryPortfolioConfigManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortfolioFdpLoginsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPortfolioFdpLoginsListArgs = {
  filter?: InputMaybe<PortfolioFdpLoginsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioFdpLoginsSort>>;
};


export type QueryPortfolioFdpLoginsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPortfolioFactSheetArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  additionalBenchmarkNames?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalBenchmarks?: InputMaybe<Array<Scalars['Int']['input']>>;
  additionalIndexNames?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalIndexes?: InputMaybe<Array<Scalars['Int']['input']>>;
  betaIndex?: InputMaybe<Scalars['Int']['input']>;
  betaName?: InputMaybe<Scalars['String']['input']>;
  coveredFund?: InputMaybe<Scalars['Int']['input']>;
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  footnote?: InputMaybe<Scalars['String']['input']>;
  fundTerms?: InputMaybe<Scalars['Int']['input']>;
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  separateAccount?: InputMaybe<Scalars['Int']['input']>;
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
  useProxies?: Scalars['Boolean']['input'];
  vehicleType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPortfolioGenomeReportArgs = {
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  strategies?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: Scalars['String']['input'];
};


export type QueryPortfolioListArgs = {
  filter?: InputMaybe<PortfolioFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PortfolioSort>>;
};


export type QueryPositionReportDatesArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryPositionsReportArgs = {
  aggregate?: Scalars['Boolean']['input'];
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  useProxyPositions?: Scalars['Boolean']['input'];
};


export type QueryPresignedTempUrlArgs = {
  input: PresignedTempUrlInput;
};


export type QueryPreviewLlmModelArgs = {
  bedrockModelId: Scalars['String']['input'];
  benchmarkSlug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPricingFrequencyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPricingFrequencyEnumListArgs = {
  filter?: InputMaybe<PricingFrequencyEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PricingFrequencyEnumSort>>;
};


export type QueryPricingFrequencyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPrivateQuartileGroupCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPrivateQuartileGroupCategoryListArgs = {
  filter?: InputMaybe<PrivateQuartileGroupCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<PrivateQuartileGroupCategorySort>>;
};


export type QueryPrivateQuartileGroupCategoryManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryProxyPositionsReportArgs = {
  asOfDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  exportAs?: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  sendEmail?: Scalars['Boolean']['input'];
};


export type QueryRangerDraftStatusArgs = {
  investmentId: Scalars['Int']['input'];
};


export type QueryRecentlyViewedInvestmentListArgs = {
  filter?: InputMaybe<RecentlyViewedInvestmentFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RecentlyViewedInvestmentSort>>;
};


export type QueryReportArgs = {
  format: FormatOptions;
  id: Scalars['ID']['input'];
};


export type QueryResultEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryResultEnumListArgs = {
  filter?: InputMaybe<ResultEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ResultEnumSort>>;
};


export type QueryResultEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRightOfExtensionEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRightOfExtensionEnumListArgs = {
  filter?: InputMaybe<RightOfExtensionEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RightOfExtensionEnumSort>>;
};


export type QueryRightOfExtensionEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRiskCategoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryRiskCategoryListArgs = {
  filter?: InputMaybe<RiskCategoryFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RiskCategorySort>>;
};


export type QueryRiskMeasuresArgs = {
  investmentId: Scalars['Int']['input'];
  reportDate: Scalars['Date']['input'];
};


export type QueryRiskRefreshListArgs = {
  filter?: InputMaybe<RiskRefreshListFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<RiskRefreshListSort>>;
};


export type QueryRiskVisualizationsDataArgs = {
  portfolioId: Scalars['Int']['input'];
};


export type QuerySavedEntitySearchArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySavedEntitySearchListArgs = {
  filter?: InputMaybe<SavedEntitySearchFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SavedEntitySearchSort>>;
};


export type QuerySavedKnowledgeBaseArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySavedKnowledgeBaseListArgs = {
  filter?: InputMaybe<SavedKnowledgeBaseFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SavedKnowledgeBaseSort>>;
};


export type QuerySchoolEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySchoolEnumListArgs = {
  filter?: InputMaybe<SchoolEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SchoolEnumSort>>;
};


export type QuerySchoolEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySecurityMasterListArgs = {
  filter?: InputMaybe<SecurityMasterFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SecurityMasterSort>>;
};


export type QuerySecurityMasterMeasurementsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentTypeListArgs = {
  filter?: InputMaybe<ServiceProviderDocumentTypeFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentTypeSort>>;
};


export type QueryServiceProviderDocumentTypeManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderDocumentsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderDocumentsListArgs = {
  filter?: InputMaybe<ServiceProviderDocumentsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderDocumentsSort>>;
};


export type QueryServiceProviderDocumentsManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderFirmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderFirmListArgs = {
  filter?: InputMaybe<ServiceProviderFirmFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderFirmSort>>;
};


export type QueryServiceProviderFirmManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryServiceProviderNotesArgs = {
  id: Scalars['Int']['input'];
};


export type QueryServiceProviderNotesListArgs = {
  filter?: InputMaybe<ServiceProviderNotesFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ServiceProviderNotesSort>>;
};


export type QueryServiceProviderNotesManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySetArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySetListArgs = {
  filter?: InputMaybe<SetFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SetSort>>;
};


export type QuerySetManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryShareClassArgs = {
  id: Scalars['Int']['input'];
};


export type QueryShareClassListArgs = {
  filter?: InputMaybe<ShareClassFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<ShareClassSort>>;
};


export type QueryShareClassManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryShareClassProfileBuilderArgs = {
  Keys: Array<Scalars['String']['input']>;
  bucket: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  investmentId: Scalars['Int']['input'];
};


export type QuerySharedGroupEntityArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySharedGroupEntityListArgs = {
  filter?: InputMaybe<SharedGroupEntityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SharedGroupEntitySort>>;
};


export type QuerySharedGroupEntityManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySoftLockupArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySoftLockupListArgs = {
  filter?: InputMaybe<SoftLockupFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SoftLockupSort>>;
};


export type QuerySoftLockupManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStageEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStageEnumListArgs = {
  filter?: InputMaybe<StageEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StageEnumSort>>;
};


export type QueryStageEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStateEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStateEnumListArgs = {
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StateEnumSort>>;
};


export type QueryStateEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStatsGroupArgs = {
  groupKey: StatsGroupKey;
};


export type QueryStoredPromptFromFieldKeyArgs = {
  fieldKey: Scalars['String']['input'];
};


export type QueryStoredPromptsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStoredPromptsListArgs = {
  filter?: InputMaybe<StoredPromptsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StoredPromptsSort>>;
};


export type QueryStoryboardGenArgs = {
  calculationPeriods?: Scalars['Int']['input'];
  currency?: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
};


export type QueryStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStrategyEnumListArgs = {
  filter?: InputMaybe<StrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StrategyEnumSort>>;
};


export type QueryStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryStrategyOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryStressTestReportArgs = {
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs?: Scalars['String']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  scenarioFactors: Array<ScenarioFactorsInput>;
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QuerySubStrategyEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubStrategyEnumListArgs = {
  filter?: InputMaybe<SubStrategyEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SubStrategyEnumSort>>;
};


export type QuerySubStrategyEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QuerySummaryRiskReportArgs = {
  accountName?: InputMaybe<Scalars['String']['input']>;
  benchmarks: Array<BenchmarkWeightInput>;
  calculationDate: Scalars['Date']['input'];
  currency?: Scalars['String']['input'];
  customBenchmarkName?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['Date']['input'];
  excludeCash?: Scalars['Boolean']['input'];
  exportAs: Scalars['String']['input'];
  hideNames?: Scalars['Boolean']['input'];
  portfolioId: Scalars['Int']['input'];
  quarterly?: Scalars['Boolean']['input'];
  strategies: Array<Scalars['String']['input']>;
  tag: Scalars['String']['input'];
  timePeriod: Scalars['Int']['input'];
};


export type QuerySystemConfigValueArgs = {
  key: SystemConfigurationKey;
};


export type QuerySystemConfigurationArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySystemConfigurationByKeyArgs = {
  key: SystemConfigurationKey;
};


export type QuerySystemConfigurationListArgs = {
  filter?: InputMaybe<SystemConfigurationFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<SystemConfigurationSort>>;
};


export type QuerySystemConfigurationManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTagArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagClassArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTagClassListArgs = {
  filter?: InputMaybe<TagClassFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagClassSort>>;
};


export type QueryTagClassManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTagListArgs = {
  filter?: InputMaybe<TagFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort>>;
};


export type QueryTagManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTeamMemberListArgs = {
  filter?: InputMaybe<TeamFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TeamSort>>;
};


export type QueryTemplateAttachmentsArgs = {
  entityLevel?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTitleEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTitleEnumListArgs = {
  filter?: InputMaybe<TitleEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TitleEnumSort>>;
};


export type QueryTitleEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryTypeAssetClassStrategyOptionsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTypeAssetClassStrategyOptionsListArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserActivityArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserActivityListArgs = {
  filter?: InputMaybe<UserActivityFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UserActivitySort>>;
};


export type QueryUserListArgs = {
  filter?: InputMaybe<UserFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UserSort>>;
};


export type QueryUserMutationAccessibleArgs = {
  mutationArgs: Scalars['String']['input'];
  mutationName: Scalars['String']['input'];
};


export type QueryUserSettingsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUsersXGroupsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsersXGroupsListArgs = {
  filter?: InputMaybe<UsersXGroupsFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<UsersXGroupsSort>>;
};


export type QueryUsersXGroupsManyArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryVehicleTypeEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryVehicleTypeEnumListArgs = {
  filter?: InputMaybe<VehicleTypeEnumFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VehicleTypeEnumSort>>;
};


export type QueryVehicleTypeEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryVehicleTypeOptionsArgs = {
  filter?: InputMaybe<TypeAssetClassStrategyOptionsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TypeAssetClassStrategyOptionsSort>>;
};


export type QueryWorkoutEnumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryWorkoutEnumListArgs = {
  filter?: InputMaybe<WorkoutEnumFilter>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<WorkoutEnumSort>>;
};


export type QueryWorkoutEnumManyArgs = {
  ids: Array<Scalars['Int']['input']>;
};

export type QuerySearchFilter = {
  value: Scalars['String']['input'];
};

export type QuestionResponse = {
  __typename?: 'QuestionResponse';
  answer?: Maybe<Scalars['String']['output']>;
  consultedExcerpts?: Maybe<Array<ConsultedExcerpts>>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  tools?: Maybe<Array<ToolResult>>;
  wasStopped?: Maybe<Scalars['Boolean']['output']>;
};

export type RcgPortfolioFilters = {
  isPortfolio?: InputMaybe<Scalars['Boolean']['input']>;
  managerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  portfolioIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RangerChatPayload = {
  __typename?: 'RangerChatPayload';
  answer?: Maybe<Scalars['String']['output']>;
  consultedExcerpts?: Maybe<Array<ConsultedExcerpts>>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  effort?: Maybe<Scalars['String']['output']>;
  messageStream: MessageStream;
  model?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  tools?: Maybe<Array<ToolResult>>;
};

export type RangerDraftStatus = {
  __typename?: 'RangerDraftStatus';
  investmentId: Scalars['Int']['output'];
  lastRun?: Maybe<RangerRerunSummary>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  staleFields: Array<RangerStaleFieldInfo>;
};

export type RangerRerunFieldOutcome = {
  __typename?: 'RangerRerunFieldOutcome';
  citations: Array<Citation>;
  fieldKey: Scalars['String']['output'];
  newValue?: Maybe<Scalars['JSON']['output']>;
  oldValue?: Maybe<Scalars['JSON']['output']>;
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  triggeredBy: Array<Citation>;
};

export type RangerRerunSummary = {
  __typename?: 'RangerRerunSummary';
  fields: Array<RangerRerunFieldOutcome>;
  ranAt: Scalars['DateTime']['output'];
  runId: Scalars['String']['output'];
};

export type RangerStaleFieldInfo = {
  __typename?: 'RangerStaleFieldInfo';
  artifacts: Array<Citation>;
  fieldKey: Scalars['String']['output'];
  markedAt: Scalars['DateTime']['output'];
  ownerId: Scalars['Int']['output'];
  ownerType: Scalars['String']['output'];
};

export type RecentlyViewedInvestment = {
  __typename?: 'RecentlyViewedInvestment';
  createDate: Scalars['DateTime']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type RecentlyViewedInvestmentFilter = {
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type RecentlyViewedInvestmentInput = {
  investmentId: Scalars['Int']['input'];
};

export type RecentlyViewedInvestmentList = {
  __typename?: 'RecentlyViewedInvestmentList';
  items: Array<RecentlyViewedInvestment>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RecentlyViewedInvestmentSort = {
  field: RecentlyViewedInvestmentSortEnum;
  order: SortInput;
};

export enum RecentlyViewedInvestmentSortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

export type ReconcileNewPortalFirmInput = {
  name: Scalars['String']['input'];
  portalFirmId: Scalars['ID']['input'];
  user: ExternalUserInput;
};

export enum RefreshInvestmentRiskListType {
  All = 'ALL',
  Custom = 'CUSTOM',
  Database = 'DATABASE'
}

export enum RelativeDateUnit {
  D = 'd',
  M = 'm',
  W = 'w',
  Y = 'y'
}

export type ReportFilePayload = {
  __typename?: 'ReportFilePayload';
  error?: Maybe<Scalars['Boolean']['output']>;
  requestId: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ReportRecipientInput = {
  recipients: Array<Scalars['String']['input']>;
  /** Omit to add a report. */
  reportId?: InputMaybe<Scalars['Int']['input']>;
  reportName: Scalars['String']['input'];
};

/** A scheduled report and the addresses it is mailed to. */
export type ReportRecipientRow = {
  __typename?: 'ReportRecipientRow';
  /** Email addresses, stored ';'-separated. */
  recipients?: Maybe<Array<Scalars['String']['output']>>;
  reportId: Scalars['Int']['output'];
  reportName: Scalars['String']['output'];
};

export enum ReportStructure {
  Analytics = 'Analytics',
  Diligence = 'Diligence',
  Overview = 'Overview',
  Team = 'Team'
}

export enum ReportTypeOptions {
  CaseStudy = 'CaseStudy',
  Complete = 'Complete',
  Custom = 'Custom',
  OnePage = 'OnePage',
  Ranger = 'Ranger',
  Summary = 'Summary',
  TwoPage = 'TwoPage'
}

export type ResaveDocumentCredentials = {
  accessKeyId: Scalars['String']['input'];
  roleArn: Scalars['String']['input'];
  secretAccessKey: Scalars['String']['input'];
};

export type ResultEnum = {
  __typename?: 'ResultEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ResultEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ResultEnumList = {
  __typename?: 'ResultEnumList';
  items: Array<ResultEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ResultEnumSort = {
  field: ResultEnumSortEnum;
  order: SortInput;
};

export enum ResultEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ReturnDistributionRecord = {
  __typename?: 'ReturnDistributionRecord';
  negative2to0?: Maybe<Scalars['Int']['output']>;
  negative4to2?: Maybe<Scalars['Int']['output']>;
  negative6to4?: Maybe<Scalars['Int']['output']>;
  negative8to6?: Maybe<Scalars['Int']['output']>;
  negative10to8?: Maybe<Scalars['Int']['output']>;
  overPositive10?: Maybe<Scalars['Int']['output']>;
  positive0to2?: Maybe<Scalars['Int']['output']>;
  positive2to4?: Maybe<Scalars['Int']['output']>;
  positive4to6?: Maybe<Scalars['Int']['output']>;
  positive6to8?: Maybe<Scalars['Int']['output']>;
  positive8to10?: Maybe<Scalars['Int']['output']>;
  underNegative10?: Maybe<Scalars['Int']['output']>;
};

export enum ReturnTypes {
  Gross = 'GROSS',
  Net = 'NET'
}

export type RightOfExtensionEnum = {
  __typename?: 'RightOfExtensionEnum';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RightOfExtensionEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type RightOfExtensionEnumList = {
  __typename?: 'RightOfExtensionEnumList';
  items: Array<RightOfExtensionEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RightOfExtensionEnumSort = {
  field: RightOfExtensionEnumSortEnum;
  order: SortInput;
};

export enum RightOfExtensionEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type RiskCategory = {
  __typename?: 'RiskCategory';
  category1?: Maybe<Scalars['String']['output']>;
  category2?: Maybe<Scalars['String']['output']>;
  category3?: Maybe<Scalars['String']['output']>;
  category4?: Maybe<Scalars['String']['output']>;
  category5?: Maybe<Scalars['String']['output']>;
  display1?: Maybe<Scalars['Int']['output']>;
  display2?: Maybe<Scalars['Int']['output']>;
  display3?: Maybe<Scalars['Int']['output']>;
  display4?: Maybe<Scalars['Int']['output']>;
  display5?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
};

export type RiskCategoryFilter = {
  display1?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RiskCategoryList = {
  __typename?: 'RiskCategoryList';
  items: Array<RiskCategory>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RiskCategoryPartition = {
  __typename?: 'RiskCategoryPartition';
  category1?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  display1?: Maybe<Scalars['Int']['output']>;
};

export type RiskCategorySort = {
  field: RiskCategorySortEnum;
  order: SortInput;
};

export enum RiskCategorySortEnum {
  Category1 = 'category1',
  Category2 = 'category2',
  Id = 'id'
}

export type RiskFileParse = {
  __typename?: 'RiskFileParse';
  errorCount: Scalars['Int']['output'];
  errorRows: Array<RiskFileRow>;
  totalCount: Scalars['Int']['output'];
  validInvestments: Array<RiskIdName>;
};

export type RiskFileRow = {
  __typename?: 'RiskFileRow';
  error?: Maybe<Scalars['String']['output']>;
  line: Scalars['Int']['output'];
  parsed?: Maybe<RockCreekMeasure>;
  raw?: Maybe<RiskMeasureRaw>;
};

export type RiskIdName = {
  __typename?: 'RiskIdName';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RiskMeasureRaw = {
  __typename?: 'RiskMeasureRaw';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  category5: Scalars['String']['output'];
  investmentId: Scalars['String']['output'];
  measure: Scalars['String']['output'];
  reportDate: Scalars['String']['output'];
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
};

/** One raw VFactManagerRisk measure row: the full tier/category tuple plus its value, with no family filtering or label coalescing. For consumers that need the whole measure set for a manager on a report date (e.g. the proxy-position engine keys on tier2 + category1..5) rather than one hardcoded exposure dimension. */
export type RiskMeasureRecord = {
  __typename?: 'RiskMeasureRecord';
  category1: Scalars['String']['output'];
  category2: Scalars['String']['output'];
  category3: Scalars['String']['output'];
  category4: Scalars['String']['output'];
  category5: Scalars['String']['output'];
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
  /** DefaultMeasureFilled, raw -- NOT a percentage like ExposureRecord.weight. */
  value?: Maybe<Scalars['Float']['output']>;
};

export type RiskRefreshListFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type RiskRefreshListInput = {
  add?: InputMaybe<Array<Scalars['Int']['input']>>;
  remove?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RiskRefreshListList = {
  __typename?: 'RiskRefreshListList';
  items: Array<InvestmentIdToRefresh>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type RiskRefreshListSort = {
  field: RiskRefreshListSortEnum;
  order: SortInput;
};

export enum RiskRefreshListSortEnum {
  Id = 'id'
}

export type RiskTierInfo = {
  __typename?: 'RiskTierInfo';
  definition?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  noNegative?: Maybe<Scalars['Boolean']['output']>;
  tier1: Scalars['String']['output'];
  tier2: Scalars['String']['output'];
};

export type RockCreekMeasure = {
  __typename?: 'RockCreekMeasure';
  appCode?: Maybe<Scalars['Int']['output']>;
  categoryId: Scalars['String']['output'];
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  investmentId: Scalars['Int']['output'];
  measure: Scalars['Float']['output'];
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  reportDate: Scalars['Date']['output'];
  tierId: Scalars['String']['output'];
};

export type SavedEntitySearch = {
  __typename?: 'SavedEntitySearch';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  data: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  userId: Scalars['Int']['output'];
};

export enum SavedEntitySearchEntityTypeEnum {
  Company = 'company',
  Investment = 'investment'
}

export type SavedEntitySearchFilter = {
  entityType?: InputMaybe<SavedEntitySearchEntityTypeEnum>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type SavedEntitySearchInput = {
  data: Scalars['String']['input'];
  entityType: SavedEntitySearchEntityTypeEnum;
  name: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

export type SavedEntitySearchList = {
  __typename?: 'SavedEntitySearchList';
  items: Array<SavedEntitySearch>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SavedEntitySearchSort = {
  field: SavedEntitySearchSortEnum;
  order: SortInput;
};

export enum SavedEntitySearchSortEnum {
  EntityType = 'entityType',
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type SavedKnowledgeBase = {
  __typename?: 'SavedKnowledgeBase';
  companyCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documentCount?: Maybe<Scalars['Int']['output']>;
  engagementCount?: Maybe<Scalars['Int']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  filters: Scalars['JSONObject']['output'];
  firmCount?: Maybe<Scalars['Int']['output']>;
  groupId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentCount?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  noteCount?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['Int']['output'];
};

export type SavedKnowledgeBaseFilterInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<SavedKnowledgeBaseScope>;
  status?: InputMaybe<KnowledgeBaseStatus>;
  type?: InputMaybe<KnowledgeBaseType>;
};

export type SavedKnowledgeBaseInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<KnowledgeBaseFilter>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<KnowledgeBaseType>;
};

export type SavedKnowledgeBaseList = {
  __typename?: 'SavedKnowledgeBaseList';
  items: Array<SavedKnowledgeBase>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum SavedKnowledgeBaseScope {
  Org = 'ORG',
  User = 'USER'
}

export type SavedKnowledgeBaseSort = {
  field: SavedKnowledgeBaseSortEnum;
  order: SortInput;
};

export enum SavedKnowledgeBaseSortEnum {
  CreatedAt = 'createdAt',
  Name = 'name'
}

export type ScenarioFactorsInput = {
  factors?: InputMaybe<Array<FactorInput>>;
  historicalPeriod?: InputMaybe<HistoricalPeriodInput>;
  scenarioId: Scalars['String']['input'];
  scenarioName: Scalars['String']['input'];
};

export type SchoolEnum = {
  __typename?: 'SchoolEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  uniqueId: Scalars['String']['output'];
};

export type SchoolEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type SchoolEnumList = {
  __typename?: 'SchoolEnumList';
  items: Array<SchoolEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SchoolEnumSort = {
  field: SchoolEnumSortEnum;
  order: SortInput;
};

export enum SchoolEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type SearchSetting = {
  __typename?: 'SearchSetting';
  id: Scalars['Int']['output'];
  type: SettingEntityType;
};

export type SearchSettingInput = {
  id: Scalars['Int']['input'];
  type: SettingEntityType;
};

export type SecurityMaster = {
  __typename?: 'SecurityMaster';
  assetClass?: Maybe<Scalars['String']['output']>;
  axysSecuritySymbol?: Maybe<Scalars['String']['output']>;
  barraCUSIP?: Maybe<Scalars['String']['output']>;
  barraCountryOfExposure?: Maybe<Scalars['String']['output']>;
  barraCurrency?: Maybe<Scalars['String']['output']>;
  barraISIN?: Maybe<Scalars['String']['output']>;
  barraId?: Maybe<Scalars['String']['output']>;
  barraLocalid?: Maybe<Scalars['String']['output']>;
  barraSedol?: Maybe<Scalars['String']['output']>;
  bbgIdSdg?: Maybe<Scalars['String']['output']>;
  blankPositionName?: Maybe<Scalars['String']['output']>;
  citcoSecurityId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cusipSdg?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  diligenceStrategyBucketing?: Maybe<Scalars['String']['output']>;
  em?: Maybe<Scalars['String']['output']>;
  emerging?: Maybe<Scalars['String']['output']>;
  equitySdg?: Maybe<Scalars['String']['output']>;
  esg?: Maybe<Scalars['String']['output']>;
  firearmsExposure?: Maybe<Scalars['String']['output']>;
  gicsSubIndustry?: Maybe<Scalars['String']['output']>;
  gicsSubIndustryName?: Maybe<Scalars['String']['output']>;
  gicsSubSector?: Maybe<Scalars['String']['output']>;
  grade?: Maybe<Scalars['String']['output']>;
  hfrName?: Maybe<Scalars['String']['output']>;
  hfrid?: Maybe<Scalars['String']['output']>;
  historicalReturnProxy?: Maybe<Scalars['String']['output']>;
  historicalReturnProxyScaling?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAfricanAmericanLatinoCEO?: Maybe<Scalars['String']['output']>;
  isAfricanAmericanLatinoCoFounder?: Maybe<Scalars['String']['output']>;
  isFemaleCEO?: Maybe<Scalars['String']['output']>;
  isFemaleCoFounder?: Maybe<Scalars['String']['output']>;
  isImpactOriented?: Maybe<Scalars['String']['output']>;
  isin?: Maybe<Scalars['String']['output']>;
  isinSdg?: Maybe<Scalars['String']['output']>;
  jpmSecurityId?: Maybe<Scalars['String']['output']>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  localId?: Maybe<Scalars['String']['output']>;
  markerCap?: Maybe<Scalars['String']['output']>;
  mktCapAmt?: Maybe<Scalars['Float']['output']>;
  mwbeCarry?: Maybe<Scalars['Float']['output']>;
  mwbeGP?: Maybe<Scalars['Float']['output']>;
  nameSdg?: Maybe<Scalars['String']['output']>;
  privateRegion?: Maybe<Scalars['String']['output']>;
  privateSector?: Maybe<Scalars['String']['output']>;
  rcgFundIdSdg?: Maybe<Scalars['Int']['output']>;
  rcgId?: Maybe<Scalars['Int']['output']>;
  rcgIdentifierType?: Maybe<Scalars['String']['output']>;
  rcgReportName?: Maybe<Scalars['String']['output']>;
  ric?: Maybe<Scalars['String']['output']>;
  rockCreekLinkedSecurity?: Maybe<Scalars['String']['output']>;
  sdg?: Maybe<Scalars['String']['output']>;
  secType?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  security?: Maybe<Scalars['String']['output']>;
  sedol?: Maybe<Scalars['String']['output']>;
  sedolSdg?: Maybe<Scalars['String']['output']>;
  stateStreetId?: Maybe<Scalars['String']['output']>;
  ticker?: Maybe<Scalars['String']['output']>;
  totalDiverseGPs?: Maybe<Scalars['Float']['output']>;
  totalWomanGPs?: Maybe<Scalars['Float']['output']>;
  totalofGPs?: Maybe<Scalars['Float']['output']>;
  trBusinessSummary?: Maybe<Scalars['String']['output']>;
  trCO2EmissionTotal?: Maybe<Scalars['Int']['output']>;
  trPolicyDiversityOpportunity?: Maybe<Scalars['String']['output']>;
  trSocialPillarScore?: Maybe<Scalars['Float']['output']>;
  trTRESGCommunityScore?: Maybe<Scalars['Float']['output']>;
  trTargetsDiversityOpportunity?: Maybe<Scalars['String']['output']>;
  trpe?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  webAddress?: Maybe<Scalars['String']['output']>;
};

export type SecurityMasterFilter = {
  assetClass?: InputMaybe<Scalars['String']['input']>;
  barraCUSIP?: InputMaybe<Scalars['String']['input']>;
  citcoSecurityId?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  esg?: InputMaybe<Scalars['String']['input']>;
  gicsSubSector?: InputMaybe<Scalars['String']['input']>;
  hasHistoricalReturnProxy?: InputMaybe<Scalars['Boolean']['input']>;
  hasHistoricalReturnProxyScaling?: InputMaybe<Scalars['Boolean']['input']>;
  isin?: InputMaybe<Scalars['String']['input']>;
  isins?: InputMaybe<Array<Scalars['String']['input']>>;
  lastUpdate?: InputMaybe<DateRangeFilter>;
  mktCapAmt?: InputMaybe<FloatRangeFilter>;
  /** Substring search across Security, Ticker, ISIN, CUSIP and SEDOL. Every whitespace-separated word must match. Sort by `nameSearchRank` DESC for best-match-first. */
  q?: InputMaybe<Scalars['String']['input']>;
  ric?: InputMaybe<Scalars['String']['input']>;
  secType?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  security?: InputMaybe<Scalars['String']['input']>;
  sedol?: InputMaybe<Scalars['String']['input']>;
  ticker?: InputMaybe<Scalars['String']['input']>;
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum SecurityMasterImportTarget {
  Measurements = 'measurements',
  SecurityMaster = 'securityMaster'
}

export type SecurityMasterList = {
  __typename?: 'SecurityMasterList';
  items: Array<SecurityMaster>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SecurityMasterMeasurements = {
  __typename?: 'SecurityMasterMeasurements';
  asOfDate: Scalars['DateTime']['output'];
  createdDate: Scalars['DateTime']['output'];
  createdUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  measure: SecurityMasterMeasurementsEnum;
  measureId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  secMasterId: Scalars['Int']['output'];
  source?: Maybe<SecurityMasterMeasurementsSourceEnum>;
  sourceField?: Maybe<SecurityMasterMeasurementsSourceFieldEnum>;
  sourceFieldId?: Maybe<Scalars['Int']['output']>;
  sourceId?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<SecurityMasterMeasurementsUnitEnum>;
  unitId?: Maybe<Scalars['Int']['output']>;
  valueQual?: Maybe<Scalars['String']['output']>;
  valueQuant?: Maybe<Scalars['Float']['output']>;
};

export type SecurityMasterMeasurementsEnum = {
  __typename?: 'SecurityMasterMeasurementsEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsSourceEnum = {
  __typename?: 'SecurityMasterMeasurementsSourceEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsSourceFieldEnum = {
  __typename?: 'SecurityMasterMeasurementsSourceFieldEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterMeasurementsUnitEnum = {
  __typename?: 'SecurityMasterMeasurementsUnitEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type SecurityMasterSort = {
  field: SecurityMasterSortEnum;
  order: SortInput;
};

export enum SecurityMasterSortEnum {
  HistoricalReturnProxy = 'historicalReturnProxy',
  HistoricalReturnProxyScaling = 'historicalReturnProxyScaling',
  Id = 'id',
  LastUpdate = 'lastUpdate',
  NameSearchRank = 'nameSearchRank',
  RcgId = 'rcgId'
}

export type ServiceProviderDocumentType = {
  __typename?: 'ServiceProviderDocumentType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ServiceProviderDocumentTypeFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderDocumentTypeList = {
  __typename?: 'ServiceProviderDocumentTypeList';
  items: Array<ServiceProviderDocumentType>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderDocumentTypeSort = {
  field: ServiceProviderDocumentTypeSortEnum;
  order: SortInput;
};

export enum ServiceProviderDocumentTypeSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderDocuments = {
  __typename?: 'ServiceProviderDocuments';
  documentDate?: Maybe<Scalars['Date']['output']>;
  documentType?: Maybe<ServiceProviderDocumentType>;
  documentTypeId: Scalars['Int']['output'];
  fileName: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
  serviceProviderFirmId: Scalars['Int']['output'];
  uploadedBy?: Maybe<Scalars['String']['output']>;
  uploadedDate?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceProviderDocumentsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
  serviceProviderFirmId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderDocumentsInput = {
  documentDate?: InputMaybe<Scalars['Date']['input']>;
  documentTypeId?: InputMaybe<Scalars['Int']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceProviderFirmId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderDocumentsList = {
  __typename?: 'ServiceProviderDocumentsList';
  items: Array<ServiceProviderDocuments>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderDocumentsSort = {
  field: ServiceProviderDocumentsSortEnum;
  order: SortInput;
};

export enum ServiceProviderDocumentsSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderFirm = {
  __typename?: 'ServiceProviderFirm';
  comments?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isEvaluating?: Maybe<Scalars['Boolean']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  name: Scalars['String']['output'];
  officeLocations?: Maybe<Array<GlobalProviderInstitutions>>;
  registeredWithOther?: Maybe<Scalars['String']['output']>;
  tierLevel?: Maybe<Scalars['Int']['output']>;
  yearFounded?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProviderFirmFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  institutionTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  isEvaluating?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderFirmInput = {
  isEvaluating?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tierLevel?: InputMaybe<Scalars['Int']['input']>;
  yearFounded?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderFirmList = {
  __typename?: 'ServiceProviderFirmList';
  items: Array<ServiceProviderFirm>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderFirmSort = {
  field: ServiceProviderFirmSortEnum;
  order: SortInput;
};

export enum ServiceProviderFirmSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type ServiceProviderNotes = {
  __typename?: 'ServiceProviderNotes';
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUser?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['Date']['output']>;
  id: Scalars['Int']['output'];
  isDeleted?: Maybe<Scalars['String']['output']>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  noteText: Scalars['String']['output'];
  providerId?: Maybe<Scalars['Int']['output']>;
  providerNoteTypeEnum?: Maybe<GlobalProviderNoteTypeEnum>;
  providerNoteTypeEnumId?: Maybe<Scalars['Int']['output']>;
  serviceProviderFirm?: Maybe<ServiceProviderFirm>;
};

export type ServiceProviderNotesFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerNoteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceProviderNotesInput = {
  eventDate?: InputMaybe<Scalars['Date']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  noteText?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['Int']['input']>;
  providerNoteTypeEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderNotesList = {
  __typename?: 'ServiceProviderNotesList';
  items: Array<ServiceProviderNotes>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ServiceProviderNotesSort = {
  field: ServiceProviderNotesSortEnum;
  order: SortInput;
};

export enum ServiceProviderNotesSortEnum {
  Id = 'id',
  TextSearchRank = 'textSearchRank'
}

export type Set = {
  __typename?: 'Set';
  description?: Maybe<Scalars['String']['output']>;
  disabled: Scalars['Boolean']['output'];
  expression: Scalars['String']['output'];
  expressionPg?: Maybe<Scalars['String']['output']>;
  givesAccess: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isBaseSet: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  setType: Scalars['Int']['output'];
  subscriptionLevelEnumId: Scalars['Int']['output'];
};

export type SetFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  myCuratedSets?: InputMaybe<Scalars['Boolean']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  setType?: InputMaybe<SetType>;
  subscriptionLevelEnumId?: InputMaybe<SetSubscriptionLevel>;
};

export type SetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  expression?: InputMaybe<Scalars['String']['input']>;
  expressionPg?: InputMaybe<Scalars['String']['input']>;
  givesAccess?: InputMaybe<Scalars['Boolean']['input']>;
  isBaseSet?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  setType?: InputMaybe<Scalars['Int']['input']>;
  subscriptionLevelEnumId?: InputMaybe<Scalars['Int']['input']>;
};

export type SetList = {
  __typename?: 'SetList';
  items: Array<Set>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SetSearchFilter = {
  setId: Scalars['Int']['input'];
};

export type SetSort = {
  field: SetSortEnum;
  order: SortInput;
};

export enum SetSortEnum {
  Id = 'id',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export enum SetSubscriptionLevel {
  AutoSubscribe = 'AutoSubscribe',
  NotSubscribeable = 'NotSubscribeable',
  Subscribeable = 'Subscribeable'
}

export enum SetType {
  Investment = 'Investment',
  Set = 'Set'
}

export type Setting = {
  __typename?: 'Setting';
  chatPreferences?: Maybe<ChatPreferences>;
  defaultInvestmentView?: Maybe<SearchSetting>;
};

export enum SettingEntityType {
  InvestmentSet = 'investmentSet',
  SavedEntitySearch = 'savedEntitySearch'
}

export type SettingInput = {
  chatPreferences?: InputMaybe<ChatPreferencesInput>;
  defaultInvestmentView?: InputMaybe<SearchSettingInput>;
};

export type ShareClass = {
  __typename?: 'ShareClass';
  FAS157?: Maybe<Scalars['Int']['output']>;
  createDate?: Maybe<Scalars['DateTime']['output']>;
  createUser?: Maybe<Scalars['String']['output']>;
  currencyDenominationEnumId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investment?: Maybe<Investment>;
  investmentFees?: Maybe<InvestmentFees>;
  investmentId: Scalars['Int']['output'];
  isRcgNegotiated?: Maybe<Scalars['Boolean']['output']>;
  liquidity?: Maybe<Liquidity>;
  modifyDate?: Maybe<Scalars['DateTime']['output']>;
  modifyUser?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  otherFees?: Maybe<Scalars['String']['output']>;
  peLiquidity?: Maybe<PeLiquidity>;
  restricted?: Maybe<Scalars['Boolean']['output']>;
  softLockups?: Maybe<Array<SoftLockup>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type ShareClassFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type ShareClassInput = {
  FAS157?: InputMaybe<Scalars['Int']['input']>;
  currencyDenominationEnumId?: InputMaybe<Scalars['Int']['input']>;
  investmentFees?: InputMaybe<InvestmentFeesInput>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  isRcgNegotiated?: InputMaybe<Scalars['Boolean']['input']>;
  liquidity?: InputMaybe<LiquidityInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherFees?: InputMaybe<Scalars['String']['input']>;
  peLiquidity?: InputMaybe<PeLiquidityInput>;
  restricted?: InputMaybe<Scalars['Boolean']['input']>;
  softLockups?: InputMaybe<Array<SoftLockupInput>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ShareClassList = {
  __typename?: 'ShareClassList';
  items: Array<ShareClass>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type ShareClassProfileBuilderResponse = {
  __typename?: 'ShareClassProfileBuilderResponse';
  answer?: Maybe<Scalars['String']['output']>;
  conversationId?: Maybe<Scalars['Int']['output']>;
  shareClassProfiles?: Maybe<Array<GeneratedShareClassProfile>>;
};

export type ShareClassSort = {
  field: ShareClassSortEnum;
  order: SortInput;
};

export enum ShareClassSortEnum {
  Id = 'id',
  Name = 'name'
}

export type SharePortfolioInput = {
  shareWithAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type SharedContentFilter = {
  /** excludeShared hides investments shared into the user's groups from groups the user does not belong to; onlyShared returns only those shared investments. */
  mode?: InputMaybe<SharedContentMode>;
};

export enum SharedContentMode {
  ExcludeShared = 'excludeShared',
  OnlyShared = 'onlyShared'
}

export type SharedGroupEntity = {
  __typename?: 'SharedGroupEntity';
  createDate: Scalars['DateTime']['output'];
  createUser?: Maybe<Scalars['String']['output']>;
  entityId: Scalars['Int']['output'];
  groupShareDefinition?: Maybe<GroupShareDefinition>;
  groupShareDefinitionId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser?: Maybe<Scalars['String']['output']>;
  sourceGroup?: Maybe<User>;
  sourceGroupId: Scalars['Int']['output'];
  targetGroup?: Maybe<User>;
  targetGroupId: Scalars['Int']['output'];
};

export type SharedGroupEntityFilter = {
  entityId?: InputMaybe<Scalars['Int']['input']>;
  groupShareDefinitionId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  sourceGroupId?: InputMaybe<Scalars['Int']['input']>;
  targetGroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type SharedGroupEntityList = {
  __typename?: 'SharedGroupEntityList';
  items: Array<SharedGroupEntity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SharedGroupEntitySort = {
  field: SharedGroupEntitySortEnum;
  order: SortInput;
};

export enum SharedGroupEntitySortEnum {
  CreateDate = 'createDate',
  Id = 'id',
  ModifyDate = 'modifyDate'
}

export enum SharedQueueTypeEnum {
  ManagerInbox = 'MANAGER_INBOX',
  MyQueue = 'MY_QUEUE',
  OperationsInbox = 'OPERATIONS_INBOX'
}

export type SiriusChat = {
  __typename?: 'SiriusChat';
  asyncLambda: Scalars['String']['output'];
  investmentPerformance: SiriusChat_InvestmentPerformanceResult;
  syncLambda: SyncLambdaResult;
  topPositionsTrends: SyncLambdaResult;
};


export type SiriusChatAsyncLambdaArgs = {
  input: Scalars['JSONObject']['input'];
  label: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


export type SiriusChatInvestmentPerformanceArgs = {
  input: SiriusChat_InvestmentPerformanceInput;
};


export type SiriusChatSyncLambdaArgs = {
  input: Scalars['JSONObject']['input'];
  label: Scalars['String']['input'];
};


export type SiriusChatTopPositionsTrendsArgs = {
  input: Scalars['JSONObject']['input'];
};

export type SiriusChat_InvestmentPerformanceInput = {
  endDate: Scalars['Date']['input'];
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  investmentName?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['Date']['input'];
};

export type SiriusChat_InvestmentPerformanceResult = {
  __typename?: 'SiriusChat_InvestmentPerformanceResult';
  ann?: Maybe<Scalars['Float']['output']>;
  cum?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum SiriusMcpCategory {
  Authoring = 'Authoring',
  Diligence = 'Diligence',
  Extraction = 'Extraction',
  Firms = 'Firms',
  KnowledgeBase = 'KnowledgeBase',
  Market = 'Market',
  Mutations = 'Mutations',
  Navigation = 'Navigation',
  Notifications = 'Notifications',
  PerformanceRisk = 'PerformanceRisk',
  Portfolio = 'Portfolio',
  Reference = 'Reference',
  Reporting = 'Reporting',
  Search = 'Search'
}

export type SoftLockup = {
  __typename?: 'SoftLockup';
  cashAvailableDays?: Maybe<Scalars['Int']['output']>;
  hasRedemptionFee?: Maybe<Scalars['Boolean']['output']>;
  holdBackPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  liquidityId: Scalars['Int']['output'];
  liquidityUnit?: Maybe<CalendarUnitEnum>;
  liquidityUnitId?: Maybe<Scalars['Int']['output']>;
  liquidityValue?: Maybe<Scalars['Int']['output']>;
  lockupEndRedemptionOn?: Maybe<FinancialPeriodEnum>;
  lockupEndRedemptionOnId?: Maybe<Scalars['Int']['output']>;
  noticeBizDays?: Maybe<Scalars['Boolean']['output']>;
  noticeValue?: Maybe<Scalars['Int']['output']>;
  redemptionFee: Scalars['Float']['output'];
  redemptionOnBizDays?: Maybe<Scalars['Boolean']['output']>;
  secondLockupEndRedemptionOn?: Maybe<FinancialPeriodEnum>;
  secondLockupEndRedemptionOnId?: Maybe<Scalars['Int']['output']>;
  termBeginMonth: Scalars['Int']['output'];
  termEndMonth: Scalars['Int']['output'];
};

export type SoftLockupFilter = {
  id?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  liquidityId?: InputMaybe<Scalars['Int']['input']>;
  shareClassId?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftLockupInput = {
  cashAvailableDays?: InputMaybe<Scalars['Int']['input']>;
  holdBackPercent?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityUnitId?: InputMaybe<Scalars['Int']['input']>;
  liquidityValue?: InputMaybe<Scalars['Int']['input']>;
  lockupEndRedemptionOnId?: InputMaybe<Scalars['Int']['input']>;
  noticeBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  noticeValue?: InputMaybe<Scalars['Int']['input']>;
  redemptionFee?: InputMaybe<Scalars['Float']['input']>;
  redemptionOnBizDays?: InputMaybe<Scalars['Boolean']['input']>;
  secondLockupEndRedemptionOnId?: InputMaybe<Scalars['Int']['input']>;
  termBeginMonth?: InputMaybe<Scalars['Int']['input']>;
  termEndMonth?: InputMaybe<Scalars['Int']['input']>;
};

export type SoftLockupList = {
  __typename?: 'SoftLockupList';
  items: Array<SoftLockup>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SoftLockupSort = {
  field: SoftLockupSortEnum;
  order: SortInput;
};

export enum SoftLockupSortEnum {
  Id = 'id'
}

export type SolutionsCutoverReadiness = {
  __typename?: 'SolutionsCutoverReadiness';
  appOwned: Scalars['Int']['output'];
  blockers: Array<SolutionsReadinessBlocker>;
  ready: Scalars['Boolean']['output'];
};

export type SolutionsReadinessBlocker = {
  __typename?: 'SolutionsReadinessBlocker';
  entities: Array<Scalars['String']['output']>;
  more: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
};

/** sort direction */
export enum SortInput {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StageEnum = {
  __typename?: 'StageEnum';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type StageEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StageEnumList = {
  __typename?: 'StageEnumList';
  items: Array<StageEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StageEnumSort = {
  field: StageEnumSortEnum;
  order: SortInput;
};

export enum StageEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type StageMutationPlanInput = {
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  steps: Array<MutationStepInput>;
  title: Scalars['String']['input'];
};

export type StateEnum = {
  __typename?: 'StateEnum';
  code: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type StateEnumList = {
  __typename?: 'StateEnumList';
  items: Array<StateEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StateEnumSort = {
  field: StateEnumSortEnum;
  order: SortInput;
};

export enum StateEnumSortEnum {
  Name = 'name'
}

export type StatsGroup = {
  __typename?: 'StatsGroup';
  alpha?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  asOfDate: Array<Maybe<Scalars['DateTime']['output']>>;
  beta: Array<Maybe<Scalars['Float']['output']>>;
  compoundReturn: Array<Maybe<Scalars['Float']['output']>>;
  correlation: Array<Maybe<Scalars['Float']['output']>>;
  correlationMatrix?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  inceptionDate: Array<Maybe<Scalars['DateTime']['output']>>;
  infoRatio: Array<Maybe<Scalars['Float']['output']>>;
  kurtosis: Array<Maybe<Scalars['Float']['output']>>;
  lengthOfMaxDrawDown?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  maxDrawDown?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  percentProfitablePeriods?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  recoveryFromMaxDrawDown: Array<Maybe<Scalars['Float']['output']>>;
  returnsStream?: Maybe<Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>>;
  sharpeRatio?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  skewness: Array<Maybe<Scalars['Float']['output']>>;
  stdDev?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  trackingError: Array<Maybe<Scalars['Float']['output']>>;
};


export type StatsGroupAlphaArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupBetaArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCompoundReturnArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCorrelationArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupCorrelationMatrixArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupInfoRatioArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupKurtosisArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupLengthOfMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupPercentProfitablePeriodsArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupRecoveryFromMaxDrawDownArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupReturnsStreamArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupSharpeRatioArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupSkewnessArgs = {
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupStdDevArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};


export type StatsGroupTrackingErrorArgs = {
  annualized: Scalars['Boolean']['input'];
  rangeLimit?: InputMaybe<Scalars['Int']['input']>;
  rangeOffset?: InputMaybe<Scalars['Int']['input']>;
  rangeUnit?: InputMaybe<StatsRangeUnit>;
};

export type StatsGroupKey = {
  asOfDate: Scalars['DateTime']['input'];
  /** The investment at position zero is the independent investment (i.e. base investment); the others are dependent investments (e.g. peers or benchmarks). */
  investmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** If true, includes performance data before the fund's inception date (prior track record). */
  priorTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  /** The 'with respect to' investment. It is the _other_ investment used for various _relative_ statistics, such as beta and tracking error. Required when such statistics are queried. */
  wrtInvestmentId?: InputMaybe<Scalars['Int']['input']>;
};

export enum StatsRangeUnit {
  I = 'I',
  M = 'M',
  Q = 'Q',
  Y = 'Y'
}

export type StoredPrompts = {
  __typename?: 'StoredPrompts';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  deleteDate?: Maybe<Scalars['DateTime']['output']>;
  deleteUserId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
};

export type StoredPromptsFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  q?: InputMaybe<Scalars['String']['input']>;
};

export type StoredPromptsInput = {
  prompt?: InputMaybe<Scalars['String']['input']>;
};

export type StoredPromptsList = {
  __typename?: 'StoredPromptsList';
  items: Array<StoredPrompts>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StoredPromptsSort = {
  field: StoredPromptsSortEnum;
  order: SortInput;
};

export enum StoredPromptsSortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

export type StrategyEnum = {
  __typename?: 'StrategyEnum';
  code: Scalars['String']['output'];
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  subStrategies: Array<SubStrategyEnum>;
};

export type StrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type StrategyEnumList = {
  __typename?: 'StrategyEnumList';
  items: Array<StrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type StrategyEnumSort = {
  field: StrategyEnumSortEnum;
  order: SortInput;
};

export enum StrategyEnumSortEnum {
  DisplayOrder = 'displayOrder',
  Id = 'id',
  Name = 'name'
}

export type StringIdName = {
  __typename?: 'StringIdName';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StringIdNameList = {
  __typename?: 'StringIdNameList';
  items: Array<StringIdName>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export enum SubSections {
  AnalyticsAssetClassExposure = 'Analytics_asset_class_exposure',
  AnalyticsBenchmarkReturns = 'Analytics_benchmark_returns',
  AnalyticsCumulativeReturns = 'Analytics_cumulative_returns',
  AnalyticsDistributionOfReturns = 'Analytics_distribution_of_returns',
  AnalyticsDrawdowns = 'Analytics_drawdowns',
  AnalyticsFirmAum = 'Analytics_firm_aum',
  AnalyticsGrowthOf_1000 = 'Analytics_growth_of_1000',
  AnalyticsInvestmentAum = 'Analytics_investment_aum',
  AnalyticsPortfolioExposure = 'Analytics_portfolio_exposure',
  AnalyticsRegionExposure = 'Analytics_region_exposure',
  AnalyticsRiskVsReturns = 'Analytics_risk_vs_returns',
  AnalyticsSectorExposure = 'Analytics_sector_exposure',
  AnalyticsStrategyAum = 'Analytics_strategy_aum',
  AnalyticsUpDownCapture = 'Analytics_up_down_capture',
  DiligenceImpact = 'Diligence_impact',
  DiligenceInvestment = 'Diligence_investment',
  DiligenceOperations = 'Diligence_operations',
  OverviewBenchmarkStatisticsData = 'Overview_benchmark_statistics_data',
  OverviewClassificationsTileData = 'Overview_classifications_tile_data',
  OverviewContactsData = 'Overview_contacts_data',
  OverviewFirmTileData = 'Overview_firm_tile_data',
  OverviewFundTermsData = 'Overview_fund_terms_data',
  OverviewFundTileData = 'Overview_fund_tile_data',
  OverviewInvestmentSummaryData = 'Overview_investment_summary_data',
  OverviewMaxDrawDownStatisticsData = 'Overview_max_draw_down_statistics_data',
  OverviewPeerStatisticsData = 'Overview_peer_statistics_data',
  OverviewPerformanceData = 'Overview_performance_data',
  OverviewPositionsData = 'Overview_positions_data',
  OverviewPrivateInvestmentFamilyData = 'Overview_private_investment_family_data',
  OverviewPrivatePerformanceData = 'Overview_private_performance_data',
  OverviewPrivatePositionsData = 'Overview_private_positions_data',
  OverviewRiskBenchmarkStatisticsData = 'Overview_risk_benchmark_statistics_data',
  OverviewRiskStatisticsData = 'Overview_risk_statistics_data',
  OverviewServiceProvidersData = 'Overview_service_providers_data',
  OverviewStatusTileData = 'Overview_status_tile_data',
  TeamKeyPersonnel = 'Team_key_personnel',
  TeamTeamSummary = 'Team_team_summary'
}

export type SubStrategyEnum = {
  __typename?: 'SubStrategyEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  strategy: StrategyEnum;
  strategyId: Scalars['Int']['output'];
};

export type SubStrategyEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  strategyId?: InputMaybe<Scalars['Int']['input']>;
};

export type SubStrategyEnumList = {
  __typename?: 'SubStrategyEnumList';
  items: Array<SubStrategyEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SubStrategyEnumSort = {
  field: SubStrategyEnumSortEnum;
  order: SortInput;
};

export enum SubStrategyEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type Subscription = {
  __typename?: 'Subscription';
  chatMessages: ChatSubscriptionPayload;
  /** Fires when a report started from a chat finishes, either way. Re-fetch the file through the report query; the event carries no link. */
  chatTaskFinished: ChatTaskFinishedPayload;
  rangerChatSubscription: RangerChatPayload;
  reportFileSubscription: ReportFilePayload;
};


export type SubscriptionChatMessagesArgs = {
  sessionId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionChatTaskFinishedArgs = {
  taskId: Scalars['String']['input'];
};


export type SubscriptionRangerChatSubscriptionArgs = {
  sessionId: Scalars['String']['input'];
};


export type SubscriptionReportFileSubscriptionArgs = {
  sessionId: Scalars['String']['input'];
};

export type SyncEntityStatus = {
  __typename?: 'SyncEntityStatus';
  backfillComplete: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  entity: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  lastDriftCount?: Maybe<Scalars['Int']['output']>;
  lastReconcileAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunAt?: Maybe<Scalars['DateTime']['output']>;
  lastRunError?: Maybe<Scalars['String']['output']>;
  lastRunMode?: Maybe<Scalars['String']['output']>;
  lastRunStatus?: Maybe<Scalars['String']['output']>;
  mirrorRows?: Maybe<Scalars['Float']['output']>;
  owner: Scalars['String']['output'];
  pgTable: Scalars['String']['output'];
  readFrom: Scalars['String']['output'];
  rowsSynced: Scalars['Float']['output'];
  sourceDb: Scalars['String']['output'];
  sourceRows?: Maybe<Scalars['Float']['output']>;
  sourceTable: Scalars['String']['output'];
  state: Scalars['String']['output'];
  writeTo: Scalars['String']['output'];
};

export type SyncLambdaResult = {
  __typename?: 'SyncLambdaResult';
  result: Scalars['String']['output'];
  urls?: Maybe<Array<Scalars['String']['output']>>;
};

export enum SyncMode {
  Backfill = 'backfill',
  Repair = 'repair',
  Verify = 'verify'
}

export type SystemConfigEntry = {
  __typename?: 'SystemConfigEntry';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  isOverridden: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['JSON']['output']>;
};

export type SystemConfiguration = {
  __typename?: 'SystemConfiguration';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  key: SystemConfigurationKey;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
};

export type SystemConfigurationFilterInput = {
  key?: InputMaybe<SystemConfigurationKey>;
};

export type SystemConfigurationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  key: SystemConfigurationKey;
  value: Scalars['JSON']['input'];
};

export enum SystemConfigurationKey {
  BatchReportConcurrency = 'BATCH_REPORT_CONCURRENCY',
  DdDraftsConcurrency = 'DD_DRAFTS_CONCURRENCY',
  KnowledgeBaseItemLimit = 'KNOWLEDGE_BASE_ITEM_LIMIT',
  KnowledgeBaseNoteLimit = 'KNOWLEDGE_BASE_NOTE_LIMIT',
  LlmGuardrailJudge = 'LLM_GUARDRAIL_JUDGE',
  LlmGuardrailMode = 'LLM_GUARDRAIL_MODE',
  RangerStalenessDocumentTypeIds = 'RANGER_STALENESS_DOCUMENT_TYPE_IDS',
  RangerStalenessMaxDistance = 'RANGER_STALENESS_MAX_DISTANCE',
  SentryProfileSampleRate = 'SENTRY_PROFILE_SAMPLE_RATE',
  SentryTracesSampleRate = 'SENTRY_TRACES_SAMPLE_RATE',
  SolovisDataIssueRecipients = 'SOLOVIS_DATA_ISSUE_RECIPIENTS',
  SolutionsForwardCapture = 'SOLUTIONS_FORWARD_CAPTURE'
}

export type SystemConfigurationList = {
  __typename?: 'SystemConfigurationList';
  items: Array<SystemConfiguration>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type SystemConfigurationSort = {
  field: SystemConfigurationSortEnum;
  order: SortInput;
};

export enum SystemConfigurationSortEnum {
  Key = 'key',
  Modifydate = 'modifydate'
}

export type Tag = {
  __typename?: 'Tag';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentTags: VInvestmentTagsList;
  name: Scalars['String']['output'];
  tagClass: TagClass;
  tagClassId: Scalars['Int']['output'];
};


export type TagInvestmentTagsArgs = {
  filter?: InputMaybe<VInvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VInvestmentTagsSort>>;
};

export type TagAttributes = {
  __typename?: 'TagAttributes';
  countryFocus?: Maybe<Array<Tag>>;
  creditQualityFocus?: Maybe<Array<Tag>>;
  creditSectorFocus?: Maybe<Array<Tag>>;
  decisionMakingProcess?: Maybe<Array<Tag>>;
  durationFocus?: Maybe<Array<Tag>>;
  exposureBias?: Maybe<Array<Tag>>;
  geographicFocus?: Maybe<Array<Tag>>;
  investmentId?: Maybe<Scalars['Int']['output']>;
  marketCap?: Maybe<Array<Tag>>;
  marketFocus?: Maybe<Array<Tag>>;
  realEstateFocus?: Maybe<Array<Tag>>;
  regionalFocus?: Maybe<Array<Tag>>;
  sdgGoals?: Maybe<Array<Tag>>;
  sectorFocus?: Maybe<Array<Tag>>;
  styleBias?: Maybe<Array<Tag>>;
};

export type TagClass = {
  __typename?: 'TagClass';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tags: TagList;
};


export type TagClassTagsArgs = {
  filter?: InputMaybe<TagFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<TagSort>>;
};

export type TagClassFilterInput = {
  idRange?: InputMaybe<IntRangeFilter>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type TagClassList = {
  __typename?: 'TagClassList';
  items: Array<TagClass>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TagClassSort = {
  field: TagClassSortEnum;
  order: SortInput;
};

export enum TagClassSortEnum {
  DisplayOrder = 'displayOrder',
  Name = 'name',
  NameSearchRank = 'nameSearchRank'
}

export type TagFilterInput = {
  investmentCountGTE?: InputMaybe<Scalars['Int']['input']>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  otherTags?: InputMaybe<Array<Scalars['Int']['input']>>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagClassIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TagList = {
  __typename?: 'TagList';
  items: Array<TagListItem>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TagListItem = {
  __typename?: 'TagListItem';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  investmentCount: Scalars['Int']['output'];
  investmentTags: VInvestmentTagsList;
  name: Scalars['String']['output'];
  nameSearchRank?: Maybe<Scalars['Float']['output']>;
  tagClass: TagClass;
  tagClassId: Scalars['Int']['output'];
};


export type TagListItemInvestmentTagsArgs = {
  filter?: InputMaybe<VInvestmentTagsFilterInput>;
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<VInvestmentTagsSort>>;
};

export type TagSort = {
  field: TagSortEnum;
  order: SortInput;
};

export enum TagSortEnum {
  DisplayOrder = 'displayOrder',
  InvestmentCount = 'investmentCount',
  Name = 'name',
  NameSearchRank = 'nameSearchRank',
  TagClassId = 'tagClassId',
  TagClassName = 'tagClassName'
}

export type TagsInput = {
  id: Scalars['Int']['input'];
  tagClassId: Scalars['Int']['input'];
};

export type TeamFilterInput = {
  firmEmployment?: InputMaybe<FirmEmploymentFilterInput>;
};

export type TeamSort = {
  field: TeamSortEnum;
  order: SortInput;
};

export enum TeamSortEnum {
  EmployeeRole = 'employeeRole'
}

export type TempFile = {
  __typename?: 'TempFile';
  bucket: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  suggestions?: Maybe<TempFileSuggestions>;
};

export type TempFileSuggestions = {
  __typename?: 'TempFileSuggestions';
  date?: Maybe<Scalars['Date']['output']>;
  documentTypeEnumId?: Maybe<Scalars['Int']['output']>;
};

export type TempFileUpload = {
  file: Scalars['Upload']['input'];
};

export type Template = {
  __typename?: 'Template';
  content: Scalars['JSON']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  fieldSetGroup: Scalars['String']['output'];
  fieldSetType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isCurrent: Scalars['Boolean']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['Int']['output']>;
  version: Scalars['String']['output'];
};

export type TemplateAttachment = {
  __typename?: 'TemplateAttachment';
  assetClassName?: Maybe<Scalars['String']['output']>;
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  entityLevel: Scalars['String']['output'];
  fieldSetType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  organizationId: Scalars['Int']['output'];
  vehicleType?: Maybe<Scalars['String']['output']>;
};

export type TimeSeriesRecord = {
  __typename?: 'TimeSeriesRecord';
  month: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
  year: Scalars['Int']['output'];
};

export type TitleEnum = {
  __typename?: 'TitleEnum';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TitleEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type TitleEnumList = {
  __typename?: 'TitleEnumList';
  items: Array<TitleEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TitleEnumSort = {
  field: TitleEnumSortEnum;
  order: SortInput;
};

export enum TitleEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type ToolResult = {
  __typename?: 'ToolResult';
  params: Scalars['JSONObject']['output'];
  results: Scalars['JSONObject']['output'];
  tool: ChatToolType;
  toolCallId?: Maybe<Scalars['String']['output']>;
  toolId: Scalars['String']['output'];
  toolName?: Maybe<Scalars['String']['output']>;
};

export type TransformResult = {
  __typename?: 'TransformResult';
  skipped: Scalars['Boolean']['output'];
  transformKey: Scalars['String']['output'];
  writeResult?: Maybe<Scalars['JSONObject']['output']>;
};

export type TypeAssetClassStrategyOptions = {
  __typename?: 'TypeAssetClassStrategyOptions';
  assetClass: AssetClass2Enum;
  assetClassId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  strategy?: Maybe<StrategyEnum>;
  strategyId?: Maybe<Scalars['Int']['output']>;
  vehicleType: VehicleTypeEnum;
  vehicleTypeId: Scalars['Int']['output'];
};

export type TypeAssetClassStrategyOptionsFilterInput = {
  assetClassId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  strategyId?: InputMaybe<Scalars['Int']['input']>;
  vehicleTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type TypeAssetClassStrategyOptionsList = {
  __typename?: 'TypeAssetClassStrategyOptionsList';
  items: Array<TypeAssetClassStrategyOptions>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type TypeAssetClassStrategyOptionsSort = {
  field: TypeAssetClassStrategyOptionsSortEnum;
  order: SortInput;
};

export enum TypeAssetClassStrategyOptionsSortEnum {
  AssetClass = 'assetClass',
  AssetClassId = 'assetClassId',
  Id = 'id',
  Strategy = 'strategy',
  StrategyId = 'strategyId',
  VehicleType = 'vehicleType',
  VehicleTypeId = 'vehicleTypeId'
}

export type UpdateFieldDefinitionInput = {
  columns?: InputMaybe<Array<FieldColumnInput>>;
  displayName: Scalars['String']['input'];
  displayType: Scalars['String']['input'];
  id: Scalars['Int']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  questionText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuidelineInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  limitRelationToResult?: InputMaybe<Scalars['Int']['input']>;
  limitValue?: InputMaybe<Scalars['String']['input']>;
  metricInfoId?: InputMaybe<Scalars['Int']['input']>;
  resultCardinality?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGuidelineNoteInput = {
  noteText?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGuidelineResultInput = {
  isCompliant?: InputMaybe<Scalars['Boolean']['input']>;
  isOverride?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNoticeLegInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  category?: InputMaybe<NoticeLegCategory>;
  investmentId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTemplateAttachmentInput = {
  displayOrder?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  access: EntityAccess;
  commonName: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  entryType: AdEntryType;
  entryTypeId: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags: UserFlags;
  groupEntityType?: Maybe<GroupEntityType>;
  groupIds?: Maybe<Array<Scalars['Int']['output']>>;
  groups?: Maybe<Array<User>>;
  id: Scalars['Int']['output'];
  imageType?: Maybe<Scalars['String']['output']>;
  imageTypeSm?: Maybe<Scalars['String']['output']>;
  isGroup: Scalars['Boolean']['output'];
  isPrimaryOrganizationGroup?: Maybe<Scalars['Boolean']['output']>;
  isUser: Scalars['Boolean']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  oktaUser?: Maybe<OktaUser>;
  organization?: Maybe<Organization>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  pushProfileChanges?: Maybe<Scalars['Boolean']['output']>;
  roleIds: Array<Scalars['Int']['output']>;
  roles: Array<ApplicationFlags>;
  sets?: Maybe<Array<Set>>;
  sub?: Maybe<Scalars['String']['output']>;
  userIds?: Maybe<Array<Scalars['Int']['output']>>;
  userName: Scalars['String']['output'];
  userSettings?: Maybe<UserSettings>;
  username?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};

export type UserActivity = {
  __typename?: 'UserActivity';
  adEntryId?: Maybe<Scalars['Int']['output']>;
  applicationId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  rcgApplicationVersion: Scalars['String']['output'];
  requestUri: Scalars['String']['output'];
  requestUtc: Scalars['DateTime']['output'];
};

export type UserActivityFilter = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UserActivityInput = {
  applicationId: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  rcgApplicationVersion?: InputMaybe<Scalars['String']['input']>;
  requestUri: Scalars['String']['input'];
  requestUtc: Scalars['DateTime']['input'];
};

export type UserActivityList = {
  __typename?: 'UserActivityList';
  items: Array<UserActivity>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UserActivitySort = {
  field: UserActivitySortEnum;
  order: SortInput;
};

export enum UserActivitySortEnum {
  CreateDate = 'createDate',
  Id = 'id'
}

/** The authentication type for a user */
export enum UserAuthType {
  CustomAuth = 'CUSTOM_AUTH',
  NotFound = 'NOT_FOUND',
  Saml = 'SAML'
}

export type UserChatSkill = {
  __typename?: 'UserChatSkill';
  chatSkillId: Scalars['Int']['output'];
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  optedOut: Scalars['Boolean']['output'];
  userId: Scalars['Int']['output'];
};

export type UserCreateInput = {
  commonName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  organizationId: Scalars['Int']['input'];
};

export type UserCreditUsage = {
  __typename?: 'UserCreditUsage';
  allotment: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  remaining: Scalars['Float']['output'];
  used: Scalars['Float']['output'];
  userId: Scalars['Int']['output'];
};

export type UserFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
  groupEntityType?: InputMaybe<GroupEntityType>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isUser?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['Int']['input']>;
  userNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserFlags = {
  __typename?: 'UserFlags';
  /** No one should have this access, placeholder role. */
  ABSOLUTELY_NO_ONE: Scalars['Boolean']['output'];
  /** Is this user able to acess data collection administrative functionality? */
  DCAdmin: Scalars['Boolean']['output'];
  /** User is a RECFReviewer. */
  RECFReviewer: Scalars['Boolean']['output'];
  /** If this is false, then this user has miss assigned roles, contact support. */
  anyUser: Scalars['Boolean']['output'];
  /** User is a business applicant user. */
  businessApplicant: Scalars['Boolean']['output'];
  /** Is this user able to assume another user? */
  canAssumeUser: Scalars['Boolean']['output'];
  /** Has access to portfolio configuration settings. */
  canManagePortfolioConfig: Scalars['Boolean']['output'];
  /** Has access to chat features in Sirius */
  canSiriusChat: Scalars['Boolean']['output'];
  /** Is this user able to update companies? */
  canUpdateCompany: Scalars['Boolean']['output'];
  /** Is this user able to upload documents? */
  canUploadDocuments: Scalars['Boolean']['output'];
  /** Can edit features of client docs */
  clientDocsAdmin: Scalars['Boolean']['output'];
  /** Core users involved in Rock Creek's investment business, as opposed to lending activities, business applicants */
  coreUser: Scalars['Boolean']['output'];
  /** use group based entitlements will become default in the future */
  groupBasedEntitlements: Scalars['Boolean']['output'];
  /** Can view investment pages in Sirius */
  investmentPageAccess: Scalars['Boolean']['output'];
  /** Does this user have edit access to the advisor fund fields (eg. IsSubAdvised). */
  isAdvisorFundManager: Scalars['Boolean']['output'];
  /** Allows saving changes to the Admin :: Bloomberg page. */
  isBloombergCodeUpdateUser: Scalars['Boolean']['output'];
  /** User is a member of the client services team. */
  isClientServicesUser: Scalars['Boolean']['output'];
  /** Is this user a client of Rock Creek? */
  isClientUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek legal/compliance data? */
  isComplianceUser: Scalars['Boolean']['output'];
  /** Is this user allowed to manage data for rock creek? */
  isDataManager: Scalars['Boolean']['output'];
  /** Can edit primary portfolios */
  isEditPrimary: Scalars['Boolean']['output'];
  /** Is this user a data intake user / manages external data? */
  isPortalUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek reporting data? */
  isReportingUser: Scalars['Boolean']['output'];
  /** Does this user manage internal Rock Creek risk data? */
  isRiskUser: Scalars['Boolean']['output'];
  /** Is this user a member of Rock Creek Group? */
  isRockCreek: Scalars['Boolean']['output'];
  /** User is able to receive Rock Creek investment emails. */
  isRockCreekInvestmentEmailUser: Scalars['Boolean']['output'];
  /** User is a service provider manager, they may access service providers in data collection and manage data relating. */
  isServiceProviderManager: Scalars['Boolean']['output'];
  /** Is this user a subscription user? */
  isSubscriptionUser: Scalars['Boolean']['output'];
  /** Is this user able to perform adminstrative functions? */
  isSuperUser: Scalars['Boolean']['output'];
  /** User is the machine user. */
  machineUser: Scalars['Boolean']['output'];
  /** If the user has access to odc manager entered data */
  managerDataAccess: Scalars['Boolean']['output'];
  /** This user will write data as manager entered. */
  managerDataEntry: Scalars['Boolean']['output'];
  /** Should receive investment emails. */
  shouldReceiveInvestmentEmails: Scalars['Boolean']['output'];
  /** If the user has access to odc subscriber entered data (XDD) */
  subscriberDataAccess: Scalars['Boolean']['output'];
};

export type UserGroupCreateInput = {
  commonName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  groupEntityType?: InputMaybe<GroupEntityType>;
  organizationId: Scalars['Int']['input'];
};

export type UserGroupUpdateInput = {
  commonName?: InputMaybe<Scalars['String']['input']>;
};

export type UserInvestmentSetSubscription = {
  __typename?: 'UserInvestmentSetSubscription';
  user?: Maybe<User>;
  userId: Scalars['Int']['output'];
};

export type UserList = {
  __typename?: 'UserList';
  items: Array<User>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UserSettings = {
  __typename?: 'UserSettings';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  data: Setting;
  id: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UserSettingsInput = {
  data: SettingInput;
  userId: Scalars['Int']['input'];
};

export type UserSort = {
  field: UserSortEnum;
  order: SortInput;
};

export enum UserSortEnum {
  Name = 'name'
}

export type UserUpdateInput = {
  commonName?: InputMaybe<Scalars['String']['input']>;
};

export type UsersXGroups = {
  __typename?: 'UsersXGroups';
  group: User;
  groupId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UsersXGroupsFilter = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersXGroupsInput = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UsersXGroupsList = {
  __typename?: 'UsersXGroupsList';
  items: Array<UsersXGroups>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type UsersXGroupsSort = {
  field: UsersXGroupsSortEnum;
  order: SortInput;
};

export enum UsersXGroupsSortEnum {
  Id = 'id'
}

export type VInvestmentTag = {
  __typename?: 'VInvestmentTag';
  createDate: Scalars['DateTime']['output'];
  createUser: Scalars['String']['output'];
  investment: Investment;
  investmentId: Scalars['Int']['output'];
  modifyDate: Scalars['DateTime']['output'];
  modifyUser: Scalars['String']['output'];
  partitionKey: Scalars['Int']['output'];
  sourceTagClassId: Scalars['Int']['output'];
  sourceTagId: Scalars['Int']['output'];
  tag: VTag;
  tagClassId: Scalars['Int']['output'];
  tagId: Scalars['Int']['output'];
};

export type VInvestmentTagsFilterInput = {
  investmentId?: InputMaybe<Scalars['Int']['input']>;
  tagClassId?: InputMaybe<Scalars['Int']['input']>;
  tagId?: InputMaybe<Scalars['Int']['input']>;
};

export type VInvestmentTagsList = {
  __typename?: 'VInvestmentTagsList';
  items: Array<VInvestmentTag>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type VInvestmentTagsSort = {
  field: VInvestmentTagsSortEnum;
  order: SortInput;
};

export enum VInvestmentTagsSortEnum {
  Id = 'id'
}

export type VManagerAttribute = {
  __typename?: 'VManagerAttribute';
  managerId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
  valueAbbrev?: Maybe<Scalars['String']['output']>;
  valueId?: Maybe<Scalars['ID']['output']>;
};

export type VTag = {
  __typename?: 'VTag';
  displayOrder: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  partitionKey: Scalars['Int']['output'];
  sourceTagClassId: Scalars['Int']['output'];
  sourceTagId: Scalars['Int']['output'];
  tagClassId: Scalars['Int']['output'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type VehicleTypeEnum = {
  __typename?: 'VehicleTypeEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  typeAssetClassStrategyOptions: Array<TypeAssetClassStrategyOptions>;
};

export type VehicleTypeEnumFilterInput = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type VehicleTypeEnumList = {
  __typename?: 'VehicleTypeEnumList';
  items: Array<VehicleTypeEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type VehicleTypeEnumSort = {
  field: VehicleTypeEnumSortEnum;
  order: SortInput;
};

export enum VehicleTypeEnumSortEnum {
  Name = 'name'
}

export type VolatilityPrivateSearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformancePrivateStatType;
};

export type VolatilitySearchFilter = {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
  statType: PerformanceStatType;
};

export type WeightedBalance = {
  __typename?: 'WeightedBalance';
  acctManager?: Maybe<AccountingManager>;
  additions: Scalars['Float']['output'];
  date: Scalars['DateTime']['output'];
  endBalance: Scalars['Float']['output'];
  manager?: Maybe<Investment>;
  managerId: Scalars['Int']['output'];
  performance: Scalars['Float']['output'];
  portfolio?: Maybe<Portfolio>;
  portfolioId: Scalars['Int']['output'];
  redemptions: Scalars['Float']['output'];
  redemptionsSource?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<ManagerTags>;
  weight: Scalars['Float']['output'];
};

export type WorkoutEnum = {
  __typename?: 'WorkoutEnum';
  displayOrder?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type WorkoutEnumFilter = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type WorkoutEnumList = {
  __typename?: 'WorkoutEnumList';
  items: Array<WorkoutEnum>;
  nextPage: NextPage;
  total: Scalars['Int']['output'];
};

export type WorkoutEnumSort = {
  field: WorkoutEnumSortEnum;
  order: SortInput;
};

export enum WorkoutEnumSortEnum {
  Id = 'id',
  Name = 'name'
}

export type AddShareClassMutationVariables = Exact<{
  input: ShareClassInput;
}>;


export type AddShareClassMutation = { __typename?: 'Mutation', addShareClass?: { __typename?: 'ShareClass', id: number, name: string } | null };

export type GetShareClassProfileQueryVariables = Exact<{
  bucket: Scalars['String']['input'];
  Keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
}>;


export type GetShareClassProfileQuery = { __typename?: 'Query', shareClassProfileBuilder: { __typename?: 'ShareClassProfileBuilderResponse', answer?: string | null, conversationId?: number | null, shareClassProfiles?: Array<{ __typename?: 'GeneratedShareClassProfile', name?: string | null, status?: string | null, restricted?: boolean | null, isRcgNegotiated?: boolean | null, currencyDenominationEnumId?: number | null, otherFees?: string | null, investmentFees?: { __typename?: 'GeneratedInvestmentFees', mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, annualReset?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, standardShareClassRates?: boolean | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null } | null, liquidity?: { __typename?: 'GeneratedLiquidity', hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupEndValueId?: number | null, lockupEndBizDays?: boolean | null, secondLockupEndValueId?: number | null, secondLockupEndBizDays?: boolean | null, lockupMonthlyValue?: number | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, liquidityMonthlyValue?: number | null, cashAvailableDays?: number | null, noticeValue?: number | null, noticeBizDays?: boolean | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, modelingNotes?: string | null } | null, peLiquidity?: { __typename?: 'GeneratedPeLiquidity', preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null } | null }> | null } };

export type GetFeeCalcEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeeCalcEnumQuery = { __typename?: 'Query', feeCalcEnumList: { __typename?: 'FeeCalcEnumList', items: Array<{ __typename?: 'FeeCalcEnum', id: number, name: string }> } };

export type GetFeeFreqEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeeFreqEnumQuery = { __typename?: 'Query', feeFreqEnumList: { __typename?: 'FeeFreqEnumList', items: Array<{ __typename?: 'FeeFreqEnum', id: number, name: string }> } };

export type GetPeMgmtFeeCalcEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeMgmtFeeCalcEnumQuery = { __typename?: 'Query', peMgmtFeeCalcEnumList: { __typename?: 'PeMgmtFeeCalcEnumList', items: Array<{ __typename?: 'PeMgmtFeeCalcEnum', id: number, name?: string | null }> } };

export type GetCalendarUnitEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCalendarUnitEnumQuery = { __typename?: 'Query', calendarUnitEnumList: { __typename?: 'CalendarUnitEnumList', items: Array<{ __typename?: 'CalendarUnitEnum', id: number, name: string }> } };

export type GetLockupEndValueEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLockupEndValueEnumQuery = { __typename?: 'Query', lockupEndValueEnumList: { __typename?: 'LockupEndValueEnumList', items: Array<{ __typename?: 'LockupEndValueEnum', id: number, name?: string | null }> } };

export type GetRightOfExtensionEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRightOfExtensionEnumQuery = { __typename?: 'Query', rightOfExtensionEnumList: { __typename?: 'RightOfExtensionEnumList', items: Array<{ __typename?: 'RightOfExtensionEnum', id: number, name?: string | null }> } };

export type GetCompoundingPeriodEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompoundingPeriodEnumQuery = { __typename?: 'Query', compoundingPeriodEnumList: { __typename?: 'CompoundingPeriodEnumList', items: Array<{ __typename?: 'CompoundingPeriodEnum', id: number, name?: string | null }> } };

export type GetWorkoutEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkoutEnumQuery = { __typename?: 'Query', workoutEnumList: { __typename?: 'WorkoutEnumList', items: Array<{ __typename?: 'WorkoutEnum', id: number, name: string }> } };

export type GetCurrencyDenominationEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrencyDenominationEnumQuery = { __typename?: 'Query', currencyDenominationEnumList: { __typename?: 'CurrencyDenominationEnumList', items: Array<{ __typename?: 'CurrencyDenominationEnum', id: number, name: string, displayOrder?: number | null }> } };

export type GetPeInctFeeCalcEnumQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPeInctFeeCalcEnumQuery = { __typename?: 'Query', peInctFeeCalcEnumList: { __typename?: 'PeInctFeeCalcEnumList', items: Array<{ __typename?: 'PeInctFeeCalcEnum', id: number, name?: string | null }> } };

export type GetExistingShareClassesQueryVariables = Exact<{
  filter: ShareClassFilter;
}>;


export type GetExistingShareClassesQuery = { __typename?: 'Query', shareClassList: { __typename?: 'ShareClassList', total: number, items: Array<{ __typename?: 'ShareClass', id: number, investmentId: number, name: string, status?: string | null, restricted?: boolean | null, isRcgNegotiated?: boolean | null, currencyDenominationEnumId?: number | null, otherFees?: string | null, investmentFees?: { __typename?: 'InvestmentFees', id: number, mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, annualReset?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, standardShareClassRates?: boolean | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null } | null, liquidity?: { __typename?: 'Liquidity', id: number, hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupEndValueId?: number | null, lockupEndBizDays?: boolean | null, secondLockupEndValueId?: number | null, secondLockupEndBizDays?: boolean | null, lockupMonthlyValue: number, subscriptionValue?: number | null, subscriptionUnitId?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, liquidityMonthlyValue: number, cashAvailableDays?: number | null, noticeValue?: number | null, noticeBizDays?: boolean | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, modelingNotes?: string | null } | null, peLiquidity?: { __typename?: 'PeLiquidity', id: number, preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null } | null }> } };

export type UpdateShareClassMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ShareClassInput;
}>;


export type UpdateShareClassMutation = { __typename?: 'Mutation', updateShareClass: { __typename?: 'ShareClass', id: number, name: string } };

export type GetBusinessApplicantDocumentsQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type GetBusinessApplicantDocumentsQuery = { __typename?: 'Query', documents: { __typename?: 'DocumentList', total: number, items: Array<{ __typename?: 'Document', id: number, name: string, date: any, signedUrl?: string | null, signedThumbnailUrl?: string | null, documentTypeEnumId: number, accessLevel: number, isGallery?: boolean | null, entityAssociations: Array<{ __typename?: 'DocumentXEntity', id: number, businessObjectTypeEnumId: number, entityId: number }>, documentTypeEnum: { __typename?: 'DocumentTypeEnum', id: number, name: string } }> }, documentTypeEnumList: { __typename?: 'DocumentTypeEnumList', items: Array<{ __typename?: 'DocumentTypeEnum', name: string, id: number }> } };

export type UploadBussinessApplicantDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type UploadBussinessApplicantDocumentMutation = { __typename?: 'Mutation', addDocument?: { __typename?: 'Document', id: number } | null };

export type DeleteBusinessApplicationDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteBusinessApplicationDocumentMutation = { __typename?: 'Mutation', deleteDocument: number };

export type ChatSkillsForInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatSkillsForInputQuery = { __typename?: 'Query', myActiveChatSkills: Array<{ __typename?: 'ChatSkill', id: number, name: string, description: string }> };

export type ChatAgentsForInputQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatAgentsForInputQuery = { __typename?: 'Query', mySpawnableChatAgents: Array<{ __typename?: 'ChatAgent', id: number, name: string, description: string }> };

export type AddStoredPromptsMutationVariables = Exact<{
  input: StoredPromptsInput;
}>;


export type AddStoredPromptsMutation = { __typename?: 'Mutation', addStoredPrompts: { __typename?: 'StoredPrompts', id: string, prompt: string } };

export type GetStoredPromptsListQueryVariables = Exact<{
  page?: InputMaybe<PageInput>;
  sort?: InputMaybe<Array<StoredPromptsSort> | StoredPromptsSort>;
  filter?: InputMaybe<StoredPromptsFilter>;
}>;


export type GetStoredPromptsListQuery = { __typename?: 'Query', storedPromptsList: { __typename?: 'StoredPromptsList', total: number, items: Array<{ __typename?: 'StoredPrompts', id: string, prompt: string }> } };

export type PresignedTempUrlQueryVariables = Exact<{
  input: PresignedTempUrlInput;
}>;


export type PresignedTempUrlQuery = { __typename?: 'Query', presignedTempUrl?: { __typename?: 'PresignedTempUrlResult', bucket?: string | null, key?: string | null, url?: string | null } | null };

export type FirmDiligenceTabsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FirmDiligenceTabsQuery = { __typename?: 'Query', firm?: { __typename?: 'Firm', id: number, diligenceTabs?: Array<{ __typename?: 'TemplateAttachment', fieldSetType: string, label?: string | null }> | null } | null };

export type CompanyDiligenceTabsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CompanyDiligenceTabsQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, diligenceTabs?: Array<{ __typename?: 'TemplateAttachment', fieldSetType: string, label?: string | null }> | null } | null };

export type DiligenceGapsQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type DiligenceGapsQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, gapAnalysis?: { __typename?: 'DiligenceGapAnalysis', generatedAt: any, gaps: Array<{ __typename?: 'DiligenceGap', id: string, fieldKey: string, ownerType: FieldOwnerType, questionText: string, section?: string | null, severity: DiligenceGapSeverity, rank: number, whyItMatters: string, status: DiligenceGapStatus, suggestedSources: Array<{ __typename?: 'DiligenceGapSource', kind: DiligenceGapSourceKind, label: string }> }> } | null } };

export type AnalyseDiligenceGapsMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type AnalyseDiligenceGapsMutation = { __typename?: 'Mutation', analyseDiligenceGaps: { __typename?: 'DiligenceGapAnalysis', investmentId: number, generatedAt: any, gaps: Array<{ __typename?: 'DiligenceGap', id: string, fieldKey: string, ownerType: FieldOwnerType, questionText: string, section?: string | null, severity: DiligenceGapSeverity, rank: number, whyItMatters: string, status: DiligenceGapStatus, suggestedSources: Array<{ __typename?: 'DiligenceGapSource', kind: DiligenceGapSourceKind, label: string }> }> } };

export type AsyncDocumentProcessQueryVariables = Exact<{
  documentId: Scalars['Int']['input'];
  processName: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  requestId: Scalars['String']['input'];
}>;


export type AsyncDocumentProcessQuery = { __typename?: 'Query', asyncDocumentProcess?: string | null };

export type DocumentProcessChatMessageSubscriptionSubscriptionVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type DocumentProcessChatMessageSubscriptionSubscription = { __typename?: 'Subscription', chatMessages: { __typename?: 'ChatSubscriptionPayload', sessionId: string, requestId: string, error?: boolean | null, messageStream: { __typename?: 'MessageStream', message?: string | null, messageIndex?: number | null, contentType?: MessageType | null, blockIndex?: number | null, event: MessageStreamEvent, id: string } } };

export type FirmEngagementFormFieldsFragment = { __typename?: 'FirmEngagement', id: number, name: string, description?: string | null, firmId: number, firmEngagementTypeEnumId: number, firmEngagementGroupId: number, imageDocument?: { __typename?: 'Document', id: number, name: string } | null };

export type FirmEngagementFormTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FirmEngagementFormTypesQuery = { __typename?: 'Query', firmEngagementTypeEnumList: { __typename?: 'FirmEngagementTypeEnumList', items: Array<{ __typename?: 'FirmEngagementTypeEnum', id: string, name: string, displayOrder: number }> } };

export type FirmEngagementDocumentTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type FirmEngagementDocumentTypeQuery = { __typename?: 'Query', documentTypeEnumList: { __typename?: 'DocumentTypeEnumList', items: Array<{ __typename?: 'DocumentTypeEnum', id: number, name: string }> } };

export type FirmEngagementFormAddImageMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type FirmEngagementFormAddImageMutation = { __typename?: 'Mutation', addDocument?: { __typename?: 'Document', id: number, name: string } | null };

export type FirmEngagementFormAddDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type FirmEngagementFormAddDocumentMutation = { __typename?: 'Mutation', addDocument?: { __typename?: 'Document', id: number, name: string } | null };

export type FirmEngagementFormDetailQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type FirmEngagementFormDetailQuery = { __typename?: 'Query', firmEngagement?: { __typename?: 'FirmEngagement', id: number, name: string, description?: string | null, firmId: number, firmEngagementTypeEnumId: number, firmEngagementGroupId: number, imageDocument?: { __typename?: 'Document', id: number, name: string } | null } | null };

export type AddFirmEngagementSharedMutationVariables = Exact<{
  input: FirmEngagementInput;
}>;


export type AddFirmEngagementSharedMutation = { __typename?: 'Mutation', addFirmEngagement: { __typename?: 'FirmEngagement', id: number, name: string, description?: string | null, firmId: number, firmEngagementTypeEnumId: number, firmEngagementGroupId: number, imageDocument?: { __typename?: 'Document', id: number, name: string } | null } };

export type UpdateFirmEngagementSharedMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: FirmEngagementInput;
}>;


export type UpdateFirmEngagementSharedMutation = { __typename?: 'Mutation', updateFirmEngagement: { __typename?: 'FirmEngagement', id: number, name: string, description?: string | null, firmId: number, firmEngagementTypeEnumId: number, firmEngagementGroupId: number, imageDocument?: { __typename?: 'Document', id: number, name: string } | null } };

export type InvestmentCompletenessQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type InvestmentCompletenessQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', completeness?: Array<{ __typename?: 'MemoizedInvestmentCompletenessSummary', category: string, subcategory: string, level: number, weight: number, percentComplete: number, description?: string | null }> | null } };

export type GetFirmsBySearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetFirmsBySearchQuery = { __typename?: 'Query', firmList: { __typename?: 'FirmList', items: Array<{ __typename?: 'Firm', id: number, name: string }> } };

export type GetFirmByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFirmByIdQuery = { __typename?: 'Query', firm?: { __typename?: 'Firm', id: number, name: string } | null };

export type GetInvestmentsBySearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetInvestmentsBySearchQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null }> } };

export type GetInvestmentByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetInvestmentByIdQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null } };

export type GetCompaniesBySearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetCompaniesBySearchQuery = { __typename?: 'Query', companyList: { __typename?: 'CompanyList', items: Array<{ __typename?: 'Company', id: number, name: string }> } };

export type GetCompanyByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetCompanyByIdQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, name: string } | null };

export type GetDealsBySearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetDealsBySearchQuery = { __typename?: 'Query', dealList: { __typename?: 'DealList', items: Array<{ __typename?: 'Deal', id: number, name?: string | null }> } };

export type GetDealByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetDealByIdQuery = { __typename?: 'Query', deal?: { __typename?: 'Deal', id: number, name?: string | null } | null };

export type GetFirmEngagementsBySearchQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
}>;


export type GetFirmEngagementsBySearchQuery = { __typename?: 'Query', firmEngagementList: { __typename?: 'FirmEngagementList', items: Array<{ __typename?: 'FirmEngagement', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null }> } };

export type GetFirmEngagementByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetFirmEngagementByIdQuery = { __typename?: 'Query', firmEngagement?: { __typename?: 'FirmEngagement', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null } | null };

export type EntityCreateCanAccessQueryVariables = Exact<{
  mutationName: Scalars['String']['input'];
  mutationArgs: Scalars['String']['input'];
}>;


export type EntityCreateCanAccessQuery = { __typename?: 'Query', userMutationAccessible: { __typename?: 'MutationAccess', canAccess: boolean } };

export type EntityCreateFirmNearMatchesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EntityCreateFirmNearMatchesQuery = { __typename?: 'Query', firmList: { __typename?: 'FirmList', items: Array<{ __typename?: 'Firm', id: number, name: string }> } };

export type EntityCreateInvestmentNearMatchesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type EntityCreateInvestmentNearMatchesQuery = { __typename?: 'Query', investmentList: { __typename?: 'InvestmentList', items: Array<{ __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null }> } };

export type EntityCreateInvestmentEnumsQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityCreateInvestmentEnumsQuery = { __typename?: 'Query', investmentListEnumList: { __typename?: 'InvestmentListEnumList', items: Array<{ __typename?: 'InvestmentListEnum', id: number, name: string }> }, assetClassEnumList: { __typename?: 'AssetClassEnumList', items: Array<{ __typename?: 'AssetClassEnum', id: number, name: string }> }, strategyEnumList: { __typename?: 'StrategyEnumList', items: Array<{ __typename?: 'StrategyEnum', id: number, name: string }> } };

export type EntityCreateAddFirmMutationVariables = Exact<{
  input: FirmInput;
}>;


export type EntityCreateAddFirmMutation = { __typename?: 'Mutation', addFirm?: { __typename?: 'Firm', id: number, name: string } | null };

export type EntityCreateAddInvestmentMutationVariables = Exact<{
  input: InvestmentInput;
}>;


export type EntityCreateAddInvestmentMutation = { __typename?: 'Mutation', addInvestment?: { __typename?: 'Investment', id: number, name: string, firm?: { __typename?: 'Firm', id: number, name: string } | null } | null };

export type AddDocumentQueueSignedUriMutationVariables = Exact<{
  names: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AddDocumentQueueSignedUriMutation = { __typename?: 'Mutation', addDocumentQueueSignedURI: Array<{ __typename?: 'DocumentQueue', url?: string | null, documentQueueId: string }> };

export type GetDocumentQueuesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type GetDocumentQueuesByIdsQuery = { __typename?: 'Query', documentQueueMany: Array<{ __typename?: 'DocumentQueue', id: string, name: string, queueDate: any, documentsId?: number | null, hash?: string | null, llmEntityId?: number | null, llmEntityNotes?: string | null, llmEntityTypeId?: number | null, llmEntityTypeNotes?: string | null, llmAsOfDate?: any | null, llmAsOfDateNotes?: string | null, llmDocumentTypeEnumId?: number | null, llmDocumentTypeEnumNotes?: string | null, llmProcessedAt?: any | null, duplicateDocuments?: Array<{ __typename?: 'Document', id: number, name: string, date: any }> | null } | null> };

export type ProcessDocumentQueueMutationVariables = Exact<{
  documentQueueId: Scalars['ID']['input'];
}>;


export type ProcessDocumentQueueMutation = { __typename?: 'Mutation', processDocumentQueue: string };

export type PublishDocumentQueuesMutationVariables = Exact<{
  input: Array<DocumentQueuePublishInput> | DocumentQueuePublishInput;
}>;


export type PublishDocumentQueuesMutation = { __typename?: 'Mutation', publishDocumentQueues: Array<{ __typename?: 'DocumentPublishResult', documentQueueId: string, success: boolean, documentId?: number | null, documentName?: string | null, error?: string | null }> };

export type GetBusinessObjectEnumsQueryVariables = Exact<{
  filter?: InputMaybe<BusinessObjectEnumFilter>;
}>;


export type GetBusinessObjectEnumsQuery = { __typename?: 'Query', businessObjectEnumList: { __typename?: 'BusinessObjectEnumList', items: Array<{ __typename?: 'BusinessObjectEnum', id: number, name: string }> } };

export type GetDocumentAccessLevelsQueryVariables = Exact<{
  filter?: InputMaybe<DocumentAccessLevelFilter>;
}>;


export type GetDocumentAccessLevelsQuery = { __typename?: 'Query', documentAccessLevelList: { __typename?: 'DocumentAccessLevelList', items: Array<{ __typename?: 'DocumentAccessLevel', id: number, name: string }> } };

export type GetDocumentTypeEnumsQueryVariables = Exact<{
  filter?: InputMaybe<DocumentTypeEnumFilter>;
}>;


export type GetDocumentTypeEnumsQuery = { __typename?: 'Query', documentTypeEnumList: { __typename?: 'DocumentTypeEnumList', items: Array<{ __typename?: 'DocumentTypeEnum', id: number, name: string }> } };

export type DeleteDocumentQueueMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentQueueMutation = { __typename?: 'Mutation', deleteDocumentQueue: string };

export type GetDocumentAuthGroupsQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
}>;


export type GetDocumentAuthGroupsQuery = { __typename?: 'Query', userList: { __typename?: 'UserList', items: Array<{ __typename?: 'User', id: number, commonName: string, organizationId?: number | null, userName: string }> } };

export type GetKnowledgeBaseTagsQueryVariables = Exact<{
  filter?: InputMaybe<KnowledgeBaseTagsFilter>;
}>;


export type GetKnowledgeBaseTagsQuery = { __typename?: 'Query', knowledgeBaseTagsList: { __typename?: 'KnowledgeBaseTagsList', items: Array<{ __typename?: 'KnowledgeBaseTags', id: number, name: string, description?: string | null }> } };

export type AddKnowledgeBaseTagMutationVariables = Exact<{
  input: KnowledgeBaseTagsInput;
}>;


export type AddKnowledgeBaseTagMutation = { __typename?: 'Mutation', addKnowledgeBaseTags: { __typename?: 'KnowledgeBaseTags', id: number, name: string, description?: string | null } };

export type MutationPlanQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type MutationPlanQuery = { __typename?: 'Query', mutationPlan?: { __typename?: 'MutationPlan', id: number, title: string, status: MutationPlanStatus, expiresAt: any, createdBy: number, steps: Array<{ __typename?: 'MutationStep', id: number, sequence: number, mutationName: string, description: string, input: any, status: MutationStepStatus, result?: any | null, errorMessage?: string | null, fieldSchema?: any | null, lockedFields?: Array<string> | null, liveSnapshot?: any | null, valueLabels?: any | null, previousState?: any | null, resultLinks?: any | null, filePreviewUrl?: string | null, dataSources?: any | null }> } | null };

export type ApproveMutationPlanMutationVariables = Exact<{
  planId: Scalars['Int']['input'];
}>;


export type ApproveMutationPlanMutation = { __typename?: 'Mutation', approveMutationPlan: { __typename?: 'MutationPlan', id: number, status: MutationPlanStatus } };

export type CancelMutationPlanMutationVariables = Exact<{
  planId: Scalars['Int']['input'];
}>;


export type CancelMutationPlanMutation = { __typename?: 'Mutation', cancelMutationPlan: boolean };

export type UpdateMutationStepInputMutationVariables = Exact<{
  stepId: Scalars['Int']['input'];
  input: Scalars['JSON']['input'];
}>;


export type UpdateMutationStepInputMutation = { __typename?: 'Mutation', updateMutationStepInput: { __typename?: 'MutationStep', id: number, input: any } };

export type RetryFailedStepsMutationVariables = Exact<{
  planId: Scalars['Int']['input'];
}>;


export type RetryFailedStepsMutation = { __typename?: 'Mutation', retryFailedSteps: { __typename?: 'MutationPlan', id: number, status: MutationPlanStatus } };

export type NotificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: number, eventType: NotificationEventType, subjectType: NotificationSubjectType, subjectId: any, message: string, detail?: string | null, hasArtifact: boolean, reason: string, createdAt: any, readAt?: any | null }> };

export type NotificationArtifactUrlQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type NotificationArtifactUrlQuery = { __typename?: 'Query', notificationArtifactUrl?: string | null };

export type MarkNotificationsReadMutationVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type MarkNotificationsReadMutation = { __typename?: 'Mutation', markNotificationsRead: number };

export type MutedNotificationCountQueryVariables = Exact<{ [key: string]: never; }>;


export type MutedNotificationCountQuery = { __typename?: 'Query', mutedNotificationCount: number };

export type NotificationEventPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationEventPreferencesQuery = { __typename?: 'Query', notificationEventPreferences: Array<{ __typename?: 'NotificationEventPreference', eventType: NotificationEventType, requiresSubscription: boolean, subscribedDirectly: boolean, subscribedViaGroup: boolean, toast: boolean, email: boolean, usingDefaults: boolean }> };

export type AgentChatQueryVariables = Exact<{
  question: Scalars['String']['input'];
  conversationId?: InputMaybe<Scalars['Int']['input']>;
  chatContext?: InputMaybe<ChatContext>;
  tools?: InputMaybe<Array<ChatToolType> | ChatToolType>;
  sessionId: Scalars['String']['input'];
  model?: InputMaybe<Scalars['String']['input']>;
  effort?: InputMaybe<ChatEffort>;
  excludedMcpCategories?: InputMaybe<Array<SiriusMcpCategory> | SiriusMcpCategory>;
}>;


export type AgentChatQuery = { __typename?: 'Query', chat: { __typename?: 'QuestionResponse', conversationId?: number | null } };

export type RangerChatSubscriptionSubscriptionVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type RangerChatSubscriptionSubscription = { __typename?: 'Subscription', rangerChatSubscription: { __typename?: 'RangerChatPayload', answer?: string | null, conversationId?: number | null, model?: string | null, effort?: string | null, sessionId: string, tools?: Array<{ __typename?: 'ToolResult', toolId: string, toolCallId?: string | null, tool: ChatToolType, toolName?: string | null, params: any, results: any }> | null, messageStream: { __typename?: 'MessageStream', message?: string | null, messageIndex?: number | null, contentType?: MessageType | null, blockIndex?: number | null, event: MessageStreamEvent, id: string } } };

export type StopChatMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;


export type StopChatMutation = { __typename?: 'Mutation', stopChat: boolean };

export type GetSavedKnowledgeBaseQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetSavedKnowledgeBaseQuery = { __typename?: 'Query', savedKnowledgeBase?: { __typename?: 'SavedKnowledgeBase', id: number, name: string, status: string, filters: any, noteCount?: number | null, documentCount?: number | null, investmentCount?: number | null, firmCount?: number | null, companyCount?: number | null, updatedAt: any } | null };

export type MyConversationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sources?: InputMaybe<Array<ConversationSource> | ConversationSource>;
}>;


export type MyConversationsQuery = { __typename?: 'Query', myConversations: { __typename?: 'ConversationList', total: number, items: Array<{ __typename?: 'Conversation', id: number, summary?: string | null, createDate: any, lastActivityDate?: any | null, hasMutationPlans?: boolean | null }> } };

export type LoadConversationQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type LoadConversationQuery = { __typename?: 'Query', loadConversation: Array<{ __typename?: 'ConversationHistory', id: number, question: string, answer?: string | null, createDate: any, chatContext?: string | null }> };

export type MutationPlansByConversationQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type MutationPlansByConversationQuery = { __typename?: 'Query', mutationPlansByConversation: Array<{ __typename?: 'MutationPlan', id: number, title: string, status: MutationPlanStatus }> };

export type ConversationArtifactsQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type ConversationArtifactsQuery = { __typename?: 'Query', conversationArtifacts: Array<{ __typename?: 'ConversationArtifact', artifactName: string, downloadUrl: string }> };

export type ChatReportFilesQueryVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type ChatReportFilesQuery = { __typename?: 'Query', conversationArtifacts: Array<{ __typename?: 'ConversationArtifact', id: number, downloadUrl: string, metadata?: any | null }> };

export type ChatTaskFinishedSubscriptionVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type ChatTaskFinishedSubscription = { __typename?: 'Subscription', chatTaskFinished: { __typename?: 'ChatTaskFinishedPayload', taskId: string } };

export type DeleteStoredPromptMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteStoredPromptMutation = { __typename?: 'Mutation', deleteStoredPrompts: string };

export type DeleteConversationMutationVariables = Exact<{
  conversationId: Scalars['Int']['input'];
}>;


export type DeleteConversationMutation = { __typename?: 'Mutation', deleteConversation: number };

export type CurrentUserChatPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserChatPreferencesQuery = { __typename?: 'Query', currentUserSettings?: { __typename?: 'UserSettings', id: number, userId: number, data: { __typename?: 'Setting', chatPreferences?: { __typename?: 'ChatPreferences', enabled: boolean, preferences?: string | null, lastUpdated?: string | null } | null } } | null };

export type UpdateChatPreferencesMutationVariables = Exact<{
  input: UserSettingsInput;
}>;


export type UpdateChatPreferencesMutation = { __typename?: 'Mutation', addOrUpdateUserSettings: { __typename?: 'UserSettings', id: number } };

export type MyActiveChatSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyActiveChatSkillsQuery = { __typename?: 'Query', myActiveChatSkills: Array<{ __typename?: 'ChatSkill', id: number, name: string, description: string, instructions: string, isAutoInvocable: boolean, scope: ChatSkillScope, organizationId?: number | null, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean }> };

export type AvailableOrgChatSkillsQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
}>;


export type AvailableOrgChatSkillsQuery = { __typename?: 'Query', availableOrgChatSkills: Array<{ __typename?: 'ChatSkill', id: number, name: string, description: string, instructions: string, isAutoInvocable: boolean, scope: ChatSkillScope, organizationId?: number | null, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean }> };

export type CreateChatSkillMutationVariables = Exact<{
  input: ChatSkillInput;
}>;


export type CreateChatSkillMutation = { __typename?: 'Mutation', createChatSkill: { __typename?: 'ChatSkill', id: number, name: string, description: string, instructions: string, isAutoInvocable: boolean, scope: ChatSkillScope, organizationId?: number | null, createUser: string, createUserFullName?: string | null } };

export type UpdateChatSkillMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ChatSkillUpdateInput;
}>;


export type UpdateChatSkillMutation = { __typename?: 'Mutation', updateChatSkill: { __typename?: 'ChatSkill', id: number, name: string, description: string, instructions: string, isAutoInvocable: boolean, scope: ChatSkillScope } };

export type DeleteChatSkillMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteChatSkillMutation = { __typename?: 'Mutation', deleteChatSkill: boolean };

export type OptInToChatSkillMutationVariables = Exact<{
  chatSkillId: Scalars['Int']['input'];
}>;


export type OptInToChatSkillMutation = { __typename?: 'Mutation', optInToChatSkill: { __typename?: 'UserChatSkill', id: number, chatSkillId: number } };

export type OptOutOfChatSkillMutationVariables = Exact<{
  chatSkillId: Scalars['Int']['input'];
}>;


export type OptOutOfChatSkillMutation = { __typename?: 'Mutation', optOutOfChatSkill: boolean };

export type SystemChatSkillsQueryVariables = Exact<{ [key: string]: never; }>;


export type SystemChatSkillsQuery = { __typename?: 'Query', chatSkillsByScope: Array<{ __typename?: 'ChatSkill', id: number, name: string, description: string, isAutoInvocable: boolean }> };

export type ChatSkillGroupAccessQueryVariables = Exact<{
  chatSkillId: Scalars['Int']['input'];
}>;


export type ChatSkillGroupAccessQuery = { __typename?: 'Query', chatSkillGroupAccess: Array<{ __typename?: 'ChatSkillGroup', id: number, chatSkillId: number, groupId: number, access: ChatSkillGroupAccess, groupName?: string | null }> };

export type GrantChatSkillGroupAccessMutationVariables = Exact<{
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type GrantChatSkillGroupAccessMutation = { __typename?: 'Mutation', grantChatSkillGroupAccess: { __typename?: 'ChatSkillGroup', id: number, groupId: number } };

export type RevokeChatSkillGroupAccessMutationVariables = Exact<{
  chatSkillId: Scalars['Int']['input'];
  groupId: Scalars['Int']['input'];
}>;


export type RevokeChatSkillGroupAccessMutation = { __typename?: 'Mutation', revokeChatSkillGroupAccess: boolean };

export type ChatSkillGrantableGroupsQueryVariables = Exact<{
  organizationId: Scalars['Int']['input'];
  q?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatSkillGrantableGroupsQuery = { __typename?: 'Query', chatSkillGrantableGroups: Array<{ __typename?: 'ChatSkillGrantableGroup', id: number, name: string }> };

export type ChatSkillHistoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ChatSkillHistoryQuery = { __typename?: 'Query', chatSkillHistory: Array<{ __typename?: 'ChatSkillHistory', id: number, version: number, name: string, description: string, instructions: string, archivedAt: any, archivedBy: string, archivedByFullName?: string | null }> };

export type MyChatSkillSchedulesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyChatSkillSchedulesQuery = { __typename?: 'Query', chatSkillScheduleList: { __typename?: 'ChatSkillScheduleList', items: Array<{ __typename?: 'ChatSkillSchedule', id: number, chatSkillId: number, frequency: ChatSkillScheduleFrequency, runAtHour: number, runAtMinute: number, runOnWeekday?: number | null, runOnDayOfMonth?: number | null, timezone: string, extraInstructions?: string | null, enabled: boolean, nextRunAt: any, lastRunAt?: any | null, lastRunStatus?: ChatSkillScheduleRunStatus | null, lastConversationId?: number | null }> } };

export type AddChatSkillScheduleMutationVariables = Exact<{
  input: ChatSkillScheduleInput;
}>;


export type AddChatSkillScheduleMutation = { __typename?: 'Mutation', addChatSkillSchedule: { __typename?: 'ChatSkillSchedule', id: number } };

export type UpdateChatSkillScheduleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ChatSkillScheduleInput;
}>;


export type UpdateChatSkillScheduleMutation = { __typename?: 'Mutation', updateChatSkillSchedule: { __typename?: 'ChatSkillSchedule', id: number } };

export type DeleteChatSkillScheduleMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteChatSkillScheduleMutation = { __typename?: 'Mutation', deleteChatSkillSchedule: number };

export type RunChatSkillScheduleNowMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RunChatSkillScheduleNowMutation = { __typename?: 'Mutation', runChatSkillScheduleNow: boolean };

export type MySpawnableChatAgentsQueryVariables = Exact<{ [key: string]: never; }>;


export type MySpawnableChatAgentsQuery = { __typename?: 'Query', mySpawnableChatAgents: Array<{ __typename?: 'ChatAgent', id: number, name: string, description: string, directive: string, tools?: Array<string> | null, model?: string | null, effort?: ChatEffort | null, color?: string | null, defaultMode: ChatAgentRunMode, scope: ChatSkillScope, organizationId?: number | null, version: number, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean, skills: Array<{ __typename?: 'ChatSkill', id: number, name: string }> }> };

export type ChatAgentsByScopeQueryVariables = Exact<{
  scope: ChatSkillScope;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatAgentsByScopeQuery = { __typename?: 'Query', chatAgentsByScope: Array<{ __typename?: 'ChatAgent', id: number, name: string, description: string, directive: string, tools?: Array<string> | null, model?: string | null, effort?: ChatEffort | null, color?: string | null, defaultMode: ChatAgentRunMode, scope: ChatSkillScope, organizationId?: number | null, version: number, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean, skills: Array<{ __typename?: 'ChatSkill', id: number, name: string }> }> };

export type CreateChatAgentMutationVariables = Exact<{
  input: ChatAgentInput;
}>;


export type CreateChatAgentMutation = { __typename?: 'Mutation', createChatAgent: { __typename?: 'ChatAgent', id: number, name: string, description: string, directive: string, tools?: Array<string> | null, model?: string | null, effort?: ChatEffort | null, color?: string | null, defaultMode: ChatAgentRunMode, scope: ChatSkillScope, organizationId?: number | null, version: number, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean, skills: Array<{ __typename?: 'ChatSkill', id: number, name: string }> } };

export type UpdateChatAgentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: ChatAgentUpdateInput;
}>;


export type UpdateChatAgentMutation = { __typename?: 'Mutation', updateChatAgent: { __typename?: 'ChatAgent', id: number, name: string, description: string, directive: string, tools?: Array<string> | null, model?: string | null, effort?: ChatEffort | null, color?: string | null, defaultMode: ChatAgentRunMode, scope: ChatSkillScope, organizationId?: number | null, version: number, createUser: string, createUserFullName?: string | null, canEdit: boolean, canDelete: boolean, skills: Array<{ __typename?: 'ChatSkill', id: number, name: string }> } };

export type DeleteChatAgentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteChatAgentMutation = { __typename?: 'Mutation', deleteChatAgent: boolean };

export type ChatAgentHistoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type ChatAgentHistoryQuery = { __typename?: 'Query', chatAgentHistory: Array<{ __typename?: 'ChatAgentHistory', id: number, version: number, name: string, description: string, directive: string, tools?: Array<string> | null, model?: string | null, effort?: ChatEffort | null, defaultMode: ChatAgentRunMode, scope: ChatSkillScope, skills?: any | null, archivedAt: any, archivedBy: string }> };

export type ChatAgentCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatAgentCapabilitiesQuery = { __typename?: 'Query', chatAgentCapabilities: { __typename?: 'ChatAgentCapabilities', allowedModels: Array<string>, allowedEfforts: Array<ChatEffort>, allowedColors: Array<string>, blockedTools: Array<ChatToolType>, mcpToolBundles: Array<{ __typename?: 'McpToolBundleType', key: SiriusMcpCategory, title: string, description: string, tools: Array<{ __typename?: 'McpToolRefType', name: string, description: string }> }>, mcpToolCategories: Array<{ __typename?: 'McpToolBundleType', key: SiriusMcpCategory, title: string, tools: Array<{ __typename?: 'McpToolRefType', name: string }> }>, notOfferedToAgents: Array<{ __typename?: 'McpToolBundleType', key: SiriusMcpCategory, title: string, description: string, tools: Array<{ __typename?: 'McpToolRefType', name: string }> }> } };

export type LlmModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type LlmModelsQuery = { __typename?: 'Query', llmModels: Array<{ __typename?: 'LlmModel', key: string, displayName: string, description?: string | null, supportsEffort: boolean, defaultEffort?: string | null, isDefault: boolean, enabled: boolean, verifiedRoles: Array<LlmModelRole>, intelligenceIndex?: number | null, outputTokensPerSecond?: number | null, blendedPricePer1M?: number | null, effortBenchmarks?: Array<{ __typename?: 'EffortBenchmark', effort: string, intelligenceIndex?: number | null, outputTokensPerSecond?: number | null }> | null, behavior: Array<{ __typename?: 'LlmModelBehavior', feature: string, limited: boolean }> }> };

export type DocumentRangerChatLinkQueryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DocumentRangerChatLinkQueryQuery = { __typename?: 'Query', document?: { __typename?: 'Document', id: number, name: string } | null };

export type GetReportQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  format: FormatOptions;
}>;


export type GetReportQuery = { __typename?: 'Query', report?: string | null };

export type GetCaseStudyReportQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCaseStudyReportQuery = { __typename?: 'Query', caseStudyReport?: string | null };

export type GetRiskVisualizationsDataQueryVariables = Exact<{
  portfolioId: Scalars['Int']['input'];
}>;


export type GetRiskVisualizationsDataQuery = { __typename?: 'Query', riskVisualizationsData: { __typename?: 'ComputePortfolioBenchmarksResponse', json: any } };

export type Fetch_Company_TemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  name: FieldSetType;
  version?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type Fetch_Company_TemplateQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: number, templateOptions: Array<string>, fieldData: { __typename?: 'FieldData', assetClassName?: string | null, fieldMeta: any, fieldSet: any, fieldSetType: FieldSetType, strategyName?: string | null, version: string } } | null };

export type Fetch_Firm_TemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  name: FieldSetType;
  version?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type Fetch_Firm_TemplateQuery = { __typename?: 'Query', firm?: { __typename?: 'Firm', id: number, templateOptions?: Array<string> | null, fieldData?: { __typename?: 'FieldData', assetClassName?: string | null, fieldMeta: any, fieldSet: any, fieldSetType: FieldSetType, strategyName?: string | null, version: string } | null } | null };

export type Fetch_Investment_TemplateQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  name: FieldSetType;
  version?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}>;


export type Fetch_Investment_TemplateQuery = { __typename?: 'Query', investment: { __typename?: 'Investment', id: number, firmId?: number | null, publishedFieldState?: string | null, templateOptions?: Array<string> | null, fieldData?: { __typename?: 'FieldData', assetClassName?: string | null, fieldMeta: any, fieldSet: any, fieldSetType: FieldSetType, strategyName?: string | null, version: string } | null } };

export type RangerDueDilligenceDraftsMutationVariables = Exact<{
  fieldKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
  customPromptsInput?: InputMaybe<Array<CustomPromptsInput> | CustomPromptsInput>;
  ragLimits?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RangerDueDilligenceDraftsMutation = { __typename?: 'Mutation', rangerDueDilligenceDrafts: { __typename?: 'AsyncTaskStatus', id?: string | null } };

export type GetAsyncTaskStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAsyncTaskStatusQuery = { __typename?: 'Query', asyncTaskStatus?: { __typename?: 'AsyncTaskStatus', id?: string | null, endDate?: any | null, error?: string | null } | null };

export type RangerDueDiligenceDraftsReturnQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RangerDueDiligenceDraftsReturnQuery = { __typename?: 'Query', getRangerDueDiligenceDrafts?: string | null };

export type StoredPromptFromFieldKeyQueryVariables = Exact<{
  fieldKey: Scalars['String']['input'];
}>;


export type StoredPromptFromFieldKeyQuery = { __typename?: 'Query', storedPromptFromFieldKey?: { __typename?: 'StoredPrompts', id: string, prompt: string } | null };

export type AddDocumentMutationVariables = Exact<{
  input: DocumentInput;
}>;


export type AddDocumentMutation = { __typename?: 'Mutation', addDocument?: { __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: number };

export type CitationDocumentManyQueryVariables = Exact<{
  documentIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CitationDocumentManyQuery = { __typename?: 'Query', documentMany: Array<{ __typename?: 'Document', id: number, name: string, signedUrl?: string | null } | null> };

export type CitationNoteManyQueryVariables = Exact<{
  noteIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type CitationNoteManyQuery = { __typename?: 'Query', notesMany: Array<{ __typename?: 'Notes', id: number, text?: string | null, noteDate?: any | null } | null> };

export type RangerDraftStatusQueryVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type RangerDraftStatusQuery = { __typename?: 'Query', rangerDraftStatus: { __typename?: 'RangerDraftStatus', investmentId: number, lastRunAt?: any | null, staleFields: Array<{ __typename?: 'RangerStaleFieldInfo', ownerType: string, ownerId: number, fieldKey: string, markedAt: any, artifacts: Array<{ __typename?: 'Citation', type: string, id: number }> }>, lastRun?: { __typename?: 'RangerRerunSummary', runId: string, ranAt: any, fields: Array<{ __typename?: 'RangerRerunFieldOutcome', ownerType: string, ownerId: number, fieldKey: string, status: string, oldValue?: any | null, newValue?: any | null, triggeredBy: Array<{ __typename?: 'Citation', type: string, id: number }>, citations: Array<{ __typename?: 'Citation', type: string, id: number }> }> } | null } };

export type RerunStaleRangerFieldsMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
}>;


export type RerunStaleRangerFieldsMutation = { __typename?: 'Mutation', rerunStaleRangerFields: { __typename?: 'AsyncTaskStatus', id?: string | null } };

export type ApplyRangerSuggestionToInvestmentDraftMutationVariables = Exact<{
  investmentId: Scalars['Int']['input'];
  values: Array<FieldValueInput> | FieldValueInput;
}>;


export type ApplyRangerSuggestionToInvestmentDraftMutation = { __typename?: 'Mutation', saveInvestmentFieldDrafts: { __typename?: 'InvestmentFields', investmentId: string, state?: string | null } };

export type ApplyRangerSuggestionToFirmDraftMutationVariables = Exact<{
  firmId: Scalars['Int']['input'];
  values: Array<FieldValueInput> | FieldValueInput;
}>;


export type ApplyRangerSuggestionToFirmDraftMutation = { __typename?: 'Mutation', saveFirmFieldDrafts: { __typename?: 'FirmFields', firmId: string, state?: string | null } };

export type RangerRerunTaskStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RangerRerunTaskStatusQuery = { __typename?: 'Query', asyncTaskStatus?: { __typename?: 'AsyncTaskStatus', id?: string | null, endDate?: any | null, error?: string | null } | null };

export type UserSettingsAttributesFragment = { __typename?: 'UserSettings', id: number, data: { __typename?: 'Setting', defaultInvestmentView?: { __typename?: 'SearchSetting', type: SettingEntityType, id: number } | null } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'CurrentUser', id: number, organizationId?: number | null, sub?: string | null, username?: string | null, userName: string, commonName: string, email?: string | null, imageType?: string | null, imageTypeSm?: string | null, entryTypeId: number, currentUserId: number, flags: { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, subscriberDataAccess: boolean, isDataManager: boolean, anyUser: boolean, businessApplicant: boolean, isSuperUser: boolean, RECFReviewer: boolean, canAssumeUser: boolean, canSiriusChat: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, coreUser: boolean, isEditPrimary: boolean, isComplianceUser: boolean }, userSettings?: { __typename?: 'UserSettings', id: number, data: { __typename?: 'Setting', defaultInvestmentView?: { __typename?: 'SearchSetting', type: SettingEntityType, id: number } | null } } | null, organization: { __typename?: 'Organization', name: string, id: number } } };

export type UserFlagListFragment = { __typename?: 'UserFlags', DCAdmin: boolean, isRockCreek: boolean, isSubscriptionUser: boolean, subscriberDataAccess: boolean, isDataManager: boolean, anyUser: boolean, businessApplicant: boolean, isSuperUser: boolean, RECFReviewer: boolean, canAssumeUser: boolean, canSiriusChat: boolean, isClientUser: boolean, isPortalUser: boolean, investmentPageAccess: boolean, coreUser: boolean, isEditPrimary: boolean, isComplianceUser: boolean };

export type InvestmentProfileFragmentFragment = { __typename?: 'GeneratedInvestmentProfile', name?: string | null, firmId?: number | null, firmName?: string | null, inceptionDate?: any | null, isImpact?: boolean | null, summary?: string | null, marketEnumId?: number | null, vehicleTypeEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, peStrategyEnumId?: number | null, primaryGeographicFocusId?: number | null, primaryBenchmarkId?: number | null, secondaryBenchmarkId?: number | null, currencyDenominationEnumId?: number | null, vintageYear?: number | null, peLegalLifeYrs?: number | null, gpCommitted?: number | null, committedCapital?: number | null, targetRaise?: number | null, minTargetNetMOIC?: number | null, minTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, maxTargetNetIRR?: number | null };

export type FirmProfileFragmentFragment = { __typename?: 'GeneratedFirmProfile', name?: string | null, yearFounded?: number | null, cik?: string | null, lei?: string | null, crd?: string | null, firmIrEmail?: string | null, registeredWithIds?: Array<number> | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, primaryAddress?: { __typename?: 'GeneratedAddress', line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, countryEnumId?: number | null, stateEnumId?: number | null, zipCode?: string | null, website?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } | null };

export type ShareClassProfileFragmentFragment = { __typename?: 'GeneratedShareClassProfile', name?: string | null, status?: string | null, restricted?: boolean | null, isRcgNegotiated?: boolean | null, FAS157?: number | null, currencyDenominationEnumId?: number | null, otherFees?: string | null, investmentFees?: { __typename?: 'GeneratedInvestmentFees', mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, annualReset?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, standardShareClassRates?: boolean | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null } | null, liquidity?: { __typename?: 'GeneratedLiquidity', hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndBizDays?: boolean | null, secondLockupEndValueId?: number | null, secondLockupEndBizDays?: boolean | null, lockupMonthlyValue?: number | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, liquidityMonthlyValue?: number | null, cashAvailableDays?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, modelingNotes?: string | null } | null, peLiquidity?: { __typename?: 'GeneratedPeLiquidity', preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null } | null };

export type AddTempFilesMutationVariables = Exact<{
  input: Array<TempFileUpload> | TempFileUpload;
}>;


export type AddTempFilesMutation = { __typename?: 'Mutation', addTempFiles: Array<{ __typename?: 'TempFile', key: string, bucket: string, filename?: string | null, suggestions?: { __typename?: 'TempFileSuggestions', documentTypeEnumId?: number | null, date?: any | null } | null }> };

export type ProfileBuilderQueryVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  bucket: Scalars['String']['input'];
}>;


export type ProfileBuilderQuery = { __typename?: 'Query', investmentProfileBuilder: { __typename?: 'ProfileBuilderResponse', answer?: string | null, conversationId?: number | null, investmentProfile?: { __typename?: 'GeneratedInvestmentProfile', name?: string | null, firmId?: number | null, firmName?: string | null, inceptionDate?: any | null, isImpact?: boolean | null, summary?: string | null, marketEnumId?: number | null, vehicleTypeEnumId?: number | null, assetClassEnumId?: number | null, strategyEnumId?: number | null, peStrategyEnumId?: number | null, primaryGeographicFocusId?: number | null, primaryBenchmarkId?: number | null, secondaryBenchmarkId?: number | null, currencyDenominationEnumId?: number | null, vintageYear?: number | null, peLegalLifeYrs?: number | null, gpCommitted?: number | null, committedCapital?: number | null, targetRaise?: number | null, minTargetNetMOIC?: number | null, minTargetNetIRR?: number | null, maxTargetNetMOIC?: number | null, maxTargetNetIRR?: number | null } | null } };

export type FirmProfileFromUrlBuilderQueryVariables = Exact<{
  url: Scalars['String']['input'];
  firmId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FirmProfileFromUrlBuilderQuery = { __typename?: 'Query', firmProfileFromUrlBuilder: { __typename?: 'FirmProfileBuilderResponse', answer?: string | null, conversationId?: number | null, firmProfile?: { __typename?: 'GeneratedFirmProfile', name?: string | null, yearFounded?: number | null, cik?: string | null, lei?: string | null, crd?: string | null, firmIrEmail?: string | null, registeredWithIds?: Array<number> | null, employeeTotal?: number | null, portfolioManagerCount?: number | null, investmentCount?: number | null, analystCount?: number | null, traderCount?: number | null, operationsCount?: number | null, administrativeCount?: number | null, investorRelationsCount?: number | null, legalCount?: number | null, primaryAddress?: { __typename?: 'GeneratedAddress', line1?: string | null, line2?: string | null, line3?: string | null, city?: string | null, countryEnumId?: number | null, stateEnumId?: number | null, zipCode?: string | null, website?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null } | null } | null } };

export type ShareClassProfileBuilderQueryVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  bucket: Scalars['String']['input'];
  investmentId: Scalars['Int']['input'];
}>;


export type ShareClassProfileBuilderQuery = { __typename?: 'Query', shareClassProfileBuilder: { __typename?: 'ShareClassProfileBuilderResponse', answer?: string | null, conversationId?: number | null, shareClassProfiles?: Array<{ __typename?: 'GeneratedShareClassProfile', name?: string | null, status?: string | null, restricted?: boolean | null, isRcgNegotiated?: boolean | null, FAS157?: number | null, currencyDenominationEnumId?: number | null, otherFees?: string | null, investmentFees?: { __typename?: 'GeneratedInvestmentFees', mgmtFee?: number | null, mgmtFeeCalcEnumId?: number | null, mgmtFeeFreqEnumId?: number | null, incentiveFee?: number | null, incentiveFeeCalcEnumId?: number | null, incentiveFeeFreqEnumId?: number | null, otherFee?: number | null, otherFeeCalcEnumId?: number | null, otherFeeFreqEnumId?: number | null, highWaterMark?: boolean | null, annualReset?: boolean | null, hurdle?: boolean | null, hurdleBenchmark?: string | null, standardShareClassRates?: boolean | null, feeStructureChanged?: boolean | null, feeStructureChangedNotes?: string | null, abnormalFees?: boolean | null, abnormalFeesNotes?: string | null, peMgmtFeeCalcEnumId?: number | null, peIncentiveFeeCalcEnumId?: number | null, peMgmtFeeDuringCommitment?: number | null, peMgmtFeeDuringCommitmentCalcEnumId?: number | null, peMgmtFeeDuringHarvest?: number | null, peMgmtFeeDuringHarvestCalcEnumId?: number | null, hasMgmtFeeStepDown?: boolean | null, peMgmtFeeStepDownPercent?: number | null, peMgmtFeeStepDownCalcEnumId?: number | null } | null, liquidity?: { __typename?: 'GeneratedLiquidity', hasGate?: boolean | null, gatePercentNav?: number | null, gatePercentCapital?: number | null, exceptions?: string | null, hasRollover?: boolean | null, rolloverValue?: number | null, rolloverUnitId?: number | null, hasLockup?: boolean | null, lockupValue?: number | null, lockupUnitId?: number | null, lockupEndValueId?: number | null, lockupEndBizDays?: boolean | null, secondLockupEndValueId?: number | null, secondLockupEndBizDays?: boolean | null, lockupMonthlyValue?: number | null, subscriptionValue?: number | null, subscriptionUnitId?: number | null, liquidityValue?: number | null, liquidityUnitId?: number | null, liquidityMonthlyValue?: number | null, cashAvailableDays?: number | null, noticeValue?: number | null, noticeUnitId?: number | null, noticeBizDays?: boolean | null, hasHoldback?: boolean | null, holdbackPercent?: number | null, workoutId?: number | null, modelingNotes?: string | null } | null, peLiquidity?: { __typename?: 'GeneratedPeLiquidity', preferredReturn?: number | null, isCompounded?: boolean | null, compoundingPeriodId?: number | null, hasCatchupProvision?: boolean | null, catchupPercent?: number | null, optionOfExtensionId?: number | null } | null }> | null } };

export type PersonProfileFragmentFragment = { __typename?: 'GeneratedPersonProfile', firstName?: string | null, middleName?: string | null, lastName?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, biography?: string | null, titleEnumId?: number | null, educationSummary?: string | null, pronouns?: string | null, workExperienceSummary?: string | null, comments?: string | null, linkedin?: string | null, twitter?: string | null, firmEmployment?: { __typename?: 'GeneratedFirmEmployment', firmId?: number | null, firmName?: string | null, employeeRoleEnumId?: number | null, jobDescription?: string | null, startDate?: any | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null } | null, diversity?: { __typename?: 'GeneratedPersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, nativeAmerican?: boolean | null, other?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, woman?: boolean | null, nonBinary?: boolean | null, hawaiianOrPacificIslander?: boolean | null } | null };

export type PersonProfileFromUrlBuilderQueryVariables = Exact<{
  url: Scalars['String']['input'];
  personId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PersonProfileFromUrlBuilderQuery = { __typename?: 'Query', personProfileFromUrlBuilder: { __typename?: 'PersonProfileBuilderResponse', answer?: string | null, conversationId?: number | null, personProfile?: { __typename?: 'GeneratedPersonProfile', firstName?: string | null, middleName?: string | null, lastName?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, biography?: string | null, titleEnumId?: number | null, educationSummary?: string | null, pronouns?: string | null, workExperienceSummary?: string | null, comments?: string | null, linkedin?: string | null, twitter?: string | null, firmEmployment?: { __typename?: 'GeneratedFirmEmployment', firmId?: number | null, firmName?: string | null, employeeRoleEnumId?: number | null, jobDescription?: string | null, startDate?: any | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null } | null, diversity?: { __typename?: 'GeneratedPersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, nativeAmerican?: boolean | null, other?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, woman?: boolean | null, nonBinary?: boolean | null, hawaiianOrPacificIslander?: boolean | null } | null } | null } };

export type PersonProfileFromFilesBuilderQueryVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  bucket: Scalars['String']['input'];
}>;


export type PersonProfileFromFilesBuilderQuery = { __typename?: 'Query', personProfileFromFilesBuilder: { __typename?: 'PersonProfileBuilderResponse', answer?: string | null, conversationId?: number | null, personProfile?: { __typename?: 'GeneratedPersonProfile', firstName?: string | null, middleName?: string | null, lastName?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, biography?: string | null, titleEnumId?: number | null, educationSummary?: string | null, pronouns?: string | null, workExperienceSummary?: string | null, comments?: string | null, linkedin?: string | null, twitter?: string | null, firmEmployment?: { __typename?: 'GeneratedFirmEmployment', firmId?: number | null, firmName?: string | null, employeeRoleEnumId?: number | null, jobDescription?: string | null, startDate?: any | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null } | null, diversity?: { __typename?: 'GeneratedPersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, nativeAmerican?: boolean | null, other?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, woman?: boolean | null, nonBinary?: boolean | null, hawaiianOrPacificIslander?: boolean | null } | null } | null } };

export type BulkPersonProfileFromFilesBuilderQueryVariables = Exact<{
  keys: Array<Scalars['String']['input']> | Scalars['String']['input'];
  bucket: Scalars['String']['input'];
  firmId?: InputMaybe<Scalars['Int']['input']>;
  conversationId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkPersonProfileFromFilesBuilderQuery = { __typename?: 'Query', bulkPersonProfileFromFilesBuilder: { __typename?: 'BulkPersonProfileBuilderResponse', answer?: string | null, conversationId?: number | null, personProfiles?: Array<{ __typename?: 'GeneratedPersonProfile', firstName?: string | null, middleName?: string | null, lastName?: string | null, phone?: string | null, phone2?: string | null, fax?: string | null, fax2?: string | null, email?: string | null, email2?: string | null, isCFA?: boolean | null, biography?: string | null, titleEnumId?: number | null, educationSummary?: string | null, pronouns?: string | null, workExperienceSummary?: string | null, comments?: string | null, linkedin?: string | null, twitter?: string | null, firmEmployment?: { __typename?: 'GeneratedFirmEmployment', firmId?: number | null, firmName?: string | null, employeeRoleEnumId?: number | null, jobDescription?: string | null, startDate?: any | null, isFounder?: boolean | null, isKeyPersonnel?: boolean | null } | null, diversity?: { __typename?: 'GeneratedPersonDiversity', africanAmerican?: boolean | null, asian?: boolean | null, hispanic?: boolean | null, lgbtq?: boolean | null, nativeAmerican?: boolean | null, other?: boolean | null, veteran?: boolean | null, disabled?: boolean | null, woman?: boolean | null, nonBinary?: boolean | null, hawaiianOrPacificIslander?: boolean | null } | null }> | null } };

export type AddUserActivityMutationVariables = Exact<{
  input: UserActivityInput;
}>;


export type AddUserActivityMutation = { __typename?: 'Mutation', addUserActivity: { __typename?: 'UserActivity', id: string } };

export const FirmEngagementFormFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmEngagementFormFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"imageDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FirmEngagementFormFieldsFragment, unknown>;
export const UserSettingsAttributesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultInvestmentView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<UserSettingsAttributesFragment, unknown>;
export const UserFlagListFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFlagList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserFlags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DCAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isRockCreek"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionUser"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberDataAccess"}},{"kind":"Field","name":{"kind":"Name","value":"isDataManager"}},{"kind":"Field","name":{"kind":"Name","value":"anyUser"}},{"kind":"Field","name":{"kind":"Name","value":"businessApplicant"}},{"kind":"Field","name":{"kind":"Name","value":"isSuperUser"}},{"kind":"Field","name":{"kind":"Name","value":"RECFReviewer"}},{"kind":"Field","name":{"kind":"Name","value":"canAssumeUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSiriusChat"}},{"kind":"Field","name":{"kind":"Name","value":"isClientUser"}},{"kind":"Field","name":{"kind":"Name","value":"isPortalUser"}},{"kind":"Field","name":{"kind":"Name","value":"investmentPageAccess"}},{"kind":"Field","name":{"kind":"Name","value":"coreUser"}},{"kind":"Field","name":{"kind":"Name","value":"isEditPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isComplianceUser"}}]}}]} as unknown as DocumentNode<UserFlagListFragment, unknown>;
export const InvestmentProfileFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvestmentProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedInvestmentProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"inceptionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isImpact"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"marketEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"strategyEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peStrategyEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryGeographicFocusId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryBenchmarkId"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryBenchmarkId"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"vintageYear"}},{"kind":"Field","name":{"kind":"Name","value":"peLegalLifeYrs"}},{"kind":"Field","name":{"kind":"Name","value":"gpCommitted"}},{"kind":"Field","name":{"kind":"Name","value":"committedCapital"}},{"kind":"Field","name":{"kind":"Name","value":"targetRaise"}},{"kind":"Field","name":{"kind":"Name","value":"minTargetNetMOIC"}},{"kind":"Field","name":{"kind":"Name","value":"minTargetNetIRR"}},{"kind":"Field","name":{"kind":"Name","value":"maxTargetNetMOIC"}},{"kind":"Field","name":{"kind":"Name","value":"maxTargetNetIRR"}}]}}]} as unknown as DocumentNode<InvestmentProfileFragmentFragment, unknown>;
export const FirmProfileFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedFirmProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"yearFounded"}},{"kind":"Field","name":{"kind":"Name","value":"cik"}},{"kind":"Field","name":{"kind":"Name","value":"lei"}},{"kind":"Field","name":{"kind":"Name","value":"crd"}},{"kind":"Field","name":{"kind":"Name","value":"firmIrEmail"}},{"kind":"Field","name":{"kind":"Name","value":"registeredWithIds"}},{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"stateEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeTotal"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioManagerCount"}},{"kind":"Field","name":{"kind":"Name","value":"investmentCount"}},{"kind":"Field","name":{"kind":"Name","value":"analystCount"}},{"kind":"Field","name":{"kind":"Name","value":"traderCount"}},{"kind":"Field","name":{"kind":"Name","value":"operationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"administrativeCount"}},{"kind":"Field","name":{"kind":"Name","value":"investorRelationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"legalCount"}}]}}]} as unknown as DocumentNode<FirmProfileFragmentFragment, unknown>;
export const ShareClassProfileFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareClassProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedShareClassProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"restricted"}},{"kind":"Field","name":{"kind":"Name","value":"isRcgNegotiated"}},{"kind":"Field","name":{"kind":"Name","value":"FAS157"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFees"}},{"kind":"Field","name":{"kind":"Name","value":"investmentFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mgmtFee"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFee"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFee"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"highWaterMark"}},{"kind":"Field","name":{"kind":"Name","value":"annualReset"}},{"kind":"Field","name":{"kind":"Name","value":"hurdle"}},{"kind":"Field","name":{"kind":"Name","value":"hurdleBenchmark"}},{"kind":"Field","name":{"kind":"Name","value":"standardShareClassRates"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChanged"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChangedNotes"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFees"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFeesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peIncentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitment"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitmentCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvest"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvestCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"hasMgmtFeeStepDown"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownPercent"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownCalcEnumId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGate"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentNav"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentCapital"}},{"kind":"Field","name":{"kind":"Name","value":"exceptions"}},{"kind":"Field","name":{"kind":"Name","value":"hasRollover"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverValue"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"hasLockup"}},{"kind":"Field","name":{"kind":"Name","value":"lockupValue"}},{"kind":"Field","name":{"kind":"Name","value":"lockupUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"lockupMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityValue"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"cashAvailableDays"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValue"}},{"kind":"Field","name":{"kind":"Name","value":"noticeUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"noticeBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"hasHoldback"}},{"kind":"Field","name":{"kind":"Name","value":"holdbackPercent"}},{"kind":"Field","name":{"kind":"Name","value":"workoutId"}},{"kind":"Field","name":{"kind":"Name","value":"modelingNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peLiquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredReturn"}},{"kind":"Field","name":{"kind":"Name","value":"isCompounded"}},{"kind":"Field","name":{"kind":"Name","value":"compoundingPeriodId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatchupProvision"}},{"kind":"Field","name":{"kind":"Name","value":"catchupPercent"}},{"kind":"Field","name":{"kind":"Name","value":"optionOfExtensionId"}}]}}]}}]} as unknown as DocumentNode<ShareClassProfileFragmentFragment, unknown>;
export const PersonProfileFragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedPersonProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email2"}},{"kind":"Field","name":{"kind":"Name","value":"isCFA"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"titleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"educationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"workExperienceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"firmEmployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeRoleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"isFounder"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyPersonnel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diversity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"africanAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"asian"}},{"kind":"Field","name":{"kind":"Name","value":"hispanic"}},{"kind":"Field","name":{"kind":"Name","value":"lgbtq"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"veteran"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"woman"}},{"kind":"Field","name":{"kind":"Name","value":"nonBinary"}},{"kind":"Field","name":{"kind":"Name","value":"hawaiianOrPacificIslander"}}]}}]}}]} as unknown as DocumentNode<PersonProfileFragmentFragment, unknown>;
export const AddShareClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddShareClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addShareClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AddShareClassMutation, AddShareClassMutationVariables>;
export const GetShareClassProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetShareClassProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareClassProfileBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}}},{"kind":"Argument","name":{"kind":"Name","value":"Keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"shareClassProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"restricted"}},{"kind":"Field","name":{"kind":"Name","value":"isRcgNegotiated"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFees"}},{"kind":"Field","name":{"kind":"Name","value":"investmentFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mgmtFee"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFee"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFee"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"highWaterMark"}},{"kind":"Field","name":{"kind":"Name","value":"annualReset"}},{"kind":"Field","name":{"kind":"Name","value":"hurdle"}},{"kind":"Field","name":{"kind":"Name","value":"hurdleBenchmark"}},{"kind":"Field","name":{"kind":"Name","value":"standardShareClassRates"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChanged"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChangedNotes"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFees"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFeesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peIncentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitment"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitmentCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvest"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvestCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"hasMgmtFeeStepDown"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownPercent"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownCalcEnumId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGate"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentNav"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentCapital"}},{"kind":"Field","name":{"kind":"Name","value":"exceptions"}},{"kind":"Field","name":{"kind":"Name","value":"hasLockup"}},{"kind":"Field","name":{"kind":"Name","value":"lockupValue"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"lockupMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityValue"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"cashAvailableDays"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValue"}},{"kind":"Field","name":{"kind":"Name","value":"noticeBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"hasHoldback"}},{"kind":"Field","name":{"kind":"Name","value":"holdbackPercent"}},{"kind":"Field","name":{"kind":"Name","value":"workoutId"}},{"kind":"Field","name":{"kind":"Name","value":"modelingNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peLiquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredReturn"}},{"kind":"Field","name":{"kind":"Name","value":"isCompounded"}},{"kind":"Field","name":{"kind":"Name","value":"compoundingPeriodId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatchupProvision"}},{"kind":"Field","name":{"kind":"Name","value":"catchupPercent"}},{"kind":"Field","name":{"kind":"Name","value":"optionOfExtensionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetShareClassProfileQuery, GetShareClassProfileQueryVariables>;
export const GetFeeCalcEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeeCalcEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeCalcEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeeCalcEnumQuery, GetFeeCalcEnumQueryVariables>;
export const GetFeeFreqEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeeFreqEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feeFreqEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetFeeFreqEnumQuery, GetFeeFreqEnumQueryVariables>;
export const GetPeMgmtFeeCalcEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPEMgmtFeeCalcEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeCalcEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetPeMgmtFeeCalcEnumQuery, GetPeMgmtFeeCalcEnumQueryVariables>;
export const GetCalendarUnitEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCalendarUnitEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calendarUnitEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCalendarUnitEnumQuery, GetCalendarUnitEnumQueryVariables>;
export const GetLockupEndValueEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLockupEndValueEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lockupEndValueEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLockupEndValueEnumQuery, GetLockupEndValueEnumQueryVariables>;
export const GetRightOfExtensionEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRightOfExtensionEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rightOfExtensionEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetRightOfExtensionEnumQuery, GetRightOfExtensionEnumQueryVariables>;
export const GetCompoundingPeriodEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompoundingPeriodEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"compoundingPeriodEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompoundingPeriodEnumQuery, GetCompoundingPeriodEnumQueryVariables>;
export const GetWorkoutEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWorkoutEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workoutEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetWorkoutEnumQuery, GetWorkoutEnumQueryVariables>;
export const GetCurrencyDenominationEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrencyDenominationEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isPerformanceCurrency"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"displayOrder"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]}}]} as unknown as DocumentNode<GetCurrencyDenominationEnumQuery, GetCurrencyDenominationEnumQueryVariables>;
export const GetPeInctFeeCalcEnumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPEInctFeeCalcEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"peInctFeeCalcEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetPeInctFeeCalcEnumQuery, GetPeInctFeeCalcEnumQueryVariables>;
export const GetExistingShareClassesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExistingShareClasses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareClassFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareClassList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"investmentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"restricted"}},{"kind":"Field","name":{"kind":"Name","value":"isRcgNegotiated"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFees"}},{"kind":"Field","name":{"kind":"Name","value":"investmentFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFee"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFee"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFee"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"highWaterMark"}},{"kind":"Field","name":{"kind":"Name","value":"annualReset"}},{"kind":"Field","name":{"kind":"Name","value":"hurdle"}},{"kind":"Field","name":{"kind":"Name","value":"hurdleBenchmark"}},{"kind":"Field","name":{"kind":"Name","value":"standardShareClassRates"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChanged"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChangedNotes"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFees"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFeesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peIncentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitment"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitmentCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvest"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvestCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"hasMgmtFeeStepDown"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownPercent"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownCalcEnumId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasGate"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentNav"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentCapital"}},{"kind":"Field","name":{"kind":"Name","value":"exceptions"}},{"kind":"Field","name":{"kind":"Name","value":"hasLockup"}},{"kind":"Field","name":{"kind":"Name","value":"lockupValue"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"lockupMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityValue"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"cashAvailableDays"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValue"}},{"kind":"Field","name":{"kind":"Name","value":"noticeBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"hasHoldback"}},{"kind":"Field","name":{"kind":"Name","value":"holdbackPercent"}},{"kind":"Field","name":{"kind":"Name","value":"workoutId"}},{"kind":"Field","name":{"kind":"Name","value":"modelingNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peLiquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"preferredReturn"}},{"kind":"Field","name":{"kind":"Name","value":"isCompounded"}},{"kind":"Field","name":{"kind":"Name","value":"compoundingPeriodId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatchupProvision"}},{"kind":"Field","name":{"kind":"Name","value":"catchupPercent"}},{"kind":"Field","name":{"kind":"Name","value":"optionOfExtensionId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetExistingShareClassesQuery, GetExistingShareClassesQueryVariables>;
export const UpdateShareClassDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateShareClass"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShareClassInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateShareClass"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateShareClassMutation, UpdateShareClassMutationVariables>;
export const GetBusinessApplicantDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBusinessApplicantDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"entities"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"businessObjectEnumId"},"value":{"kind":"IntValue","value":"3"}},{"kind":"ObjectField","name":{"kind":"Name","value":"entityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}},{"kind":"Field","name":{"kind":"Name","value":"signedThumbnailUrl"}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"accessLevel"}},{"kind":"Field","name":{"kind":"Name","value":"isGallery"}},{"kind":"Field","name":{"kind":"Name","value":"entityAssociations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"businessObjectTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"entityId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetBusinessApplicantDocumentsQuery, GetBusinessApplicantDocumentsQueryVariables>;
export const UploadBussinessApplicantDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadBussinessApplicantDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UploadBussinessApplicantDocumentMutation, UploadBussinessApplicantDocumentMutationVariables>;
export const DeleteBusinessApplicationDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteBusinessApplicationDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteBusinessApplicationDocumentMutation, DeleteBusinessApplicationDocumentMutationVariables>;
export const ChatSkillsForInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatSkillsForInput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myActiveChatSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ChatSkillsForInputQuery, ChatSkillsForInputQueryVariables>;
export const ChatAgentsForInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatAgentsForInput"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mySpawnableChatAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<ChatAgentsForInputQuery, ChatAgentsForInputQueryVariables>;
export const AddStoredPromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddStoredPrompts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoredPromptsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addStoredPrompts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]} as unknown as DocumentNode<AddStoredPromptsMutation, AddStoredPromptsMutationVariables>;
export const GetStoredPromptsListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStoredPromptsList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PageInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StoredPromptsSort"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StoredPromptsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPromptsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<GetStoredPromptsListQuery, GetStoredPromptsListQueryVariables>;
export const PresignedTempUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PresignedTempUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PresignedTempUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"presignedTempUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<PresignedTempUrlQuery, PresignedTempUrlQueryVariables>;
export const FirmDiligenceTabsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmDiligenceTabs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"diligenceTabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldSetType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<FirmDiligenceTabsQuery, FirmDiligenceTabsQueryVariables>;
export const CompanyDiligenceTabsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyDiligenceTabs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"diligenceTabs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fieldSetType"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]} as unknown as DocumentNode<CompanyDiligenceTabsQuery, CompanyDiligenceTabsQueryVariables>;
export const DiligenceGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"diligenceGaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"gapAnalysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"gaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldKey"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"whyItMatters"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<DiligenceGapsQuery, DiligenceGapsQueryVariables>;
export const AnalyseDiligenceGapsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"analyseDiligenceGaps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"analyseDiligenceGaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentId"}},{"kind":"Field","name":{"kind":"Name","value":"generatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"gaps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fieldKey"}},{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"questionText"}},{"kind":"Field","name":{"kind":"Name","value":"section"}},{"kind":"Field","name":{"kind":"Name","value":"severity"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}},{"kind":"Field","name":{"kind":"Name","value":"whyItMatters"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"suggestedSources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AnalyseDiligenceGapsMutation, AnalyseDiligenceGapsMutationVariables>;
export const AsyncDocumentProcessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"asyncDocumentProcess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"processName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncDocumentProcess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"processName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"processName"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}]}]}}]} as unknown as DocumentNode<AsyncDocumentProcessQuery, AsyncDocumentProcessQueryVariables>;
export const DocumentProcessChatMessageSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"DocumentProcessChatMessageSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"requestId"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"messageStream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"messageIndex"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"blockIndex"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DocumentProcessChatMessageSubscriptionSubscription, DocumentProcessChatMessageSubscriptionSubscriptionVariables>;
export const FirmEngagementFormTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmEngagementFormTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmEngagementTypeEnumList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]}}]} as unknown as DocumentNode<FirmEngagementFormTypesQuery, FirmEngagementFormTypesQueryVariables>;
export const FirmEngagementDocumentTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmEngagementDocumentType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"q"},"value":{"kind":"StringValue","value":"Firm Engagement Document","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<FirmEngagementDocumentTypeQuery, FirmEngagementDocumentTypeQueryVariables>;
export const FirmEngagementFormAddImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FirmEngagementFormAddImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FirmEngagementFormAddImageMutation, FirmEngagementFormAddImageMutationVariables>;
export const FirmEngagementFormAddDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FirmEngagementFormAddDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FirmEngagementFormAddDocumentMutation, FirmEngagementFormAddDocumentMutationVariables>;
export const FirmEngagementFormDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmEngagementFormDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirmEngagementFormFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmEngagementFormFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"imageDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<FirmEngagementFormDetailQuery, FirmEngagementFormDetailQueryVariables>;
export const AddFirmEngagementSharedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddFirmEngagementShared"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFirmEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirmEngagementFormFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmEngagementFormFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"imageDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AddFirmEngagementSharedMutation, AddFirmEngagementSharedMutationVariables>;
export const UpdateFirmEngagementSharedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFirmEngagementShared"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFirmEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirmEngagementFormFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmEngagementFormFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FirmEngagement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"firmEngagementGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"imageDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateFirmEngagementSharedMutation, UpdateFirmEngagementSharedMutationVariables>;
export const InvestmentCompletenessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"investmentCompleteness"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeness"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memoized"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"subcategory"}},{"kind":"Field","name":{"kind":"Name","value":"level"}},{"kind":"Field","name":{"kind":"Name","value":"weight"}},{"kind":"Field","name":{"kind":"Name","value":"percentComplete"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<InvestmentCompletenessQuery, InvestmentCompletenessQueryVariables>;
export const GetFirmsBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFirmsBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"nameSearchRank"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"q"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetFirmsBySearchQuery, GetFirmsBySearchQueryVariables>;
export const GetFirmByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFirmById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetFirmByIdQuery, GetFirmByIdQueryVariables>;
export const GetInvestmentsBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvestmentsBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"searchFilters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"SEARCH_TERM"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInvestmentsBySearchQuery, GetInvestmentsBySearchQueryVariables>;
export const GetInvestmentByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInvestmentById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetInvestmentByIdQuery, GetInvestmentByIdQueryVariables>;
export const GetCompaniesBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompaniesBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"nameSearchRank"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"q"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCompaniesBySearchQuery, GetCompaniesBySearchQueryVariables>;
export const GetCompanyByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompanyById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetCompanyByIdQuery, GetCompanyByIdQueryVariables>;
export const GetDealsBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDealsBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dealList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"q"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDealsBySearchQuery, GetDealsBySearchQueryVariables>;
export const GetDealByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDealById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deal"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDealByIdQuery, GetDealByIdQueryVariables>;
export const GetFirmEngagementsBySearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFirmEngagementsBySearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmEngagementList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"15"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"nameSearchRank"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"q"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchTerm"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFirmEngagementsBySearchQuery, GetFirmEngagementsBySearchQueryVariables>;
export const GetFirmEngagementByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFirmEngagementById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmEngagement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetFirmEngagementByIdQuery, GetFirmEngagementByIdQueryVariables>;
export const EntityCreateCanAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"entityCreateCanAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mutationName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mutationArgs"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userMutationAccessible"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mutationName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mutationName"}}},{"kind":"Argument","name":{"kind":"Name","value":"mutationArgs"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mutationArgs"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAccess"}}]}}]}}]} as unknown as DocumentNode<EntityCreateCanAccessQuery, EntityCreateCanAccessQueryVariables>;
export const EntityCreateFirmNearMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"entityCreateFirmNearMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fuzzyTerm"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"fuzzyRank"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EntityCreateFirmNearMatchesQuery, EntityCreateFirmNearMatchesQueryVariables>;
export const EntityCreateInvestmentNearMatchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"entityCreateInvestmentNearMatches"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchFilters"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"FUZZY_TERM"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"fuzzyRank"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EntityCreateInvestmentNearMatchesQuery, EntityCreateInvestmentNearMatchesQueryVariables>;
export const EntityCreateInvestmentEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"entityCreateInvestmentEnums"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentListEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"name"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assetClassEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"displayOrder"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"200"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"strategyEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"name"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"500"}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"0"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EntityCreateInvestmentEnumsQuery, EntityCreateInvestmentEnumsQueryVariables>;
export const EntityCreateAddFirmDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"entityCreateAddFirm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FirmInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addFirm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EntityCreateAddFirmMutation, EntityCreateAddFirmMutationVariables>;
export const EntityCreateAddInvestmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"entityCreateAddInvestment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvestmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addInvestment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firm"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<EntityCreateAddInvestmentMutation, EntityCreateAddInvestmentMutationVariables>;
export const AddDocumentQueueSignedUriDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addDocumentQueueSignedURI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"names"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDocumentQueueSignedURI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"names"},"value":{"kind":"Variable","name":{"kind":"Name","value":"names"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","alias":{"kind":"Name","value":"documentQueueId"},"name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddDocumentQueueSignedUriMutation, AddDocumentQueueSignedUriMutationVariables>;
export const GetDocumentQueuesByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentQueuesByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentQueueMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"queueDate"}},{"kind":"Field","name":{"kind":"Name","value":"documentsId"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"llmEntityId"}},{"kind":"Field","name":{"kind":"Name","value":"llmEntityNotes"}},{"kind":"Field","name":{"kind":"Name","value":"llmEntityTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"llmEntityTypeNotes"}},{"kind":"Field","name":{"kind":"Name","value":"llmAsOfDate"}},{"kind":"Field","name":{"kind":"Name","value":"llmAsOfDateNotes"}},{"kind":"Field","name":{"kind":"Name","value":"llmDocumentTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"llmDocumentTypeEnumNotes"}},{"kind":"Field","name":{"kind":"Name","value":"llmProcessedAt"}},{"kind":"Field","name":{"kind":"Name","value":"duplicateDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentQueuesByIdsQuery, GetDocumentQueuesByIdsQueryVariables>;
export const ProcessDocumentQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"processDocumentQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentQueueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processDocumentQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"documentQueueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentQueueId"}}}]}]}}]} as unknown as DocumentNode<ProcessDocumentQueueMutation, ProcessDocumentQueueMutationVariables>;
export const PublishDocumentQueuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"publishDocumentQueues"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentQueuePublishInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"publishDocumentQueues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentQueueId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentName"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<PublishDocumentQueuesMutation, PublishDocumentQueuesMutationVariables>;
export const GetBusinessObjectEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBusinessObjectEnums"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BusinessObjectEnumFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"businessObjectEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetBusinessObjectEnumsQuery, GetBusinessObjectEnumsQueryVariables>;
export const GetDocumentAccessLevelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAccessLevels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentAccessLevelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentAccessLevelList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentAccessLevelsQuery, GetDocumentAccessLevelsQueryVariables>;
export const GetDocumentTypeEnumsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentTypeEnums"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentTypeEnumFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnumList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"name"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentTypeEnumsQuery, GetDocumentTypeEnumsQueryVariables>;
export const DeleteDocumentQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteDocumentQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocumentQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDocumentQueueMutation, DeleteDocumentQueueMutationVariables>;
export const GetDocumentAuthGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDocumentAuthGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"groupEntityType"},"value":{"kind":"EnumValue","value":"document"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentAuthGroupsQuery, GetDocumentAuthGroupsQueryVariables>;
export const GetKnowledgeBaseTagsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKnowledgeBaseTags"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KnowledgeBaseTagsFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"knowledgeBaseTagsList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"id"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"ASC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]}}]} as unknown as DocumentNode<GetKnowledgeBaseTagsQuery, GetKnowledgeBaseTagsQueryVariables>;
export const AddKnowledgeBaseTagDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"addKnowledgeBaseTag"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KnowledgeBaseTagsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addKnowledgeBaseTags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<AddKnowledgeBaseTagMutation, AddKnowledgeBaseTagMutationVariables>;
export const MutationPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MutationPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mutationPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sequence"}},{"kind":"Field","name":{"kind":"Name","value":"mutationName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"input"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSchema"}},{"kind":"Field","name":{"kind":"Name","value":"lockedFields"}},{"kind":"Field","name":{"kind":"Name","value":"liveSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"valueLabels"}},{"kind":"Field","name":{"kind":"Name","value":"previousState"}},{"kind":"Field","name":{"kind":"Name","value":"resultLinks"}},{"kind":"Field","name":{"kind":"Name","value":"filePreviewUrl"}},{"kind":"Field","name":{"kind":"Name","value":"dataSources"}}]}}]}}]}}]} as unknown as DocumentNode<MutationPlanQuery, MutationPlanQueryVariables>;
export const ApproveMutationPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApproveMutationPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveMutationPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<ApproveMutationPlanMutation, ApproveMutationPlanMutationVariables>;
export const CancelMutationPlanDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelMutationPlan"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelMutationPlan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}]}]}}]} as unknown as DocumentNode<CancelMutationPlanMutation, CancelMutationPlanMutationVariables>;
export const UpdateMutationStepInputDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateMutationStepInput"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JSON"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateMutationStepInput"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"stepId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"stepId"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"input"}}]}}]}}]} as unknown as DocumentNode<UpdateMutationStepInputMutation, UpdateMutationStepInputMutationVariables>;
export const RetryFailedStepsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryFailedSteps"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"planId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retryFailedSteps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"planId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"planId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<RetryFailedStepsMutation, RetryFailedStepsMutationVariables>;
export const NotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Notifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"subjectType"}},{"kind":"Field","name":{"kind":"Name","value":"subjectId"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"hasArtifact"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"readAt"}}]}}]}}]} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const NotificationArtifactUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationArtifactUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationArtifactUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<NotificationArtifactUrlQuery, NotificationArtifactUrlQueryVariables>;
export const MarkNotificationsReadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkNotificationsRead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markNotificationsRead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}]}}]} as unknown as DocumentNode<MarkNotificationsReadMutation, MarkNotificationsReadMutationVariables>;
export const MutedNotificationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MutedNotificationCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mutedNotificationCount"}}]}}]} as unknown as DocumentNode<MutedNotificationCountQuery, MutedNotificationCountQueryVariables>;
export const NotificationEventPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NotificationEventPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notificationEventPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"requiresSubscription"}},{"kind":"Field","name":{"kind":"Name","value":"subscribedDirectly"}},{"kind":"Field","name":{"kind":"Name","value":"subscribedViaGroup"}},{"kind":"Field","name":{"kind":"Name","value":"toast"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"usingDefaults"}}]}}]}}]} as unknown as DocumentNode<NotificationEventPreferencesQuery, NotificationEventPreferencesQueryVariables>;
export const AgentChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AgentChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"question"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatContext"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatContext"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tools"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatToolType"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"model"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"effort"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatEffort"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludedMcpCategories"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiriusMcpCategory"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"question"},"value":{"kind":"Variable","name":{"kind":"Name","value":"question"}}},{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chatContext"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatContext"}}},{"kind":"Argument","name":{"kind":"Name","value":"tools"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tools"}}},{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}},{"kind":"Argument","name":{"kind":"Name","value":"model"},"value":{"kind":"Variable","name":{"kind":"Name","value":"model"}}},{"kind":"Argument","name":{"kind":"Name","value":"effort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"effort"}}},{"kind":"Argument","name":{"kind":"Name","value":"excludedMcpCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludedMcpCategories"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationId"}}]}}]}}]} as unknown as DocumentNode<AgentChatQuery, AgentChatQueryVariables>;
export const RangerChatSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"RangerChatSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangerChatSubscription"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toolId"}},{"kind":"Field","name":{"kind":"Name","value":"toolCallId"}},{"kind":"Field","name":{"kind":"Name","value":"tool"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}},{"kind":"Field","name":{"kind":"Name","value":"params"}},{"kind":"Field","name":{"kind":"Name","value":"results"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"messageStream"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"messageIndex"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"blockIndex"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RangerChatSubscriptionSubscription, RangerChatSubscriptionSubscriptionVariables>;
export const StopChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StopChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stopChat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sessionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sessionId"}}}]}]}}]} as unknown as DocumentNode<StopChatMutation, StopChatMutationVariables>;
export const GetSavedKnowledgeBaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedKnowledgeBase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedKnowledgeBase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"filters"}},{"kind":"Field","name":{"kind":"Name","value":"noteCount"}},{"kind":"Field","name":{"kind":"Name","value":"documentCount"}},{"kind":"Field","name":{"kind":"Name","value":"investmentCount"}},{"kind":"Field","name":{"kind":"Name","value":"firmCount"}},{"kind":"Field","name":{"kind":"Name","value":"companyCount"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetSavedKnowledgeBaseQuery, GetSavedKnowledgeBaseQueryVariables>;
export const MyConversationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyConversations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sources"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConversationSource"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myConversations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"sources"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sources"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastActivityDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasMutationPlans"}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<MyConversationsQuery, MyConversationsQueryVariables>;
export const LoadConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"question"}},{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"createDate"}},{"kind":"Field","name":{"kind":"Name","value":"chatContext"}}]}}]}}]} as unknown as DocumentNode<LoadConversationQuery, LoadConversationQueryVariables>;
export const MutationPlansByConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MutationPlansByConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mutationPlansByConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<MutationPlansByConversationQuery, MutationPlansByConversationQueryVariables>;
export const ConversationArtifactsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ConversationArtifacts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationArtifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artifactName"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}}]}}]}}]} as unknown as DocumentNode<ConversationArtifactsQuery, ConversationArtifactsQueryVariables>;
export const ChatReportFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatReportFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationArtifacts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"downloadUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<ChatReportFilesQuery, ChatReportFilesQueryVariables>;
export const ChatTaskFinishedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ChatTaskFinished"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatTaskFinished"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"taskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"taskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskId"}}]}}]}}]} as unknown as DocumentNode<ChatTaskFinishedSubscription, ChatTaskFinishedSubscriptionVariables>;
export const DeleteStoredPromptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteStoredPrompt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteStoredPrompts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteStoredPromptMutation, DeleteStoredPromptMutationVariables>;
export const DeleteConversationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConversation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConversation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}]}]}}]} as unknown as DocumentNode<DeleteConversationMutation, DeleteConversationMutationVariables>;
export const CurrentUserChatPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CurrentUserChatPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUserSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"preferences"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserChatPreferencesQuery, CurrentUserChatPreferencesQueryVariables>;
export const UpdateChatPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChatPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettingsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addOrUpdateUserSettings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateChatPreferencesMutation, UpdateChatPreferencesMutationVariables>;
export const MyActiveChatSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyActiveChatSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myActiveChatSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"isAutoInvocable"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}}]}}]} as unknown as DocumentNode<MyActiveChatSkillsQuery, MyActiveChatSkillsQueryVariables>;
export const AvailableOrgChatSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AvailableOrgChatSkills"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"availableOrgChatSkills"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"isAutoInvocable"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}}]}}]}}]} as unknown as DocumentNode<AvailableOrgChatSkillsQuery, AvailableOrgChatSkillsQueryVariables>;
export const CreateChatSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatSkillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChatSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"isAutoInvocable"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}}]}}]}}]} as unknown as DocumentNode<CreateChatSkillMutation, CreateChatSkillMutationVariables>;
export const UpdateChatSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChatSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatSkillUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChatSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"isAutoInvocable"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}}]}}]}}]} as unknown as DocumentNode<UpdateChatSkillMutation, UpdateChatSkillMutationVariables>;
export const DeleteChatSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChatSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChatSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteChatSkillMutation, DeleteChatSkillMutationVariables>;
export const OptInToChatSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OptInToChatSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optInToChatSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSkillId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSkillId"}}]}}]}}]} as unknown as DocumentNode<OptInToChatSkillMutation, OptInToChatSkillMutationVariables>;
export const OptOutOfChatSkillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OptOutOfChatSkill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"optOutOfChatSkill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSkillId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}}}]}]}}]} as unknown as DocumentNode<OptOutOfChatSkillMutation, OptOutOfChatSkillMutationVariables>;
export const SystemChatSkillsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SystemChatSkills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSkillsByScope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scope"},"value":{"kind":"EnumValue","value":"SYSTEM"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"isAutoInvocable"}}]}}]}}]} as unknown as DocumentNode<SystemChatSkillsQuery, SystemChatSkillsQueryVariables>;
export const ChatSkillGroupAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatSkillGroupAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSkillGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSkillId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSkillId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"access"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}}]}}]}}]} as unknown as DocumentNode<ChatSkillGroupAccessQuery, ChatSkillGroupAccessQueryVariables>;
export const GrantChatSkillGroupAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GrantChatSkillGroupAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantChatSkillGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSkillId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}}]}}]}}]} as unknown as DocumentNode<GrantChatSkillGroupAccessMutation, GrantChatSkillGroupAccessMutationVariables>;
export const RevokeChatSkillGroupAccessDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RevokeChatSkillGroupAccess"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"revokeChatSkillGroupAccess"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chatSkillId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chatSkillId"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupId"}}}]}]}}]} as unknown as DocumentNode<RevokeChatSkillGroupAccessMutation, RevokeChatSkillGroupAccessMutationVariables>;
export const ChatSkillGrantableGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatSkillGrantableGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"q"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSkillGrantableGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"q"},"value":{"kind":"Variable","name":{"kind":"Name","value":"q"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ChatSkillGrantableGroupsQuery, ChatSkillGrantableGroupsQueryVariables>;
export const ChatSkillHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatSkillHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSkillHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedBy"}},{"kind":"Field","name":{"kind":"Name","value":"archivedByFullName"}}]}}]}}]} as unknown as DocumentNode<ChatSkillHistoryQuery, ChatSkillHistoryQueryVariables>;
export const MyChatSkillSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MyChatSkillSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatSkillScheduleList"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"field"},"value":{"kind":"EnumValue","value":"createdate"}},{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"EnumValue","value":"DESC"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"chatSkillId"}},{"kind":"Field","name":{"kind":"Name","value":"frequency"}},{"kind":"Field","name":{"kind":"Name","value":"runAtHour"}},{"kind":"Field","name":{"kind":"Name","value":"runAtMinute"}},{"kind":"Field","name":{"kind":"Name","value":"runOnWeekday"}},{"kind":"Field","name":{"kind":"Name","value":"runOnDayOfMonth"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"extraInstructions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"nextRunAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastRunAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastRunStatus"}},{"kind":"Field","name":{"kind":"Name","value":"lastConversationId"}}]}}]}}]}}]} as unknown as DocumentNode<MyChatSkillSchedulesQuery, MyChatSkillSchedulesQueryVariables>;
export const AddChatSkillScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddChatSkillSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatSkillScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addChatSkillSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddChatSkillScheduleMutation, AddChatSkillScheduleMutationVariables>;
export const UpdateChatSkillScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChatSkillSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatSkillScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChatSkillSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateChatSkillScheduleMutation, UpdateChatSkillScheduleMutationVariables>;
export const DeleteChatSkillScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChatSkillSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChatSkillSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteChatSkillScheduleMutation, DeleteChatSkillScheduleMutationVariables>;
export const RunChatSkillScheduleNowDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RunChatSkillScheduleNow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runChatSkillScheduleNow"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RunChatSkillScheduleNowMutation, RunChatSkillScheduleNowMutationVariables>;
export const MySpawnableChatAgentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MySpawnableChatAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mySpawnableChatAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directive"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMode"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MySpawnableChatAgentsQuery, MySpawnableChatAgentsQueryVariables>;
export const ChatAgentsByScopeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatAgentsByScope"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scope"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatSkillScope"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatAgentsByScope"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scope"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scope"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directive"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMode"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ChatAgentsByScopeQuery, ChatAgentsByScopeQueryVariables>;
export const CreateChatAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateChatAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatAgentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createChatAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directive"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMode"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateChatAgentMutation, CreateChatAgentMutationVariables>;
export const UpdateChatAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateChatAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChatAgentUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateChatAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directive"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"color"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMode"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"createUser"}},{"kind":"Field","name":{"kind":"Name","value":"createUserFullName"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}},{"kind":"Field","name":{"kind":"Name","value":"canDelete"}},{"kind":"Field","name":{"kind":"Name","value":"skills"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateChatAgentMutation, UpdateChatAgentMutationVariables>;
export const DeleteChatAgentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteChatAgent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteChatAgent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteChatAgentMutation, DeleteChatAgentMutationVariables>;
export const ChatAgentHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatAgentHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatAgentHistory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"version"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"directive"}},{"kind":"Field","name":{"kind":"Name","value":"tools"}},{"kind":"Field","name":{"kind":"Name","value":"model"}},{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"defaultMode"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"skills"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedBy"}}]}}]}}]} as unknown as DocumentNode<ChatAgentHistoryQuery, ChatAgentHistoryQueryVariables>;
export const ChatAgentCapabilitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatAgentCapabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatAgentCapabilities"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowedModels"}},{"kind":"Field","name":{"kind":"Name","value":"allowedEfforts"}},{"kind":"Field","name":{"kind":"Name","value":"allowedColors"}},{"kind":"Field","name":{"kind":"Name","value":"blockedTools"}},{"kind":"Field","name":{"kind":"Name","value":"mcpToolBundles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"mcpToolCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"notOfferedToAgents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tools"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ChatAgentCapabilitiesQuery, ChatAgentCapabilitiesQueryVariables>;
export const LlmModelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LlmModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"llmModels"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"supportsEffort"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEffort"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedRoles"}},{"kind":"Field","name":{"kind":"Name","value":"intelligenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokensPerSecond"}},{"kind":"Field","name":{"kind":"Name","value":"blendedPricePer1M"}},{"kind":"Field","name":{"kind":"Name","value":"effortBenchmarks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"effort"}},{"kind":"Field","name":{"kind":"Name","value":"intelligenceIndex"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokensPerSecond"}}]}},{"kind":"Field","name":{"kind":"Name","value":"behavior"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feature"}},{"kind":"Field","name":{"kind":"Name","value":"limited"}}]}}]}}]}}]} as unknown as DocumentNode<LlmModelsQuery, LlmModelsQueryVariables>;
export const DocumentRangerChatLinkQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"documentRangerChatLinkQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DocumentRangerChatLinkQueryQuery, DocumentRangerChatLinkQueryQueryVariables>;
export const GetReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"format"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FormatOptions"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"Variable","name":{"kind":"Name","value":"format"}}}]}]}}]} as unknown as DocumentNode<GetReportQuery, GetReportQueryVariables>;
export const GetCaseStudyReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getCaseStudyReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseStudyReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<GetCaseStudyReportQuery, GetCaseStudyReportQueryVariables>;
export const GetRiskVisualizationsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRiskVisualizationsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"portfolioId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskVisualizationsData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"portfolioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"portfolioId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<GetRiskVisualizationsDataQuery, GetRiskVisualizationsDataQueryVariables>;
export const Fetch_Company_TemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_COMPANY_TEMPLATE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldSetType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]},{"kind":"Field","name":{"kind":"Name","value":"fieldData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMeta"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSet"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSetType"}},{"kind":"Field","name":{"kind":"Name","value":"strategyName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<Fetch_Company_TemplateQuery, Fetch_Company_TemplateQueryVariables>;
export const Fetch_Firm_TemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_FIRM_TEMPLATE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldSetType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]},{"kind":"Field","name":{"kind":"Name","value":"fieldData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMeta"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSet"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSetType"}},{"kind":"Field","name":{"kind":"Name","value":"strategyName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<Fetch_Firm_TemplateQuery, Fetch_Firm_TemplateQueryVariables>;
export const Fetch_Investment_TemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FETCH_INVESTMENT_TEMPLATE"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldSetType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"version"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"publishedFieldState"}},{"kind":"Field","name":{"kind":"Name","value":"templateOptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]},{"kind":"Field","name":{"kind":"Name","value":"fieldData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldSetType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"Argument","name":{"kind":"Name","value":"version"},"value":{"kind":"Variable","name":{"kind":"Name","value":"version"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assetClassName"}},{"kind":"Field","name":{"kind":"Name","value":"fieldMeta"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSet"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSetType"}},{"kind":"Field","name":{"kind":"Name","value":"strategyName"}},{"kind":"Field","name":{"kind":"Name","value":"version"}}]}}]}}]}}]} as unknown as DocumentNode<Fetch_Investment_TemplateQuery, Fetch_Investment_TemplateQueryVariables>;
export const RangerDueDilligenceDraftsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"rangerDueDilligenceDrafts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldKeys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customPromptsInput"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomPromptsInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ragLimits"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangerDueDilligenceDrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"fieldKeys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldKeys"}}},{"kind":"Argument","name":{"kind":"Name","value":"customPromptsInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customPromptsInput"}}},{"kind":"Argument","name":{"kind":"Name","value":"retain"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"ragLimits"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ragLimits"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RangerDueDilligenceDraftsMutation, RangerDueDilligenceDraftsMutationVariables>;
export const GetAsyncTaskStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAsyncTaskStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncTaskStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<GetAsyncTaskStatusQuery, GetAsyncTaskStatusQueryVariables>;
export const RangerDueDiligenceDraftsReturnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"rangerDueDiligenceDraftsReturn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getRangerDueDiligenceDrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<RangerDueDiligenceDraftsReturnQuery, RangerDueDiligenceDraftsReturnQueryVariables>;
export const StoredPromptFromFieldKeyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StoredPromptFromFieldKey"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fieldKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"storedPromptFromFieldKey"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"fieldKey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fieldKey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}}]} as unknown as DocumentNode<StoredPromptFromFieldKeyQuery, StoredPromptFromFieldKeyQueryVariables>;
export const AddDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]} as unknown as DocumentNode<AddDocumentMutation, AddDocumentMutationVariables>;
export const DeleteDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const CitationDocumentManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CitationDocumentMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"signedUrl"}}]}}]}}]} as unknown as DocumentNode<CitationDocumentManyQuery, CitationDocumentManyQueryVariables>;
export const CitationNoteManyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CitationNoteMany"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"noteIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notesMany"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ids"},"value":{"kind":"Variable","name":{"kind":"Name","value":"noteIds"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"noteDate"}}]}}]}}]} as unknown as DocumentNode<CitationNoteManyQuery, CitationNoteManyQueryVariables>;
export const RangerDraftStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RangerDraftStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rangerDraftStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentId"}},{"kind":"Field","name":{"kind":"Name","value":"lastRunAt"}},{"kind":"Field","name":{"kind":"Name","value":"staleFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldKey"}},{"kind":"Field","name":{"kind":"Name","value":"markedAt"}},{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastRun"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"runId"}},{"kind":"Field","name":{"kind":"Name","value":"ranAt"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ownerType"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"fieldKey"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"oldValue"}},{"kind":"Field","name":{"kind":"Name","value":"newValue"}},{"kind":"Field","name":{"kind":"Name","value":"triggeredBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"citations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RangerDraftStatusQuery, RangerDraftStatusQueryVariables>;
export const RerunStaleRangerFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RerunStaleRangerFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rerunStaleRangerFields"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RerunStaleRangerFieldsMutation, RerunStaleRangerFieldsMutationVariables>;
export const ApplyRangerSuggestionToInvestmentDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyRangerSuggestionToInvestmentDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveInvestmentFieldDrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}},{"kind":"Argument","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<ApplyRangerSuggestionToInvestmentDraftMutation, ApplyRangerSuggestionToInvestmentDraftMutationVariables>;
export const ApplyRangerSuggestionToFirmDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyRangerSuggestionToFirmDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"values"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldValueInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveFirmFieldDrafts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"firmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"values"},"value":{"kind":"Variable","name":{"kind":"Name","value":"values"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<ApplyRangerSuggestionToFirmDraftMutation, ApplyRangerSuggestionToFirmDraftMutationVariables>;
export const RangerRerunTaskStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RangerRerunTaskStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asyncTaskStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<RangerRerunTaskStatusQuery, RangerRerunTaskStatusQueryVariables>;
export const CurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"sub"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"commonName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"imageType"}},{"kind":"Field","name":{"kind":"Name","value":"imageTypeSm"}},{"kind":"Field","name":{"kind":"Name","value":"entryTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"flags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFlagList"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserSettingsAttributes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currentUserId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserFlagList"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserFlags"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"DCAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isRockCreek"}},{"kind":"Field","name":{"kind":"Name","value":"isSubscriptionUser"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberDataAccess"}},{"kind":"Field","name":{"kind":"Name","value":"isDataManager"}},{"kind":"Field","name":{"kind":"Name","value":"anyUser"}},{"kind":"Field","name":{"kind":"Name","value":"businessApplicant"}},{"kind":"Field","name":{"kind":"Name","value":"isSuperUser"}},{"kind":"Field","name":{"kind":"Name","value":"RECFReviewer"}},{"kind":"Field","name":{"kind":"Name","value":"canAssumeUser"}},{"kind":"Field","name":{"kind":"Name","value":"canSiriusChat"}},{"kind":"Field","name":{"kind":"Name","value":"isClientUser"}},{"kind":"Field","name":{"kind":"Name","value":"isPortalUser"}},{"kind":"Field","name":{"kind":"Name","value":"investmentPageAccess"}},{"kind":"Field","name":{"kind":"Name","value":"coreUser"}},{"kind":"Field","name":{"kind":"Name","value":"isEditPrimary"}},{"kind":"Field","name":{"kind":"Name","value":"isComplianceUser"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserSettingsAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserSettings"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultInvestmentView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const AddTempFilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTempFiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TempFileUpload"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTempFiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"bucket"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"suggestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"date"}}]}}]}}]}}]} as unknown as DocumentNode<AddTempFilesMutation, AddTempFilesMutationVariables>;
export const ProfileBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProfileBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"investmentProfileBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"investmentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvestmentProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvestmentProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedInvestmentProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"inceptionDate"}},{"kind":"Field","name":{"kind":"Name","value":"isImpact"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"marketEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"vehicleTypeEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"assetClassEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"strategyEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peStrategyEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryGeographicFocusId"}},{"kind":"Field","name":{"kind":"Name","value":"primaryBenchmarkId"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryBenchmarkId"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"vintageYear"}},{"kind":"Field","name":{"kind":"Name","value":"peLegalLifeYrs"}},{"kind":"Field","name":{"kind":"Name","value":"gpCommitted"}},{"kind":"Field","name":{"kind":"Name","value":"committedCapital"}},{"kind":"Field","name":{"kind":"Name","value":"targetRaise"}},{"kind":"Field","name":{"kind":"Name","value":"minTargetNetMOIC"}},{"kind":"Field","name":{"kind":"Name","value":"minTargetNetIRR"}},{"kind":"Field","name":{"kind":"Name","value":"maxTargetNetMOIC"}},{"kind":"Field","name":{"kind":"Name","value":"maxTargetNetIRR"}}]}}]} as unknown as DocumentNode<ProfileBuilderQuery, ProfileBuilderQueryVariables>;
export const FirmProfileFromUrlBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FirmProfileFromUrlBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmProfileFromUrlBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"firmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"firmProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FirmProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FirmProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedFirmProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"yearFounded"}},{"kind":"Field","name":{"kind":"Name","value":"cik"}},{"kind":"Field","name":{"kind":"Name","value":"lei"}},{"kind":"Field","name":{"kind":"Name","value":"crd"}},{"kind":"Field","name":{"kind":"Name","value":"firmIrEmail"}},{"kind":"Field","name":{"kind":"Name","value":"registeredWithIds"}},{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"line3"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"countryEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"stateEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"zipCode"}},{"kind":"Field","name":{"kind":"Name","value":"website"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}}]}},{"kind":"Field","name":{"kind":"Name","value":"employeeTotal"}},{"kind":"Field","name":{"kind":"Name","value":"portfolioManagerCount"}},{"kind":"Field","name":{"kind":"Name","value":"investmentCount"}},{"kind":"Field","name":{"kind":"Name","value":"analystCount"}},{"kind":"Field","name":{"kind":"Name","value":"traderCount"}},{"kind":"Field","name":{"kind":"Name","value":"operationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"administrativeCount"}},{"kind":"Field","name":{"kind":"Name","value":"investorRelationsCount"}},{"kind":"Field","name":{"kind":"Name","value":"legalCount"}}]}}]} as unknown as DocumentNode<FirmProfileFromUrlBuilderQuery, FirmProfileFromUrlBuilderQueryVariables>;
export const ShareClassProfileBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ShareClassProfileBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shareClassProfileBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"Keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}}},{"kind":"Argument","name":{"kind":"Name","value":"investmentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"investmentId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"shareClassProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ShareClassProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ShareClassProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedShareClassProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"restricted"}},{"kind":"Field","name":{"kind":"Name","value":"isRcgNegotiated"}},{"kind":"Field","name":{"kind":"Name","value":"FAS157"}},{"kind":"Field","name":{"kind":"Name","value":"currencyDenominationEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFees"}},{"kind":"Field","name":{"kind":"Name","value":"investmentFees"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mgmtFee"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"mgmtFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFee"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"incentiveFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFee"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"otherFeeFreqEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"highWaterMark"}},{"kind":"Field","name":{"kind":"Name","value":"annualReset"}},{"kind":"Field","name":{"kind":"Name","value":"hurdle"}},{"kind":"Field","name":{"kind":"Name","value":"hurdleBenchmark"}},{"kind":"Field","name":{"kind":"Name","value":"standardShareClassRates"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChanged"}},{"kind":"Field","name":{"kind":"Name","value":"feeStructureChangedNotes"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFees"}},{"kind":"Field","name":{"kind":"Name","value":"abnormalFeesNotes"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peIncentiveFeeCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitment"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringCommitmentCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvest"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeDuringHarvestCalcEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"hasMgmtFeeStepDown"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownPercent"}},{"kind":"Field","name":{"kind":"Name","value":"peMgmtFeeStepDownCalcEnumId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"liquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasGate"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentNav"}},{"kind":"Field","name":{"kind":"Name","value":"gatePercentCapital"}},{"kind":"Field","name":{"kind":"Name","value":"exceptions"}},{"kind":"Field","name":{"kind":"Name","value":"hasRollover"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverValue"}},{"kind":"Field","name":{"kind":"Name","value":"rolloverUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"hasLockup"}},{"kind":"Field","name":{"kind":"Name","value":"lockupValue"}},{"kind":"Field","name":{"kind":"Name","value":"lockupUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"lockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndValueId"}},{"kind":"Field","name":{"kind":"Name","value":"secondLockupEndBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"lockupMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionValue"}},{"kind":"Field","name":{"kind":"Name","value":"subscriptionUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityValue"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityMonthlyValue"}},{"kind":"Field","name":{"kind":"Name","value":"cashAvailableDays"}},{"kind":"Field","name":{"kind":"Name","value":"noticeValue"}},{"kind":"Field","name":{"kind":"Name","value":"noticeUnitId"}},{"kind":"Field","name":{"kind":"Name","value":"noticeBizDays"}},{"kind":"Field","name":{"kind":"Name","value":"hasHoldback"}},{"kind":"Field","name":{"kind":"Name","value":"holdbackPercent"}},{"kind":"Field","name":{"kind":"Name","value":"workoutId"}},{"kind":"Field","name":{"kind":"Name","value":"modelingNotes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"peLiquidity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredReturn"}},{"kind":"Field","name":{"kind":"Name","value":"isCompounded"}},{"kind":"Field","name":{"kind":"Name","value":"compoundingPeriodId"}},{"kind":"Field","name":{"kind":"Name","value":"hasCatchupProvision"}},{"kind":"Field","name":{"kind":"Name","value":"catchupPercent"}},{"kind":"Field","name":{"kind":"Name","value":"optionOfExtensionId"}}]}}]}}]} as unknown as DocumentNode<ShareClassProfileBuilderQuery, ShareClassProfileBuilderQueryVariables>;
export const PersonProfileFromUrlBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonProfileFromUrlBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"personId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personProfileFromUrlBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}},{"kind":"Argument","name":{"kind":"Name","value":"personId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"personId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"personProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedPersonProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email2"}},{"kind":"Field","name":{"kind":"Name","value":"isCFA"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"titleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"educationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"workExperienceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"firmEmployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeRoleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"isFounder"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyPersonnel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diversity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"africanAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"asian"}},{"kind":"Field","name":{"kind":"Name","value":"hispanic"}},{"kind":"Field","name":{"kind":"Name","value":"lgbtq"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"veteran"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"woman"}},{"kind":"Field","name":{"kind":"Name","value":"nonBinary"}},{"kind":"Field","name":{"kind":"Name","value":"hawaiianOrPacificIslander"}}]}}]}}]} as unknown as DocumentNode<PersonProfileFromUrlBuilderQuery, PersonProfileFromUrlBuilderQueryVariables>;
export const PersonProfileFromFilesBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PersonProfileFromFilesBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"personProfileFromFilesBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"personProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedPersonProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email2"}},{"kind":"Field","name":{"kind":"Name","value":"isCFA"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"titleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"educationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"workExperienceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"firmEmployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeRoleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"isFounder"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyPersonnel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diversity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"africanAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"asian"}},{"kind":"Field","name":{"kind":"Name","value":"hispanic"}},{"kind":"Field","name":{"kind":"Name","value":"lgbtq"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"veteran"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"woman"}},{"kind":"Field","name":{"kind":"Name","value":"nonBinary"}},{"kind":"Field","name":{"kind":"Name","value":"hawaiianOrPacificIslander"}}]}}]}}]} as unknown as DocumentNode<PersonProfileFromFilesBuilderQuery, PersonProfileFromFilesBuilderQueryVariables>;
export const BulkPersonProfileFromFilesBuilderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BulkPersonProfileFromFilesBuilder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bulkPersonProfileFromFilesBuilder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"keys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}},{"kind":"Argument","name":{"kind":"Name","value":"bucket"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bucket"}}},{"kind":"Argument","name":{"kind":"Name","value":"firmId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"firmId"}}},{"kind":"Argument","name":{"kind":"Name","value":"conversationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"conversationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answer"}},{"kind":"Field","name":{"kind":"Name","value":"conversationId"}},{"kind":"Field","name":{"kind":"Name","value":"personProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PersonProfileFragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PersonProfileFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GeneratedPersonProfile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"middleName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"phone2"}},{"kind":"Field","name":{"kind":"Name","value":"fax"}},{"kind":"Field","name":{"kind":"Name","value":"fax2"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"email2"}},{"kind":"Field","name":{"kind":"Name","value":"isCFA"}},{"kind":"Field","name":{"kind":"Name","value":"biography"}},{"kind":"Field","name":{"kind":"Name","value":"titleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"educationSummary"}},{"kind":"Field","name":{"kind":"Name","value":"pronouns"}},{"kind":"Field","name":{"kind":"Name","value":"workExperienceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"comments"}},{"kind":"Field","name":{"kind":"Name","value":"linkedin"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"firmEmployment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firmId"}},{"kind":"Field","name":{"kind":"Name","value":"firmName"}},{"kind":"Field","name":{"kind":"Name","value":"employeeRoleEnumId"}},{"kind":"Field","name":{"kind":"Name","value":"jobDescription"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"isFounder"}},{"kind":"Field","name":{"kind":"Name","value":"isKeyPersonnel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diversity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"africanAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"asian"}},{"kind":"Field","name":{"kind":"Name","value":"hispanic"}},{"kind":"Field","name":{"kind":"Name","value":"lgbtq"}},{"kind":"Field","name":{"kind":"Name","value":"nativeAmerican"}},{"kind":"Field","name":{"kind":"Name","value":"other"}},{"kind":"Field","name":{"kind":"Name","value":"veteran"}},{"kind":"Field","name":{"kind":"Name","value":"disabled"}},{"kind":"Field","name":{"kind":"Name","value":"woman"}},{"kind":"Field","name":{"kind":"Name","value":"nonBinary"}},{"kind":"Field","name":{"kind":"Name","value":"hawaiianOrPacificIslander"}}]}}]}}]} as unknown as DocumentNode<BulkPersonProfileFromFilesBuilderQuery, BulkPersonProfileFromFilesBuilderQueryVariables>;
export const AddUserActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddUserActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserActivityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addUserActivity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AddUserActivityMutation, AddUserActivityMutationVariables>;